webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(48);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _baseStyles = __webpack_require__(116);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _BurgerIcon = __webpack_require__(113);
	
	var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);
	
	var _CrossIcon = __webpack_require__(115);
	
	var _CrossIcon2 = _interopRequireDefault(_CrossIcon);
	
	exports['default'] = function (styles) {
	  var Menu = (function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu(props) {
	      _classCallCheck(this, Menu);
	
	      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
	      this.state = {
	        isOpen: false
	      };
	    }
	
	    _createClass(Menu, [{
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        var _this = this;
	
	        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	        var isOpen = options.isOpen;
	        var noStateChange = options.noStateChange;
	
	        var newState = {
	          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
	        };
	
	        this.applyWrapperStyles();
	
	        this.setState(newState, function () {
	          !noStateChange && _this.props.onStateChange(newState);
	
	          // Timeout ensures wrappers are cleared after animation finishes.
	          _this.timeoutId && clearTimeout(_this.timeoutId);
	          _this.timeoutId = setTimeout(function () {
	            _this.timeoutId = null;
	            if (!newState.isOpen) {
	              _this.applyWrapperStyles(false);
	            }
	          }, 500);
	        });
	      }
	
	      // Applies component-specific styles to external wrapper elements.
	    }, {
	      key: 'applyWrapperStyles',
	      value: function applyWrapperStyles() {
	        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	        if (this.props.bodyClassName) {
	          var body = document.querySelector('body');
	          body.classList[set ? 'add' : 'remove'](this.props.bodyClassName);
	        }
	
	        if (styles.pageWrap && this.props.pageWrapId) {
	          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
	        }
	
	        if (styles.outerContainer && this.props.outerContainerId) {
	          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
	        }
	      }
	
	      // Sets or unsets styles on DOM elements outside the menu component.
	      // This is necessary for correct page interaction with some of the menus.
	      // Throws and returns if the required external elements don't exist,
	      // which means any external page animations won't be applied.
	    }, {
	      key: 'handleExternalWrapper',
	      value: function handleExternalWrapper(id, wrapperStyles, set) {
	        var html = document.querySelector('html');
	        var body = document.querySelector('body');
	        var wrapper = document.getElementById(id);
	
	        if (!wrapper) {
	          console.error("Element with ID '" + id + "' not found");
	          return;
	        }
	
	        var builtStyles = this.getStyle(wrapperStyles);
	
	        for (var prop in builtStyles) {
	          if (builtStyles.hasOwnProperty(prop)) {
	            wrapper.style[prop] = set ? builtStyles[prop] : '';
	          }
	        }
	
	        // Prevent any horizontal scroll.
	        [html, body].forEach(function (element) {
	          element.style['overflow-x'] = set ? 'hidden' : '';
	        });
	      }
	
	      // Builds styles incrementally for a given element.
	    }, {
	      key: 'getStyles',
	      value: function getStyles(el, index, inline) {
	        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
	
	        // Set base styles.
	        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};
	
	        // Add animation-specific styles.
	        if (styles[el]) {
	          output = _extends({}, output, this.getStyle(styles[el], index + 1));
	        }
	
	        // Add custom styles.
	        if (this.props.styles[propName]) {
	          output = _extends({}, output, this.props.styles[propName]);
	        }
	
	        // Add element inline styles.
	        if (inline) {
	          output = _extends({}, output, inline);
	        }
	
	        return output;
	      }
	    }, {
	      key: 'getStyle',
	      value: function getStyle(style, index) {
	        var width = this.props.width;
	
	        var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
	        return style(this.state.isOpen, formattedWidth, this.props.right, index);
	      }
	    }, {
	      key: 'listenForClose',
	      value: function listenForClose(e) {
	        e = e || window.event;
	
	        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'shouldDisableOverlayClick',
	      value: function shouldDisableOverlayClick() {
	        if (typeof this.props.disableOverlayClick === 'function') {
	          return this.props.disableOverlayClick();
	        } else {
	          return this.props.disableOverlayClick;
	        }
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (!styles) {
	          throw new Error('No styles supplied');
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // Bind ESC key handler (unless disabled or custom function supplied).
	        if (this.props.customOnKeyDown) {
	          window.onkeydown = this.props.customOnKeyDown;
	        } else if (!this.props.disableCloseOnEsc) {
	          window.onkeydown = this.listenForClose.bind(this);
	        }
	
	        // Allow initial open state to be set by props.
	        if (this.props.isOpen) {
	          this.toggleMenu({ isOpen: true, noStateChange: true });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.onkeydown = null;
	
	        this.applyWrapperStyles(false);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        var _this2 = this;
	
	        if (styles.svg) {
	          (function () {
	            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
	            var path = styles.svg.lib(morphShape).select('path');
	
	            if (_this2.state.isOpen) {
	              // Animate SVG path.
	              styles.svg.animate(path);
	            } else {
	              // Reset path (timeout ensures animation happens off screen).
	              setTimeout(function () {
	                path.attr('d', styles.svg.pathInitial);
	              }, 300);
	            }
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          !this.props.noOverlay && _react2['default'].createElement('div', {
	            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
	            onClick: function () {
	              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
	            },
	            style: this.getStyles('overlay')
	          }),
	          _react2['default'].createElement(
	            'div',
	            {
	              id: this.props.id,
	              className: ('bm-menu-wrap ' + this.props.className).trim(),
	              style: this.getStyles('menuWrap')
	            },
	            styles.svg && _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
	                style: this.getStyles('morphShape')
	              },
	              _react2['default'].createElement(
	                'svg',
	                {
	                  width: '100%',
	                  height: '100%',
	                  viewBox: '0 0 100 800',
	                  preserveAspectRatio: 'none'
	                },
	                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-menu ' + this.props.menuClassName).trim(),
	                style: this.getStyles('menu')
	              },
	              _react2['default'].createElement(
	                'nav',
	                {
	                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
	                  style: this.getStyles('itemList')
	                },
	                _react2['default'].Children.map(this.props.children, function (item, index) {
	                  if (item) {
	                    var classList = ['bm-item', _this3.props.itemClassName, item.props.className].filter(function (className) {
	                      return !!className;
	                    }).join(' ');
	                    var extraProps = {
	                      key: index,
	                      className: classList,
	                      style: _this3.getStyles('item', index, item.props.style)
	                    };
	                    return _react2['default'].cloneElement(item, extraProps);
	                  }
	                })
	              )
	            ),
	            this.props.customCrossIcon !== false && _react2['default'].createElement(
	              'div',
	              { style: this.getStyles('closeButton') },
	              _react2['default'].createElement(_CrossIcon2['default'], {
	                onClick: function () {
	                  return _this3.toggleMenu();
	                },
	                styles: this.props.styles,
	                customIcon: this.props.customCrossIcon,
	                className: this.props.crossButtonClassName,
	                crossClassName: this.props.crossClassName
	              })
	            )
	          ),
	          this.props.customBurgerIcon !== false && _react2['default'].createElement(
	            'div',
	            { style: this.getStyles('burgerIcon') },
	            _react2['default'].createElement(_BurgerIcon2['default'], {
	              onClick: function () {
	                return _this3.toggleMenu();
	              },
	              styles: this.props.styles,
	              customIcon: this.props.customBurgerIcon,
	              className: this.props.burgerButtonClassName,
	              barClassName: this.props.burgerBarClassName
	            })
	          )
	        );
	      }
	    }]);
	
	    return Menu;
	  })(_react.Component);
	
	  Menu.propTypes = {
	    bodyClassName: _propTypes2['default'].string,
	    burgerBarClassName: _propTypes2['default'].string,
	    burgerButtonClassName: _propTypes2['default'].string,
	    crossButtonClassName: _propTypes2['default'].string,
	    crossClassName: _propTypes2['default'].string,
	    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customOnKeyDown: _propTypes2['default'].func,
	    disableCloseOnEsc: _propTypes2['default'].bool,
	    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
	    id: _propTypes2['default'].string,
	    isOpen: _propTypes2['default'].bool,
	    itemClassName: _propTypes2['default'].string,
	    itemListClassName: _propTypes2['default'].string,
	    menuClassName: _propTypes2['default'].string,
	    morphShapeClassName: _propTypes2['default'].string,
	    noOverlay: _propTypes2['default'].bool,
	    onStateChange: _propTypes2['default'].func,
	    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    overlayClassName: _propTypes2['default'].string,
	    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    right: _propTypes2['default'].bool,
	    styles: _propTypes2['default'].object,
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	  };
	
	  Menu.defaultProps = {
	    bodyClassName: '',
	    burgerBarClassName: '',
	    burgerButtonClassName: '',
	    className: '',
	    crossButtonClassName: '',
	    crossClassName: '',
	    disableCloseOnEsc: false,
	    id: '',
	    itemClassName: '',
	    itemListClassName: '',
	    menuClassName: '',
	    morphShapeClassName: '',
	    noOverlay: false,
	    onStateChange: function onStateChange() {},
	    outerContainerId: '',
	    overlayClassName: '',
	    pageWrapId: '',
	    styles: {},
	    width: 300
	  };
	
	  return Menu;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var HEY_LISTEN = 'Hey, listen! ';
	exports.warning = function () { };
	exports.invariant = function () { };
	if (false) {
	    exports.warning = function (check, message) {
	        if (!check && typeof console !== 'undefined') {
	            console.warn(HEY_LISTEN + message);
	        }
	    };
	    exports.invariant = function (check, message) {
	        if (!check) {
	            throw new Error(HEY_LISTEN.toUpperCase() + message);
	        }
	    };
	}


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(104);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(87);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(28);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	                t[p[i]] = s[p[i]];
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	        if (m) return m.call(o);
	        return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(19);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(78);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(27),
	    isObjectLike = __webpack_require__(107);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	var clamp = function (min, max) { return function (v) {
	    return Math.max(Math.min(v, max), min);
	}; };
	var contains = function (term) { return function (v) {
	    return typeof v === 'string' && v.indexOf(term) !== -1;
	}; };
	var isFirstChars = function (term) { return function (v) {
	    return typeof v === 'string' && v.indexOf(term) === 0;
	}; };
	var getValueFromFunctionString = function (value) {
	    return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
	};
	var splitCommaDelimited = function (value) {
	    return typeof value === 'string' ? value.split(/,\s*/) : [value];
	};
	
	var number = {
	    test: function (v) { return typeof v === 'number'; },
	    parse: parseFloat,
	    transform: function (v) { return v; }
	};
	var alpha = __assign({}, number, { transform: clamp(0, 1) });
	var scale = __assign({}, number, { default: 1 });
	
	var createUnitType = function (unit) {
	    var containsUnit = contains(unit);
	    return {
	        test: function (v) {
	            return typeof v === 'string' && containsUnit(v) && v.split(' ').length === 1;
	        },
	        parse: parseFloat,
	        transform: function (v) { return "" + v + unit; }
	    };
	};
	var degrees = createUnitType('deg');
	var percent = createUnitType('%');
	var px = createUnitType('px');
	var vh = createUnitType('vh');
	var vw = createUnitType('vw');
	
	var clampRgbUnit = clamp(0, 255);
	var onlyColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))$/i;
	var isRgba = function (v) { return v.red !== undefined; };
	var isHsla = function (v) { return v.hue !== undefined; };
	var splitColorValues = function (terms) {
	    var numTerms = terms.length;
	    return function (v) {
	        if (typeof v !== 'string')
	            return v;
	        var values = {};
	        var valuesArray = splitCommaDelimited(getValueFromFunctionString(v));
	        for (var i = 0; i < numTerms; i++) {
	            values[terms[i]] =
	                valuesArray[i] !== undefined ? parseFloat(valuesArray[i]) : 1;
	        }
	        return values;
	    };
	};
	var rgbaTemplate = function (_a) {
	    var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$$1 = _b === void 0 ? 1 : _b;
	    return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha$$1 + ")";
	};
	var hslaTemplate = function (_a) {
	    var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$$1 = _b === void 0 ? 1 : _b;
	    return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha$$1 + ")";
	};
	var rgbUnit = __assign({}, number, { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
	var testRgbaString = isFirstChars('rgb');
	var rgba = {
	    test: function (v) { return (typeof v === 'string' ? testRgbaString(v) : isRgba(v)); },
	    parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
	    transform: function (_a) {
	        var red = _a.red, green = _a.green, blue = _a.blue, alpha$$1 = _a.alpha;
	        return rgbaTemplate({
	            red: rgbUnit.transform(red),
	            green: rgbUnit.transform(green),
	            blue: rgbUnit.transform(blue),
	            alpha: alpha$$1
	        });
	    }
	};
	var testHslaString = isFirstChars('hsl');
	var hsla = {
	    test: function (v) { return (typeof v === 'string' ? testHslaString(v) : isHsla(v)); },
	    parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
	    transform: function (_a) {
	        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, alpha$$1 = _a.alpha;
	        return hslaTemplate({
	            hue: Math.round(hue),
	            saturation: percent.transform(saturation),
	            lightness: percent.transform(lightness),
	            alpha: alpha$$1
	        });
	    }
	};
	var hex = __assign({}, rgba, { test: isFirstChars('#'), parse: function (v) {
	        var r = '';
	        var g = '';
	        var b = '';
	        if (v.length > 4) {
	            r = v.substr(1, 2);
	            g = v.substr(3, 2);
	            b = v.substr(5, 2);
	        }
	        else {
	            r = v.substr(1, 1);
	            g = v.substr(2, 1);
	            b = v.substr(3, 1);
	            r += r;
	            g += g;
	            b += b;
	        }
	        return {
	            red: parseInt(r, 16),
	            green: parseInt(g, 16),
	            blue: parseInt(b, 16),
	            alpha: 1
	        };
	    } });
	var color = {
	    test: function (v) {
	        return (typeof v === 'string' && onlyColorRegex.test(v)) ||
	            rgba.test(v) ||
	            hsla.test(v) ||
	            hex.test(v);
	    },
	    parse: function (v) {
	        if (rgba.test(v)) {
	            return rgba.parse(v);
	        }
	        else if (hsla.test(v)) {
	            return hsla.parse(v);
	        }
	        else if (hex.test(v)) {
	            return hex.parse(v);
	        }
	        return v;
	    },
	    transform: function (v) {
	        if (isRgba(v)) {
	            return rgba.transform(v);
	        }
	        else if (isHsla(v)) {
	            return hsla.transform(v);
	        }
	        return v;
	    }
	};
	
	var floatRegex = /(-)?(\d[\d\.]*)/g;
	var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
	var COLOR_TOKEN = '${c}';
	var NUMBER_TOKEN = '${n}';
	var complex = {
	    test: function (v) {
	        if (typeof v !== 'string')
	            return false;
	        var numValues = 0;
	        var foundNumbers = v.match(floatRegex);
	        var foundColors = v.match(colorRegex);
	        if (foundNumbers)
	            numValues += foundNumbers.length;
	        if (foundColors)
	            numValues += foundColors.length;
	        return numValues > 1;
	    },
	    parse: function (v) {
	        var input = v;
	        var parsed = [];
	        var foundColors = input.match(colorRegex);
	        if (foundColors) {
	            input = input.replace(colorRegex, COLOR_TOKEN);
	            parsed.push.apply(parsed, foundColors.map(color.parse));
	        }
	        var foundNumbers = input.match(floatRegex);
	        if (foundNumbers) {
	            parsed.push.apply(parsed, foundNumbers.map(number.parse));
	        }
	        return parsed;
	    },
	    createTransformer: function (prop) {
	        var template = prop;
	        var token = 0;
	        var foundColors = prop.match(colorRegex);
	        var numColors = foundColors ? foundColors.length : 0;
	        if (foundColors) {
	            for (var i = 0; i < numColors; i++) {
	                template = template.replace(foundColors[i], COLOR_TOKEN);
	                token++;
	            }
	        }
	        var foundNumbers = template.match(floatRegex);
	        var numNumbers = foundNumbers ? foundNumbers.length : 0;
	        if (foundNumbers) {
	            for (var i = 0; i < numNumbers; i++) {
	                template = template.replace(foundNumbers[i], NUMBER_TOKEN);
	                token++;
	            }
	        }
	        return function (v) {
	            var output = template;
	            for (var i = 0; i < token; i++) {
	                output = output.replace(i < numColors ? COLOR_TOKEN : NUMBER_TOKEN, i < numColors ? color.transform(v[i]) : v[i]);
	            }
	            return output;
	        };
	    }
	};
	
	exports.number = number;
	exports.scale = scale;
	exports.alpha = alpha;
	exports.degrees = degrees;
	exports.percent = percent;
	exports.px = px;
	exports.vw = vw;
	exports.vh = vh;
	exports.rgba = rgba;
	exports.rgbUnit = rgbUnit;
	exports.hex = hex;
	exports.hsla = hsla;
	exports.color = color;
	exports.complex = complex;


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var hasRAF = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined;
	var prevTime = 0;
	var onNextFrame = hasRAF
	    ? function (callback) { return window.requestAnimationFrame(callback); }
	    : function (callback) {
	        var currentTime = Date.now();
	        var timeToCall = Math.max(0, 16.7 - (currentTime - prevTime));
	        prevTime = currentTime + timeToCall;
	        setTimeout(function () { return callback(prevTime); }, timeToCall);
	    };
	
	function createRenderStep(startRenderLoop) {
	    var functionsToRun = [];
	    var functionsToRunNextFrame = [];
	    var numThisFrame = 0;
	    var isProcessing = false;
	    var i = 0;
	    return {
	        cancel: function (callback) {
	            var indexOfCallback = functionsToRunNextFrame.indexOf(callback);
	            if (indexOfCallback !== -1) {
	                functionsToRunNextFrame.splice(indexOfCallback, 1);
	            }
	        },
	        process: function () {
	            isProcessing = true;
	            _a = [functionsToRunNextFrame, functionsToRun], functionsToRun = _a[0], functionsToRunNextFrame = _a[1];
	            functionsToRunNextFrame.length = 0;
	            numThisFrame = functionsToRun.length;
	            for (i = 0; i < numThisFrame; i++) {
	                functionsToRun[i]();
	            }
	            isProcessing = false;
	            var _a;
	        },
	        schedule: function (callback, immediate) {
	            if (immediate === void 0) { immediate = false; }
	            startRenderLoop();
	            var addToCurrentBuffer = immediate && isProcessing;
	            var buffer = addToCurrentBuffer ? functionsToRun : functionsToRunNextFrame;
	            if (buffer.indexOf(callback) === -1) {
	                buffer.push(callback);
	                if (addToCurrentBuffer) {
	                    numThisFrame = functionsToRun.length;
	                }
	            }
	        },
	    };
	}
	
	var HAS_PERFORMANCE_NOW = typeof performance !== 'undefined' && performance.now !== undefined;
	var currentTime = HAS_PERFORMANCE_NOW ? function () { return performance.now(); } : function () { return Date.now(); };
	var willRenderNextFrame = false;
	var MAX_ELAPSED = 40;
	var defaultElapsed = 16.7;
	var useDefaultElapsed = true;
	var currentFramestamp = 0;
	var elapsed = 0;
	function startRenderLoop() {
	    if (willRenderNextFrame)
	        return;
	    willRenderNextFrame = true;
	    useDefaultElapsed = true;
	    onNextFrame(processFrame);
	}
	var frameStart = createRenderStep(startRenderLoop);
	var frameUpdate = createRenderStep(startRenderLoop);
	var frameRender = createRenderStep(startRenderLoop);
	var frameEnd = createRenderStep(startRenderLoop);
	function processFrame(framestamp) {
	    willRenderNextFrame = false;
	    elapsed = useDefaultElapsed
	        ? defaultElapsed
	        : Math.max(Math.min(framestamp - currentFramestamp, MAX_ELAPSED), 1);
	    if (!useDefaultElapsed)
	        defaultElapsed = elapsed;
	    currentFramestamp = framestamp;
	    frameStart.process();
	    frameUpdate.process();
	    frameRender.process();
	    frameEnd.process();
	    if (willRenderNextFrame)
	        useDefaultElapsed = false;
	}
	var onFrameStart = frameStart.schedule;
	var onFrameUpdate = frameUpdate.schedule;
	var onFrameRender = frameRender.schedule;
	var onFrameEnd = frameEnd.schedule;
	var cancelOnFrameStart = frameStart.cancel;
	var cancelOnFrameUpdate = frameUpdate.cancel;
	var cancelOnFrameRender = frameRender.cancel;
	var cancelOnFrameEnd = frameEnd.cancel;
	var timeSinceLastFrame = function () { return elapsed; };
	var currentFrameTime = function () { return currentFramestamp; };
	
	exports.currentTime = currentTime;
	exports.onFrameStart = onFrameStart;
	exports.onFrameUpdate = onFrameUpdate;
	exports.onFrameRender = onFrameRender;
	exports.onFrameEnd = onFrameEnd;
	exports.cancelOnFrameStart = cancelOnFrameStart;
	exports.cancelOnFrameUpdate = cancelOnFrameUpdate;
	exports.cancelOnFrameRender = cancelOnFrameRender;
	exports.cancelOnFrameEnd = cancelOnFrameEnd;
	exports.timeSinceLastFrame = timeSinceLastFrame;
	exports.currentFrameTime = currentFrameTime;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(18),
	    getRawTag = __webpack_require__(79),
	    objectToString = __webpack_require__(100);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(74),
	    getValue = __webpack_require__(80);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function () {
	  var Snap = undefined;
	  try {
	    Snap = __webpack_require__(131);
	  } finally {
	    return Snap;
	  }
	};
	
	module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var tslib_1 = __webpack_require__(13);
	var React = __webpack_require__(1);
	var poseFactory = _interopDefault(__webpack_require__(110));
	var heyListen = __webpack_require__(5);
	
	var hasChanged = function (prev, next) {
	    if (prev === next)
	        return false;
	    var prevIsArray = Array.isArray(prev);
	    var nextIsArray = Array.isArray(next);
	    if (prevIsArray !== nextIsArray || (!prevIsArray && !nextIsArray)) {
	        return true;
	    }
	    else if (prevIsArray && nextIsArray) {
	        var numPrev = prev.length;
	        var numNext = next.length;
	        if (numPrev !== numNext)
	            return true;
	        for (var i = numPrev; i < numPrev; i++) {
	            if (prev[i] !== next[i])
	                return true;
	        }
	    }
	    return false;
	};
	
	var PoseParentContext = React.createContext({});
	var calcPopFromFlowStyle = function (el) {
	    var offsetTop = el.offsetTop, offsetLeft = el.offsetLeft, offsetWidth = el.offsetWidth, offsetHeight = el.offsetHeight;
	    return {
	        position: 'absolute',
	        top: offsetTop,
	        left: offsetLeft,
	        width: offsetWidth,
	        height: offsetHeight
	    };
	};
	var hasPose = function (pose, key) {
	    return Array.isArray(pose) ? pose.indexOf(key) !== -1 : pose === key;
	};
	var objectToMap = function (obj) {
	    return Object.keys(obj).reduce(function (map, key) {
	        map.set(key, { raw: obj[key] });
	        return map;
	    }, new Map());
	};
	var PoseElement = (function (_super) {
	    tslib_1.__extends(PoseElement, _super);
	    function PoseElement() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.children = new Set();
	        _this.childrenHandlers = {
	            registerChild: function (props) {
	                _this.children.add(props);
	                if (_this.poser)
	                    _this.flushChildren();
	            },
	            onUnmount: function (child) { return _this.poser.removeChild(child); },
	            getParentPoseConfig: function () { return _this.props.poseConfig; },
	            getInitialPoseFromParent: function () { return _this.getInitialPose(); }
	        };
	        _this.getRefs = function () {
	            var refs = {};
	            var elementType = _this.props.elementType;
	            if (typeof elementType === 'string') {
	                refs.ref = _this.setRef;
	            }
	            else {
	                refs.innerRef = _this.setRef;
	                refs.hostRef = _this.setRef;
	            }
	            return refs;
	        };
	        _this.setRef = function (ref) {
	            if (ref instanceof Element || (_this.ref && ref === null)) {
	                var innerRef = _this.props.innerRef;
	                if (innerRef)
	                    innerRef(ref);
	                _this.ref = ref;
	            }
	        };
	        return _this;
	    }
	    PoseElement.prototype.getInitialPose = function () {
	        var _a = this.props, getInitialPoseFromParent = _a.getInitialPoseFromParent, pose = _a.pose, _pose = _a._pose, initialPose = _a.initialPose;
	        if (initialPose) {
	            return initialPose;
	        }
	        else {
	            var parentPose = getInitialPoseFromParent && getInitialPoseFromParent();
	            var thisPose = Array.isArray(pose) ? pose : [pose];
	            var thisInternalPose = Array.isArray(_pose) ? _pose : [_pose];
	            return Array.isArray(parentPose)
	                ? parentPose.concat(thisPose, thisInternalPose) : [parentPose].concat(thisPose, thisInternalPose);
	        }
	    };
	    PoseElement.prototype.getFirstPose = function () {
	        var _a = this.props, initialPose = _a.initialPose, pose = _a.pose, _pose = _a._pose;
	        if (!initialPose)
	            return;
	        var thisPose = Array.isArray(pose) ? pose : [pose];
	        var thisInternalPose = Array.isArray(_pose) ? _pose : [_pose];
	        return thisPose.concat(thisInternalPose);
	    };
	    PoseElement.prototype.getSetProps = function () {
	        var _a = this.props, children = _a.children, elementType = _a.elementType, poseConfig = _a.poseConfig, onValueChange = _a.onValueChange, innerRef = _a.innerRef, _pose = _a._pose, pose = _a.pose, initialPose = _a.initialPose, poseKey = _a.poseKey, onPoseComplete = _a.onPoseComplete, getParentPoseConfig = _a.getParentPoseConfig, registerChild = _a.registerChild, onUnmount = _a.onUnmount, getInitialPoseFromParent = _a.getInitialPoseFromParent, popFromFlow = _a.popFromFlow, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, props = tslib_1.__rest(_a, ["children", "elementType", "poseConfig", "onValueChange", "innerRef", "_pose", "pose", "initialPose", "poseKey", "onPoseComplete", "getParentPoseConfig", "registerChild", "onUnmount", "getInitialPoseFromParent", "popFromFlow", "values", "parentValues", "onDragStart", "onDragEnd"]);
	        if (popFromFlow && this.ref && this.ref instanceof HTMLElement) {
	            if (!this.popStyle) {
	                props.style = tslib_1.__assign({}, props.style, calcPopFromFlowStyle(this.ref));
	                this.popStyle = props.style;
	            }
	            else {
	                props.style = this.popStyle;
	            }
	        }
	        else {
	            this.popStyle = null;
	        }
	        return props;
	    };
	    PoseElement.prototype.componentDidMount = function () {
	        var _this = this;
	        heyListen.invariant(typeof this.ref !== 'undefined', "No DOM ref found. If you're converting an existing component via posed(Component), you must ensure you're passing the hostRef prop to your underlying DOM element.");
	        var _a = this.props, poseConfig = _a.poseConfig, onValueChange = _a.onValueChange, registerChild = _a.registerChild, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd;
	        var config = tslib_1.__assign({}, poseConfig, { initialPose: this.getInitialPose(), values: values || poseConfig.values, parentValues: parentValues ? objectToMap(parentValues) : undefined, props: this.getSetProps(), onDragStart: onDragStart,
	            onDragEnd: onDragEnd, onChange: onValueChange });
	        if (!registerChild) {
	            this.initPoser(poseFactory(this.ref, config));
	        }
	        else {
	            registerChild({
	                element: this.ref,
	                poseConfig: config,
	                onRegistered: function (poser) { return _this.initPoser(poser); }
	            });
	        }
	    };
	    PoseElement.prototype.UNSAFE_componentWillUpdate = function (_a) {
	        var pose = _a.pose, _pose = _a._pose;
	        if (hasPose(pose, 'flip') || hasPose(_pose, 'flip'))
	            this.poser.measure();
	    };
	    PoseElement.prototype.componentDidUpdate = function (prevProps) {
	        var _a = this.props, pose = _a.pose, _pose = _a._pose, poseKey = _a.poseKey;
	        this.poser.setProps(this.getSetProps());
	        if (poseKey !== prevProps.key ||
	            hasChanged(prevProps.pose, pose) ||
	            pose === 'flip') {
	            this.setPose(pose);
	        }
	        if (_pose !== prevProps._pose || _pose === 'flip')
	            this.setPose(_pose);
	    };
	    PoseElement.prototype.componentWillUnmount = function () {
	        if (!this.poser)
	            return;
	        var onUnmount = this.props.onUnmount;
	        if (onUnmount)
	            onUnmount(this.poser);
	        this.poser.destroy();
	    };
	    PoseElement.prototype.initPoser = function (poser) {
	        this.poser = poser;
	        this.flushChildren();
	        var firstPose = this.getFirstPose();
	        if (firstPose)
	            this.setPose(firstPose);
	    };
	    PoseElement.prototype.setPose = function (pose) {
	        var _this = this;
	        var onPoseComplete = this.props.onPoseComplete;
	        var poseList = Array.isArray(pose) ? pose : [pose];
	        Promise.all(poseList.map(function (key) { return key && _this.poser.set(key); })).then(function () { return onPoseComplete && onPoseComplete(); });
	    };
	    PoseElement.prototype.flushChildren = function () {
	        var _this = this;
	        this.children.forEach(function (_a) {
	            var element = _a.element, poseConfig = _a.poseConfig, onRegistered = _a.onRegistered;
	            return onRegistered(_this.poser.addChild(element, poseConfig));
	        });
	        this.children.clear();
	    };
	    PoseElement.prototype.render = function () {
	        var _a = this.props, elementType = _a.elementType, children = _a.children;
	        return (React.createElement(PoseParentContext.Provider, { value: this.childrenHandlers }, React.createElement(elementType, tslib_1.__assign({}, this.getSetProps(), this.getRefs()), children)));
	    };
	    return PoseElement;
	}(React.PureComponent));
	
	var supportedElements = [
	    'a',
	    'article',
	    'aside',
	    'audio',
	    'b',
	    'blockquote',
	    'body',
	    'br',
	    'button',
	    'canvas',
	    'caption',
	    'cite',
	    'code',
	    'col',
	    'colgroup',
	    'data',
	    'datalist',
	    'dialog',
	    'div',
	    'em',
	    'embed',
	    'fieldset',
	    'figcaption',
	    'figure',
	    'footer',
	    'form',
	    'h1',
	    'h2',
	    'h3',
	    'h4',
	    'h5',
	    'h6',
	    'head',
	    'header',
	    'hgroup',
	    'hr',
	    'i',
	    'iframe',
	    'img',
	    'input',
	    'label',
	    'legend',
	    'li',
	    'nav',
	    'object',
	    'ol',
	    'option',
	    'p',
	    'param',
	    'picture',
	    'pre',
	    'progress',
	    'q',
	    'section',
	    'select',
	    'span',
	    'strong',
	    'table',
	    'tbody',
	    'td',
	    'textarea',
	    'tfoot',
	    'th',
	    'thead',
	    'time',
	    'title',
	    'tr',
	    'ul',
	    'video',
	    'circle',
	    'clipPath',
	    'defs',
	    'ellipse',
	    'g',
	    'image',
	    'line',
	    'linearGradient',
	    'mask',
	    'path',
	    'pattern',
	    'polygon',
	    'polyline',
	    'radialGradient',
	    'rect',
	    'stop',
	    'svg',
	    'text',
	    'tspan'
	];
	
	var componentCache = new Map();
	var createComponentFactory = function (key) {
	    var componentFactory = function (poseConfig) {
	        if (poseConfig === void 0) { poseConfig = {}; }
	        return function (_a) {
	            var _b = _a.withParent, withParent = _b === void 0 ? true : _b, props = tslib_1.__rest(_a, ["withParent"]);
	            return !withParent || props.parentValues ? (React.createElement(PoseElement, tslib_1.__assign({ poseConfig: poseConfig, elementType: key }, props))) : (React.createElement(PoseParentContext.Consumer, null, function (parentCtx) { return (React.createElement(PoseElement, tslib_1.__assign({ poseConfig: poseConfig, elementType: key }, props, parentCtx))); }));
	        };
	    };
	    componentCache.set(key, componentFactory);
	    return componentFactory;
	};
	var getComponentFactory = function (key) {
	    return componentCache.has(key)
	        ? componentCache.get(key)
	        : createComponentFactory(key);
	};
	var posed = (function (component) {
	    return getComponentFactory(component);
	});
	supportedElements.reduce(function (acc, key) {
	    acc[key] = getComponentFactory(key);
	    return acc;
	}, posed);
	
	var Children = React.Children, cloneElement = React.cloneElement;
	var getKey = function (child) { return child.key; };
	var animateChildrenList = function (incomingChildren, pose, initialPose) {
	    var children = [];
	    Children.forEach(incomingChildren, function (child) {
	        return children.push(cloneElement(child, { pose: pose, initialPose: initialPose }));
	    });
	    return children;
	};
	var mergeChildren = function (_a) {
	    var incomingChildren = _a.incomingChildren, displayedChildren = _a.displayedChildren, isLeaving = _a.isLeaving, removeFromTree = _a.removeFromTree, preEnterPose = _a.preEnterPose, enterPose = _a.enterPose, exitPose = _a.exitPose, flipMove = _a.flipMove;
	    var children = [];
	    var prevKeys = displayedChildren.map(getKey);
	    var nextKeys = incomingChildren.map(getKey);
	    var entering = new Set(nextKeys.filter(function (key) { return isLeaving.has(key) || prevKeys.indexOf(key) === -1; }));
	    entering.forEach(function (key) { return isLeaving.delete(key); });
	    var leaving = prevKeys.filter(function (key) {
	        return !entering.has(key) && (isLeaving.has(key) || nextKeys.indexOf(key) === -1);
	    });
	    leaving.forEach(function (key) { return isLeaving.add(key); });
	    var moving = new Set(prevKeys.filter(function (key, i) {
	        var nextIndex = nextKeys.indexOf(key);
	        return !entering.has(key) && nextIndex !== -1 && i !== nextIndex;
	    }));
	    incomingChildren.forEach(function (child) {
	        var newChildProps = entering.has(child.key)
	            ? { initialPose: preEnterPose, _pose: enterPose }
	            : moving.has(child.key) && flipMove
	                ? { _pose: [enterPose, 'flip'] }
	                : { _pose: enterPose };
	        children.push(cloneElement(child, newChildProps));
	    });
	    leaving.forEach(function (key) {
	        var child = displayedChildren.find(function (c) { return c.key === key; });
	        var newChild = cloneElement(child, {
	            _pose: exitPose,
	            onPoseComplete: removeFromTree(key),
	            popFromFlow: flipMove
	        });
	        var insertionIndex = prevKeys.indexOf(key);
	        children.splice(insertionIndex, 0, newChild);
	    });
	    return children;
	};
	var handleIncomingChildren = function (props) {
	    var displayedChildren = props.displayedChildren, incomingChildren = props.incomingChildren, animateOnMount = props.animateOnMount, preEnterPose = props.preEnterPose, enterPose = props.enterPose;
	    if (!displayedChildren && animateOnMount) {
	        return animateChildrenList(incomingChildren, enterPose, preEnterPose);
	    }
	    else if (displayedChildren) {
	        return mergeChildren(props);
	    }
	    else {
	        return animateChildrenList(incomingChildren, enterPose);
	    }
	};
	var makeChildList = function (children) {
	    var list = [];
	    Children.forEach(children, function (child) { return child && list.push(child); });
	    return list;
	};
	var removeFromChildren = function (children, key) { return children.filter(function (child) { return child.key !== key; }); };
	
	var Fragment = React.Fragment;
	var PoseGroup = (function (_super) {
	    tslib_1.__extends(PoseGroup, _super);
	    function PoseGroup() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            incomingChildren: [],
	            isLeaving: new Set(),
	            removeFromTree: function (key) { return function () {
	                var isLeaving = _this.state.isLeaving;
	                isLeaving.delete(key);
	                _this.removeFromChildren(key);
	            }; }
	        };
	        return _this;
	    }
	    PoseGroup.prototype.removeFromChildren = function (key) {
	        var children = this.state.children;
	        this.setState({
	            children: removeFromChildren(children, key)
	        });
	    };
	    PoseGroup.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        return this.state !== nextState;
	    };
	    PoseGroup.prototype.render = function () {
	        var children = this.state.children;
	        return React.createElement(Fragment, null, children);
	    };
	    PoseGroup.defaultProps = {
	        flipMove: true,
	        preEnterPose: 'exit',
	        enterPose: 'enter',
	        exitPose: 'exit',
	        singleChildOnly: false
	    };
	    PoseGroup.getDerivedStateFromProps = function (props, _a) {
	        var isLeaving = _a.isLeaving, removeFromTree = _a.removeFromTree, children = _a.children;
	        var incomingChildren = makeChildList(props.children);
	        return {
	            incomingChildren: incomingChildren,
	            children: handleIncomingChildren({
	                incomingChildren: incomingChildren,
	                displayedChildren: children,
	                isLeaving: isLeaving,
	                removeFromTree: removeFromTree,
	                enterPose: props.enterPose,
	                exitPose: props.exitPose,
	                flipMove: props.flipMove,
	                animateOnMount: props.animateOnMount,
	                preEnterPose: props.preEnterPose
	            })
	        };
	    };
	    return PoseGroup;
	}(React.Component));
	
	exports.default = posed;
	exports.PoseGroup = PoseGroup;


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var tslib_1 = __webpack_require__(13);
	var framesync = __webpack_require__(26);
	var styleValueTypes = __webpack_require__(22);
	var heyListen = __webpack_require__(5);
	var styler = _interopDefault(__webpack_require__(132));
	
	var isNum = function (v) { return typeof v === 'number'; };
	var isPoint = function (point) {
	    return point.x !== undefined && point.y !== undefined;
	};
	var isPoint3D = function (point) {
	    return point.z !== undefined;
	};
	var toDecimal = function (num, precision) {
	    if (precision === void 0) { precision = 2; }
	    precision = Math.pow(10, precision);
	    return Math.round(num * precision) / precision;
	};
	var ZERO_POINT = {
	    x: 0,
	    y: 0,
	    z: 0
	};
	var distance1D = function (a, b) { return Math.abs(a - b); };
	var angle = function (a, b) {
	    if (b === void 0) { b = ZERO_POINT; }
	    return radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
	};
	var degreesToRadians = function (degrees) { return degrees * Math.PI / 180; };
	var dilate = function (a, b, dilation) { return a + ((b - a) * dilation); };
	var distance = function (a, b) {
	    if (b === void 0) { b = ZERO_POINT; }
	    if (isNum(a) && isNum(b)) {
	        return distance1D(a, b);
	    }
	    else if (isPoint(a) && isPoint(b)) {
	        var xDelta = distance1D(a.x, b.x);
	        var yDelta = distance1D(a.y, b.y);
	        var zDelta = (isPoint3D(a) && isPoint3D(b)) ? distance1D(a.z, b.z) : 0;
	        return Math.sqrt((Math.pow(xDelta, 2)) + (Math.pow(yDelta, 2)) + (Math.pow(zDelta, 2)));
	    }
	    return 0;
	};
	var getProgressFromValue = function (from, to, value) {
	    var toFromDifference = to - from;
	    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
	};
	var getValueFromProgress = function (from, to, progress) {
	    return (-progress * from) + (progress * to) + from;
	};
	var pointFromAngleAndDistance = function (origin, angle, distance) {
	    angle = degreesToRadians(angle);
	    return {
	        x: distance * Math.cos(angle) + origin.x,
	        y: distance * Math.sin(angle) + origin.y
	    };
	};
	var radiansToDegrees = function (radians) { return radians * 180 / Math.PI; };
	var smooth = function (newValue, oldValue, duration, smoothing) {
	    if (smoothing === void 0) { smoothing = 0; }
	    return toDecimal(oldValue + (duration * (newValue - oldValue) / Math.max(smoothing, duration)));
	};
	var speedPerFrame = function (xps, frameDuration) {
	    return (isNum(xps)) ? xps / (1000 / frameDuration) : 0;
	};
	var speedPerSecond = function (velocity, frameDuration) {
	    return frameDuration ? velocity * (1000 / frameDuration) : 0;
	};
	var stepProgress = function (steps, progress) {
	    var segment = 1 / (steps - 1);
	    var target = 1 - (1 / steps);
	    var progressOfTarget = Math.min(progress / target, 1);
	    return Math.floor(progressOfTarget / segment) * segment;
	};
	
	var calc = /*#__PURE__*/Object.freeze({
	  isPoint: isPoint,
	  isPoint3D: isPoint3D,
	  angle: angle,
	  degreesToRadians: degreesToRadians,
	  dilate: dilate,
	  distance: distance,
	  getProgressFromValue: getProgressFromValue,
	  getValueFromProgress: getValueFromProgress,
	  pointFromAngleAndDistance: pointFromAngleAndDistance,
	  radiansToDegrees: radiansToDegrees,
	  smooth: smooth,
	  speedPerFrame: speedPerFrame,
	  speedPerSecond: speedPerSecond,
	  stepProgress: stepProgress
	});
	
	var noop = function (v) { return v; };
	var appendUnit = function (unit) { return function (v) { return "" + v + unit; }; };
	var applyOffset = function (from, to) {
	    var hasReceivedFrom = true;
	    if (to === undefined) {
	        to = from;
	        hasReceivedFrom = false;
	    }
	    var getOffset = function (v) { return v - from; };
	    var applyOffsetTo = function (v) { return v + to; };
	    return function (v) {
	        if (hasReceivedFrom) {
	            return applyOffsetTo(getOffset(v));
	        }
	        else {
	            from = v;
	            hasReceivedFrom = true;
	            return to;
	        }
	    };
	};
	var blend = function (from, to, v) {
	    var fromExpo = from * from;
	    var toExpo = to * to;
	    return Math.sqrt(v * (toExpo - fromExpo) + fromExpo);
	};
	var blendColor = function (from, to) {
	    var fromColor = typeof from === 'string' ? styleValueTypes.color.parse(from) : from;
	    var toColor = typeof to === 'string' ? styleValueTypes.color.parse(to) : to;
	    var blended = tslib_1.__assign({}, fromColor);
	    var blendFunc = from.hue !== undefined ||
	        (typeof from === 'string' && styleValueTypes.hsla.test(from))
	        ? getValueFromProgress
	        : blend;
	    return function (v) {
	        blended = tslib_1.__assign({}, blended);
	        for (var key in blended) {
	            if (key !== 'alpha' && blended.hasOwnProperty(key)) {
	                blended[key] = blendFunc(fromColor[key], toColor[key], v);
	            }
	        }
	        blended.alpha = getValueFromProgress(fromColor.alpha, toColor.alpha, v);
	        return blended;
	    };
	};
	var blendArray = function (from, to) {
	    var output = from.slice();
	    var numValues = output.length;
	    var blendValue = from.map(function (fromThis, i) {
	        var toThis = to[i];
	        return typeof fromThis === 'number'
	            ? function (v) { return getValueFromProgress(fromThis, toThis, v); }
	            : blendColor(fromThis, toThis);
	    });
	    return function (v) {
	        for (var i = 0; i < numValues; i++) {
	            output[i] = blendValue[i](v);
	        }
	        return output;
	    };
	};
	var clamp = function (min, max) { return function (v) {
	    return Math.min(Math.max(v, min), max);
	}; };
	var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
	var pipe = function () {
	    var transformers = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        transformers[_i] = arguments[_i];
	    }
	    return transformers.reduce(combineFunctions);
	};
	var conditional = function (check, apply) { return function (v) {
	    return check(v) ? apply(v) : v;
	}; };
	var slowInterpolate = function (input, output, rangeLength, rangeEasing) {
	    var finalIndex = rangeLength - 1;
	    if (input[0] > input[finalIndex]) {
	        input.reverse();
	        output.reverse();
	    }
	    return function (v) {
	        if (v <= input[0]) {
	            return output[0];
	        }
	        if (v >= input[finalIndex]) {
	            return output[finalIndex];
	        }
	        var i = 1;
	        for (; i < rangeLength; i++) {
	            if (input[i] > v || i === finalIndex) {
	                break;
	            }
	        }
	        var progressInRange = getProgressFromValue(input[i - 1], input[i], v);
	        var easedProgress = rangeEasing
	            ? rangeEasing[i - 1](progressInRange)
	            : progressInRange;
	        return getValueFromProgress(output[i - 1], output[i], easedProgress);
	    };
	};
	var fastInterpolate = function (minA, maxA, minB, maxB) { return function (v) { return ((v - minA) * (maxB - minB)) / (maxA - minA) + minB; }; };
	var interpolate = function (input, output, rangeEasing) {
	    var rangeLength = input.length;
	    return rangeLength !== 2
	        ? slowInterpolate(input, output, rangeLength, rangeEasing)
	        : fastInterpolate(input[0], input[1], output[0], output[1]);
	};
	var generateStaticSpring = function (alterDisplacement) {
	    if (alterDisplacement === void 0) { alterDisplacement = noop; }
	    return function (constant, origin) { return function (v) {
	        var displacement = origin - v;
	        var springModifiedDisplacement = -constant * (0 - alterDisplacement(Math.abs(displacement)));
	        return displacement <= 0
	            ? origin + springModifiedDisplacement
	            : origin - springModifiedDisplacement;
	    }; };
	};
	var linearSpring = generateStaticSpring();
	var nonlinearSpring = generateStaticSpring(Math.sqrt);
	var wrap = function (min, max) { return function (v) {
	    var rangeSize = max - min;
	    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
	}; };
	var smooth$1 = function (strength) {
	    if (strength === void 0) { strength = 50; }
	    var previousValue = 0;
	    var lastUpdated = 0;
	    return function (v) {
	        var currentFramestamp = framesync.currentFrameTime();
	        var timeDelta = currentFramestamp !== lastUpdated ? currentFramestamp - lastUpdated : 0;
	        var newValue = timeDelta
	            ? smooth(v, previousValue, timeDelta, strength)
	            : previousValue;
	        lastUpdated = currentFramestamp;
	        previousValue = newValue;
	        return newValue;
	    };
	};
	var snap = function (points) {
	    if (typeof points === 'number') {
	        return function (v) { return Math.round(v / points) * points; };
	    }
	    else {
	        var i_1 = 0;
	        var numPoints_1 = points.length;
	        return function (v) {
	            var lastDistance = Math.abs(points[0] - v);
	            for (i_1 = 1; i_1 < numPoints_1; i_1++) {
	                var point = points[i_1];
	                var distance$$1 = Math.abs(point - v);
	                if (distance$$1 === 0)
	                    return point;
	                if (distance$$1 > lastDistance)
	                    return points[i_1 - 1];
	                if (i_1 === numPoints_1 - 1)
	                    return point;
	                lastDistance = distance$$1;
	            }
	        };
	    }
	};
	var steps = function (st, min, max) {
	    if (min === void 0) { min = 0; }
	    if (max === void 0) { max = 1; }
	    return function (v) {
	        var progress = getProgressFromValue(min, max, v);
	        return getValueFromProgress(min, max, stepProgress(st, progress));
	    };
	};
	var transformMap = function (childTransformers) { return function (v) {
	    var output = tslib_1.__assign({}, v);
	    for (var key in childTransformers) {
	        if (childTransformers.hasOwnProperty(key)) {
	            var childTransformer = childTransformers[key];
	            output[key] = childTransformer(v[key]);
	        }
	    }
	    return output;
	}; };
	
	var transformers = /*#__PURE__*/Object.freeze({
	  appendUnit: appendUnit,
	  applyOffset: applyOffset,
	  blendColor: blendColor,
	  blendArray: blendArray,
	  clamp: clamp,
	  pipe: pipe,
	  conditional: conditional,
	  interpolate: interpolate,
	  generateStaticSpring: generateStaticSpring,
	  linearSpring: linearSpring,
	  nonlinearSpring: nonlinearSpring,
	  wrap: wrap,
	  smooth: smooth$1,
	  snap: snap,
	  steps: steps,
	  transformMap: transformMap
	});
	
	var Chainable = (function () {
	    function Chainable(props) {
	        if (props === void 0) { props = {}; }
	        this.props = props;
	    }
	    Chainable.prototype.applyMiddleware = function (middleware) {
	        return this.create(tslib_1.__assign({}, this.props, { middleware: this.props.middleware ? [middleware].concat(this.props.middleware) : [middleware] }));
	    };
	    Chainable.prototype.pipe = function () {
	        var funcs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            funcs[_i] = arguments[_i];
	        }
	        var pipedUpdate = funcs.length === 1 ? funcs[0] : pipe.apply(void 0, funcs);
	        return this.applyMiddleware(function (update) { return function (v) { return update(pipedUpdate(v)); }; });
	    };
	    Chainable.prototype.while = function (predicate) {
	        return this.applyMiddleware(function (update, complete) { return function (v) { return predicate(v) ? update(v) : complete(); }; });
	    };
	    Chainable.prototype.filter = function (predicate) {
	        return this.applyMiddleware(function (update, complete) { return function (v) { return predicate(v) && update(v); }; });
	    };
	    return Chainable;
	}());
	
	var Observer = (function () {
	    function Observer(_a, observer) {
	        var middleware = _a.middleware, onComplete = _a.onComplete;
	        var _this = this;
	        this.isActive = true;
	        this.update = function (v) {
	            if (_this.observer.update)
	                _this.updateObserver(v);
	        };
	        this.complete = function () {
	            if (_this.observer.complete && _this.isActive)
	                _this.observer.complete();
	            if (_this.onComplete)
	                _this.onComplete();
	            _this.isActive = false;
	        };
	        this.error = function (err) {
	            if (_this.observer.error && _this.isActive)
	                _this.observer.error(err);
	            _this.isActive = false;
	        };
	        this.observer = observer;
	        this.updateObserver = function (v) { return observer.update(v); };
	        this.onComplete = onComplete;
	        if (observer.update && middleware && middleware.length) {
	            middleware.forEach(function (m) { return _this.updateObserver = m(_this.updateObserver, _this.complete); });
	        }
	    }
	    return Observer;
	}());
	var createObserver = (function (observerCandidate, _a, onComplete) {
	    var middleware = _a.middleware;
	    if (typeof observerCandidate === 'function') {
	        return new Observer({ middleware: middleware, onComplete: onComplete }, { update: observerCandidate });
	    }
	    else {
	        return new Observer({ middleware: middleware, onComplete: onComplete }, observerCandidate);
	    }
	});
	
	var Action = (function (_super) {
	    tslib_1.__extends(Action, _super);
	    function Action() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Action.prototype.create = function (props) {
	        return new Action(props);
	    };
	    Action.prototype.start = function (observerCandidate) {
	        if (observerCandidate === void 0) { observerCandidate = {}; }
	        var isComplete = false;
	        var subscription = {
	            stop: function () { return undefined; }
	        };
	        var _a = this.props, init = _a.init, observerProps = tslib_1.__rest(_a, ["init"]);
	        var observer = createObserver(observerCandidate, observerProps, function () {
	            isComplete = true;
	            subscription.stop();
	        });
	        var api = init(observer);
	        subscription = api
	            ? tslib_1.__assign({}, subscription, api) : subscription;
	        if (observerCandidate.registerParent) {
	            observerCandidate.registerParent(subscription);
	        }
	        if (isComplete)
	            subscription.stop();
	        return subscription;
	    };
	    return Action;
	}(Chainable));
	var action = (function (init) { return new Action({ init: init }); });
	
	var BaseMulticast = (function (_super) {
	    tslib_1.__extends(BaseMulticast, _super);
	    function BaseMulticast() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.subscribers = [];
	        return _this;
	    }
	    BaseMulticast.prototype.complete = function () {
	        this.subscribers.forEach(function (subscriber) { return subscriber.complete(); });
	    };
	    BaseMulticast.prototype.error = function (err) {
	        this.subscribers.forEach(function (subscriber) { return subscriber.error(err); });
	    };
	    BaseMulticast.prototype.update = function (v) {
	        for (var i = 0; i < this.subscribers.length; i++) {
	            this.subscribers[i].update(v);
	        }
	    };
	    BaseMulticast.prototype.subscribe = function (observerCandidate) {
	        var _this = this;
	        var observer = createObserver(observerCandidate, this.props);
	        this.subscribers.push(observer);
	        var subscription = {
	            unsubscribe: function () {
	                var index = _this.subscribers.indexOf(observer);
	                if (index !== -1)
	                    _this.subscribers.splice(index, 1);
	            }
	        };
	        return subscription;
	    };
	    BaseMulticast.prototype.stop = function () {
	        if (this.parent)
	            this.parent.stop();
	    };
	    BaseMulticast.prototype.registerParent = function (subscription) {
	        this.stop();
	        this.parent = subscription;
	    };
	    return BaseMulticast;
	}(Chainable));
	
	var Multicast = (function (_super) {
	    tslib_1.__extends(Multicast, _super);
	    function Multicast() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Multicast.prototype.create = function (props) {
	        return new Multicast(props);
	    };
	    return Multicast;
	}(BaseMulticast));
	var multicast = (function () { return new Multicast(); });
	
	var isValueList = function (v) { return Array.isArray(v); };
	var isSingleValue = function (v) {
	    var typeOfV = typeof v;
	    return (typeOfV === 'string' || typeOfV === 'number');
	};
	var ValueReaction = (function (_super) {
	    tslib_1.__extends(ValueReaction, _super);
	    function ValueReaction(props) {
	        var _this = _super.call(this, props) || this;
	        _this.scheduleVelocityCheck = function () { return framesync.onFrameEnd(_this.velocityCheck); };
	        _this.velocityCheck = function () {
	            if (framesync.currentFrameTime() !== _this.lastUpdated) {
	                _this.prev = _this.current;
	            }
	        };
	        _this.prev = _this.current = props.value || 0;
	        if (isSingleValue(_this.current)) {
	            _this.updateCurrent = function (v) { return _this.current = v; };
	            _this.getVelocityOfCurrent = function () { return _this.getSingleVelocity(_this.current, _this.prev); };
	        }
	        else if (isValueList(_this.current)) {
	            _this.updateCurrent = function (v) { return _this.current = v.slice(); };
	            _this.getVelocityOfCurrent = function () { return _this.getListVelocity(); };
	        }
	        else {
	            _this.updateCurrent = function (v) {
	                _this.current = {};
	                for (var key in v) {
	                    if (v.hasOwnProperty(key)) {
	                        _this.current[key] = v[key];
	                    }
	                }
	            };
	            _this.getVelocityOfCurrent = function () { return _this.getMapVelocity(); };
	        }
	        if (props.initialSubscription)
	            _this.subscribe(props.initialSubscription);
	        return _this;
	    }
	    ValueReaction.prototype.create = function (props) {
	        return new ValueReaction(props);
	    };
	    ValueReaction.prototype.get = function () {
	        return this.current;
	    };
	    ValueReaction.prototype.getVelocity = function () {
	        return this.getVelocityOfCurrent();
	    };
	    ValueReaction.prototype.update = function (v) {
	        _super.prototype.update.call(this, v);
	        this.prev = this.current;
	        this.updateCurrent(v);
	        this.timeDelta = framesync.timeSinceLastFrame();
	        this.lastUpdated = framesync.currentFrameTime();
	        framesync.onFrameEnd(this.scheduleVelocityCheck);
	    };
	    ValueReaction.prototype.subscribe = function (observerCandidate) {
	        var sub = _super.prototype.subscribe.call(this, observerCandidate);
	        this.update(this.current);
	        return sub;
	    };
	    ValueReaction.prototype.getSingleVelocity = function (current, prev) {
	        return (typeof current === 'number' && typeof prev === 'number')
	            ? speedPerSecond(current - prev, this.timeDelta)
	            : speedPerSecond(parseFloat(current) - parseFloat(prev), this.timeDelta) || 0;
	    };
	    ValueReaction.prototype.getListVelocity = function () {
	        var _this = this;
	        return this.current.map(function (c, i) { return _this.getSingleVelocity(c, _this.prev[i]); });
	    };
	    ValueReaction.prototype.getMapVelocity = function () {
	        var velocity = {};
	        for (var key in this.current) {
	            if (this.current.hasOwnProperty(key)) {
	                velocity[key] = this.getSingleVelocity(this.current[key], this.prev[key]);
	            }
	        }
	        return velocity;
	    };
	    return ValueReaction;
	}(BaseMulticast));
	var value = (function (value, initialSubscription) { return new ValueReaction({ value: value, initialSubscription: initialSubscription }); });
	
	var multi = function (_a) {
	    var getCount = _a.getCount, getFirst = _a.getFirst, getOutput = _a.getOutput, mapApi = _a.mapApi, setProp = _a.setProp, startActions = _a.startActions;
	    return function (actions) {
	        return action(function (_a) {
	            var update = _a.update, complete = _a.complete, error = _a.error;
	            var numActions = getCount(actions);
	            var output = getOutput();
	            var updateOutput = function () { return update(output); };
	            var numCompletedActions = 0;
	            var subs = startActions(actions, function (a, name) {
	                var hasCompleted = false;
	                return a.start({
	                    complete: function () {
	                        if (!hasCompleted) {
	                            hasCompleted = true;
	                            numCompletedActions++;
	                            if (numCompletedActions === numActions)
	                                framesync.onFrameUpdate(complete);
	                        }
	                    },
	                    error: error,
	                    update: function (v) {
	                        setProp(output, name, v);
	                        framesync.onFrameUpdate(updateOutput, true);
	                    }
	                });
	            });
	            return Object.keys(getFirst(subs)).reduce(function (api, methodName) {
	                api[methodName] = mapApi(subs, methodName);
	                return api;
	            }, {});
	        });
	    };
	};
	
	var composite = multi({
	    getOutput: function () { return ({}); },
	    getCount: function (subs) { return Object.keys(subs).length; },
	    getFirst: function (subs) { return subs[Object.keys(subs)[0]]; },
	    mapApi: function (subs, methodName) { return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return Object.keys(subs)
	            .reduce(function (output, propKey) {
	            if (subs[propKey][methodName]) {
	                (args[0] && args[0][propKey] !== undefined)
	                    ? output[propKey] = subs[propKey][methodName](args[0][propKey])
	                    : output[propKey] = (_a = subs[propKey])[methodName].apply(_a, args);
	            }
	            return output;
	            var _a;
	        }, {});
	    }; },
	    setProp: function (output, name, v) { return output[name] = v; },
	    startActions: function (actions, starter) { return Object.keys(actions)
	        .reduce(function (subs, key) {
	        subs[key] = starter(actions[key], key);
	        return subs;
	    }, {}); }
	});
	
	var parallel = multi({
	    getOutput: function () { return ([]); },
	    getCount: function (subs) { return subs.length; },
	    getFirst: function (subs) { return subs[0]; },
	    mapApi: function (subs, methodName) { return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return subs.map(function (sub, i) {
	            if (sub[methodName]) {
	                return Array.isArray(args[0])
	                    ? sub[methodName](args[0][i])
	                    : sub[methodName].apply(sub, args);
	            }
	        });
	    }; },
	    setProp: function (output, name, v) { return output[name] = v; },
	    startActions: function (actions, starter) { return actions.map(function (action, i) { return starter(action, i); }); }
	});
	var parallel$1 = (function () {
	    var actions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        actions[_i] = arguments[_i];
	    }
	    return parallel(actions);
	});
	
	var createVectorTests = function (typeTests) {
	    var testNames = Object.keys(typeTests);
	    var isVectorProp = function (prop, key) {
	        return prop !== undefined && !typeTests[key](prop);
	    };
	    var getVectorKeys = function (props) {
	        return testNames.reduce(function (vectorKeys, key) {
	            if (isVectorProp(props[key], key))
	                vectorKeys.push(key);
	            return vectorKeys;
	        }, []);
	    };
	    var testVectorProps = function (props) {
	        return props &&
	            testNames.reduce(function (isVector, key) { return isVector || isVectorProp(props[key], key); }, false);
	    };
	    return { getVectorKeys: getVectorKeys, testVectorProps: testVectorProps };
	};
	var unitTypes = [styleValueTypes.px, styleValueTypes.percent, styleValueTypes.degrees, styleValueTypes.vh, styleValueTypes.vw];
	var findUnitType = function (prop) { return unitTypes.find(function (type) { return type.test(prop); }); };
	var isUnitProp = function (prop) { return Boolean(findUnitType(prop)); };
	var createAction = function (action, props) { return action(props); };
	var reduceArrayValue = function (i) { return function (props, key) {
	    props[key] = props[key][i];
	    return props;
	}; };
	var createArrayAction = function (action, props, vectorKeys) {
	    var firstVectorKey = vectorKeys[0];
	    var actionList = props[firstVectorKey].map(function (v, i) {
	        var childActionProps = vectorKeys.reduce(reduceArrayValue(i), tslib_1.__assign({}, props));
	        return getActionCreator(v)(action, childActionProps);
	    });
	    return parallel$1.apply(void 0, actionList);
	};
	var reduceObjectValue = function (key) { return function (props, propKey) {
	    props[propKey] = props[propKey][key];
	    return props;
	}; };
	var createObjectAction = function (action, props, vectorKeys) {
	    var firstVectorKey = vectorKeys[0];
	    var actionMap = Object.keys(props[firstVectorKey]).reduce(function (map, key) {
	        var childActionProps = vectorKeys.reduce(reduceObjectValue(key), tslib_1.__assign({}, props));
	        map[key] = getActionCreator(props[firstVectorKey][key])(action, childActionProps);
	        return map;
	    }, {});
	    return composite(actionMap);
	};
	var createUnitAction = function (action, _a) {
	    var from = _a.from, to = _a.to, props = tslib_1.__rest(_a, ["from", "to"]);
	    var unitType = findUnitType(from) || findUnitType(to);
	    var transform = unitType.transform, parse = unitType.parse;
	    return action(tslib_1.__assign({}, props, { from: typeof from === 'string' ? parse(from) : from, to: typeof to === 'string' ? parse(to) : to })).pipe(transform);
	};
	var createColorAction = function (action, _a) {
	    var from = _a.from, to = _a.to, props = tslib_1.__rest(_a, ["from", "to"]);
	    return action(tslib_1.__assign({}, props, { from: 0, to: 1 })).pipe(blendColor(from, to), styleValueTypes.color.transform);
	};
	var createComplexAction = function (action, _a) {
	    var from = _a.from, to = _a.to, props = tslib_1.__rest(_a, ["from", "to"]);
	    var valueTemplate = styleValueTypes.complex.createTransformer(from);
	    heyListen.invariant(valueTemplate(from) === styleValueTypes.complex.createTransformer(to)(from), "Values '" + from + "' and '" + to + "' are of different format, or a value might have changed value type.");
	    return action(tslib_1.__assign({}, props, { from: 0, to: 1 })).pipe(blendArray(styleValueTypes.complex.parse(from), styleValueTypes.complex.parse(to)), valueTemplate);
	};
	var createVectorAction = function (action, typeTests) {
	    var _a = createVectorTests(typeTests), testVectorProps = _a.testVectorProps, getVectorKeys = _a.getVectorKeys;
	    var vectorAction = function (props) {
	        var isVector = testVectorProps(props);
	        if (!isVector)
	            return action(props);
	        var vectorKeys = getVectorKeys(props);
	        var testKey = vectorKeys[0];
	        var testProp = props[testKey];
	        return getActionCreator(testProp)(action, props, vectorKeys);
	    };
	    return vectorAction;
	};
	var getActionCreator = function (prop) {
	    var actionCreator = createAction;
	    if (typeof prop === 'number') {
	        actionCreator = createAction;
	    }
	    else if (Array.isArray(prop)) {
	        actionCreator = createArrayAction;
	    }
	    else if (isUnitProp(prop)) {
	        actionCreator = createUnitAction;
	    }
	    else if (styleValueTypes.color.test(prop)) {
	        actionCreator = createColorAction;
	    }
	    else if (styleValueTypes.complex.test(prop)) {
	        actionCreator = createComplexAction;
	    }
	    else if (typeof prop === 'object') {
	        actionCreator = createObjectAction;
	    }
	    return actionCreator;
	};
	
	var frame = function () { return action(function (_a) {
	    var update = _a.update;
	    var isActive = true;
	    var startTime = framesync.currentTime();
	    var nextFrame = function () {
	        if (!isActive)
	            return;
	        update(Math.max(framesync.currentFrameTime() - startTime, 0));
	        framesync.onFrameUpdate(nextFrame);
	    };
	    framesync.onFrameUpdate(nextFrame);
	    return {
	        stop: function () { return isActive = false; }
	    };
	}); };
	
	var decay = function (props) {
	    if (props === void 0) { props = {}; }
	    return action(function (_a) {
	        var complete = _a.complete, update = _a.update;
	        var _b = props.velocity, velocity = _b === void 0 ? 0 : _b, _c = props.from, from = _c === void 0 ? 0 : _c, _d = props.power, power = _d === void 0 ? 0.8 : _d, _e = props.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = props.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = props.modifyTarget;
	        var elapsed = 0;
	        var amplitude = power * velocity;
	        var idealTarget = Math.round(from + amplitude);
	        var target = typeof modifyTarget === 'undefined'
	            ? idealTarget
	            : modifyTarget(idealTarget);
	        var timer = frame().start(function () {
	            elapsed += framesync.timeSinceLastFrame();
	            var delta = -amplitude * Math.exp(-elapsed / timeConstant);
	            var isMoving = delta > restDelta || delta < -restDelta;
	            var current = isMoving ? target + delta : target;
	            update(current);
	            if (!isMoving) {
	                timer.stop();
	                complete();
	            }
	        });
	        return {
	            stop: function () { return timer.stop(); }
	        };
	    });
	};
	var vectorDecay = createVectorAction(decay, {
	    from: styleValueTypes.number.test,
	    modifyTarget: function (func) { return typeof func === 'function'; },
	    velocity: styleValueTypes.number.test
	});
	
	var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
	var createReversedEasing = function (easing) {
	    return function (p) { return 1 - easing(1 - p); };
	};
	var createMirroredEasing = function (easing) {
	    return function (p) { return (p <= 0.5) ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2; };
	};
	var linear = function (p) { return p; };
	var createExpoIn = function (power) { return function (p) { return Math.pow(p, power); }; };
	var easeIn = createExpoIn(2);
	var easeOut = createReversedEasing(easeIn);
	var easeInOut = createMirroredEasing(easeIn);
	var circIn = function (p) { return 1 - Math.sin(Math.acos(p)); };
	var circOut = createReversedEasing(circIn);
	var circInOut = createMirroredEasing(circOut);
	var createBackIn = function (power) { return function (p) { return (p * p) * ((power + 1) * p - power); }; };
	var backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
	var backOut = createReversedEasing(backIn);
	var backInOut = createMirroredEasing(backIn);
	var createAnticipateEasing = function (power) {
	    var backEasing = createBackIn(power);
	    return function (p) { return ((p *= 2) < 1) ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1))); };
	};
	var anticipate = createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
	var NEWTON_ITERATIONS = 8;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	var K_SPLINE_TABLE_SIZE = 11;
	var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
	var FLOAT_32_SUPPORTED = (typeof Float32Array !== 'undefined');
	var a = function (a1, a2) { return 1.0 - 3.0 * a2 + 3.0 * a1; };
	var b = function (a1, a2) { return 3.0 * a2 - 6.0 * a1; };
	var c = function (a1) { return 3.0 * a1; };
	var getSlope = function (t, a1, a2) { return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1); };
	var calcBezier = function (t, a1, a2) { return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t; };
	function cubicBezier(mX1, mY1, mX2, mY2) {
	    var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);
	    var _precomputed = false;
	    var binarySubdivide = function (aX, aA, aB) {
	        var i = 0;
	        var currentX;
	        var currentT;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            }
	            else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    };
	    var newtonRaphsonIterate = function (aX, aGuessT) {
	        var i = 0;
	        var currentSlope = 0;
	        var currentX;
	        for (; i < NEWTON_ITERATIONS; ++i) {
	            currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) {
	                return aGuessT;
	            }
	            currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    };
	    var calcSampleValues = function () {
	        for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
	            sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
	        }
	    };
	    var getTForX = function (aX) {
	        var intervalStart = 0.0;
	        var currentSample = 1;
	        var lastSample = K_SPLINE_TABLE_SIZE - 1;
	        var dist = 0.0;
	        var guessForT = 0.0;
	        var initialSlope = 0.0;
	        for (; currentSample != lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	            intervalStart += K_SAMPLE_STEP_SIZE;
	        }
	        --currentSample;
	        dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	        guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
	        initialSlope = getSlope(guessForT, mX1, mX2);
	        if (initialSlope >= NEWTON_MIN_SLOPE) {
	            return newtonRaphsonIterate(aX, guessForT);
	        }
	        else if (initialSlope === 0.0) {
	            return guessForT;
	        }
	        else {
	            return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
	        }
	    };
	    var precompute = function () {
	        _precomputed = true;
	        if (mX1 != mY1 || mX2 != mY2) {
	            calcSampleValues();
	        }
	    };
	    var resolver = function (aX) {
	        var returnValue;
	        if (!_precomputed) {
	            precompute();
	        }
	        if (mX1 === mY1 && mX2 === mY2) {
	            returnValue = aX;
	        }
	        else if (aX === 0) {
	            returnValue = 0;
	        }
	        else if (aX === 1) {
	            returnValue = 1;
	        }
	        else {
	            returnValue = calcBezier(getTForX(aX), mY1, mY2);
	        }
	        return returnValue;
	    };
	    return resolver;
	}
	
	var easing = /*#__PURE__*/Object.freeze({
	  createReversedEasing: createReversedEasing,
	  createMirroredEasing: createMirroredEasing,
	  linear: linear,
	  createExpoIn: createExpoIn,
	  easeIn: easeIn,
	  easeOut: easeOut,
	  easeInOut: easeInOut,
	  circIn: circIn,
	  circOut: circOut,
	  circInOut: circInOut,
	  createBackIn: createBackIn,
	  backIn: backIn,
	  backOut: backOut,
	  backInOut: backInOut,
	  createAnticipateEasing: createAnticipateEasing,
	  anticipate: anticipate,
	  cubicBezier: cubicBezier
	});
	
	var scrubber = function (_a) {
	    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, _d = _a.ease, ease = _d === void 0 ? linear : _d;
	    return action(function (_a) {
	        var update = _a.update;
	        return ({
	            seek: function (progress) { return update(progress); }
	        });
	    }).pipe(ease, function (v) { return getValueFromProgress(from, to, v); });
	};
	var vectorScrubber = createVectorAction(scrubber, {
	    ease: function (func) { return typeof func === 'function'; },
	    from: styleValueTypes.number.test,
	    to: styleValueTypes.number.test
	});
	
	var clampProgress = clamp(0, 1);
	var tween = function (props) {
	    if (props === void 0) { props = {}; }
	    return action(function (_a) {
	        var update = _a.update, complete = _a.complete;
	        var _b = props.duration, duration = _b === void 0 ? 300 : _b, _c = props.ease, ease = _c === void 0 ? easeOut : _c, _d = props.flip, flip = _d === void 0 ? 0 : _d, _e = props.loop, loop = _e === void 0 ? 0 : _e, _f = props.yoyo, yoyo = _f === void 0 ? 0 : _f;
	        var _g = props.from, from = _g === void 0 ? 0 : _g, _h = props.to, to = _h === void 0 ? 1 : _h, _j = props.elapsed, elapsed = _j === void 0 ? 0 : _j, _k = props.playDirection, playDirection = _k === void 0 ? 1 : _k, _l = props.flipCount, flipCount = _l === void 0 ? 0 : _l, _m = props.yoyoCount, yoyoCount = _m === void 0 ? 0 : _m, _o = props.loopCount, loopCount = _o === void 0 ? 0 : _o;
	        var playhead = vectorScrubber({ from: from, to: to, ease: ease }).start(update);
	        var progress = 0;
	        var tweenTimer;
	        var isActive = false;
	        var reverseTween = function () { return playDirection *= -1; };
	        var isTweenComplete = function () {
	            var isComplete = (playDirection === 1)
	                ? isActive && elapsed >= duration
	                : isActive && elapsed <= 0;
	            if (!isComplete)
	                return false;
	            if (isComplete && !loop && !flip && !yoyo)
	                return true;
	            var isStepTaken = false;
	            if (loop && loopCount < loop) {
	                elapsed = 0;
	                loopCount++;
	                isStepTaken = true;
	            }
	            else if (flip && flipCount < flip) {
	                elapsed = duration - elapsed;
	                _a = [to, from], from = _a[0], to = _a[1];
	                playhead = vectorScrubber({ from: from, to: to, ease: ease }).start(update);
	                flipCount++;
	                isStepTaken = true;
	            }
	            else if (yoyo && yoyoCount < yoyo) {
	                reverseTween();
	                yoyoCount++;
	                isStepTaken = true;
	            }
	            return !isStepTaken;
	            var _a;
	        };
	        var updateTween = function () {
	            progress = clampProgress(getProgressFromValue(0, duration, elapsed));
	            playhead.seek(progress);
	        };
	        var startTimer = function () {
	            isActive = true;
	            tweenTimer = frame().start(function () {
	                elapsed += framesync.timeSinceLastFrame() * playDirection;
	                updateTween();
	                if (isTweenComplete() && complete) {
	                    tweenTimer.stop();
	                    framesync.onFrameUpdate(complete, true);
	                }
	            });
	        };
	        var stopTimer = function () {
	            isActive = false;
	            if (tweenTimer)
	                tweenTimer.stop();
	        };
	        startTimer();
	        return {
	            isActive: function () { return isActive; },
	            getElapsed: function () { return clamp(0, duration)(elapsed); },
	            getProgress: function () { return progress; },
	            stop: function () {
	                stopTimer();
	            },
	            pause: function () {
	                stopTimer();
	                return this;
	            },
	            resume: function () {
	                startTimer();
	                return this;
	            },
	            seek: function (newProgress) {
	                elapsed = getValueFromProgress(0, duration, newProgress);
	                framesync.onFrameUpdate(updateTween, true);
	                return this;
	            },
	            reverse: function () {
	                reverseTween();
	                return this;
	            }
	        };
	    });
	};
	
	var clampProgress$1 = clamp(0, 1);
	var defaultEasings = function (values, easing) {
	    return values.map(function () { return easing || easeOut; }).splice(0, values.length - 1);
	};
	var defaultTimings = function (values) {
	    var numValues = values.length;
	    return values.map(function (value, i) { return (i !== 0) ? i / (numValues - 1) : 0; });
	};
	var interpolateScrubbers = function (input, scrubbers, update) {
	    var rangeLength = input.length;
	    var finalInputIndex = rangeLength - 1;
	    var finalScrubberIndex = finalInputIndex - 1;
	    var subs = scrubbers.map(function (scrub) { return scrub.start(update); });
	    return function (v) {
	        if (v <= input[0]) {
	            subs[0].seek(0);
	        }
	        if (v >= input[finalInputIndex]) {
	            subs[finalScrubberIndex].seek(1);
	        }
	        var i = 1;
	        for (; i < rangeLength; i++) {
	            if (input[i] > v || i === finalInputIndex)
	                break;
	        }
	        var progressInRange = getProgressFromValue(input[i - 1], input[i], v);
	        subs[i - 1].seek(clampProgress$1(progressInRange));
	    };
	};
	var keyframes = function (_a) {
	    var easings = _a.easings, _b = _a.ease, ease = _b === void 0 ? linear : _b, times = _a.times, values = _a.values, tweenProps = tslib_1.__rest(_a, ["easings", "ease", "times", "values"]);
	    easings = Array.isArray(easings)
	        ? easings
	        : defaultEasings(values, easings);
	    times = times || defaultTimings(values);
	    var scrubbers = easings.map(function (easing, i) { return vectorScrubber({
	        from: values[i],
	        to: values[i + 1],
	        ease: easing
	    }); });
	    return tween(tslib_1.__assign({}, tweenProps, { ease: ease })).applyMiddleware(function (update) { return interpolateScrubbers(times, scrubbers, update); });
	};
	
	var physics = function (props) {
	    if (props === void 0) { props = {}; }
	    return action(function (_a) {
	        var complete = _a.complete, update = _a.update;
	        var _b = props.acceleration, acceleration = _b === void 0 ? 0 : _b, _c = props.friction, friction = _c === void 0 ? 0 : _c, _d = props.velocity, velocity = _d === void 0 ? 0 : _d, springStrength = props.springStrength, to = props.to;
	        var _e = props.restSpeed, restSpeed = _e === void 0 ? 0.001 : _e, _f = props.from, from = _f === void 0 ? 0 : _f;
	        var current = from;
	        var timer = frame().start(function () {
	            var elapsed = Math.max(framesync.timeSinceLastFrame(), 16);
	            if (acceleration)
	                velocity += speedPerFrame(acceleration, elapsed);
	            if (friction)
	                velocity *= Math.pow((1 - friction), (elapsed / 100));
	            if (springStrength !== undefined && to !== undefined) {
	                var distanceToTarget = to - current;
	                velocity += distanceToTarget * speedPerFrame(springStrength, elapsed);
	            }
	            current += speedPerFrame(velocity, elapsed);
	            update(current);
	            var isComplete = restSpeed !== false && (!velocity || Math.abs(velocity) <= restSpeed);
	            if (isComplete) {
	                timer.stop();
	                complete();
	            }
	        });
	        return {
	            set: function (v) {
	                current = v;
	                return this;
	            },
	            setAcceleration: function (v) {
	                acceleration = v;
	                return this;
	            },
	            setFriction: function (v) {
	                friction = v;
	                return this;
	            },
	            setSpringStrength: function (v) {
	                springStrength = v;
	                return this;
	            },
	            setSpringTarget: function (v) {
	                to = v;
	                return this;
	            },
	            setVelocity: function (v) {
	                velocity = v;
	                return this;
	            },
	            stop: function () { return timer.stop(); }
	        };
	    });
	};
	var vectorPhysics = createVectorAction(physics, {
	    acceleration: styleValueTypes.number.test,
	    friction: styleValueTypes.number.test,
	    velocity: styleValueTypes.number.test,
	    from: styleValueTypes.number.test,
	    to: styleValueTypes.number.test,
	    springStrength: styleValueTypes.number.test
	});
	
	var spring = function (props) {
	    if (props === void 0) { props = {}; }
	    return action(function (_a) {
	        var update = _a.update, complete = _a.complete;
	        var _b = props.velocity, velocity = _b === void 0 ? 0.0 : _b;
	        var _c = props.from, from = _c === void 0 ? 0.0 : _c, _d = props.to, to = _d === void 0 ? 0.0 : _d, _e = props.stiffness, stiffness = _e === void 0 ? 100 : _e, _f = props.damping, damping = _f === void 0 ? 10 : _f, _g = props.mass, mass = _g === void 0 ? 1.0 : _g, _h = props.restSpeed, restSpeed = _h === void 0 ? 0.01 : _h, _j = props.restDelta, restDelta = _j === void 0 ? 0.01 : _j;
	        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
	        var t = 0;
	        var delta = to - from;
	        var position = from;
	        var prevPosition = position;
	        var springTimer = frame().start(function () {
	            var timeDelta = framesync.timeSinceLastFrame();
	            t += timeDelta;
	            var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
	            var angularFreq = Math.sqrt(stiffness / mass) / 1000;
	            prevPosition = position;
	            if (dampingRatio < 1) {
	                var envelope = Math.exp(-dampingRatio * angularFreq * t);
	                var expoDecay = angularFreq * Math.sqrt(1.0 - dampingRatio * dampingRatio);
	                position =
	                    to -
	                        envelope *
	                            (((initialVelocity + dampingRatio * angularFreq * delta) /
	                                expoDecay) *
	                                Math.sin(expoDecay * t) +
	                                delta * Math.cos(expoDecay * t));
	            }
	            else {
	                var envelope = Math.exp(-angularFreq * t);
	                position =
	                    to -
	                        envelope * (delta + (initialVelocity + angularFreq * delta) * t);
	            }
	            velocity = speedPerSecond(position - prevPosition, timeDelta);
	            var isBelowVelocityThreshold = Math.abs(velocity) <= restSpeed;
	            var isBelowDisplacementThreshold = Math.abs(to - position) <= restDelta;
	            if (isBelowVelocityThreshold && isBelowDisplacementThreshold) {
	                position = to;
	                update(position);
	                springTimer.stop();
	                complete();
	            }
	            else {
	                update(position);
	            }
	        });
	        return {
	            stop: function () { return springTimer.stop(); }
	        };
	    });
	};
	var vectorSpring = createVectorAction(spring, {
	    from: styleValueTypes.number.test,
	    to: styleValueTypes.number.test,
	    stiffness: styleValueTypes.number.test,
	    damping: styleValueTypes.number.test,
	    mass: styleValueTypes.number.test,
	    velocity: styleValueTypes.number.test
	});
	
	var DEFAULT_DURATION = 300;
	var flattenTimings = function (instructions) {
	    var flatInstructions = [];
	    var lastArg = instructions[instructions.length - 1];
	    var isStaggered = typeof lastArg === 'number';
	    var staggerDelay = isStaggered ? lastArg : 0;
	    var segments = isStaggered ? instructions.slice(0, -1) : instructions;
	    var numSegments = segments.length;
	    var offset = 0;
	    segments.forEach(function (item, i) {
	        flatInstructions.push(item);
	        if (i !== numSegments - 1) {
	            var duration = item.duration || DEFAULT_DURATION;
	            offset += staggerDelay;
	            flatInstructions.push("-" + (duration - offset));
	        }
	    });
	    return flatInstructions;
	};
	var flattenArrayInstructions = function (instructions, instruction) {
	    Array.isArray(instruction)
	        ? instructions.push.apply(instructions, flattenTimings(instruction)) : instructions.push(instruction);
	    return instructions;
	};
	var convertDefToProps = function (props, def, i) {
	    var duration = props.duration, easings = props.easings, times = props.times, values = props.values;
	    var numValues = values.length;
	    var prevTimeTo = times[numValues - 1];
	    var timeFrom = def.at === 0 ? 0 : def.at / duration;
	    var timeTo = (def.at + def.duration) / duration;
	    if (i === 0) {
	        values.push(def.from);
	        times.push(timeFrom);
	    }
	    else {
	        if (prevTimeTo !== timeFrom) {
	            if (def.from !== undefined) {
	                values.push(values[numValues - 1]);
	                times.push(timeFrom);
	                easings.push(linear);
	            }
	            var from = def.from !== undefined ? def.from : values[numValues - 1];
	            values.push(from);
	            times.push(timeFrom);
	            easings.push(linear);
	        }
	        else if (def.from !== undefined) {
	            values.push(def.from);
	            times.push(timeFrom);
	            easings.push(linear);
	        }
	    }
	    values.push(def.to);
	    times.push(timeTo);
	    easings.push(def.ease || easeInOut);
	    return props;
	};
	var timeline = function (instructions, _a) {
	    var _b = _a === void 0 ? {} : _a, duration = _b.duration, elapsed = _b.elapsed, ease = _b.ease, loop = _b.loop, flip = _b.flip, yoyo = _b.yoyo;
	    var playhead = 0;
	    var calculatedDuration = 0;
	    var flatInstructions = instructions.reduce(flattenArrayInstructions, []);
	    var animationDefs = [];
	    flatInstructions.forEach(function (instruction) {
	        if (typeof instruction === 'string') {
	            playhead += parseFloat(instruction);
	        }
	        else if (typeof instruction === 'number') {
	            playhead = instruction;
	        }
	        else {
	            var def = tslib_1.__assign({}, instruction, { at: playhead });
	            def.duration = def.duration === undefined ? DEFAULT_DURATION : def.duration;
	            animationDefs.push(def);
	            playhead += def.duration;
	            calculatedDuration = Math.max(calculatedDuration, def.at + def.duration);
	        }
	    });
	    var tracks = {};
	    var numDefs = animationDefs.length;
	    for (var i = 0; i < numDefs; i++) {
	        var def = animationDefs[i];
	        var track = def.track;
	        if (track === undefined) {
	            throw new Error('No track defined');
	        }
	        if (!tracks.hasOwnProperty(track))
	            tracks[track] = [];
	        tracks[track].push(def);
	    }
	    var trackKeyframes = {};
	    for (var key in tracks) {
	        if (tracks.hasOwnProperty(key)) {
	            var keyframeProps = tracks[key].reduce(convertDefToProps, {
	                duration: calculatedDuration,
	                easings: [],
	                times: [],
	                values: []
	            });
	            trackKeyframes[key] = keyframes(tslib_1.__assign({}, keyframeProps, { duration: duration || calculatedDuration, ease: ease,
	                elapsed: elapsed,
	                loop: loop,
	                yoyo: yoyo,
	                flip: flip }));
	        }
	    }
	    return composite(trackKeyframes);
	};
	
	var listen = function (element, events, options) { return action(function (_a) {
	    var update = _a.update;
	    var eventNames = events.split(' ').map(function (eventName) {
	        element.addEventListener(eventName, update, options);
	        return eventName;
	    });
	    return {
	        stop: function () { return eventNames.forEach(function (eventName) { return element.removeEventListener(eventName, update, options); }); }
	    };
	}); };
	
	var defaultPointerPos = function () { return ({
	    clientX: 0,
	    clientY: 0,
	    pageX: 0,
	    pageY: 0,
	    x: 0,
	    y: 0
	}); };
	var eventToPoint = function (e, point) {
	    if (point === void 0) { point = defaultPointerPos(); }
	    point.clientX = point.x = e.clientX;
	    point.clientY = point.y = e.clientY;
	    point.pageX = e.pageX;
	    point.pageY = e.pageY;
	    return point;
	};
	
	var points = [defaultPointerPos()];
	var isTouchDevice = false;
	if (typeof document !== 'undefined') {
	    var updatePointsLocation = function (_a) {
	        var touches = _a.touches;
	        isTouchDevice = true;
	        var numTouches = touches.length;
	        points.length = 0;
	        for (var i = 0; i < numTouches; i++) {
	            var thisTouch = touches[i];
	            points.push(eventToPoint(thisTouch));
	        }
	    };
	    listen(document, 'touchstart touchmove', true)
	        .start(updatePointsLocation);
	}
	var multitouch = function (_a) {
	    var _b = _a === void 0 ? {} : _a, _c = _b.preventDefault, preventDefault = _c === void 0 ? true : _c, _d = _b.scale, scale = _d === void 0 ? 1.0 : _d, _e = _b.rotate, rotate = _e === void 0 ? 0.0 : _e;
	    return action(function (_a) {
	        var update = _a.update;
	        var output = {
	            touches: points,
	            scale: scale,
	            rotate: rotate
	        };
	        var initialDistance = 0.0;
	        var initialRotation = 0.0;
	        var isGesture = points.length > 1;
	        if (isGesture) {
	            var firstTouch = points[0], secondTouch = points[1];
	            initialDistance = distance(firstTouch, secondTouch);
	            initialRotation = angle(firstTouch, secondTouch);
	        }
	        var updatePoint = function () {
	            if (isGesture) {
	                var firstTouch = points[0], secondTouch = points[1];
	                var newDistance = distance(firstTouch, secondTouch);
	                var newRotation = angle(firstTouch, secondTouch);
	                output.scale = scale * (newDistance / initialDistance);
	                output.rotate = rotate + (newRotation - initialRotation);
	            }
	            update(output);
	        };
	        var onMove = function (e) {
	            if (preventDefault || e.touches.length > 1)
	                e.preventDefault();
	            framesync.onFrameUpdate(updatePoint);
	        };
	        var updateOnMove = listen(document, 'touchmove', { passive: !preventDefault })
	            .start(onMove);
	        if (isTouchDevice)
	            framesync.onFrameUpdate(updatePoint);
	        return {
	            stop: function () {
	                framesync.cancelOnFrameUpdate(updatePoint);
	                updateOnMove.stop();
	            }
	        };
	    });
	};
	var getIsTouchDevice = function () { return isTouchDevice; };
	
	var point = defaultPointerPos();
	var isMouseDevice = false;
	if (typeof document !== 'undefined') {
	    var updatePointLocation = function (e) {
	        isMouseDevice = true;
	        eventToPoint(e, point);
	    };
	    listen(document, 'mousedown mousemove', true)
	        .start(updatePointLocation);
	}
	var mouse = function (_a) {
	    var _b = (_a === void 0 ? {} : _a).preventDefault, preventDefault = _b === void 0 ? true : _b;
	    return action(function (_a) {
	        var update = _a.update;
	        var updatePoint = function () { return update(point); };
	        var onMove = function (e) {
	            if (preventDefault)
	                e.preventDefault();
	            framesync.onFrameUpdate(updatePoint);
	        };
	        var updateOnMove = listen(document, 'mousemove').start(onMove);
	        if (isMouseDevice)
	            framesync.onFrameUpdate(updatePoint);
	        return {
	            stop: function () {
	                framesync.cancelOnFrameUpdate(updatePoint);
	                updateOnMove.stop();
	            }
	        };
	    });
	};
	
	var getFirstTouch = function (_a) {
	    var firstTouch = _a[0];
	    return firstTouch;
	};
	var pointer = function (props) {
	    if (props === void 0) { props = {}; }
	    return getIsTouchDevice()
	        ? multitouch(props).pipe(function (_a) {
	            var touches = _a.touches;
	            return touches;
	        }, getFirstTouch)
	        : mouse(props);
	};
	var index = (function (_a) {
	    if (_a === void 0) { _a = {}; }
	    var x = _a.x, y = _a.y, props = tslib_1.__rest(_a, ["x", "y"]);
	    if (x !== undefined || y !== undefined) {
	        var applyXOffset_1 = applyOffset(x || 0);
	        var applyYOffset_1 = applyOffset(y || 0);
	        var delta_1 = { x: 0, y: 0 };
	        return pointer(props).pipe(function (point) {
	            delta_1.x = applyXOffset_1(point.x);
	            delta_1.y = applyYOffset_1(point.y);
	            return delta_1;
	        });
	    }
	    else {
	        return pointer(props);
	    }
	});
	
	var chain = function () {
	    var actions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        actions[_i] = arguments[_i];
	    }
	    return action(function (_a) {
	        var update = _a.update, complete = _a.complete;
	        var i = 0;
	        var current;
	        var playCurrent = function () {
	            current = actions[i].start({
	                complete: function () {
	                    i++;
	                    (i >= actions.length) ? complete() : playCurrent();
	                },
	                update: update
	            });
	        };
	        playCurrent();
	        return {
	            stop: function () { return current && current.stop(); }
	        };
	    });
	};
	
	var crossfade = function (a, b) { return action(function (observer) {
	    var balance = 0;
	    var fadable = parallel$1(a, b).start(tslib_1.__assign({}, observer, { update: function (_a) {
	            var va = _a[0], vb = _a[1];
	            observer.update(getValueFromProgress(va, vb, balance));
	        } }));
	    return {
	        setBalance: function (v) { return balance = v; },
	        stop: function () { return fadable.stop(); }
	    };
	}); };
	
	var delay = function (timeToDelay) { return action(function (_a) {
	    var complete = _a.complete;
	    var timeout = setTimeout(complete, timeToDelay);
	    return {
	        stop: function () { return clearTimeout(timeout); }
	    };
	}); };
	
	var merge = function () {
	    var actions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        actions[_i] = arguments[_i];
	    }
	    return action(function (observer) {
	        var subs = actions.map(function (thisAction) { return thisAction.start(observer); });
	        return {
	            stop: function () { return subs.forEach(function (sub) { return sub.stop(); }); }
	        };
	    });
	};
	
	var schedule = function (scheduler, schedulee) { return action(function (_a) {
	    var update = _a.update, complete = _a.complete;
	    var latest;
	    var schedulerSub = scheduler.start({
	        update: function () { return latest !== undefined && update(latest); },
	        complete: complete
	    });
	    var scheduleeSub = schedulee.start({
	        update: function (v) { return latest = v; },
	        complete: complete
	    });
	    return {
	        stop: function () {
	            schedulerSub.stop();
	            scheduleeSub.stop();
	        }
	    };
	}); };
	
	var stagger = function (actions, interval) {
	    var intervalIsNumber = typeof interval === 'number';
	    var actionsWithDelay = actions.map(function (a, i) {
	        var timeToDelay = intervalIsNumber ? interval * i : interval(i);
	        return chain(delay(timeToDelay), a);
	    });
	    return parallel$1.apply(void 0, actionsWithDelay);
	};
	
	var css = function (element, props) {
	    heyListen.warning(false, 'css() is deprecated, use styler instead');
	    return styler(element, props);
	};
	var svg = function (element, props) {
	    heyListen.warning(false, 'svg() is deprecated, use styler instead');
	    return styler(element, props);
	};
	
	exports.valueTypes = styleValueTypes;
	exports.styler = styler;
	exports.action = action;
	exports.multicast = multicast;
	exports.value = value;
	exports.decay = vectorDecay;
	exports.keyframes = keyframes;
	exports.everyFrame = frame;
	exports.physics = vectorPhysics;
	exports.spring = vectorSpring;
	exports.timeline = timeline;
	exports.tween = tween;
	exports.listen = listen;
	exports.pointer = index;
	exports.mouse = mouse;
	exports.multitouch = multitouch;
	exports.chain = chain;
	exports.composite = composite;
	exports.crossfade = crossfade;
	exports.delay = delay;
	exports.merge = merge;
	exports.parallel = parallel$1;
	exports.schedule = schedule;
	exports.stagger = stagger;
	exports.calc = calc;
	exports.easing = easing;
	exports.transform = transformers;
	exports.css = css;
	exports.svg = svg;
	exports.Action = Action;
	exports.ValueReaction = ValueReaction;


/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(67);
	
	var _HOMEPAGEWANCLOUDSLOGOGCFOOTER = __webpack_require__(133);
	
	var _HOMEPAGEWANCLOUDSLOGOGCFOOTER2 = _interopRequireDefault(_HOMEPAGEWANCLOUDSLOGOGCFOOTER);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	    var siteTitle = _ref.siteTitle,
	        color = _ref.color;
	    return _react2.default.createElement(
	        'div',
	        { className: 'footer' },
	        _react2.default.createElement(
	            'p',
	            { style: color === "dark" ? { color: 'black' } : { color: 'white' } },
	            'Copyright \xA9 2018 GC CREATIVE All Rights Reserved'
	        ),
	        _react2.default.createElement('img', { className: 'footer-logo', src: _HOMEPAGEWANCLOUDSLOGOGCFOOTER2.default, alt: 'home' })
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(64);
	var isArguments = __webpack_require__(63);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// ┌────────────────────────────────────────────────────────────┐ \\
	// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
	// ├────────────────────────────────────────────────────────────┤ \\
	// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
	// └────────────────────────────────────────────────────────────┘ \\
	
	(function (glob) {
	    var version = "0.5.4",
	        has = "hasOwnProperty",
	        separator = /[\.\/]/,
	        comaseparator = /\s*,\s*/,
	        wildcard = "*",
	        numsort = function (a, b) {
	            return a - b;
	        },
	        current_event,
	        stop,
	        events = {n: {}},
	        firstDefined = function () {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        lastDefined = function () {
	            var i = this.length;
	            while (--i) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        objtos = Object.prototype.toString,
	        Str = String,
	        isArray = Array.isArray || function (ar) {
	            return ar instanceof Array || objtos.call(ar) == "[object Array]";
	        },
	    /*\
	     * eve
	     [ method ]
	
	     * Fires event with given `name`, given scope and other parameters.
	
	     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
	     - scope (object) context for the event handlers
	     - varargs (...) the rest of arguments will be sent to event handlers
	
	     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
	    \*/
	        eve = function (name, scope) {
	            var oldstop = stop,
	                args = Array.prototype.slice.call(arguments, 2),
	                listeners = eve.listeners(name),
	                z = 0,
	                l,
	                indexed = [],
	                queue = {},
	                out = [],
	                ce = current_event;
	            out.firstDefined = firstDefined;
	            out.lastDefined = lastDefined;
	            current_event = name;
	            stop = 0;
	            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
	                indexed.push(listeners[i].zIndex);
	                if (listeners[i].zIndex < 0) {
	                    queue[listeners[i].zIndex] = listeners[i];
	                }
	            }
	            indexed.sort(numsort);
	            while (indexed[z] < 0) {
	                l = queue[indexed[z++]];
	                out.push(l.apply(scope, args));
	                if (stop) {
	                    stop = oldstop;
	                    return out;
	                }
	            }
	            for (i = 0; i < ii; i++) {
	                l = listeners[i];
	                if ("zIndex" in l) {
	                    if (l.zIndex == indexed[z]) {
	                        out.push(l.apply(scope, args));
	                        if (stop) {
	                            break;
	                        }
	                        do {
	                            z++;
	                            l = queue[indexed[z]];
	                            l && out.push(l.apply(scope, args));
	                            if (stop) {
	                                break;
	                            }
	                        } while (l)
	                    } else {
	                        queue[l.zIndex] = l;
	                    }
	                } else {
	                    out.push(l.apply(scope, args));
	                    if (stop) {
	                        break;
	                    }
	                }
	            }
	            stop = oldstop;
	            current_event = ce;
	            return out;
	        };
	    // Undocumented. Debug only.
	    eve._events = events;
	    /*\
	     * eve.listeners
	     [ method ]
	
	     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.
	
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated
	
	     = (array) array of event handlers
	    \*/
	    eve.listeners = function (name) {
	        var names = isArray(name) ? name : name.split(separator),
	            e = events,
	            item,
	            items,
	            k,
	            i,
	            ii,
	            j,
	            jj,
	            nes,
	            es = [e],
	            out = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            nes = [];
	            for (j = 0, jj = es.length; j < jj; j++) {
	                e = es[j].n;
	                items = [e[names[i]], e[wildcard]];
	                k = 2;
	                while (k--) {
	                    item = items[k];
	                    if (item) {
	                        nes.push(item);
	                        out = out.concat(item.f || []);
	                    }
	                }
	            }
	            es = nes;
	        }
	        return out;
	    };
	    /*\
	     * eve.separator
	     [ method ]
	
	     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
	     * here. Be aware that if you pass a string longer than one character it will be treated as
	     * a list of characters.
	
	     - separator (string) new separator. Empty string resets to default: `.` or `/`.
	    \*/
	    eve.separator = function (sep) {
	        if (sep) {
	            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
	            sep = "[" + sep + "]";
	            separator = new RegExp(sep);
	        } else {
	            separator = /[\.\/]/;
	        }
	    };
	    /*\
	     * eve.on
	     [ method ]
	     **
	     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
	     | eve.on("*.under.*", f);
	     | eve("mouse.under.floor"); // triggers f
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     - name (array) if you don’t want to use separators, you can use array of strings
	     - f (function) event handler function
	     **
	     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
	     > Example:
	     | eve.on("mouse", eatIt)(2);
	     | eve.on("mouse", scream);
	     | eve.on("mouse", catchIt)(1);
	     * This will ensure that `catchIt` function will be called before `eatIt`.
	     *
	     * If you want to put your handler before non-indexed handlers, specify a negative value.
	     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
	    \*/
	    eve.on = function (name, f) {
	        if (typeof f != "function") {
	            return function () {};
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        for (var i = 0, ii = names.length; i < ii; i++) {
	            (function (name) {
	                var names = isArray(name) ? name : Str(name).split(separator),
	                    e = events,
	                    exist;
	                for (var i = 0, ii = names.length; i < ii; i++) {
	                    e = e.n;
	                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
	                }
	                e.f = e.f || [];
	                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
	                    exist = true;
	                    break;
	                }
	                !exist && e.f.push(f);
	            }(names[i]));
	        }
	        return function (zIndex) {
	            if (+zIndex == +zIndex) {
	                f.zIndex = +zIndex;
	            }
	        };
	    };
	    /*\
	     * eve.f
	     [ method ]
	     **
	     * Returns function that will fire given event with optional arguments.
	     * Arguments that will be passed to the result function will be also
	     * concated to the list of final arguments.
	     | el.onclick = eve.f("click", 1, 2);
	     | eve.on("click", function (a, b, c) {
	     |     console.log(a, b, c); // 1, 2, [event object]
	     | });
	     - event (string) event name
	     - varargs (…) and any other arguments
	     = (function) possible event handler function
	    \*/
	    eve.f = function (event) {
	        var attrs = [].slice.call(arguments, 1);
	        return function () {
	            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
	        };
	    };
	    /*\
	     * eve.stop
	     [ method ]
	     **
	     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
	    \*/
	    eve.stop = function () {
	        stop = 1;
	    };
	    /*\
	     * eve.nt
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     - subname (string) #optional subname of the event
	     **
	     = (string) name of the event, if `subname` is not specified
	     * or
	     = (boolean) `true`, if current event’s name contains `subname`
	    \*/
	    eve.nt = function (subname) {
	        var cur = isArray(current_event) ? current_event.join(".") : current_event;
	        if (subname) {
	            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
	        }
	        return cur;
	    };
	    /*\
	     * eve.nts
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     **
	     = (array) names of the event
	    \*/
	    eve.nts = function () {
	        return isArray(current_event) ? current_event : current_event.split(separator);
	    };
	    /*\
	     * eve.off
	     [ method ]
	     **
	     * Removes given function from the list of event listeners assigned to given name.
	     * If no arguments specified all the events will be cleared.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	    \*/
	    /*\
	     * eve.unbind
	     [ method ]
	     **
	     * See @eve.off
	    \*/
	    eve.off = eve.unbind = function (name, f) {
	        if (!name) {
	            eve._events = events = {n: {}};
	            return;
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        if (names.length > 1) {
	            for (var i = 0, ii = names.length; i < ii; i++) {
	                eve.off(names[i], f);
	            }
	            return;
	        }
	        names = isArray(name) ? name : Str(name).split(separator);
	        var e,
	            key,
	            splice,
	            i, ii, j, jj,
	            cur = [events],
	            inodes = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            for (j = 0; j < cur.length; j += splice.length - 2) {
	                splice = [j, 1];
	                e = cur[j].n;
	                if (names[i] != wildcard) {
	                    if (e[names[i]]) {
	                        splice.push(e[names[i]]);
	                        inodes.unshift({
	                            n: e,
	                            name: names[i]
	                        });
	                    }
	                } else {
	                    for (key in e) if (e[has](key)) {
	                        splice.push(e[key]);
	                        inodes.unshift({
	                            n: e,
	                            name: key
	                        });
	                    }
	                }
	                cur.splice.apply(cur, splice);
	            }
	        }
	        for (i = 0, ii = cur.length; i < ii; i++) {
	            e = cur[i];
	            while (e.n) {
	                if (f) {
	                    if (e.f) {
	                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
	                            e.f.splice(j, 1);
	                            break;
	                        }
	                        !e.f.length && delete e.f;
	                    }
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        var funcs = e.n[key].f;
	                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
	                            funcs.splice(j, 1);
	                            break;
	                        }
	                        !funcs.length && delete e.n[key].f;
	                    }
	                } else {
	                    delete e.f;
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        delete e.n[key].f;
	                    }
	                }
	                e = e.n;
	            }
	        }
	        // prune inner nodes in path
	        prune: for (i = 0, ii = inodes.length; i < ii; i++) {
	            e = inodes[i];
	            for (key in e.n[e.name].f) {
	                // not empty (has listeners)
	                continue prune;
	            }
	            for (key in e.n[e.name].n) {
	                // not empty (has children)
	                continue prune;
	            }
	            // is empty
	            delete e.n[e.name];
	        }
	    };
	    /*\
	     * eve.once
	     [ method ]
	     **
	     * Binds given event handler with a given name to only run once then unbind itself.
	     | eve.once("login", f);
	     | eve("login"); // triggers f
	     | eve("login"); // no listeners
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     = (function) same return function as @eve.on
	    \*/
	    eve.once = function (name, f) {
	        var f2 = function () {
	            eve.off(name, f2);
	            return f.apply(this, arguments);
	        };
	        return eve.on(name, f2);
	    };
	    /*\
	     * eve.version
	     [ property (string) ]
	     **
	     * Current version of the library.
	    \*/
	    eve.version = version;
	    eve.toString = function () {
	        return "You are running Eve " + version;
	    };
	    glob.eve = eve;
	    typeof module != "undefined" && module.exports ? module.exports = eve :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : glob.eve = eve;
	})(typeof window != "undefined" ? window : this);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(81),
	    hashDelete = __webpack_require__(82),
	    hashGet = __webpack_require__(83),
	    hashHas = __webpack_require__(84),
	    hashSet = __webpack_require__(85);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(89),
	    listCacheDelete = __webpack_require__(90),
	    listCacheGet = __webpack_require__(91),
	    listCacheHas = __webpack_require__(92),
	    listCacheSet = __webpack_require__(93);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(28),
	    root = __webpack_require__(19);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(94),
	    mapCacheDelete = __webpack_require__(95),
	    mapCacheGet = __webpack_require__(96),
	    mapCacheHas = __webpack_require__(97),
	    mapCacheSet = __webpack_require__(98);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(76),
	    toKey = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(106),
	    isMasked = __webpack_require__(88),
	    isObject = __webpack_require__(29),
	    toSource = __webpack_require__(103);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(18),
	    arrayMap = __webpack_require__(72),
	    isArray = __webpack_require__(20),
	    isSymbol = __webpack_require__(21);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(20),
	    isKey = __webpack_require__(86),
	    stringToPath = __webpack_require__(101),
	    toString = __webpack_require__(109);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(19);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(18);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(12);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(12);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(12);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(12);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(20),
	    isSymbol = __webpack_require__(21);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(77);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(10);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(10);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(10);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(10);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(68),
	    ListCache = __webpack_require__(69),
	    Map = __webpack_require__(70);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(11);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(11);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(11);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(11);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(108);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(99);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(21);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(73);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(27),
	    isObject = __webpack_require__(29);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(71);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(75);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var popmotion = __webpack_require__(51);
	var styleValueTypes = __webpack_require__(22);
	var poseFactory = _interopDefault(__webpack_require__(111));
	var heyListen = __webpack_require__(5);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	}
	
	var createTransitionMap = function (key) { return function (map) { return function (props) {
	    var switchKey = props[key];
	    var transition = map[switchKey] || map.default;
	    return transition ? transition(props) : false;
	}; }; };
	var eachValue = createTransitionMap('key');
	
	var BoundingBoxDimension;
	(function (BoundingBoxDimension) {
	    BoundingBoxDimension["width"] = "width";
	    BoundingBoxDimension["height"] = "height";
	    BoundingBoxDimension["left"] = "left";
	    BoundingBoxDimension["right"] = "right";
	    BoundingBoxDimension["top"] = "top";
	    BoundingBoxDimension["bottom"] = "bottom";
	})(BoundingBoxDimension || (BoundingBoxDimension = {}));
	
	var linear = popmotion.easing.linear;
	var interpolate = popmotion.transform.interpolate;
	var singleAxisPointer = function (axis) { return function (from) {
	    var _a;
	    return popmotion.pointer((_a = {},
	        _a[axis] = typeof from === 'string' ? parseFloat(from) : from,
	        _a)).pipe(function (v) { return v[axis]; });
	}; };
	var pointerX = singleAxisPointer('x');
	var pointerY = singleAxisPointer('y');
	var createPointer = function (axisPointerCreator, min, max, measurement) { return function (_a) {
	    var from = _a.from, type = _a.type, dimensions = _a.dimensions, dragBounds = _a.dragBounds;
	    var axisPointer = axisPointerCreator(dimensions.measurementAsPixels(measurement, from, type));
	    var transformQueue = [];
	    if (dragBounds) {
	        if (dragBounds[min] !== undefined) {
	            transformQueue.push(function (v) {
	                return Math.max(v, dimensions.measurementAsPixels(measurement, dragBounds[min], type));
	            });
	        }
	        if (dragBounds[max] !== undefined) {
	            transformQueue.push(function (v) {
	                return Math.min(v, dimensions.measurementAsPixels(measurement, dragBounds[max], type));
	            });
	        }
	    }
	    if (type === styleValueTypes.percent) {
	        transformQueue.push(interpolate([0, dimensions.get(measurement)], [0, 100]), function (v) { return v + '%'; });
	    }
	    return transformQueue.length
	        ? axisPointer.pipe.apply(axisPointer, transformQueue) : axisPointer;
	}; };
	var just = function (from) {
	    return popmotion.action(function (_a) {
	        var update = _a.update, complete = _a.complete;
	        update(from);
	        complete();
	    });
	};
	var underDampedSpring = function (_a) {
	    var from = _a.from, velocity = _a.velocity, to = _a.to;
	    return popmotion.spring({
	        from: from,
	        to: to,
	        velocity: velocity,
	        stiffness: 500,
	        damping: 25,
	        restDelta: 0.5,
	        restSpeed: 10
	    });
	};
	var overDampedSpring = function (_a) {
	    var from = _a.from, velocity = _a.velocity, to = _a.to;
	    return popmotion.spring({ from: from, to: to, velocity: velocity, stiffness: 700, damping: to === 0 ? 100 : 35 });
	};
	var linearTween = function (_a) {
	    var from = _a.from, to = _a.to;
	    return popmotion.tween({ from: from, to: to, ease: linear });
	};
	var intelligentTransition = eachValue({
	    x: underDampedSpring,
	    y: underDampedSpring,
	    z: underDampedSpring,
	    rotate: underDampedSpring,
	    rotateX: underDampedSpring,
	    rotateY: underDampedSpring,
	    rotateZ: underDampedSpring,
	    scaleX: overDampedSpring,
	    scaleY: overDampedSpring,
	    scale: overDampedSpring,
	    opacity: linearTween,
	    default: popmotion.tween
	});
	var dragAction = eachValue({
	    x: createPointer(pointerX, 'left', 'right', BoundingBoxDimension.width),
	    y: createPointer(pointerY, 'top', 'bottom', BoundingBoxDimension.height)
	});
	var intelligentDragEnd = function (_a) {
	    var from = _a.from;
	    return just(from);
	};
	var defaultTransitions = new Map([
	    ['default', intelligentTransition],
	    ['dragging', dragAction],
	    ['dragEnd', intelligentDragEnd]
	]);
	
	var valueTypeTests = [styleValueTypes.number, styleValueTypes.degrees, styleValueTypes.percent, styleValueTypes.px];
	var testValueType = function (v) { return function (type) { return type.test(v); }; };
	var createPassiveValue = function (init, parent, transform) {
	    var raw = popmotion.value(init).pipe(transform);
	    parent.raw.subscribe(raw);
	    return { raw: raw };
	};
	var createValue = function (init) {
	    var type = valueTypeTests.find(testValueType(init));
	    var raw = popmotion.value(init);
	    return { raw: raw, type: type };
	};
	var addActionDelay = function (delay, transition) {
	    if (delay === void 0) { delay = 0; }
	    return popmotion.chain(popmotion.delay(delay), transition);
	};
	var animationLookup = {
	    tween: popmotion.tween,
	    spring: popmotion.spring,
	    decay: popmotion.decay,
	    keyframes: popmotion.keyframes,
	    physics: popmotion.physics
	};
	var easeIn = popmotion.easing.easeIn, easeOut = popmotion.easing.easeOut, easeInOut = popmotion.easing.easeInOut, circIn = popmotion.easing.circIn, circOut = popmotion.easing.circOut, circInOut = popmotion.easing.circInOut, backIn = popmotion.easing.backIn, backOut = popmotion.easing.backOut, backInOut = popmotion.easing.backInOut, anticipate = popmotion.easing.anticipate;
	var easingLookup = {
	    easeIn: easeIn,
	    easeOut: easeOut,
	    easeInOut: easeInOut,
	    circIn: circIn,
	    circOut: circOut,
	    circInOut: circInOut,
	    backIn: backIn,
	    backOut: backOut,
	    backInOut: backInOut,
	    anticipate: anticipate
	};
	var getAction = function (v, _a, _b) {
	    var from = _b.from, to = _b.to, velocity = _b.velocity;
	    var _c = _a.type, type = _c === void 0 ? 'tween' : _c, ease = _a.ease, def = __rest(_a, ["type", "ease"]);
	    heyListen.invariant(animationLookup[type] !== undefined, "Invalid transition type '" + type + "'. Valid transition types are: tween, spring, decay, physics and keyframes.");
	    if (type === 'tween') {
	        var typeOfEase = typeof ease;
	        if (typeOfEase !== 'function') {
	            if (typeOfEase === 'string') {
	                heyListen.invariant(easingLookup[ease] !== undefined, "Invalid easing type '" + ease + "'. popmotion.io/pose/api/config");
	                ease = easingLookup[ease];
	            }
	            else if (Array.isArray(ease)) {
	                heyListen.invariant(ease.length === 4, "Cubic bezier arrays must contain four numerical values.");
	                var x1 = ease[0], y1 = ease[1], x2 = ease[2], y2 = ease[3];
	                ease = popmotion.easing.cubicBezier(x1, y1, x2, y2);
	            }
	        }
	    }
	    return animationLookup[type](__assign({ from: from,
	        to: to,
	        velocity: velocity,
	        ease: ease }, def));
	};
	var isAction = function (action) {
	    return typeof action.start !== 'undefined';
	};
	var pose = function (_a) {
	    var transformPose = _a.transformPose, addListenerToValue = _a.addListenerToValue, extendAPI = _a.extendAPI, readValueFromSource = _a.readValueFromSource;
	    return poseFactory({
	        bindOnChange: function (values, onChange) { return function (key) {
	            if (!values.has(key))
	                return;
	            var raw = values.get(key).raw;
	            raw.subscribe(onChange[key]);
	        }; },
	        readValue: function (_a) {
	            var raw = _a.raw;
	            return raw.get();
	        },
	        createValue: function (init, key, _a, _b) {
	            var elementStyler = _a.elementStyler;
	            var _c = _b === void 0 ? {} : _b, passiveParent = _c.passiveParent, passiveProps = _c.passiveProps;
	            var val = passiveParent
	                ? createPassiveValue(init, passiveParent, passiveProps)
	                : createValue(init);
	            if (addListenerToValue) {
	                val.raw.subscribe(addListenerToValue(key, elementStyler));
	            }
	            return val;
	        },
	        convertValue: function (raw, key, _a) {
	            var elementStyler = _a.elementStyler;
	            if (addListenerToValue) {
	                raw.subscribe(addListenerToValue(key, elementStyler));
	            }
	            return {
	                raw: raw,
	                type: valueTypeTests.find(testValueType(raw.get()))
	            };
	        },
	        getTransitionProps: function (_a, to) {
	            var raw = _a.raw, type = _a.type;
	            return ({
	                from: raw.get(),
	                velocity: raw.getVelocity(),
	                to: to,
	                type: type
	            });
	        },
	        resolveTarget: function (_, to) { return to; },
	        selectValueToRead: function (_a) {
	            var raw = _a.raw;
	            return raw;
	        },
	        startAction: function (_a, action, complete) {
	            var raw = _a.raw;
	            var reaction = {
	                update: function (v) { return raw.update(v); },
	                complete: complete
	            };
	            return action.start(reaction);
	        },
	        stopAction: function (action) { return action.stop(); },
	        getInstantTransition: function (_, _a) {
	            var to = _a.to;
	            return just(to);
	        },
	        convertTransitionDefinition: function (val, def, props) {
	            if (isAction(def))
	                return def;
	            var delay = def.delay, min = def.min, max = def.max, round = def.round, remainingDef = __rest(def, ["delay", "min", "max", "round"]);
	            var action = getAction(val, remainingDef, props);
	            var outputPipe = [];
	            if (delay)
	                action = addActionDelay(delay, action);
	            if (min !== undefined)
	                outputPipe.push(function (v) { return Math.max(v, min); });
	            if (max !== undefined)
	                outputPipe.push(function (v) { return Math.min(v, max); });
	            if (round)
	                outputPipe.push(Math.round);
	            return outputPipe.length ? action.pipe.apply(action, outputPipe) : action;
	        },
	        addActionDelay: addActionDelay,
	        defaultTransitions: defaultTransitions,
	        transformPose: transformPose,
	        readValueFromSource: readValueFromSource,
	        extendAPI: extendAPI
	    });
	};
	
	var createDimensions = (function (element) {
	    var hasMeasured = false;
	    var current = {
	        width: 0,
	        height: 0,
	        top: 0,
	        left: 0,
	        bottom: 0,
	        right: 0
	    };
	    return {
	        get: function (measurement) { return (measurement ? current[measurement] : current); },
	        measure: function () {
	            current = element.getBoundingClientRect();
	            hasMeasured = true;
	            return current;
	        },
	        measurementAsPixels: function (measurement, value, type) {
	            return type === styleValueTypes.percent
	                ? (typeof value === 'string' ? parseFloat(value) : value) /
	                    100 *
	                    current[measurement]
	                : value;
	        },
	        has: function () { return hasMeasured; }
	    };
	});
	
	var makeDraggable = function (element, activeActions, setPose, _a) {
	    var onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd;
	    var dragStartListener = popmotion.listen(element, 'mousedown touchstart').start(function (startEvent) {
	        startEvent.preventDefault();
	        setPose('dragging');
	        if (onDragStart)
	            onDragStart(startEvent);
	        var dragEndListener = popmotion.listen(document, 'mouseup touchend').start(function (endEvent) {
	            activeActions.get('dragEndListener').stop();
	            setPose('dragEnd');
	            if (onDragEnd)
	                onDragEnd(endEvent);
	        });
	        activeActions.set('dragEndListener', dragEndListener);
	    });
	    activeActions.set('dragStartListener', dragStartListener);
	};
	var appendEventListeners = (function (element, activeActions, setPose, _a) {
	    var props = _a.props;
	    if (props.draggable)
	        makeDraggable(element, activeActions, setPose, props);
	});
	
	var ORIGIN_START = 0;
	var ORIGIN_CENTER = '50%';
	var ORIGIN_END = '100%';
	var findCenter = function (_a) {
	    var top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
	    return ({
	        x: (left + right) / 2,
	        y: (top + bottom) / 2
	    });
	};
	var positionalProps = ['width', 'height', 'top', 'left', 'bottom', 'right'];
	var positionalPropsDict = new Set(positionalProps);
	var checkPositionalProp = function (key) { return positionalPropsDict.has(key); };
	var hasPositionalProps = function (pose) {
	    return Object.keys(pose).some(checkPositionalProp);
	};
	var isFlipPose = function (flip, key, state) {
	    return state.props.element instanceof HTMLElement &&
	        (flip === true || key === 'flip');
	};
	var resolveProp = function (target, props) {
	    return typeof target === 'function' ? target(props) : target;
	};
	var setValue = function (_a, key, to) {
	    var values = _a.values, props = _a.props;
	    if (values.has(key)) {
	        var raw = values.get(key).raw;
	        raw.update(to);
	        raw.update(to);
	    }
	    else {
	        values.set(key, {
	            raw: popmotion.value(to, function (v) { return props.elementStyler.set(key, v); })
	        });
	    }
	};
	var explicitlyFlipPose = function (state, nextPose) {
	    var _a = state.props, dimensions = _a.dimensions, elementStyler = _a.elementStyler;
	    dimensions.measure();
	    var width = nextPose.width, height = nextPose.height, top = nextPose.top, left = nextPose.left, bottom = nextPose.bottom, right = nextPose.right, remainingPose = __rest(nextPose, ["width", "height", "top", "left", "bottom", "right"]);
	    elementStyler
	        .set(positionalProps.reduce(function (acc, key) {
	        if (nextPose[key] !== undefined) {
	            acc[key] = resolveProp(nextPose[key], state.props);
	        }
	        return acc;
	    }, {}))
	        .render();
	    return implicitlyFlipPose(state, remainingPose);
	};
	var implicitlyFlipPose = function (state, nextPose) {
	    var _a = state.props, dimensions = _a.dimensions, element = _a.element, elementStyler = _a.elementStyler;
	    if (!dimensions.has())
	        return {};
	    var prev = dimensions.get();
	    var transform = element.style.transform;
	    element.style.transform = '';
	    var next = element.getBoundingClientRect();
	    element.style.transform = transform;
	    var originX = prev.left === next.left
	        ? ORIGIN_START
	        : prev.right === next.right ? ORIGIN_END : ORIGIN_CENTER;
	    var originY = prev.top === next.top
	        ? ORIGIN_START
	        : prev.bottom === next.bottom ? ORIGIN_END : ORIGIN_CENTER;
	    elementStyler.set({ originX: originX, originY: originY });
	    var flipPoseProps = {};
	    if (prev.width !== next.width) {
	        setValue(state, 'scaleX', prev.width / next.width);
	        flipPoseProps.scaleX = 1;
	    }
	    if (prev.height !== next.height) {
	        setValue(state, 'scaleY', prev.height / next.height);
	        flipPoseProps.scaleY = 1;
	    }
	    var prevCenter = findCenter(prev);
	    var nextCenter = findCenter(next);
	    if (originX === ORIGIN_CENTER) {
	        setValue(state, 'x', prevCenter.x - nextCenter.x);
	        flipPoseProps.x = 0;
	    }
	    if (originY === ORIGIN_CENTER) {
	        setValue(state, 'y', prevCenter.y - nextCenter.y);
	        flipPoseProps.y = 0;
	    }
	    elementStyler.render();
	    return __assign({}, nextPose, flipPoseProps);
	};
	var flipPose = function (props, nextPose) {
	    return hasPositionalProps(nextPose)
	        ? explicitlyFlipPose(props, nextPose)
	        : implicitlyFlipPose(props, nextPose);
	};
	
	var dragPoses = function (draggable) {
	    var dragging = {
	        preTransition: function (_a) {
	            var dimensions = _a.dimensions;
	            return dimensions.measure();
	        }
	    };
	    var dragEnd = {};
	    if (draggable === true || draggable === 'x')
	        dragging.x = dragEnd.x = 0;
	    if (draggable === true || draggable === 'y')
	        dragging.y = dragEnd.y = 0;
	    return { dragging: dragging, dragEnd: dragEnd };
	};
	var createPoseConfig = function (element, _a) {
	    var onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, draggable = _a.draggable, dragBounds = _a.dragBounds, config = __rest(_a, ["onDragStart", "onDragEnd", "draggable", "dragBounds"]);
	    var poseConfig = __assign({ flip: {} }, config, { props: __assign({}, config.props, { draggable: draggable,
	            onDragStart: onDragStart,
	            onDragEnd: onDragEnd,
	            dragBounds: dragBounds,
	            element: element, elementStyler: popmotion.styler(element, { preparseOutput: false }), dimensions: createDimensions(element) }) });
	    if (draggable) {
	        var _b = dragPoses(draggable), dragging = _b.dragging, dragEnd = _b.dragEnd;
	        poseConfig.dragging = __assign({}, poseConfig.dragging, dragging);
	        poseConfig.dragEnd = __assign({}, poseConfig.dragEnd, dragEnd);
	    }
	    return poseConfig;
	};
	var domPose = pose({
	    transformPose: function (_a, name, state) {
	        var flip = _a.flip, pose$$1 = __rest(_a, ["flip"]);
	        return isFlipPose(flip, name, state) ? flipPose(state, pose$$1) : pose$$1;
	    },
	    addListenerToValue: function (key, elementStyler) { return function (v) { return elementStyler.set(key, v); }; },
	    readValueFromSource: function (key, _a) {
	        var elementStyler = _a.elementStyler;
	        var value = elementStyler.get(key);
	        return isNaN(value) ? value : parseFloat(value);
	    },
	    extendAPI: function (api, _a, config) {
	        var props = _a.props, activeActions = _a.activeActions;
	        var measure = props.dimensions.measure;
	        var poserApi = __assign({}, api, { addChild: function (element, childConfig) {
	                return api._addChild(createPoseConfig(element, childConfig), domPose);
	            }, measure: measure, flip: function (op) {
	                if (op) {
	                    measure();
	                    op();
	                }
	                return api.set('flip');
	            } });
	        appendEventListeners(props.element, activeActions, api.set, config);
	        return poserApi;
	    }
	});
	var domPose$1 = (function (element, config) {
	    return domPose(createPoseConfig(element, config));
	});
	
	exports.default = domPose$1;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib_1 = __webpack_require__(13);
	var heyListen = __webpack_require__(5);
	
	var getPoseValues = function (_a) {
	    var transition = _a.transition, delay = _a.delay, delayChildren = _a.delayChildren, staggerChildren = _a.staggerChildren, staggerDirection = _a.staggerDirection, afterChildren = _a.afterChildren, beforeChildren = _a.beforeChildren, preTransition = _a.preTransition, props = tslib_1.__rest(_a, ["transition", "delay", "delayChildren", "staggerChildren", "staggerDirection", "afterChildren", "beforeChildren", "preTransition"]);
	    return props;
	};
	var selectPoses = function (_a) {
	    var label = _a.label, props = _a.props, values = _a.values, parentValues = _a.parentValues, ancestorValues = _a.ancestorValues, onChange = _a.onChange, passive = _a.passive, initialPose = _a.initialPose, poses = tslib_1.__rest(_a, ["label", "props", "values", "parentValues", "ancestorValues", "onChange", "passive", "initialPose"]);
	    return poses;
	};
	var selectAllValues = function (values, selectValue) {
	    var allValues = {};
	    values.forEach(function (value, key) { return allValues[key] = selectValue(value); });
	    return allValues;
	};
	
	var resolveProp = function (target, props) {
	    return typeof target === 'function' ? target(props) : target;
	};
	var poseDefault = function (pose, prop, defaultValue, resolveProps) {
	    return pose && pose[prop] !== undefined
	        ? resolveProp(pose[prop], resolveProps)
	        : defaultValue;
	};
	var startChildAnimations = function (children, next, pose, props) {
	    var animations = [];
	    var delay = poseDefault(pose, 'delayChildren', 0, props);
	    var stagger = poseDefault(pose, 'staggerChildren', 0, props);
	    var staggerDirection = poseDefault(pose, 'staggerDirection', 1, props);
	    var maxStaggerDuration = (children.size - 1) * stagger;
	    var generateStaggerDuration = staggerDirection === 1
	        ? function (i) { return i * stagger; }
	        : function (i) { return maxStaggerDuration - i * stagger; };
	    Array.from(children).forEach(function (child, i) {
	        animations.push(child.set(next, tslib_1.__assign({}, props, { delay: delay + generateStaggerDuration(i) })));
	    });
	    return animations;
	};
	var resolveTransition = function (transition, key, value, props, convertTransitionDefinition, getInstantTransition) {
	    var resolvedTransition;
	    if (typeof transition === 'function') {
	        resolvedTransition = transition(props);
	    }
	    else if (transition[key] || transition.default) {
	        var keyTransition = transition[key] || transition.default;
	        if (typeof keyTransition === 'function') {
	            resolvedTransition = keyTransition(props);
	        }
	        else {
	            resolvedTransition = keyTransition;
	        }
	    }
	    else {
	        resolvedTransition = transition;
	    }
	    return resolvedTransition === false
	        ? getInstantTransition(value, props)
	        : convertTransitionDefinition(value, resolvedTransition, props);
	};
	var createPoseSetter = function (setterProps) { return function (next, nextProps) {
	    if (nextProps === void 0) { nextProps = {}; }
	    var state = setterProps.state, poses = setterProps.poses, startAction = setterProps.startAction, stopAction = setterProps.stopAction, getInstantTransition = setterProps.getInstantTransition, addActionDelay = setterProps.addActionDelay, getTransitionProps = setterProps.getTransitionProps, resolveTarget = setterProps.resolveTarget, transformPose = setterProps.transformPose, convertTransitionDefinition = setterProps.convertTransitionDefinition;
	    var children = state.children, values = state.values, props = state.props, activeActions = state.activeActions, activePoses = state.activePoses;
	    var _a = nextProps.delay, delay = _a === void 0 ? 0 : _a;
	    var hasChildren = children.size;
	    var nextPose = poses[next];
	    var baseTransitionProps = tslib_1.__assign({}, props, nextProps);
	    var getChildAnimations = function () {
	        return hasChildren
	            ? startChildAnimations(children, next, nextPose, baseTransitionProps)
	            : [];
	    };
	    var getParentAnimations = function () {
	        if (!nextPose)
	            return [];
	        if (transformPose)
	            nextPose = transformPose(nextPose, next, state);
	        var preTransition = nextPose.preTransition, getTransition = nextPose.transition;
	        if (preTransition)
	            nextPose.preTransition(baseTransitionProps);
	        return Object.keys(getPoseValues(nextPose)).map(function (key) {
	            return new Promise(function (complete) {
	                var value = values.get(key);
	                var transitionProps = tslib_1.__assign({}, baseTransitionProps, { key: key,
	                    value: value });
	                var target = resolveTarget(value, resolveProp(nextPose[key], transitionProps));
	                if (activeActions.has(key))
	                    stopAction(activeActions.get(key));
	                var resolveTransitionProps = tslib_1.__assign({ to: target }, transitionProps, getTransitionProps(value, target, transitionProps));
	                var transition = resolveTransition(getTransition, key, value, resolveTransitionProps, convertTransitionDefinition, getInstantTransition);
	                var poseDelay = resolveProp(nextPose.delay, transitionProps);
	                if (delay || poseDelay) {
	                    transition = addActionDelay(delay || poseDelay, transition);
	                }
	                activeActions.set(key, startAction(value, transition, complete));
	                activePoses.set(key, next);
	            });
	        });
	    };
	    if (nextPose && hasChildren) {
	        if (resolveProp(nextPose.beforeChildren, baseTransitionProps)) {
	            return Promise.all(getParentAnimations()).then(function () {
	                return Promise.all(getChildAnimations());
	            });
	        }
	        else if (resolveProp(nextPose.afterChildren, baseTransitionProps)) {
	            return Promise.all(getChildAnimations()).then(function () {
	                return Promise.all(getParentAnimations());
	            });
	        }
	    }
	    return Promise.all(getParentAnimations().concat(getChildAnimations()));
	}; };
	
	var isScale = function (key) { return key.includes('scale'); };
	var defaultReadValueFromSource = function (key) { return (isScale(key) ? 1 : 0); };
	var getInitialValue = function (poses, key, initialPose, props, readValueFromSource) {
	    if (readValueFromSource === void 0) { readValueFromSource = defaultReadValueFromSource; }
	    var posesToSearch = Array.isArray(initialPose)
	        ? initialPose
	        : [initialPose];
	    var pose = posesToSearch.find(function (name) { return poses[name] && poses[name][key] !== undefined; });
	    return pose
	        ? resolveProp(poses[pose][key], props)
	        : readValueFromSource(key, props);
	};
	var createValues = function (values, _a, pose) {
	    var userSetValues = _a.userSetValues, createValue = _a.createValue, convertValue = _a.convertValue, readValueFromSource = _a.readValueFromSource, initialPose = _a.initialPose, poses = _a.poses, props = _a.props;
	    return function (key) {
	        if (values.has(key))
	            return;
	        var value;
	        if (userSetValues && userSetValues[key] !== undefined) {
	            value = convertValue(userSetValues[key], key, props);
	        }
	        else {
	            var initValue = getInitialValue(poses, key, initialPose, props, readValueFromSource);
	            value = createValue(initValue, key, props);
	        }
	        values.set(key, value);
	    };
	};
	var scrapeValuesFromPose = function (values, props) { return function (key) {
	    var pose = props.poses[key];
	    Object.keys(getPoseValues(pose)).forEach(createValues(values, props, pose));
	}; };
	var getAncestorValue = function (key, fromParent, ancestors) {
	    if (fromParent === true) {
	        return ancestors[0] && ancestors[0].values.get(key);
	    }
	    else {
	        var foundAncestor = ancestors.find(function (_a) {
	            var label = _a.label;
	            return label === fromParent;
	        });
	        return foundAncestor && foundAncestor.values.get(key);
	    }
	};
	var bindPassiveValues = function (values, _a) {
	    var passive = _a.passive, ancestorValues = _a.ancestorValues, createValue = _a.createValue, readValue = _a.readValue, props = _a.props;
	    return function (key) {
	        var _a = passive[key], valueKey = _a[0], passiveProps = _a[1], fromParent = _a[2];
	        var valueToBind = fromParent && ancestorValues.length
	            ? getAncestorValue(valueKey, fromParent, ancestorValues)
	            : values.has(valueKey) ? values.get(valueKey) : false;
	        if (!valueToBind)
	            return;
	        var newValue = createValue(readValue(valueToBind), key, props, {
	            passiveParent: valueToBind,
	            passiveProps: passiveProps,
	            props: props
	        });
	        values.set(key, newValue);
	    };
	};
	var createValueMap = function (props) {
	    var poses = props.poses, passive = props.passive;
	    var values = new Map();
	    Object.keys(poses).forEach(scrapeValuesFromPose(values, props));
	    if (passive)
	        Object.keys(passive).forEach(bindPassiveValues(values, props));
	    return values;
	};
	
	var applyDefaultTransition = function (pose, key, defaultTransitions) {
	    return tslib_1.__assign({}, pose, { transition: defaultTransitions.has(key)
	            ? defaultTransitions.get(key)
	            : defaultTransitions.get('default') });
	};
	var generateTransitions = function (poses, defaultTransitions) {
	    Object.keys(poses).forEach(function (key) {
	        var pose = poses[key];
	        heyListen.invariant(typeof pose === 'object', "Pose '" + key + "' is of invalid type. All poses should be objects.");
	        poses[key] =
	            pose.transition !== undefined
	                ? pose
	                : applyDefaultTransition(pose, key, defaultTransitions);
	    });
	    return poses;
	};
	
	var createTransitionMap = function (key) { return function (map) { return function (props) {
	    var switchKey = props[key];
	    var transition = map[switchKey] || map.default;
	    return transition ? transition(props) : false;
	}; }; };
	var eachValue = createTransitionMap('key');
	var fromPose = createTransitionMap('prevPoseKey');
	
	var poseFactory = function (_a) {
	    var getDefaultProps = _a.getDefaultProps, defaultTransitions = _a.defaultTransitions, bindOnChange = _a.bindOnChange, startAction = _a.startAction, stopAction = _a.stopAction, readValue = _a.readValue, readValueFromSource = _a.readValueFromSource, resolveTarget = _a.resolveTarget, createValue = _a.createValue, convertValue = _a.convertValue, getInstantTransition = _a.getInstantTransition, getTransitionProps = _a.getTransitionProps, addActionDelay = _a.addActionDelay, selectValueToRead = _a.selectValueToRead, convertTransitionDefinition = _a.convertTransitionDefinition, transformPose = _a.transformPose, extendAPI = _a.extendAPI;
	    return function (config) {
	        var parentValues = config.parentValues, _a = config.ancestorValues, ancestorValues = _a === void 0 ? [] : _a;
	        if (parentValues)
	            ancestorValues.unshift({ values: parentValues });
	        var activeActions = new Map();
	        var activePoses = new Map();
	        var children = new Set();
	        var poses = generateTransitions(selectPoses(config), defaultTransitions);
	        var props = config.props || {};
	        if (getDefaultProps)
	            props = tslib_1.__assign({}, props, getDefaultProps(config));
	        var passive = config.passive, userSetValues = config.values, initialPose = config.initialPose;
	        var values = createValueMap({
	            poses: poses,
	            passive: passive,
	            ancestorValues: ancestorValues,
	            readValue: readValue,
	            createValue: createValue,
	            convertValue: convertValue,
	            readValueFromSource: readValueFromSource,
	            userSetValues: userSetValues,
	            initialPose: initialPose,
	            props: props
	        });
	        var state = {
	            activeActions: activeActions,
	            activePoses: activePoses,
	            children: children,
	            props: props,
	            values: values
	        };
	        var onChange = config.onChange;
	        if (onChange)
	            Object.keys(onChange).forEach(bindOnChange(values, onChange));
	        var set = createPoseSetter({
	            state: state,
	            poses: poses,
	            getInstantTransition: getInstantTransition,
	            getTransitionProps: getTransitionProps,
	            convertTransitionDefinition: convertTransitionDefinition,
	            startAction: startAction,
	            stopAction: stopAction,
	            resolveTarget: resolveTarget,
	            addActionDelay: addActionDelay,
	            transformPose: transformPose
	        });
	        var api = {
	            set: set,
	            get: function (valueName) {
	                return valueName
	                    ? selectValueToRead(values.get(valueName))
	                    : selectAllValues(values, selectValueToRead);
	            },
	            has: function (poseName) { return !!poses[poseName]; },
	            setProps: function (newProps) { return (state.props = tslib_1.__assign({}, state.props, newProps)); },
	            _addChild: function (childConfig, factory) {
	                var child = factory(tslib_1.__assign({ initialPose: initialPose }, childConfig, { ancestorValues: [{ label: config.label, values: values }].concat(ancestorValues) }));
	                children.add(child);
	                return child;
	            },
	            removeChild: function (child) { return children.delete(child); },
	            clearChildren: function () {
	                children.forEach(function (child) { return child.destroy(); });
	                children.clear();
	            },
	            destroy: function () {
	                activeActions.forEach(stopAction);
	                children.forEach(function (child) { return child.destroy(); });
	            }
	        };
	        return extendAPI(api, state, config);
	    };
	};
	
	exports.default = poseFactory;
	exports.eachValue = eachValue;
	exports.fromPose = fromPose;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["anchor-link"] = factory(require("react"));
		else
			root["anchor-link"] = factory(root["react"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _anchorLink = __webpack_require__(1);
	
	var _anchorLink2 = _interopRequireDefault(_anchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _anchorLink2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnchorLink = function (_Component) {
	  _inherits(AnchorLink, _Component);
	
	  function AnchorLink(props) {
	    _classCallCheck(this, AnchorLink);
	
	    var _this = _possibleConstructorReturn(this, (AnchorLink.__proto__ || Object.getPrototypeOf(AnchorLink)).call(this, props));
	
	    _this.smoothScroll = _this.smoothScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(AnchorLink, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      __webpack_require__(3).polyfill();
	    }
	  }, {
	    key: 'smoothScroll',
	    value: function smoothScroll(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var offset = function offset() {
	        return 0;
	      };
	      if (typeof this.props.offset !== 'undefined') {
	        if (!!(this.props.offset && this.props.offset.constructor && this.props.offset.apply)) {
	          offset = this.props.offset;
	        } else {
	          offset = function offset() {
	            return parseInt(_this2.props.offset);
	          };
	        }
	      }
	      var id = e.currentTarget.getAttribute('href').slice(1);
	      window.scroll({
	        top: document.getElementById(id).offsetTop - offset(),
	        behavior: 'smooth'
	      });
	      if (this.props.onClick) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        _extends({}, this.props, { onClick: this.smoothScroll }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return AnchorLink;
	}(_react.Component);
	
	exports.default = AnchorLink;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* smoothscroll v0.4.0 - 2017 - Dustan Kasten, Jeremias Menichelli - MIT License */
	(function () {
	  'use strict';
	
	  /*
	   * aliases
	   * w: window global object
	   * d: document
	   */
	  var w = window;
	  var d = document;
	
	  /**
	   * indicates if a the current browser is made by Microsoft
	   * @method isMicrosoftBrowser
	   * @param {String} userAgent
	   * @returns {Boolean}
	   */
	  function isMicrosoftBrowser(userAgent) {
	    var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];
	
	    return new RegExp(userAgentPatterns.join('|')).test(userAgent);
	  }
	
	   // polyfill
	  function polyfill() {
	    // return if scroll behavior is supported and polyfill is not forced
	    if ('scrollBehavior' in d.documentElement.style
	      && w.__forceSmoothScrollPolyfill__ !== true) {
	      return;
	    }
	
	    // globals
	    var Element = w.HTMLElement || w.Element;
	    var SCROLL_TIME = 468;
	
	    /*
	     * IE has rounding bug rounding down clientHeight and clientWidth and
	     * rounding up scrollHeight and scrollWidth causing false positives
	     * on hasScrollableSpace
	     */
	    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
	
	    // object gathering original scroll methods
	    var original = {
	      scroll: w.scroll || w.scrollTo,
	      scrollBy: w.scrollBy,
	      elementScroll: Element.prototype.scroll || scrollElement,
	      scrollIntoView: Element.prototype.scrollIntoView
	    };
	
	    // define timing method
	    var now = w.performance && w.performance.now
	      ? w.performance.now.bind(w.performance)
	      : Date.now;
	
	    /**
	     * changes scroll position inside an element
	     * @method scrollElement
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {undefined}
	     */
	    function scrollElement(x, y) {
	      this.scrollLeft = x;
	      this.scrollTop = y;
	    }
	
	    /**
	     * returns result of applying ease math function to a number
	     * @method ease
	     * @param {Number} k
	     * @returns {Number}
	     */
	    function ease(k) {
	      return 0.5 * (1 - Math.cos(Math.PI * k));
	    }
	
	    /**
	     * indicates if a smooth behavior should be applied
	     * @method shouldBailOut
	     * @param {Number|Object} firstArg
	     * @returns {Boolean}
	     */
	    function shouldBailOut(firstArg) {
	      if (firstArg === null
	        || typeof firstArg !== 'object'
	        || firstArg.behavior === undefined
	        || firstArg.behavior === 'auto'
	        || firstArg.behavior === 'instant') {
	        // first argument is not an object/null
	        // or behavior is auto, instant or undefined
	        return true;
	      }
	
	      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
	        // first argument is an object and behavior is smooth
	        return false;
	      }
	
	      // throw error when behavior is not supported
	      throw new TypeError(
	        'behavior member of ScrollOptions '
	        + firstArg.behavior
	        + ' is not a valid value for enumeration ScrollBehavior.'
	      );
	    }
	
	    /**
	     * indicates if an element has scrollable space in the provided axis
	     * @method hasScrollableSpace
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function hasScrollableSpace(el, axis) {
	      if (axis === 'Y') {
	        return (el.clientHeight + ROUNDING_TOLERANCE) < el.scrollHeight;
	      }
	
	      if (axis === 'X') {
	        return (el.clientWidth + ROUNDING_TOLERANCE) < el.scrollWidth;
	      }
	    }
	
	    /**
	     * indicates if an element has a scrollable overflow property in the axis
	     * @method canOverflow
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function canOverflow(el, axis) {
	      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];
	
	      return overflowValue === 'auto' || overflowValue === 'scroll';
	    }
	
	    /**
	     * indicates if an element can be scrolled in either axis
	     * @method isScrollable
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function isScrollable(el) {
	      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
	      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');
	
	      return isScrollableY || isScrollableX;
	    }
	
	    /**
	     * finds scrollable parent of an element
	     * @method findScrollableParent
	     * @param {Node} el
	     * @returns {Node} el
	     */
	    function findScrollableParent(el) {
	      var isBody;
	
	      do {
	        el = el.parentNode;
	
	        isBody = el === d.body;
	      } while (isBody === false && isScrollable(el) === false);
	
	      isBody = null;
	
	      return el;
	    }
	
	    /**
	     * self invoked function that, given a context, steps through scrolling
	     * @method step
	     * @param {Object} context
	     * @returns {undefined}
	     */
	    function step(context) {
	      var time = now();
	      var value;
	      var currentX;
	      var currentY;
	      var elapsed = (time - context.startTime) / SCROLL_TIME;
	
	      // avoid elapsed times higher than one
	      elapsed = elapsed > 1 ? 1 : elapsed;
	
	      // apply easing to elapsed time
	      value = ease(elapsed);
	
	      currentX = context.startX + (context.x - context.startX) * value;
	      currentY = context.startY + (context.y - context.startY) * value;
	
	      context.method.call(context.scrollable, currentX, currentY);
	
	      // scroll more if we have not reached our destination
	      if (currentX !== context.x || currentY !== context.y) {
	        w.requestAnimationFrame(step.bind(w, context));
	      }
	    }
	
	    /**
	     * scrolls window or element with a smooth behavior
	     * @method smoothScroll
	     * @param {Object|Node} el
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {undefined}
	     */
	    function smoothScroll(el, x, y) {
	      var scrollable;
	      var startX;
	      var startY;
	      var method;
	      var startTime = now();
	
	      // define scroll context
	      if (el === d.body) {
	        scrollable = w;
	        startX = w.scrollX || w.pageXOffset;
	        startY = w.scrollY || w.pageYOffset;
	        method = original.scroll;
	      } else {
	        scrollable = el;
	        startX = el.scrollLeft;
	        startY = el.scrollTop;
	        method = scrollElement;
	      }
	
	      // scroll looping over a frame
	      step({
	        scrollable: scrollable,
	        method: method,
	        startTime: startTime,
	        startX: startX,
	        startY: startY,
	        x: x,
	        y: y
	      });
	    }
	
	    // ORIGINAL METHODS OVERRIDES
	    // w.scroll and w.scrollTo
	    w.scroll = w.scrollTo = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.scroll.call(
	          w,
	          arguments[0].left !== undefined
	            ? arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? arguments[0]
	              : (w.scrollX || w.pageXOffset),
	          // use top prop, second argument if present or fallback to scrollY
	          arguments[0].top !== undefined
	            ? arguments[0].top
	            : arguments[1] !== undefined
	              ? arguments[1]
	              : (w.scrollY || w.pageYOffset)
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        arguments[0].left !== undefined
	          ? ~~arguments[0].left
	          : (w.scrollX || w.pageXOffset),
	        arguments[0].top !== undefined
	          ? ~~arguments[0].top
	          : (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // w.scrollBy
	    w.scrollBy = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0])) {
	        original.scrollBy.call(
	          w,
	          arguments[0].left !== undefined
	            ? arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? arguments[0]
	              : 0,
	          arguments[0].top !== undefined
	            ? arguments[0].top
	            : arguments[1] !== undefined
	             ? arguments[1]
	             : 0
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
	        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // Element.prototype.scroll and Element.prototype.scrollTo
	    Element.prototype.scroll = Element.prototype.scrollTo = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        // if one number is passed, throw error to match Firefox implementation
	        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
	          throw new SyntaxError('Value couldn\'t be converted');
	        }
	
	        original.elementScroll.call(
	          this,
	          // use left prop, first number argument or fallback to scrollLeft
	          arguments[0].left !== undefined
	            ? ~~arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? ~~arguments[0]
	              : this.scrollLeft,
	          // use top prop, second argument or fallback to scrollTop
	          arguments[0].top !== undefined
	            ? ~~arguments[0].top
	            : arguments[1] !== undefined
	              ? ~~arguments[1]
	              : this.scrollTop
	        );
	
	        return;
	      }
	
	      var left = arguments[0].left;
	      var top = arguments[0].top;
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        this,
	        this,
	        typeof left === 'undefined' ? this.scrollLeft : ~~left,
	        typeof top === 'undefined' ? this.scrollTop : ~~top
	      );
	    };
	
	    // Element.prototype.scrollBy
	    Element.prototype.scrollBy = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.elementScroll.call(
	          this,
	          arguments[0].left !== undefined
	            ? ~~arguments[0].left + this.scrollLeft
	            : ~~arguments[0] + this.scrollLeft,
	          arguments[0].top !== undefined
	            ? ~~arguments[0].top + this.scrollTop
	            : ~~arguments[1] + this.scrollTop
	        );
	
	        return;
	      }
	
	      this.scroll({
	        left: ~~arguments[0].left + this.scrollLeft,
	        top: ~~arguments[0].top + this.scrollTop,
	        behavior: arguments[0].behavior
	      });
	    };
	
	    // Element.prototype.scrollIntoView
	    Element.prototype.scrollIntoView = function() {
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.scrollIntoView.call(
	          this,
	          arguments[0] === undefined
	            ? true
	            : arguments[0]
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      var scrollableParent = findScrollableParent(this);
	      var parentRects = scrollableParent.getBoundingClientRect();
	      var clientRects = this.getBoundingClientRect();
	
	      if (scrollableParent !== d.body) {
	        // reveal element inside parent
	        smoothScroll.call(
	          this,
	          scrollableParent,
	          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
	          scrollableParent.scrollTop + clientRects.top - parentRects.top
	        );
	
	        // reveal parent in viewport unless is fixed
	        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
	          w.scrollBy({
	            left: parentRects.left,
	            top: parentRects.top,
	            behavior: 'smooth'
	          });
	        }
	      } else {
	        // reveal element in viewport
	        w.scrollBy({
	          left: clientRects.left,
	          top: clientRects.top,
	          behavior: 'smooth'
	        });
	      }
	    };
	  }
	
	  if (true) {
	    // commonjs
	    module.exports = { polyfill: polyfill };
	  } else {
	    // global
	    polyfill();
	  }
	
	}());
	
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var BurgerIcon = (function (_Component) {
	  _inherits(BurgerIcon, _Component);
	
	  function BurgerIcon(props) {
	    _classCallCheck(this, BurgerIcon);
	
	    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      hover: false
	    };
	  }
	
	  _createClass(BurgerIcon, [{
	    key: 'getLineStyle',
	    value: function getLineStyle(index) {
	      return {
	        position: 'absolute',
	        height: '20%',
	        left: 0,
	        right: 0,
	        top: 20 * (index * 2) + '%',
	        opacity: this.state.hover ? 0.6 : 1
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon = undefined;
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        opacity: 0,
	        fontSize: 8,
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-icon',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          null,
	          [0, 1, 2].map(function (bar) {
	            return _react2['default'].createElement('span', {
	              key: bar,
	              className: ('bm-burger-bars ' + _this.props.barClassName).trim(),
	              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-burger-button ' + this.props.className).trim(),
	          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          {
	            onClick: this.props.onClick,
	            onMouseOver: function () {
	              return _this.setState({ hover: true });
	            },
	            onMouseOut: function () {
	              return _this.setState({ hover: false });
	            },
	            style: buttonStyle
	          },
	          'Open Menu'
	        )
	      );
	    }
	  }]);
	
	  return BurgerIcon;
	})(_react.Component);
	
	exports['default'] = BurgerIcon;
	
	BurgerIcon.propTypes = {
	  barClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	BurgerIcon.defaultProps = {
	  barClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  slide: __webpack_require__(125),
	  stack: __webpack_require__(126),
	  elastic: __webpack_require__(118),
	  bubble: __webpack_require__(117),
	  push: __webpack_require__(120),
	  pushRotate: __webpack_require__(121),
	  scaleDown: __webpack_require__(123),
	  scaleRotate: __webpack_require__(124),
	  fallDown: __webpack_require__(119),
	  reveal: __webpack_require__(122)
	};
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var CrossIcon = (function (_Component) {
	  _inherits(CrossIcon, _Component);
	
	  function CrossIcon() {
	    _classCallCheck(this, CrossIcon);
	
	    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CrossIcon, [{
	    key: 'getCrossStyle',
	    value: function getCrossStyle(type) {
	      return {
	        position: 'absolute',
	        width: 3,
	        height: 14,
	        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon;
	      var buttonWrapperStyle = {
	        position: 'absolute',
	        width: 24,
	        height: 24,
	        right: 8,
	        top: 8
	      };
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        textIndent: -9999,
	        background: 'transparent',
	        outline: 'none',
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-cross',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          { style: { position: 'absolute', top: '6px', right: '14px' } },
	          ['before', 'after'].map(function (type, i) {
	            return _react2['default'].createElement('span', {
	              key: i,
	              className: ('bm-cross ' + _this.props.crossClassName).trim(),
	              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-cross-button ' + this.props.className).trim(),
	          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          { onClick: this.props.onClick, style: buttonStyle },
	          'Close Menu'
	        )
	      );
	    }
	  }]);
	
	  return CrossIcon;
	})(_react.Component);
	
	exports['default'] = CrossIcon;
	
	CrossIcon.propTypes = {
	  crossClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	CrossIcon.defaultProps = {
	  crossClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var styles = {
	  overlay: function overlay(isOpen) {
	    return {
	      position: 'fixed',
	      zIndex: 1000,
	      width: '100%',
	      height: '100%',
	      background: 'rgba(0, 0, 0, 0.3)',
	      opacity: isOpen ? 1 : 0,
	      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      zIndex: 1100,
	      width: width,
	      height: '100%',
	      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  menu: function menu() {
	    return {
	      height: '100%',
	      boxSizing: 'border-box',
	      overflow: 'auto'
	    };
	  },
	
	  itemList: function itemList() {
	    return {
	      height: '100%'
	    };
	  },
	
	  item: function item() {
	    return {
	      display: 'block',
	      outline: 'none'
	    };
	  }
	};
	
	exports['default'] = styles;
	module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(30);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
	    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
	    animate: function animate(path) {
	      var pos = 0;
	      var steps = this.pathOpen.split(';');
	      var stepsTotal = steps.length;
	      var mina = window.mina;
	
	      var nextStep = function nextStep() {
	        if (pos > stepsTotal - 1) return;
	
	        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
	          nextStep();
	        });
	
	        pos++;
	      };
	
	      nextStep();
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: '100%',
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    width -= 140;
	    return {
	      position: 'fixed',
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  closeButton: function closeButton(isOpen, width, right) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(30);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
	    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
	    animate: function animate(path) {
	      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: 120,
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : '',
	      MsTransform: right ? 'rotateY(180deg)' : '',
	      OTransform: right ? 'rotateY(180deg)' : '',
	      WebkitTransform: right ? 'rotateY(180deg)' : '',
	      transform: right ? 'rotateY(180deg)' : ''
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.3s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      width: 180,
	      whiteSpace: 'nowrap',
	      boxSizing: 'border-box',
	      overflow: 'visible'
	    };
	  },
	
	  itemList: function itemList(isOpen, width, right) {
	    if (right) {
	      return {
	        position: 'relative',
	        left: '-110px',
	        width: '170%',
	        overflow: 'auto'
	      };
	    }
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transition: 'all 0.5s ease-in-out'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      perspectiveOrigin: '0% 50%',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transformOrigin: right ? '100% 50%' : '0% 50%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      visibility: isOpen ? 'visible' : 'hidden',
	      MozTransform: 'translate3d(0, 0, 0)',
	      MsTransform: 'translate3d(0, 0, 0)',
	      OTransform: 'translate3d(0, 0, 0)',
	      WebkitTransform: 'translate3d(0, 0, 0)',
	      transform: 'translate3d(0, 0, 0)',
	      zIndex: 1000
	    };
	  },
	
	  overlay: function overlay(isOpen, width, right) {
	    return {
	      zIndex: 1400,
	      MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.5s',
	      visibility: isOpen ? 'visible' : 'hidden'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s',
	      zIndex: 1200,
	      position: 'relative'
	    };
	  },
	
	  burgerIcon: function burgerIcon(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.1s',
	      position: 'relative',
	      zIndex: 1300
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transformOrigin: '100%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer() {
	    return {
	      perspective: '1500px'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(3);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(129);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(62);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(128);
	
	var _HelmetConstants = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(50);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(66));
	var shallowEqual = _interopDefault(__webpack_require__(130));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	window.eve = __webpack_require__(65)
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	var mina = (function (eve) {
	    var animations = {},
	    requestAnimFrame = window.requestAnimationFrame       ||
	                       window.webkitRequestAnimationFrame ||
	                       window.mozRequestAnimationFrame    ||
	                       window.oRequestAnimationFrame      ||
	                       window.msRequestAnimationFrame     ||
	                       function (callback) {
	                           setTimeout(callback, 16, new Date().getTime());
	                           return true;
	                       },
	    requestID,
	    isArray = Array.isArray || function (a) {
	        return a instanceof Array ||
	            Object.prototype.toString.call(a) == "[object Array]";
	    },
	    idgen = 0,
	    idprefix = "M" + (+new Date).toString(36),
	    ID = function () {
	        return idprefix + (idgen++).toString(36);
	    },
	    diff = function (a, b, A, B) {
	        if (isArray(a)) {
	            res = [];
	            for (var i = 0, ii = a.length; i < ii; i++) {
	                res[i] = diff(a[i], b, A[i], B);
	            }
	            return res;
	        }
	        var dif = (A - a) / (B - b);
	        return function (bb) {
	            return a + dif * (bb - b);
	        };
	    },
	    timer = Date.now || function () {
	        return +new Date;
	    },
	    sta = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.s;
	        }
	        var ds = a.s - val;
	        a.b += a.dur * ds;
	        a.B += a.dur * ds;
	        a.s = val;
	    },
	    speed = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.spd;
	        }
	        a.spd = val;
	    },
	    duration = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.dur;
	        }
	        a.s = a.s * val / a.dur;
	        a.dur = val;
	    },
	    stopit = function () {
	        var a = this;
	        delete animations[a.id];
	        a.update();
	        eve("mina.stop." + a.id, a);
	    },
	    pause = function () {
	        var a = this;
	        if (a.pdif) {
	            return;
	        }
	        delete animations[a.id];
	        a.update();
	        a.pdif = a.get() - a.b;
	    },
	    resume = function () {
	        var a = this;
	        if (!a.pdif) {
	            return;
	        }
	        a.b = a.get() - a.pdif;
	        delete a.pdif;
	        animations[a.id] = a;
	        frame();
	    },
	    update = function () {
	        var a = this,
	            res;
	        if (isArray(a.start)) {
	            res = [];
	            for (var j = 0, jj = a.start.length; j < jj; j++) {
	                res[j] = +a.start[j] +
	                    (a.end[j] - a.start[j]) * a.easing(a.s);
	            }
	        } else {
	            res = +a.start + (a.end - a.start) * a.easing(a.s);
	        }
	        a.set(res);
	    },
	    frame = function (timeStamp) {
	        // Manual invokation?
	        if (!timeStamp) {
	            // Frame loop stopped?
	            if (!requestID) {
	                // Start frame loop...
	                requestID = requestAnimFrame(frame);
	            }
	            return;
	        }
	        var len = 0;
	        for (var i in animations) if (animations.hasOwnProperty(i)) {
	            var a = animations[i],
	                b = a.get(),
	                res;
	            len++;
	            a.s = (b - a.b) / (a.dur / a.spd);
	            if (a.s >= 1) {
	                delete animations[i];
	                a.s = 1;
	                len--;
	                (function (a) {
	                    setTimeout(function () {
	                        eve("mina.finish." + a.id, a);
	                    });
	                }(a));
	            }
	            a.update();
	        }
	        requestID = len ? requestAnimFrame(frame) : false;
	    },
	    /*\
	     * mina
	     [ method ]
	     **
	     * Generic animation of numbers
	     **
	     - a (number) start _slave_ number
	     - A (number) end _slave_ number
	     - b (number) start _master_ number (start time in general case)
	     - B (number) end _master_ number (end time in general case)
	     - get (function) getter of _master_ number (see @mina.time)
	     - set (function) setter of _slave_ number
	     - easing (function) #optional easing function, default is @mina.linear
	     = (object) animation descriptor
	     o {
	     o         id (string) animation id,
	     o         start (number) start _slave_ number,
	     o         end (number) end _slave_ number,
	     o         b (number) start _master_ number,
	     o         s (number) animation status (0..1),
	     o         dur (number) animation duration,
	     o         spd (number) animation speed,
	     o         get (function) getter of _master_ number (see @mina.time),
	     o         set (function) setter of _slave_ number,
	     o         easing (function) easing function, default is @mina.linear,
	     o         status (function) status getter/setter,
	     o         speed (function) speed getter/setter,
	     o         duration (function) duration getter/setter,
	     o         stop (function) animation stopper
	     o         pause (function) pauses the animation
	     o         resume (function) resumes the animation
	     o         update (function) calles setter with the right value of the animation
	     o }
	    \*/
	    mina = function (a, A, b, B, get, set, easing) {
	        var anim = {
	            id: ID(),
	            start: a,
	            end: A,
	            b: b,
	            s: 0,
	            dur: B - b,
	            spd: 1,
	            get: get,
	            set: set,
	            easing: easing || mina.linear,
	            status: sta,
	            speed: speed,
	            duration: duration,
	            stop: stopit,
	            pause: pause,
	            resume: resume,
	            update: update
	        };
	        animations[anim.id] = anim;
	        var len = 0, i;
	        for (i in animations) if (animations.hasOwnProperty(i)) {
	            len++;
	            if (len == 2) {
	                break;
	            }
	        }
	        len == 1 && frame();
	        return anim;
	    };
	    /*\
	     * mina.time
	     [ method ]
	     **
	     * Returns the current time. Equivalent to:
	     | function () {
	     |     return (new Date).getTime();
	     | }
	    \*/
	    mina.time = timer;
	    /*\
	     * mina.getById
	     [ method ]
	     **
	     * Returns an animation by its id
	     - id (string) animation's id
	     = (object) See @mina
	    \*/
	    mina.getById = function (id) {
	        return animations[id] || null;
	    };
	
	    /*\
	     * mina.linear
	     [ method ]
	     **
	     * Default linear easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.linear = function (n) {
	        return n;
	    };
	    /*\
	     * mina.easeout
	     [ method ]
	     **
	     * Easeout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeout = function (n) {
	        return Math.pow(n, 1.7);
	    };
	    /*\
	     * mina.easein
	     [ method ]
	     **
	     * Easein easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easein = function (n) {
	        return Math.pow(n, .48);
	    };
	    /*\
	     * mina.easeinout
	     [ method ]
	     **
	     * Easeinout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeinout = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        if (n == 0) {
	            return 0;
	        }
	        var q = .48 - n / 1.04,
	            Q = Math.sqrt(.1734 + q * q),
	            x = Q - q,
	            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
	            y = -Q - q,
	            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
	            t = X + Y + .5;
	        return (1 - t) * 3 * t * t + t * t * t;
	    };
	    /*\
	     * mina.backin
	     [ method ]
	     **
	     * Backin easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backin = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        var s = 1.70158;
	        return n * n * ((s + 1) * n - s);
	    };
	    /*\
	     * mina.backout
	     [ method ]
	     **
	     * Backout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backout = function (n) {
	        if (n == 0) {
	            return 0;
	        }
	        n = n - 1;
	        var s = 1.70158;
	        return n * n * ((s + 1) * n + s) + 1;
	    };
	    /*\
	     * mina.elastic
	     [ method ]
	     **
	     * Elastic easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.elastic = function (n) {
	        if (n == !!n) {
	            return n;
	        }
	        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
	            (2 * Math.PI) / .3) + 1;
	    };
	    /*\
	     * mina.bounce
	     [ method ]
	     **
	     * Bounce easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.bounce = function (n) {
	        var s = 7.5625,
	            p = 2.75,
	            l;
	        if (n < 1 / p) {
	            l = s * n * n;
	        } else {
	            if (n < 2 / p) {
	                n -= 1.5 / p;
	                l = s * n * n + .75;
	            } else {
	                if (n < 2.5 / p) {
	                    n -= 2.25 / p;
	                    l = s * n * n + .9375;
	                } else {
	                    n -= 2.625 / p;
	                    l = s * n * n + .984375;
	                }
	            }
	        }
	        return l;
	    };
	    window.mina = mina;
	    return mina;
	})(typeof eve == "undefined" ? function () {} : eve);
	
	// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	var Snap = (function(root) {
	Snap.version = "0.5.1";
	/*\
	 * Snap
	 [ method ]
	 **
	 * Creates a drawing surface or wraps existing SVG element.
	 **
	 - width (number|string) width of surface
	 - height (number|string) height of surface
	 * or
	 - DOM (SVGElement) element to be wrapped into Snap structure
	 * or
	 - array (array) array of elements (will return set of elements)
	 * or
	 - query (string) CSS query selector
	 = (object) @Element
	\*/
	function Snap(w, h) {
	    if (w) {
	        if (w.nodeType) {
	            return wrap(w);
	        }
	        if (is(w, "array") && Snap.set) {
	            return Snap.set.apply(Snap, w);
	        }
	        if (w instanceof Element) {
	            return w;
	        }
	        if (h == null) {
	            try {
	                w = glob.doc.querySelector(String(w));
	                return wrap(w);
	            } catch (e) {
	                return null;
	            }
	        }
	    }
	    w = w == null ? "100%" : w;
	    h = h == null ? "100%" : h;
	    return new Paper(w, h);
	}
	Snap.toString = function () {
	    return "Snap v" + this.version;
	};
	Snap._ = {};
	var glob = {
	    win: root.window,
	    doc: root.window.document
	};
	Snap._.glob = glob;
	var has = "hasOwnProperty",
	    Str = String,
	    toFloat = parseFloat,
	    toInt = parseInt,
	    math = Math,
	    mmax = math.max,
	    mmin = math.min,
	    abs = math.abs,
	    pow = math.pow,
	    PI = math.PI,
	    round = math.round,
	    E = "",
	    S = " ",
	    objectToString = Object.prototype.toString,
	    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
	    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
	    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
	    separator = Snap._.separator = /[,\s]+/,
	    whitespace = /[\s]/g,
	    commaSpaces = /[\s]*,[\s]*/,
	    hsrg = {hs: 1, rg: 1},
	    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig,
	    idgen = 0,
	    idprefix = "S" + (+new Date).toString(36),
	    ID = function (el) {
	        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
	    },
	    xlink = "http://www.w3.org/1999/xlink",
	    xmlns = "http://www.w3.org/2000/svg",
	    hub = {},
	    /*\
	     * Snap.url
	     [ method ]
	     **
	     * Wraps path into `"url('<path>')"`.
	     - value (string) path
	     = (string) wrapped path
	    \*/
	    URL = Snap.url = function (url) {
	        return "url('#" + url + "')";
	    };
	
	function $(el, attr) {
	    if (attr) {
	        if (el == "#text") {
	            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
	        }
	        if (el == "#comment") {
	            el = glob.doc.createComment(attr.text || attr["#text"] || "");
	        }
	        if (typeof el == "string") {
	            el = $(el);
	        }
	        if (typeof attr == "string") {
	            if (el.nodeType == 1) {
	                if (attr.substring(0, 6) == "xlink:") {
	                    return el.getAttributeNS(xlink, attr.substring(6));
	                }
	                if (attr.substring(0, 4) == "xml:") {
	                    return el.getAttributeNS(xmlns, attr.substring(4));
	                }
	                return el.getAttribute(attr);
	            } else if (attr == "text") {
	                return el.nodeValue;
	            } else {
	                return null;
	            }
	        }
	        if (el.nodeType == 1) {
	            for (var key in attr) if (attr[has](key)) {
	                var val = Str(attr[key]);
	                if (val) {
	                    if (key.substring(0, 6) == "xlink:") {
	                        el.setAttributeNS(xlink, key.substring(6), val);
	                    } else if (key.substring(0, 4) == "xml:") {
	                        el.setAttributeNS(xmlns, key.substring(4), val);
	                    } else {
	                        el.setAttribute(key, val);
	                    }
	                } else {
	                    el.removeAttribute(key);
	                }
	            }
	        } else if ("text" in attr) {
	            el.nodeValue = attr.text;
	        }
	    } else {
	        el = glob.doc.createElementNS(xmlns, el);
	    }
	    return el;
	}
	Snap._.$ = $;
	Snap._.id = ID;
	function getAttrs(el) {
	    var attrs = el.attributes,
	        name,
	        out = {};
	    for (var i = 0; i < attrs.length; i++) {
	        if (attrs[i].namespaceURI == xlink) {
	            name = "xlink:";
	        } else {
	            name = "";
	        }
	        name += attrs[i].name;
	        out[name] = attrs[i].textContent;
	    }
	    return out;
	}
	function is(o, type) {
	    type = Str.prototype.toLowerCase.call(type);
	    if (type == "finite") {
	        return isFinite(o);
	    }
	    if (type == "array" &&
	        (o instanceof Array || Array.isArray && Array.isArray(o))) {
	        return true;
	    }
	    return  type == "null" && o === null ||
	            type == typeof o && o !== null ||
	            type == "object" && o === Object(o) ||
	            objectToString.call(o).slice(8, -1).toLowerCase() == type;
	}
	/*\
	 * Snap.format
	 [ method ]
	 **
	 * Replaces construction of type `{<name>}` to the corresponding argument
	 **
	 - token (string) string to format
	 - json (object) object which properties are used as a replacement
	 = (string) formatted string
	 > Usage
	 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
	 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
	 |     x: 10,
	 |     y: 20,
	 |     dim: {
	 |         width: 40,
	 |         height: 50,
	 |         "negative width": -40
	 |     }
	 | }));
	\*/
	Snap.format = (function () {
	    var tokenRegex = /\{([^\}]+)\}/g,
	        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
	        replacer = function (all, key, obj) {
	            var res = obj;
	            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
	                name = name || quotedName;
	                if (res) {
	                    if (name in res) {
	                        res = res[name];
	                    }
	                    typeof res == "function" && isFunc && (res = res());
	                }
	            });
	            res = (res == null || res == obj ? all : res) + "";
	            return res;
	        };
	    return function (str, obj) {
	        return Str(str).replace(tokenRegex, function (all, key) {
	            return replacer(all, key, obj);
	        });
	    };
	})();
	function clone(obj) {
	    if (typeof obj == "function" || Object(obj) !== obj) {
	        return obj;
	    }
	    var res = new obj.constructor;
	    for (var key in obj) if (obj[has](key)) {
	        res[key] = clone(obj[key]);
	    }
	    return res;
	}
	Snap._.clone = clone;
	function repush(array, item) {
	    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
	        return array.push(array.splice(i, 1)[0]);
	    }
	}
	function cacher(f, scope, postprocessor) {
	    function newf() {
	        var arg = Array.prototype.slice.call(arguments, 0),
	            args = arg.join("\u2400"),
	            cache = newf.cache = newf.cache || {},
	            count = newf.count = newf.count || [];
	        if (cache[has](args)) {
	            repush(count, args);
	            return postprocessor ? postprocessor(cache[args]) : cache[args];
	        }
	        count.length >= 1e3 && delete cache[count.shift()];
	        count.push(args);
	        cache[args] = f.apply(scope, arg);
	        return postprocessor ? postprocessor(cache[args]) : cache[args];
	    }
	    return newf;
	}
	Snap._.cacher = cacher;
	function angle(x1, y1, x2, y2, x3, y3) {
	    if (x3 == null) {
	        var x = x1 - x2,
	            y = y1 - y2;
	        if (!x && !y) {
	            return 0;
	        }
	        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
	    } else {
	        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
	    }
	}
	function rad(deg) {
	    return deg % 360 * PI / 180;
	}
	function deg(rad) {
	    return rad * 180 / PI % 360;
	}
	function x_y() {
	    return this.x + S + this.y;
	}
	function x_y_w_h() {
	    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
	}
	
	/*\
	 * Snap.rad
	 [ method ]
	 **
	 * Transform angle to radians
	 - deg (number) angle in degrees
	 = (number) angle in radians
	\*/
	Snap.rad = rad;
	/*\
	 * Snap.deg
	 [ method ]
	 **
	 * Transform angle to degrees
	 - rad (number) angle in radians
	 = (number) angle in degrees
	\*/
	Snap.deg = deg;
	/*\
	 * Snap.sin
	 [ method ]
	 **
	 * Equivalent to `Math.sin()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) sin
	\*/
	Snap.sin = function (angle) {
	    return math.sin(Snap.rad(angle));
	};
	/*\
	 * Snap.tan
	 [ method ]
	 **
	 * Equivalent to `Math.tan()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) tan
	\*/
	Snap.tan = function (angle) {
	    return math.tan(Snap.rad(angle));
	};
	/*\
	 * Snap.cos
	 [ method ]
	 **
	 * Equivalent to `Math.cos()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) cos
	\*/
	Snap.cos = function (angle) {
	    return math.cos(Snap.rad(angle));
	};
	/*\
	 * Snap.asin
	 [ method ]
	 **
	 * Equivalent to `Math.asin()` only works with degrees, not radians.
	 - num (number) value
	 = (number) asin in degrees
	\*/
	Snap.asin = function (num) {
	    return Snap.deg(math.asin(num));
	};
	/*\
	 * Snap.acos
	 [ method ]
	 **
	 * Equivalent to `Math.acos()` only works with degrees, not radians.
	 - num (number) value
	 = (number) acos in degrees
	\*/
	Snap.acos = function (num) {
	    return Snap.deg(math.acos(num));
	};
	/*\
	 * Snap.atan
	 [ method ]
	 **
	 * Equivalent to `Math.atan()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan in degrees
	\*/
	Snap.atan = function (num) {
	    return Snap.deg(math.atan(num));
	};
	/*\
	 * Snap.atan2
	 [ method ]
	 **
	 * Equivalent to `Math.atan2()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan2 in degrees
	\*/
	Snap.atan2 = function (num) {
	    return Snap.deg(math.atan2(num));
	};
	/*\
	 * Snap.angle
	 [ method ]
	 **
	 * Returns an angle between two or three points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 - x3 (number) #optional x coord of third point
	 - y3 (number) #optional y coord of third point
	 = (number) angle in degrees
	\*/
	Snap.angle = angle;
	/*\
	 * Snap.len
	 [ method ]
	 **
	 * Returns distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len = function (x1, y1, x2, y2) {
	    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
	};
	/*\
	 * Snap.len2
	 [ method ]
	 **
	 * Returns squared distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len2 = function (x1, y1, x2, y2) {
	    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
	};
	/*\
	 * Snap.closestPoint
	 [ method ]
	 **
	 * Returns closest point to a given one on a given path.
	 - path (Element) path element
	 - x (number) x coord of a point
	 - y (number) y coord of a point
	 = (object) in format
	 {
	    x (number) x coord of the point on the path
	    y (number) y coord of the point on the path
	    length (number) length of the path to the point
	    distance (number) distance from the given point to the path
	 }
	\*/
	// Copied from http://bl.ocks.org/mbostock/8027637
	Snap.closestPoint = function (path, x, y) {
	    function distance2(p) {
	        var dx = p.x - x,
	            dy = p.y - y;
	        return dx * dx + dy * dy;
	    }
	    var pathNode = path.node,
	        pathLength = pathNode.getTotalLength(),
	        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
	        best,
	        bestLength,
	        bestDistance = Infinity;
	
	    // linear scan for coarse approximation
	    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
	        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
	            best = scan;
	            bestLength = scanLength;
	            bestDistance = scanDistance;
	        }
	    }
	
	    // binary search for precise estimate
	    precision *= .5;
	    while (precision > .5) {
	        var before,
	            after,
	            beforeLength,
	            afterLength,
	            beforeDistance,
	            afterDistance;
	        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
	            best = before;
	            bestLength = beforeLength;
	            bestDistance = beforeDistance;
	        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
	            best = after;
	            bestLength = afterLength;
	            bestDistance = afterDistance;
	        } else {
	            precision *= .5;
	        }
	    }
	
	    best = {
	        x: best.x,
	        y: best.y,
	        length: bestLength,
	        distance: Math.sqrt(bestDistance)
	    };
	    return best;
	}
	/*\
	 * Snap.is
	 [ method ]
	 **
	 * Handy replacement for the `typeof` operator
	 - o (…) any object or primitive
	 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
	 = (boolean) `true` if given value is of given type
	\*/
	Snap.is = is;
	/*\
	 * Snap.snapTo
	 [ method ]
	 **
	 * Snaps given value to given grid
	 - values (array|number) given array of values or step of the grid
	 - value (number) value to adjust
	 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
	 = (number) adjusted value
	\*/
	Snap.snapTo = function (values, value, tolerance) {
	    tolerance = is(tolerance, "finite") ? tolerance : 10;
	    if (is(values, "array")) {
	        var i = values.length;
	        while (i--) if (abs(values[i] - value) <= tolerance) {
	            return values[i];
	        }
	    } else {
	        values = +values;
	        var rem = value % values;
	        if (rem < tolerance) {
	            return value - rem;
	        }
	        if (rem > values - tolerance) {
	            return value - rem + values;
	        }
	    }
	    return value;
	};
	// Colour
	/*\
	 * Snap.getRGB
	 [ method ]
	 **
	 * Parses color string as RGB object
	 - color (string) color string in one of the following formats:
	 # <ul>
	 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
	 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
	 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
	 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
	 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
	 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
	 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
	 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
	 # </ul>
	 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) true if string can't be parsed
	 o }
	\*/
	Snap.getRGB = cacher(function (colour) {
	    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    if (colour == "none") {
	        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
	    }
	    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
	    if (!colour) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    var res,
	        red,
	        green,
	        blue,
	        opacity,
	        t,
	        values,
	        rgb = colour.match(colourRegExp);
	    if (rgb) {
	        if (rgb[2]) {
	            blue = toInt(rgb[2].substring(5), 16);
	            green = toInt(rgb[2].substring(3, 5), 16);
	            red = toInt(rgb[2].substring(1, 3), 16);
	        }
	        if (rgb[3]) {
	            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
	            green = toInt((t = rgb[3].charAt(2)) + t, 16);
	            red = toInt((t = rgb[3].charAt(1)) + t, 16);
	        }
	        if (rgb[4]) {
	            values = rgb[4].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red *= 2.55);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green *= 2.55);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue *= 2.55);
	            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	        }
	        if (rgb[5]) {
	            values = rgb[5].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsb2rgb(red, green, blue, opacity);
	        }
	        if (rgb[6]) {
	            values = rgb[6].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsl2rgb(red, green, blue, opacity);
	        }
	        red = mmin(math.round(red), 255);
	        green = mmin(math.round(green), 255);
	        blue = mmin(math.round(blue), 255);
	        opacity = mmin(mmax(opacity, 0), 1);
	        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
	        rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
	        rgb.opacity = is(opacity, "finite") ? opacity : 1;
	        return rgb;
	    }
	    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	}, Snap);
	/*\
	 * Snap.hsb
	 [ method ]
	 **
	 * Converts HSB values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - b (number) value or brightness
	 = (string) hex representation of the color
	\*/
	Snap.hsb = cacher(function (h, s, b) {
	    return Snap.hsb2rgb(h, s, b).hex;
	});
	/*\
	 * Snap.hsl
	 [ method ]
	 **
	 * Converts HSL values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (string) hex representation of the color
	\*/
	Snap.hsl = cacher(function (h, s, l) {
	    return Snap.hsl2rgb(h, s, l).hex;
	});
	/*\
	 * Snap.rgb
	 [ method ]
	 **
	 * Converts RGB values to a hex representation of the color
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (string) hex representation of the color
	\*/
	Snap.rgb = cacher(function (r, g, b, o) {
	    if (is(o, "finite")) {
	        var round = math.round;
	        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
	    }
	    return "#" + (16777216 | b | g << 8 | r << 16).toString(16).slice(1);
	});
	var toHex = function (color) {
	    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
	        red = "rgb(255, 0, 0)";
	    toHex = cacher(function (color) {
	        if (color.toLowerCase() == "red") {
	            return red;
	        }
	        i.style.color = red;
	        i.style.color = color;
	        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
	        return out == red ? null : out;
	    });
	    return toHex(color);
	},
	hsbtoString = function () {
	    return "hsb(" + [this.h, this.s, this.b] + ")";
	},
	hsltoString = function () {
	    return "hsl(" + [this.h, this.s, this.l] + ")";
	},
	rgbtoString = function () {
	    return this.opacity == 1 || this.opacity == null ?
	            this.hex :
	            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
	},
	prepareRGB = function (r, g, b) {
	    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
	        b = r.b;
	        g = r.g;
	        r = r.r;
	    }
	    if (g == null && is(r, string)) {
	        var clr = Snap.getRGB(r);
	        r = clr.r;
	        g = clr.g;
	        b = clr.b;
	    }
	    if (r > 1 || g > 1 || b > 1) {
	        r /= 255;
	        g /= 255;
	        b /= 255;
	    }
	
	    return [r, g, b];
	},
	packageRGB = function (r, g, b, o) {
	    r = math.round(r * 255);
	    g = math.round(g * 255);
	    b = math.round(b * 255);
	    var rgb = {
	        r: r,
	        g: g,
	        b: b,
	        opacity: is(o, "finite") ? o : 1,
	        hex: Snap.rgb(r, g, b),
	        toString: rgbtoString
	    };
	    is(o, "finite") && (rgb.opacity = o);
	    return rgb;
	};
	/*\
	 * Snap.color
	 [ method ]
	 **
	 * Parses the color string and returns an object featuring the color's component values
	 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
	 = (object) Combined RGB/HSB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) `true` if string can't be parsed,
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     v (number) value (brightness),
	 o     l (number) lightness
	 o }
	\*/
	Snap.color = function (clr) {
	    var rgb;
	    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
	        rgb = Snap.hsb2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
	        rgb = Snap.hsl2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else {
	        if (is(clr, "string")) {
	            clr = Snap.getRGB(clr);
	        }
	        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
	            rgb = Snap.rgb2hsl(clr);
	            clr.h = rgb.h;
	            clr.s = rgb.s;
	            clr.l = rgb.l;
	            rgb = Snap.rgb2hsb(clr);
	            clr.v = rgb.b;
	        } else {
	            clr = {hex: "none"};
	            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
	            clr.error = 1;
	        }
	    }
	    clr.toString = rgbtoString;
	    return clr;
	};
	/*\
	 * Snap.hsb2rgb
	 [ method ]
	 **
	 * Converts HSB values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - v (number) value or brightness
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsb2rgb = function (h, s, v, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
	        v = h.b;
	        s = h.s;
	        o = h.o;
	        h = h.h;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = v * s;
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = v - C;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.hsl2rgb
	 [ method ]
	 **
	 * Converts HSL values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsl2rgb = function (h, s, l, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	    }
	    if (h > 1 || s > 1 || l > 1) {
	        h /= 360;
	        s /= 100;
	        l /= 100;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = 2 * s * (l < .5 ? l : 1 - l);
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = l - C / 2;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.rgb2hsb
	 [ method ]
	 **
	 * Converts RGB values to an HSB object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSB object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     b (number) brightness
	 o }
	\*/
	Snap.rgb2hsb = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, V, C;
	    V = mmax(r, g, b);
	    C = V - mmin(r, g, b);
	    H = C == 0 ? null :
	        V == r ? (g - b) / C :
	        V == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    S = C == 0 ? 0 : C / V;
	    return {h: H, s: S, b: V, toString: hsbtoString};
	};
	/*\
	 * Snap.rgb2hsl
	 [ method ]
	 **
	 * Converts RGB values to an HSL object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSL object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     l (number) luminosity
	 o }
	\*/
	Snap.rgb2hsl = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, L, M, m, C;
	    M = mmax(r, g, b);
	    m = mmin(r, g, b);
	    C = M - m;
	    H = C == 0 ? null :
	        M == r ? (g - b) / C :
	        M == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    L = (M + m) / 2;
	    S = C == 0 ? 0 :
	         L < .5 ? C / (2 * L) :
	                  C / (2 - 2 * L);
	    return {h: H, s: S, l: L, toString: hsltoString};
	};
	
	// Transformations
	/*\
	 * Snap.parsePathString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given path string into an array of arrays of path segments
	 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
	 = (array) array of segments
	\*/
	Snap.parsePathString = function (pathString) {
	    if (!pathString) {
	        return null;
	    }
	    var pth = Snap.path(pathString);
	    if (pth.arr) {
	        return Snap.path.clone(pth.arr);
	    }
	
	    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
	        data = [];
	    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
	        data = Snap.path.clone(pathString);
	    }
	    if (!data.length) {
	        Str(pathString).replace(pathCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            if (name == "m" && params.length > 2) {
	                data.push([b].concat(params.splice(0, 2)));
	                name = "l";
	                b = b == "m" ? "l" : "L";
	            }
	            if (name == "o" && params.length == 1) {
	                data.push([b, params[0]]);
	            }
	            if (name == "r") {
	                data.push([b].concat(params));
	            } else while (params.length >= paramCounts[name]) {
	                data.push([b].concat(params.splice(0, paramCounts[name])));
	                if (!paramCounts[name]) {
	                    break;
	                }
	            }
	        });
	    }
	    data.toString = Snap.path.toString;
	    pth.arr = Snap.path.clone(data);
	    return data;
	};
	/*\
	 * Snap.parseTransformString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given transform string into an array of transformations
	 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
	 = (array) array of transformations
	\*/
	var parseTransformString = Snap.parseTransformString = function (TString) {
	    if (!TString) {
	        return null;
	    }
	    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
	        data = [];
	    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
	        data = Snap.path.clone(TString);
	    }
	    if (!data.length) {
	        Str(TString).replace(tCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            data.push([b].concat(params));
	        });
	    }
	    data.toString = Snap.path.toString;
	    return data;
	};
	function svgTransform2string(tstr) {
	    var res = [];
	    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
	        params = params.split(/\s*,\s*|\s+/);
	        if (name == "rotate" && params.length == 1) {
	            params.push(0, 0);
	        }
	        if (name == "scale") {
	            if (params.length > 2) {
	                params = params.slice(0, 2);
	            } else if (params.length == 2) {
	                params.push(0, 0);
	            }
	            if (params.length == 1) {
	                params.push(params[0], 0, 0);
	            }
	        }
	        if (name == "skewX") {
	            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
	        } else if (name == "skewY") {
	            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
	        } else {
	            res.push([name.charAt(0)].concat(params));
	        }
	        return all;
	    });
	    return res;
	}
	Snap._.svgTransform2string = svgTransform2string;
	Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
	function transform2matrix(tstr, bbox) {
	    var tdata = parseTransformString(tstr),
	        m = new Snap.Matrix;
	    if (tdata) {
	        for (var i = 0, ii = tdata.length; i < ii; i++) {
	            var t = tdata[i],
	                tlen = t.length,
	                command = Str(t[0]).toLowerCase(),
	                absolute = t[0] != command,
	                inver = absolute ? m.invert() : 0,
	                x1,
	                y1,
	                x2,
	                y2,
	                bb;
	            if (command == "t" && tlen == 2){
	                m.translate(t[1], 0);
	            } else if (command == "t" && tlen == 3) {
	                if (absolute) {
	                    x1 = inver.x(0, 0);
	                    y1 = inver.y(0, 0);
	                    x2 = inver.x(t[1], t[2]);
	                    y2 = inver.y(t[1], t[2]);
	                    m.translate(x2 - x1, y2 - y1);
	                } else {
	                    m.translate(t[1], t[2]);
	                }
	            } else if (command == "r") {
	                if (tlen == 2) {
	                    bb = bb || bbox;
	                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.rotate(t[1], x2, y2);
	                    } else {
	                        m.rotate(t[1], t[2], t[3]);
	                    }
	                }
	            } else if (command == "s") {
	                if (tlen == 2 || tlen == 3) {
	                    bb = bb || bbox;
	                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.scale(t[1], t[1], x2, y2);
	                    } else {
	                        m.scale(t[1], t[1], t[2], t[3]);
	                    }
	                } else if (tlen == 5) {
	                    if (absolute) {
	                        x2 = inver.x(t[3], t[4]);
	                        y2 = inver.y(t[3], t[4]);
	                        m.scale(t[1], t[2], x2, y2);
	                    } else {
	                        m.scale(t[1], t[2], t[3], t[4]);
	                    }
	                }
	            } else if (command == "m" && tlen == 7) {
	                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
	            }
	        }
	    }
	    return m;
	}
	Snap._.transform2matrix = transform2matrix;
	Snap._unit2px = unit2px;
	var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
	    function (a, b) {
	        var adown = a.nodeType == 9 ? a.documentElement : a,
	            bup = b && b.parentNode;
	            return a == bup || !!(bup && bup.nodeType == 1 && (
	                adown.contains ?
	                    adown.contains(bup) :
	                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
	            ));
	    } :
	    function (a, b) {
	        if (b) {
	            while (b) {
	                b = b.parentNode;
	                if (b == a) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	function getSomeDefs(el) {
	    var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) ||
	            el.node.parentNode && wrap(el.node.parentNode) ||
	            Snap.select("svg") ||
	            Snap(0, 0),
	        pdefs = p.select("defs"),
	        defs  = pdefs == null ? false : pdefs.node;
	    if (!defs) {
	        defs = make("defs", p.node).node;
	    }
	    return defs;
	}
	function getSomeSVG(el) {
	    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
	}
	Snap._.getSomeDefs = getSomeDefs;
	Snap._.getSomeSVG = getSomeSVG;
	function unit2px(el, name, value) {
	    var svg = getSomeSVG(el).node,
	        out = {},
	        mgr = svg.querySelector(".svg---mgr");
	    if (!mgr) {
	        mgr = $("rect");
	        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
	        svg.appendChild(mgr);
	    }
	    function getW(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {width: val});
	        try {
	            return mgr.getBBox().width;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function getH(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {height: val});
	        try {
	            return mgr.getBBox().height;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function set(nam, f) {
	        if (name == null) {
	            out[nam] = f(el.attr(nam) || 0);
	        } else if (nam == name) {
	            out = f(value == null ? el.attr(nam) || 0 : value);
	        }
	    }
	    switch (el.type) {
	        case "rect":
	            set("rx", getW);
	            set("ry", getH);
	        case "image":
	            set("width", getW);
	            set("height", getH);
	        case "text":
	            set("x", getW);
	            set("y", getH);
	        break;
	        case "circle":
	            set("cx", getW);
	            set("cy", getH);
	            set("r", getW);
	        break;
	        case "ellipse":
	            set("cx", getW);
	            set("cy", getH);
	            set("rx", getW);
	            set("ry", getH);
	        break;
	        case "line":
	            set("x1", getW);
	            set("x2", getW);
	            set("y1", getH);
	            set("y2", getH);
	        break;
	        case "marker":
	            set("refX", getW);
	            set("markerWidth", getW);
	            set("refY", getH);
	            set("markerHeight", getH);
	        break;
	        case "radialGradient":
	            set("fx", getW);
	            set("fy", getH);
	        break;
	        case "tspan":
	            set("dx", getW);
	            set("dy", getH);
	        break;
	        default:
	            set(name, getW);
	    }
	    svg.removeChild(mgr);
	    return out;
	}
	/*\
	 * Snap.select
	 [ method ]
	 **
	 * Wraps a DOM element specified by CSS selector as @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.select = function (query) {
	    query = Str(query).replace(/([^\\]):/g, "$1\\:");
	    return wrap(glob.doc.querySelector(query));
	};
	/*\
	 * Snap.selectAll
	 [ method ]
	 **
	 * Wraps DOM elements specified by CSS selector as set or array of @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.selectAll = function (query) {
	    var nodelist = glob.doc.querySelectorAll(query),
	        set = (Snap.set || Array)();
	    for (var i = 0; i < nodelist.length; i++) {
	        set.push(wrap(nodelist[i]));
	    }
	    return set;
	};
	
	function add2group(list) {
	    if (!is(list, "array")) {
	        list = Array.prototype.slice.call(arguments, 0);
	    }
	    var i = 0,
	        j = 0,
	        node = this.node;
	    while (this[i]) delete this[i++];
	    for (i = 0; i < list.length; i++) {
	        if (list[i].type == "set") {
	            list[i].forEach(function (el) {
	                node.appendChild(el.node);
	            });
	        } else {
	            node.appendChild(list[i].node);
	        }
	    }
	    var children = node.childNodes;
	    for (i = 0; i < children.length; i++) {
	        this[j++] = wrap(children[i]);
	    }
	    return this;
	}
	// Hub garbage collector every 10s
	setInterval(function () {
	    for (var key in hub) if (hub[has](key)) {
	        var el = hub[key],
	            node = el.node;
	        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
	            delete hub[key];
	        }
	    }
	}, 1e4);
	function Element(el) {
	    if (el.snap in hub) {
	        return hub[el.snap];
	    }
	    var svg;
	    try {
	        svg = el.ownerSVGElement;
	    } catch(e) {}
	    /*\
	     * Element.node
	     [ property (object) ]
	     **
	     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
	     > Usage
	     | // draw a circle at coordinate 10,10 with radius of 10
	     | var c = paper.circle(10, 10, 10);
	     | c.node.onclick = function () {
	     |     c.attr("fill", "red");
	     | };
	    \*/
	    this.node = el;
	    if (svg) {
	        this.paper = new Paper(svg);
	    }
	    /*\
	     * Element.type
	     [ property (string) ]
	     **
	     * SVG tag name of the given element.
	    \*/
	    this.type = el.tagName || el.nodeName;
	    var id = this.id = ID(this);
	    this.anims = {};
	    this._ = {
	        transform: []
	    };
	    el.snap = id;
	    hub[id] = this;
	    if (this.type == "g") {
	        this.add = add2group;
	    }
	    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
	        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
	            this[method] = Paper.prototype[method];
	        }
	    }
	}
	   /*\
	     * Element.attr
	     [ method ]
	     **
	     * Gets or sets given attributes of the element.
	     **
	     - params (object) contains key-value pairs of attributes you want to set
	     * or
	     - param (string) name of the attribute
	     = (Element) the current element
	     * or
	     = (string) value of attribute
	     > Usage
	     | el.attr({
	     |     fill: "#fc0",
	     |     stroke: "#000",
	     |     strokeWidth: 2, // CamelCase...
	     |     "fill-opacity": 0.5, // or dash-separated names
	     |     width: "*=2" // prefixed values
	     | });
	     | console.log(el.attr("fill")); // #fc0
	     * Prefixed values in format `"+=10"` supported. All four operations
	     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
	     * and `-`: `"+=2em"`.
	    \*/
	    Element.prototype.attr = function (params, value) {
	        var el = this,
	            node = el.node;
	        if (!params) {
	            if (node.nodeType != 1) {
	                return {
	                    text: node.nodeValue
	                };
	            }
	            var attr = node.attributes,
	                out = {};
	            for (var i = 0, ii = attr.length; i < ii; i++) {
	                out[attr[i].nodeName] = attr[i].nodeValue;
	            }
	            return out;
	        }
	        if (is(params, "string")) {
	            if (arguments.length > 1) {
	                var json = {};
	                json[params] = value;
	                params = json;
	            } else {
	                return eve("snap.util.getattr." + params, el).firstDefined();
	            }
	        }
	        for (var att in params) {
	            if (params[has](att)) {
	                eve("snap.util.attr." + att, el, params[att]);
	            }
	        }
	        return el;
	    };
	/*\
	 * Snap.parse
	 [ method ]
	 **
	 * Parses SVG fragment and converts it into a @Fragment
	 **
	 - svg (string) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.parse = function (svg) {
	    var f = glob.doc.createDocumentFragment(),
	        full = true,
	        div = glob.doc.createElement("div");
	    svg = Str(svg);
	    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
	        svg = "<svg>" + svg + "</svg>";
	        full = false;
	    }
	    div.innerHTML = svg;
	    svg = div.getElementsByTagName("svg")[0];
	    if (svg) {
	        if (full) {
	            f = svg;
	        } else {
	            while (svg.firstChild) {
	                f.appendChild(svg.firstChild);
	            }
	        }
	    }
	    return new Fragment(f);
	};
	function Fragment(frag) {
	    this.node = frag;
	}
	/*\
	 * Snap.fragment
	 [ method ]
	 **
	 * Creates a DOM fragment from a given list of elements or strings
	 **
	 - varargs (…) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.fragment = function () {
	    var args = Array.prototype.slice.call(arguments, 0),
	        f = glob.doc.createDocumentFragment();
	    for (var i = 0, ii = args.length; i < ii; i++) {
	        var item = args[i];
	        if (item.node && item.node.nodeType) {
	            f.appendChild(item.node);
	        }
	        if (item.nodeType) {
	            f.appendChild(item);
	        }
	        if (typeof item == "string") {
	            f.appendChild(Snap.parse(item).node);
	        }
	    }
	    return new Fragment(f);
	};
	
	function make(name, parent) {
	    var res = $(name);
	    parent.appendChild(res);
	    var el = wrap(res);
	    return el;
	}
	function Paper(w, h) {
	    var res,
	        desc,
	        defs,
	        proto = Paper.prototype;
	    if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
	        if (w.snap in hub) {
	            return hub[w.snap];
	        }
	        var doc = w.ownerDocument;
	        res = new Element(w);
	        desc = w.getElementsByTagName("desc")[0];
	        defs = w.getElementsByTagName("defs")[0];
	        if (!desc) {
	            desc = $("desc");
	            desc.appendChild(doc.createTextNode("Created with Snap"));
	            res.node.appendChild(desc);
	        }
	        if (!defs) {
	            defs = $("defs");
	            res.node.appendChild(defs);
	        }
	        res.defs = defs;
	        for (var key in proto) if (proto[has](key)) {
	            res[key] = proto[key];
	        }
	        res.paper = res.root = res;
	    } else {
	        res = make("svg", glob.doc.body);
	        $(res.node, {
	            height: h,
	            version: 1.1,
	            width: w,
	            xmlns: xmlns
	        });
	    }
	    return res;
	}
	function wrap(dom) {
	    if (!dom) {
	        return dom;
	    }
	    if (dom instanceof Element || dom instanceof Fragment) {
	        return dom;
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
	        return new Paper(dom);
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
	        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
	    }
	    return new Element(dom);
	}
	
	Snap._.make = make;
	Snap._.wrap = wrap;
	/*\
	 * Paper.el
	 [ method ]
	 **
	 * Creates an element on paper with a given name and no attributes
	 **
	 - name (string) tag name
	 - attr (object) attributes
	 = (Element) the current element
	 > Usage
	 | var c = paper.circle(10, 10, 10); // is the same as...
	 | var c = paper.el("circle").attr({
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	 | // and the same as
	 | var c = paper.el("circle", {
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	\*/
	Paper.prototype.el = function (name, attr) {
	    var el = make(name, this.node);
	    attr && el.attr(attr);
	    return el;
	};
	/*\
	 * Element.children
	 [ method ]
	 **
	 * Returns array of all the children of the element.
	 = (array) array of Elements
	\*/
	Element.prototype.children = function () {
	    var out = [],
	        ch = this.node.childNodes;
	    for (var i = 0, ii = ch.length; i < ii; i++) {
	        out[i] = Snap(ch[i]);
	    }
	    return out;
	};
	function jsonFiller(root, o) {
	    for (var i = 0, ii = root.length; i < ii; i++) {
	        var item = {
	                type: root[i].type,
	                attr: root[i].attr()
	            },
	            children = root[i].children();
	        o.push(item);
	        if (children.length) {
	            jsonFiller(children, item.childNodes = []);
	        }
	    }
	}
	/*\
	 * Element.toJSON
	 [ method ]
	 **
	 * Returns object representation of the given element and all its children.
	 = (object) in format
	 o {
	 o     type (string) this.type,
	 o     attr (object) attributes map,
	 o     childNodes (array) optional array of children in the same format
	 o }
	\*/
	Element.prototype.toJSON = function () {
	    var out = [];
	    jsonFiller([this], out);
	    return out[0];
	};
	// default
	eve.on("snap.util.getattr", function () {
	    var att = eve.nt();
	    att = att.substring(att.lastIndexOf(".") + 1);
	    var css = att.replace(/[A-Z]/g, function (letter) {
	        return "-" + letter.toLowerCase();
	    });
	    if (cssAttr[has](css)) {
	        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
	    } else {
	        return $(this.node, att);
	    }
	});
	var cssAttr = {
	    "alignment-baseline": 0,
	    "baseline-shift": 0,
	    "clip": 0,
	    "clip-path": 0,
	    "clip-rule": 0,
	    "color": 0,
	    "color-interpolation": 0,
	    "color-interpolation-filters": 0,
	    "color-profile": 0,
	    "color-rendering": 0,
	    "cursor": 0,
	    "direction": 0,
	    "display": 0,
	    "dominant-baseline": 0,
	    "enable-background": 0,
	    "fill": 0,
	    "fill-opacity": 0,
	    "fill-rule": 0,
	    "filter": 0,
	    "flood-color": 0,
	    "flood-opacity": 0,
	    "font": 0,
	    "font-family": 0,
	    "font-size": 0,
	    "font-size-adjust": 0,
	    "font-stretch": 0,
	    "font-style": 0,
	    "font-variant": 0,
	    "font-weight": 0,
	    "glyph-orientation-horizontal": 0,
	    "glyph-orientation-vertical": 0,
	    "image-rendering": 0,
	    "kerning": 0,
	    "letter-spacing": 0,
	    "lighting-color": 0,
	    "marker": 0,
	    "marker-end": 0,
	    "marker-mid": 0,
	    "marker-start": 0,
	    "mask": 0,
	    "opacity": 0,
	    "overflow": 0,
	    "pointer-events": 0,
	    "shape-rendering": 0,
	    "stop-color": 0,
	    "stop-opacity": 0,
	    "stroke": 0,
	    "stroke-dasharray": 0,
	    "stroke-dashoffset": 0,
	    "stroke-linecap": 0,
	    "stroke-linejoin": 0,
	    "stroke-miterlimit": 0,
	    "stroke-opacity": 0,
	    "stroke-width": 0,
	    "text-anchor": 0,
	    "text-decoration": 0,
	    "text-rendering": 0,
	    "unicode-bidi": 0,
	    "visibility": 0,
	    "word-spacing": 0,
	    "writing-mode": 0
	};
	
	eve.on("snap.util.attr", function (value) {
	    var att = eve.nt(),
	        attr = {};
	    att = att.substring(att.lastIndexOf(".") + 1);
	    attr[att] = value;
	    var style = att.replace(/-(\w)/gi, function (all, letter) {
	            return letter.toUpperCase();
	        }),
	        css = att.replace(/[A-Z]/g, function (letter) {
	            return "-" + letter.toLowerCase();
	        });
	    if (cssAttr[has](css)) {
	        this.node.style[style] = value == null ? E : value;
	    } else {
	        $(this.node, attr);
	    }
	});
	(function (proto) {}(Paper.prototype));
	
	// simple ajax
	/*\
	 * Snap.ajax
	 [ method ]
	 **
	 * Simple implementation of Ajax
	 **
	 - url (string) URL
	 - postData (object|string) data for post request
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 * or
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 = (XMLHttpRequest) the XMLHttpRequest object, just in case
	\*/
	Snap.ajax = function (url, postData, callback, scope){
	    var req = new XMLHttpRequest,
	        id = ID();
	    if (req) {
	        if (is(postData, "function")) {
	            scope = callback;
	            callback = postData;
	            postData = null;
	        } else if (is(postData, "object")) {
	            var pd = [];
	            for (var key in postData) if (postData.hasOwnProperty(key)) {
	                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
	            }
	            postData = pd.join("&");
	        }
	        req.open(postData ? "POST" : "GET", url, true);
	        if (postData) {
	            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	        }
	        if (callback) {
	            eve.once("snap.ajax." + id + ".0", callback);
	            eve.once("snap.ajax." + id + ".200", callback);
	            eve.once("snap.ajax." + id + ".304", callback);
	        }
	        req.onreadystatechange = function() {
	            if (req.readyState != 4) return;
	            eve("snap.ajax." + id + "." + req.status, scope, req);
	        };
	        if (req.readyState == 4) {
	            return req;
	        }
	        req.send(postData);
	        return req;
	    }
	};
	/*\
	 * Snap.load
	 [ method ]
	 **
	 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
	 **
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	\*/
	Snap.load = function (url, callback, scope) {
	    Snap.ajax(url, function (req) {
	        var f = Snap.parse(req.responseText);
	        scope ? callback.call(scope, f) : callback(f);
	    });
	};
	var getOffset = function (elem) {
	    var box = elem.getBoundingClientRect(),
	        doc = elem.ownerDocument,
	        body = doc.body,
	        docElem = doc.documentElement,
	        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
	        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
	        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
	    return {
	        y: top,
	        x: left
	    };
	};
	/*\
	 * Snap.getElementByPoint
	 [ method ]
	 **
	 * Returns you topmost element under given point.
	 **
	 = (object) Snap element object
	 - x (number) x coordinate from the top left corner of the window
	 - y (number) y coordinate from the top left corner of the window
	 > Usage
	 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
	\*/
	Snap.getElementByPoint = function (x, y) {
	    var paper = this,
	        svg = paper.canvas,
	        target = glob.doc.elementFromPoint(x, y);
	    if (glob.win.opera && target.tagName == "svg") {
	        var so = getOffset(target),
	            sr = target.createSVGRect();
	        sr.x = x - so.x;
	        sr.y = y - so.y;
	        sr.width = sr.height = 1;
	        var hits = target.getIntersectionList(sr, null);
	        if (hits.length) {
	            target = hits[hits.length - 1];
	        }
	    }
	    if (!target) {
	        return null;
	    }
	    return wrap(target);
	};
	/*\
	 * Snap.plugin
	 [ method ]
	 **
	 * Let you write plugins. You pass in a function with five arguments, like this:
	 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
	 |     Snap.newmethod = function () {};
	 |     Element.prototype.newmethod = function () {};
	 |     Paper.prototype.newmethod = function () {};
	 | });
	 * Inside the function you have access to all main objects (and their
	 * prototypes). This allow you to extend anything you want.
	 **
	 - f (function) your plugin body
	\*/
	Snap.plugin = function (f) {
	    f(Snap, Element, Paper, glob, Fragment);
	};
	glob.win.Snap = Snap;
	return Snap;
	}(window || this));
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        unit2px = Snap._unit2px,
	        $ = Snap._.$,
	        make = Snap._.make,
	        getSomeDefs = Snap._.getSomeDefs,
	        has = "hasOwnProperty",
	        wrap = Snap._.wrap;
	    /*\
	     * Element.getBBox
	     [ method ]
	     **
	     * Returns the bounding box descriptor for the given element
	     **
	     = (object) bounding box descriptor:
	     o {
	     o     cx: (number) x of the center,
	     o     cy: (number) x of the center,
	     o     h: (number) height,
	     o     height: (number) height,
	     o     path: (string) path command for the box,
	     o     r0: (number) radius of a circle that fully encloses the box,
	     o     r1: (number) radius of the smallest circle that can be enclosed,
	     o     r2: (number) radius of the largest circle that can be enclosed,
	     o     vb: (string) box as a viewbox command,
	     o     w: (number) width,
	     o     width: (number) width,
	     o     x2: (number) x of the right side,
	     o     x: (number) x of the left side,
	     o     y2: (number) y of the bottom edge,
	     o     y: (number) y of the top edge
	     o }
	    \*/
	    elproto.getBBox = function (isWithoutTransform) {
	        if (this.type == "tspan") {
	            return Snap._.box(this.node.getClientRects().item(0));
	        }
	        if (!Snap.Matrix || !Snap.path) {
	            return this.node.getBBox();
	        }
	        var el = this,
	            m = new Snap.Matrix;
	        if (el.removed) {
	            return Snap._.box();
	        }
	        while (el.type == "use") {
	            if (!isWithoutTransform) {
	                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
	            }
	            if (el.original) {
	                el = el.original;
	            } else {
	                var href = el.attr("xlink:href");
	                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
	            }
	        }
	        var _ = el._,
	            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
	        try {
	            if (isWithoutTransform) {
	                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
	                return Snap._.box(_.bboxwt);
	            } else {
	                el.realPath = pathfinder(el);
	                el.matrix = el.transform().localMatrix;
	                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
	                return Snap._.box(_.bbox);
	            }
	        } catch (e) {
	            // Firefox doesn’t give you bbox of hidden element
	            return Snap._.box();
	        }
	    };
	    var propString = function () {
	        return this.string;
	    };
	    function extractTransform(el, tstr) {
	        if (tstr == null) {
	            var doReturn = true;
	            if (el.type == "linearGradient" || el.type == "radialGradient") {
	                tstr = el.node.getAttribute("gradientTransform");
	            } else if (el.type == "pattern") {
	                tstr = el.node.getAttribute("patternTransform");
	            } else {
	                tstr = el.node.getAttribute("transform");
	            }
	            if (!tstr) {
	                return new Snap.Matrix;
	            }
	            tstr = Snap._.svgTransform2string(tstr);
	        } else {
	            if (!Snap._.rgTransform.test(tstr)) {
	                tstr = Snap._.svgTransform2string(tstr);
	            } else {
	                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
	            }
	            if (is(tstr, "array")) {
	                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
	            }
	            el._.transform = tstr;
	        }
	        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
	        if (doReturn) {
	            return m;
	        } else {
	            el.matrix = m;
	        }
	    }
	    /*\
	     * Element.transform
	     [ method ]
	     **
	     * Gets or sets transformation of the element
	     **
	     - tstr (string) transform string in Snap or SVG format
	     = (Element) the current element
	     * or
	     = (object) transformation descriptor:
	     o {
	     o     string (string) transform string,
	     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
	     o     localMatrix (Matrix) matrix of transformations applied only to the element,
	     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
	     o     global (string) global transformation as string,
	     o     local (string) local transformation as string,
	     o     toString (function) returns `string` property
	     o }
	    \*/
	    elproto.transform = function (tstr) {
	        var _ = this._;
	        if (tstr == null) {
	            var papa = this,
	                global = new Snap.Matrix(this.node.getCTM()),
	                local = extractTransform(this),
	                ms = [local],
	                m = new Snap.Matrix,
	                i,
	                localString = local.toTransformString(),
	                string = Str(local) == Str(this.matrix) ?
	                            Str(_.transform) : localString;
	            while (papa.type != "svg" && (papa = papa.parent())) {
	                ms.push(extractTransform(papa));
	            }
	            i = ms.length;
	            while (i--) {
	                m.add(ms[i]);
	            }
	            return {
	                string: string,
	                globalMatrix: global,
	                totalMatrix: m,
	                localMatrix: local,
	                diffMatrix: global.clone().add(local.invert()),
	                global: global.toTransformString(),
	                total: m.toTransformString(),
	                local: localString,
	                toString: propString
	            };
	        }
	        if (tstr instanceof Snap.Matrix) {
	            this.matrix = tstr;
	            this._.transform = tstr.toTransformString();
	        } else {
	            extractTransform(this, tstr);
	        }
	
	        if (this.node) {
	            if (this.type == "linearGradient" || this.type == "radialGradient") {
	                $(this.node, {gradientTransform: this.matrix});
	            } else if (this.type == "pattern") {
	                $(this.node, {patternTransform: this.matrix});
	            } else {
	                $(this.node, {transform: this.matrix});
	            }
	        }
	
	        return this;
	    };
	    /*\
	     * Element.parent
	     [ method ]
	     **
	     * Returns the element's parent
	     **
	     = (Element) the parent element
	    \*/
	    elproto.parent = function () {
	        return wrap(this.node.parentNode);
	    };
	    /*\
	     * Element.append
	     [ method ]
	     **
	     * Appends the given element to current one
	     **
	     - el (Element|Set) element to append
	     = (Element) the parent element
	    \*/
	    /*\
	     * Element.add
	     [ method ]
	     **
	     * See @Element.append
	    \*/
	    elproto.append = elproto.add = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this;
	                el.forEach(function (el) {
	                    it.add(el);
	                });
	                return this;
	            }
	            el = wrap(el);
	            this.node.appendChild(el.node);
	            el.paper = this.paper;
	        }
	        return this;
	    };
	    /*\
	     * Element.appendTo
	     [ method ]
	     **
	     * Appends the current element to the given one
	     **
	     - el (Element) parent element to append to
	     = (Element) the child element
	    \*/
	    elproto.appendTo = function (el) {
	        if (el) {
	            el = wrap(el);
	            el.append(this);
	        }
	        return this;
	    };
	    /*\
	     * Element.prepend
	     [ method ]
	     **
	     * Prepends the given element to the current one
	     **
	     - el (Element) element to prepend
	     = (Element) the parent element
	    \*/
	    elproto.prepend = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this,
	                    first;
	                el.forEach(function (el) {
	                    if (first) {
	                        first.after(el);
	                    } else {
	                        it.prepend(el);
	                    }
	                    first = el;
	                });
	                return this;
	            }
	            el = wrap(el);
	            var parent = el.parent();
	            this.node.insertBefore(el.node, this.node.firstChild);
	            this.add && this.add();
	            el.paper = this.paper;
	            this.parent() && this.parent().add();
	            parent && parent.add();
	        }
	        return this;
	    };
	    /*\
	     * Element.prependTo
	     [ method ]
	     **
	     * Prepends the current element to the given one
	     **
	     - el (Element) parent element to prepend to
	     = (Element) the child element
	    \*/
	    elproto.prependTo = function (el) {
	        el = wrap(el);
	        el.prepend(this);
	        return this;
	    };
	    /*\
	     * Element.before
	     [ method ]
	     **
	     * Inserts given element before the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.before = function (el) {
	        if (el.type == "set") {
	            var it = this;
	            el.forEach(function (el) {
	                var parent = el.parent();
	                it.node.parentNode.insertBefore(el.node, it.node);
	                parent && parent.add();
	            });
	            this.parent().add();
	            return this;
	        }
	        el = wrap(el);
	        var parent = el.parent();
	        this.node.parentNode.insertBefore(el.node, this.node);
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.after
	     [ method ]
	     **
	     * Inserts given element after the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.after = function (el) {
	        el = wrap(el);
	        var parent = el.parent();
	        if (this.node.nextSibling) {
	            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
	        } else {
	            this.node.parentNode.appendChild(el.node);
	        }
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.insertBefore
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertBefore = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.insertAfter
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertAfter = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.remove
	     [ method ]
	     **
	     * Removes element from the DOM
	     = (Element) the detached element
	    \*/
	    elproto.remove = function () {
	        var parent = this.parent();
	        this.node.parentNode && this.node.parentNode.removeChild(this.node);
	        delete this.paper;
	        this.removed = true;
	        parent && parent.add();
	        return this;
	    };
	    /*\
	     * Element.select
	     [ method ]
	     **
	     * Gathers the nested @Element matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Element) result of query selection
	    \*/
	    elproto.select = function (query) {
	        return wrap(this.node.querySelector(query));
	    };
	    /*\
	     * Element.selectAll
	     [ method ]
	     **
	     * Gathers nested @Element objects matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Set|array) result of query selection
	    \*/
	    elproto.selectAll = function (query) {
	        var nodelist = this.node.querySelectorAll(query),
	            set = (Snap.set || Array)();
	        for (var i = 0; i < nodelist.length; i++) {
	            set.push(wrap(nodelist[i]));
	        }
	        return set;
	    };
	    /*\
	     * Element.asPX
	     [ method ]
	     **
	     * Returns given attribute of the element as a `px` value (not %, em, etc.)
	     **
	     - attr (string) attribute name
	     - value (string) #optional attribute value
	     = (Element) result of query selection
	    \*/
	    elproto.asPX = function (attr, value) {
	        if (value == null) {
	            value = this.attr(attr);
	        }
	        return +unit2px(this, attr, value);
	    };
	    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
	    /*\
	     * Element.use
	     [ method ]
	     **
	     * Creates a `<use>` element linked to the current element
	     **
	     = (Element) the `<use>` element
	    \*/
	    elproto.use = function () {
	        var use,
	            id = this.node.id;
	        if (!id) {
	            id = this.id;
	            $(this.node, {
	                id: id
	            });
	        }
	        if (this.type == "linearGradient" || this.type == "radialGradient" ||
	            this.type == "pattern") {
	            use = make(this.type, this.node.parentNode);
	        } else {
	            use = make("use", this.node.parentNode);
	        }
	        $(use.node, {
	            "xlink:href": "#" + id
	        });
	        use.original = this;
	        return use;
	    };
	    function fixids(el) {
	        var els = el.selectAll("*"),
	            it,
	            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
	            ids = [],
	            uses = {};
	        function urltest(it, name) {
	            var val = $(it.node, name);
	            val = val && val.match(url);
	            val = val && val[2];
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    var attr = {};
	                    attr[name] = Snap.url(id);
	                    $(it.node, attr);
	                });
	            }
	        }
	        function linktest(it) {
	            var val = $(it.node, "xlink:href");
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    it.attr("xlink:href", "#" + id);
	                });
	            }
	        }
	        for (var i = 0, ii = els.length; i < ii; i++) {
	            it = els[i];
	            urltest(it, "fill");
	            urltest(it, "stroke");
	            urltest(it, "filter");
	            urltest(it, "mask");
	            urltest(it, "clip-path");
	            linktest(it);
	            var oldid = $(it.node, "id");
	            if (oldid) {
	                $(it.node, {id: it.id});
	                ids.push({
	                    old: oldid,
	                    id: it.id
	                });
	            }
	        }
	        for (i = 0, ii = ids.length; i < ii; i++) {
	            var fs = uses[ids[i].old];
	            if (fs) {
	                for (var j = 0, jj = fs.length; j < jj; j++) {
	                    fs[j](ids[i].id);
	                }
	            }
	        }
	    }
	    /*\
	     * Element.clone
	     [ method ]
	     **
	     * Creates a clone of the element and inserts it after the element
	     **
	     = (Element) the clone
	    \*/
	    elproto.clone = function () {
	        var clone = wrap(this.node.cloneNode(true));
	        if ($(clone.node, "id")) {
	            $(clone.node, {id: clone.id});
	        }
	        fixids(clone);
	        clone.insertAfter(this);
	        return clone;
	    };
	    /*\
	     * Element.toDefs
	     [ method ]
	     **
	     * Moves element to the shared `<defs>` area
	     **
	     = (Element) the element
	    \*/
	    elproto.toDefs = function () {
	        var defs = getSomeDefs(this);
	        defs.appendChild(this.node);
	        return this;
	    };
	    /*\
	     * Element.toPattern
	     [ method ]
	     **
	     * Creates a `<pattern>` element from the current element
	     **
	     * To create a pattern you have to specify the pattern rect:
	     - x (string|number)
	     - y (string|number)
	     - width (string|number)
	     - height (string|number)
	     = (Element) the `<pattern>` element
	     * You can use pattern later on as an argument for `fill` attribute:
	     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
	     |         fill: "none",
	     |         stroke: "#bada55",
	     |         strokeWidth: 5
	     |     }).pattern(0, 0, 10, 10),
	     |     c = paper.circle(200, 200, 100);
	     | c.attr({
	     |     fill: p
	     | });
	    \*/
	    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
	        var p = make("pattern", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        $(p.node, {
	            x: x,
	            y: y,
	            width: width,
	            height: height,
	            patternUnits: "userSpaceOnUse",
	            id: p.id,
	            viewBox: [x, y, width, height].join(" ")
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
	// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
	    /*\
	     * Element.marker
	     [ method ]
	     **
	     * Creates a `<marker>` element from the current element
	     **
	     * To create a marker you have to specify the bounding rect and reference point:
	     - x (number)
	     - y (number)
	     - width (number)
	     - height (number)
	     - refX (number)
	     - refY (number)
	     = (Element) the `<marker>` element
	     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
	    \*/
	    // TODO add usage for markers
	    elproto.marker = function (x, y, width, height, refX, refY) {
	        var p = make("marker", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            refX = x.refX || x.cx;
	            refY = x.refY || x.cy;
	            x = x.x;
	        }
	        $(p.node, {
	            viewBox: [x, y, width, height].join(" "),
	            markerWidth: width,
	            markerHeight: height,
	            orient: "auto",
	            refX: refX || 0,
	            refY: refY || 0,
	            id: p.id
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	    var eldata = {};
	    /*\
	     * Element.data
	     [ method ]
	     **
	     * Adds or retrieves given value associated with given key. (Don’t confuse
	     * with `data-` attributes)
	     *
	     * See also @Element.removeData
	     - key (string) key to store data
	     - value (any) #optional value to store
	     = (object) @Element
	     * or, if value is not specified:
	     = (any) value
	     > Usage
	     | for (var i = 0, i < 5, i++) {
	     |     paper.circle(10 + 15 * i, 10, 10)
	     |          .attr({fill: "#000"})
	     |          .data("i", i)
	     |          .click(function () {
	     |             alert(this.data("i"));
	     |          });
	     | }
	    \*/
	    elproto.data = function (key, value) {
	        var data = eldata[this.id] = eldata[this.id] || {};
	        if (arguments.length == 0){
	            eve("snap.data.get." + this.id, this, data, null);
	            return data;
	        }
	        if (arguments.length == 1) {
	            if (Snap.is(key, "object")) {
	                for (var i in key) if (key[has](i)) {
	                    this.data(i, key[i]);
	                }
	                return this;
	            }
	            eve("snap.data.get." + this.id, this, data[key], key);
	            return data[key];
	        }
	        data[key] = value;
	        eve("snap.data.set." + this.id, this, value, key);
	        return this;
	    };
	    /*\
	     * Element.removeData
	     [ method ]
	     **
	     * Removes value associated with an element by given key.
	     * If key is not provided, removes all the data of the element.
	     - key (string) #optional key
	     = (object) @Element
	    \*/
	    elproto.removeData = function (key) {
	        if (key == null) {
	            eldata[this.id] = {};
	        } else {
	            eldata[this.id] && delete eldata[this.id][key];
	        }
	        return this;
	    };
	    /*\
	     * Element.outerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
	     *
	     * See also @Element.innerSVG
	     = (string) SVG code for the element
	    \*/
	    /*\
	     * Element.toString
	     [ method ]
	     **
	     * See @Element.outerSVG
	    \*/
	    elproto.outerSVG = elproto.toString = toString(1);
	    /*\
	     * Element.innerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
	     = (string) SVG code for the element
	    \*/
	    elproto.innerSVG = toString();
	    function toString(type) {
	        return function () {
	            var res = type ? "<" + this.type : "",
	                attr = this.node.attributes,
	                chld = this.node.childNodes;
	            if (type) {
	                for (var i = 0, ii = attr.length; i < ii; i++) {
	                    res += " " + attr[i].name + '="' +
	                            attr[i].value.replace(/"/g, '\\"') + '"';
	                }
	            }
	            if (chld.length) {
	                type && (res += ">");
	                for (i = 0, ii = chld.length; i < ii; i++) {
	                    if (chld[i].nodeType == 3) {
	                        res += chld[i].nodeValue;
	                    } else if (chld[i].nodeType == 1) {
	                        res += wrap(chld[i]).toString();
	                    }
	                }
	                type && (res += "</" + this.type + ">");
	            } else {
	                type && (res += "/>");
	            }
	            return res;
	        };
	    }
	    elproto.toDataURL = function () {
	        if (window && window.btoa) {
	            var bb = this.getBBox(),
	                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
	                x: +bb.x.toFixed(3),
	                y: +bb.y.toFixed(3),
	                width: +bb.width.toFixed(3),
	                height: +bb.height.toFixed(3),
	                contents: this.outerSVG()
	            });
	            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
	        }
	    };
	    /*\
	     * Fragment.select
	     [ method ]
	     **
	     * See @Element.select
	    \*/
	    Fragment.prototype.select = elproto.select;
	    /*\
	     * Fragment.selectAll
	     [ method ]
	     **
	     * See @Element.selectAll
	    \*/
	    Fragment.prototype.selectAll = elproto.selectAll;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var objectToString = Object.prototype.toString,
	        Str = String,
	        math = Math,
	        E = "";
	    function Matrix(a, b, c, d, e, f) {
	        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
	            this.a = a.a;
	            this.b = a.b;
	            this.c = a.c;
	            this.d = a.d;
	            this.e = a.e;
	            this.f = a.f;
	            return;
	        }
	        if (a != null) {
	            this.a = +a;
	            this.b = +b;
	            this.c = +c;
	            this.d = +d;
	            this.e = +e;
	            this.f = +f;
	        } else {
	            this.a = 1;
	            this.b = 0;
	            this.c = 0;
	            this.d = 1;
	            this.e = 0;
	            this.f = 0;
	        }
	    }
	    (function (matrixproto) {
	        /*\
	         * Matrix.add
	         [ method ]
	         **
	         * Adds the given matrix to existing one
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        matrixproto.add = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + b * this.c,
	                bNew = a * this.b + b * this.d;
	            this.e += e * this.a + f * this.c;
	            this.f += e * this.b + f * this.d;
	            this.c = c * this.a + d * this.c;
	            this.d = c * this.b + d * this.d;
	
	            this.a = aNew;
	            this.b = bNew;
	            return this;
	        };
	        /*\
	         * Matrix.multLeft
	         [ method ]
	         **
	         * Multiplies a passed affine transform to the left: M * this.
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        Matrix.prototype.multLeft = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + c * this.b,
	                cNew = a * this.c + c * this.d,
	                eNew = a * this.e + c * this.f + e;
	            this.b = b * this.a + d * this.b;
	            this.d = b * this.c + d * this.d;
	            this.f = b * this.e + d * this.f + f;
	
	            this.a = aNew;
	            this.c = cNew;
	            this.e = eNew;
	            return this;
	        };
	        /*\
	         * Matrix.invert
	         [ method ]
	         **
	         * Returns an inverted version of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.invert = function () {
	            var me = this,
	                x = me.a * me.d - me.b * me.c;
	            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
	        };
	        /*\
	         * Matrix.clone
	         [ method ]
	         **
	         * Returns a copy of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.clone = function () {
	            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
	        };
	        /*\
	         * Matrix.translate
	         [ method ]
	         **
	         * Translate the matrix
	         - x (number) horizontal offset distance
	         - y (number) vertical offset distance
	        \*/
	        matrixproto.translate = function (x, y) {
	            this.e += x * this.a + y * this.c;
	            this.f += x * this.b + y * this.d;
	            return this;
	        };
	        /*\
	         * Matrix.scale
	         [ method ]
	         **
	         * Scales the matrix
	         - x (number) amount to be scaled, with `1` resulting in no change
	         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
	         - cx (number) #optional horizontal origin point from which to scale
	         - cy (number) #optional vertical origin point from which to scale
	         * Default cx, cy is the middle point of the element.
	        \*/
	        matrixproto.scale = function (x, y, cx, cy) {
	            y == null && (y = x);
	            (cx || cy) && this.translate(cx, cy);
	            this.a *= x;
	            this.b *= x;
	            this.c *= y;
	            this.d *= y;
	            (cx || cy) && this.translate(-cx, -cy);
	            return this;
	        };
	        /*\
	         * Matrix.rotate
	         [ method ]
	         **
	         * Rotates the matrix
	         - a (number) angle of rotation, in degrees
	         - x (number) horizontal origin point from which to rotate
	         - y (number) vertical origin point from which to rotate
	        \*/
	        matrixproto.rotate = function (a, x, y) {
	            a = Snap.rad(a);
	            x = x || 0;
	            y = y || 0;
	            var cos = +math.cos(a).toFixed(9),
	                sin = +math.sin(a).toFixed(9);
	            this.add(cos, sin, -sin, cos, x, y);
	            return this.add(1, 0, 0, 1, -x, -y);
	        };
	        /*\
	         * Matrix.skewX
	         [ method ]
	         **
	         * Skews the matrix along the x-axis
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skewX = function (x) {
	            return this.skew(x, 0);
	        };
	        /*\
	         * Matrix.skewY
	         [ method ]
	         **
	         * Skews the matrix along the y-axis
	         - y (number) Angle to skew along the y-axis (in degrees).
	        \*/
	        matrixproto.skewY = function (y) {
	            return this.skew(0, y);
	        };
	        /*\
	         * Matrix.skew
	         [ method ]
	         **
	         * Skews the matrix
	         - y (number) Angle to skew along the y-axis (in degrees).
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skew = function (x, y) {
	            x = x || 0;
	            y = y || 0;
	            x = Snap.rad(x);
	            y = Snap.rad(y);
	            var c = math.tan(x).toFixed(9);
	            var b = math.tan(y).toFixed(9);
	            return this.add(1, b, c, 1, 0, 0);
	        };
	        /*\
	         * Matrix.x
	         [ method ]
	         **
	         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
	         - x (number)
	         - y (number)
	         = (number) x
	        \*/
	        matrixproto.x = function (x, y) {
	            return x * this.a + y * this.c + this.e;
	        };
	        /*\
	         * Matrix.y
	         [ method ]
	         **
	         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
	         - x (number)
	         - y (number)
	         = (number) y
	        \*/
	        matrixproto.y = function (x, y) {
	            return x * this.b + y * this.d + this.f;
	        };
	        matrixproto.get = function (i) {
	            return +this[Str.fromCharCode(97 + i)].toFixed(4);
	        };
	        matrixproto.toString = function () {
	            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
	        };
	        matrixproto.offset = function () {
	            return [this.e.toFixed(4), this.f.toFixed(4)];
	        };
	        function norm(a) {
	            return a[0] * a[0] + a[1] * a[1];
	        }
	        function normalize(a) {
	            var mag = math.sqrt(norm(a));
	            a[0] && (a[0] /= mag);
	            a[1] && (a[1] /= mag);
	        }
	        /*\
	         * Matrix.determinant
	         [ method ]
	         **
	         * Finds determinant of the given matrix.
	         = (number) determinant
	        \*/
	        matrixproto.determinant = function () {
	            return this.a * this.d - this.b * this.c;
	        };
	        /*\
	         * Matrix.split
	         [ method ]
	         **
	         * Splits matrix into primitive transformations
	         = (object) in format:
	         o dx (number) translation by x
	         o dy (number) translation by y
	         o scalex (number) scale by x
	         o scaley (number) scale by y
	         o shear (number) shear
	         o rotate (number) rotation in deg
	         o isSimple (boolean) could it be represented via simple transformations
	        \*/
	        matrixproto.split = function () {
	            var out = {};
	            // translation
	            out.dx = this.e;
	            out.dy = this.f;
	
	            // scale and shear
	            var row = [[this.a, this.b], [this.c, this.d]];
	            out.scalex = math.sqrt(norm(row[0]));
	            normalize(row[0]);
	
	            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
	            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];
	
	            out.scaley = math.sqrt(norm(row[1]));
	            normalize(row[1]);
	            out.shear /= out.scaley;
	
	            if (this.determinant() < 0) {
	                out.scalex = -out.scalex;
	            }
	
	            // rotation
	            var sin = row[0][1],
	                cos = row[1][1];
	            if (cos < 0) {
	                out.rotate = Snap.deg(math.acos(cos));
	                if (sin < 0) {
	                    out.rotate = 360 - out.rotate;
	                }
	            } else {
	                out.rotate = Snap.deg(math.asin(sin));
	            }
	
	            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
	            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
	            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
	            return out;
	        };
	        /*\
	         * Matrix.toTransformString
	         [ method ]
	         **
	         * Returns transform string that represents given matrix
	         = (string) transform string
	        \*/
	        matrixproto.toTransformString = function (shorter) {
	            var s = shorter || this.split();
	            if (!+s.shear.toFixed(9)) {
	                s.scalex = +s.scalex.toFixed(4);
	                s.scaley = +s.scaley.toFixed(4);
	                s.rotate = +s.rotate.toFixed(4);
	                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) +
	                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E) +
	                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E);
	            } else {
	                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
	            }
	        };
	    })(Matrix.prototype);
	    /*\
	     * Snap.Matrix
	     [ method ]
	     **
	     * Matrix constructor, extend on your own risk.
	     * To create matrices use @Snap.matrix.
	    \*/
	    Snap.Matrix = Matrix;
	    /*\
	     * Snap.matrix
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns a matrix based on the given parameters
	     - a (number)
	     - b (number)
	     - c (number)
	     - d (number)
	     - e (number)
	     - f (number)
	     * or
	     - svgMatrix (SVGMatrix)
	     = (object) @Matrix
	    \*/
	    Snap.matrix = function (a, b, c, d, e, f) {
	        return new Matrix(a, b, c, d, e, f);
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var has = "hasOwnProperty",
	        make = Snap._.make,
	        wrap = Snap._.wrap,
	        is = Snap.is,
	        getSomeDefs = Snap._.getSomeDefs,
	        reURLValue = /^url\((['"]?)([^)]+)\1\)$/,
	        $ = Snap._.$,
	        URL = Snap.url,
	        Str = String,
	        separator = Snap._.separator,
	        E = "";
	    /*\
	     * Snap.deurl
	     [ method ]
	     **
	     * Unwraps path from `"url(<path>)"`.
	     - value (string) url path
	     = (string) unwrapped path
	    \*/
	    Snap.deurl = function (value) {
	        var res = String(value).match(reURLValue);
	        return res ? res[2] : value;
	    }
	    // Attributes event handlers
	    eve.on("snap.util.attr.mask", function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value.type == "mask") {
	                var mask = value;
	            } else {
	                mask = make("mask", getSomeDefs(this));
	                mask.node.appendChild(value.node);
	            }
	            !mask.node.id && $(mask.node, {
	                id: mask.id
	            });
	            $(this.node, {
	                mask: URL(mask.id)
	            });
	        }
	    });
	    (function (clipIt) {
	        eve.on("snap.util.attr.clip", clipIt);
	        eve.on("snap.util.attr.clip-path", clipIt);
	        eve.on("snap.util.attr.clipPath", clipIt);
	    }(function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            var clip,
	                node = value.node;
	            while (node) {
	                if (node.nodeName === "clipPath") {
	                    clip = new Element(node);
	                    break;
	                }
	                if (node.nodeName === "svg") {
	                    clip = undefined;
	                    break;
	                }
	                node = node.parentNode;
	            }
	            if (!clip) {
	                clip = make("clipPath", getSomeDefs(this));
	                clip.node.appendChild(value.node);
	                !clip.node.id && $(clip.node, {
	                    id: clip.id
	                });
	            }
	            $(this.node, {
	                "clip-path": URL(clip.node.id || clip.id)
	            });
	        }
	    }));
	    function fillStroke(name) {
	        return function (value) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
	                (value.node.firstChild.tagName == "radialGradient" ||
	                value.node.firstChild.tagName == "linearGradient" ||
	                value.node.firstChild.tagName == "pattern")) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value instanceof Element) {
	                if (value.type == "radialGradient" || value.type == "linearGradient"
	                   || value.type == "pattern") {
	                    if (!value.node.id) {
	                        $(value.node, {
	                            id: value.id
	                        });
	                    }
	                    var fill = URL(value.node.id);
	                } else {
	                    fill = value.attr(name);
	                }
	            } else {
	                fill = Snap.color(value);
	                if (fill.error) {
	                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
	                    if (grad) {
	                        if (!grad.node.id) {
	                            $(grad.node, {
	                                id: grad.id
	                            });
	                        }
	                        fill = URL(grad.node.id);
	                    } else {
	                        fill = value;
	                    }
	                } else {
	                    fill = Str(fill);
	                }
	            }
	            var attrs = {};
	            attrs[name] = fill;
	            $(this.node, attrs);
	            this.node.style[name] = E;
	        };
	    }
	    eve.on("snap.util.attr.fill", fillStroke("fill"));
	    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
	    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
	    eve.on("snap.util.grad.parse", function parseGrad(string) {
	        string = Str(string);
	        var tokens = string.match(gradrg);
	        if (!tokens) {
	            return null;
	        }
	        var type = tokens[1],
	            params = tokens[2],
	            stops = tokens[3];
	        params = params.split(/\s*,\s*/).map(function (el) {
	            return +el == el ? +el : el;
	        });
	        if (params.length == 1 && params[0] == 0) {
	            params = [];
	        }
	        stops = stops.split("-");
	        stops = stops.map(function (el) {
	            el = el.split(":");
	            var out = {
	                color: el[0]
	            };
	            if (el[1]) {
	                out.offset = parseFloat(el[1]);
	            }
	            return out;
	        });
	        var len = stops.length,
	            start = 0,
	            j = 0;
	        function seed(i, end) {
	            var step = (end - start) / (i - j);
	            for (var k = j; k < i; k++) {
	                stops[k].offset = +(+start + step * (k - j)).toFixed(2);
	            }
	            j = i;
	            start = end;
	        }
	        len--;
	        for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
	            seed(i, stops[i].offset);
	        }
	        stops[len].offset = stops[len].offset || 100;
	        seed(len, stops[len].offset);
	        return {
	            type: type,
	            params: params,
	            stops: stops
	        };
	    });
	
	    eve.on("snap.util.attr.d", function (value) {
	        eve.stop();
	        if (is(value, "array") && is(value[0], "array")) {
	            value = Snap.path.toString.call(value);
	        }
	        value = Str(value);
	        if (value.match(/[ruo]/i)) {
	            value = Snap.path.toAbsolute(value);
	        }
	        $(this.node, {d: value});
	    })(-1);
	    eve.on("snap.util.attr.#text", function (value) {
	        eve.stop();
	        value = Str(value);
	        var txt = glob.doc.createTextNode(value);
	        while (this.node.firstChild) {
	            this.node.removeChild(this.node.firstChild);
	        }
	        this.node.appendChild(txt);
	    })(-1);
	    eve.on("snap.util.attr.path", function (value) {
	        eve.stop();
	        this.attr({d: value});
	    })(-1);
	    eve.on("snap.util.attr.class", function (value) {
	        eve.stop();
	        this.node.className.baseVal = value;
	    })(-1);
	    eve.on("snap.util.attr.viewBox", function (value) {
	        var vb;
	        if (is(value, "object") && "x" in value) {
	            vb = [value.x, value.y, value.width, value.height].join(" ");
	        } else if (is(value, "array")) {
	            vb = value.join(" ");
	        } else {
	            vb = value;
	        }
	        $(this.node, {
	            viewBox: vb
	        });
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.transform", function (value) {
	        this.transform(value);
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.r", function (value) {
	        if (this.type == "rect") {
	            eve.stop();
	            $(this.node, {
	                rx: value,
	                ry: value
	            });
	        }
	    })(-1);
	    eve.on("snap.util.attr.textpath", function (value) {
	        eve.stop();
	        if (this.type == "text") {
	            var id, tp, node;
	            if (!value && this.textPath) {
	                tp = this.textPath;
	                while (tp.node.firstChild) {
	                    this.node.appendChild(tp.node.firstChild);
	                }
	                tp.remove();
	                delete this.textPath;
	                return;
	            }
	            if (is(value, "string")) {
	                var defs = getSomeDefs(this),
	                    path = wrap(defs.parentNode).path(value);
	                defs.appendChild(path.node);
	                id = path.id;
	                path.attr({id: id});
	            } else {
	                value = wrap(value);
	                if (value instanceof Element) {
	                    id = value.attr("id");
	                    if (!id) {
	                        id = value.id;
	                        value.attr({id: id});
	                    }
	                }
	            }
	            if (id) {
	                tp = this.textPath;
	                node = this.node;
	                if (tp) {
	                    tp.attr({"xlink:href": "#" + id});
	                } else {
	                    tp = $("textPath", {
	                        "xlink:href": "#" + id
	                    });
	                    while (node.firstChild) {
	                        tp.appendChild(node.firstChild);
	                    }
	                    node.appendChild(tp);
	                    this.textPath = wrap(tp);
	                }
	            }
	        }
	    })(-1);
	    eve.on("snap.util.attr.text", function (value) {
	        if (this.type == "text") {
	            var i = 0,
	                node = this.node,
	                tuner = function (chunk) {
	                    var out = $("tspan");
	                    if (is(chunk, "array")) {
	                        for (var i = 0; i < chunk.length; i++) {
	                            out.appendChild(tuner(chunk[i]));
	                        }
	                    } else {
	                        out.appendChild(glob.doc.createTextNode(chunk));
	                    }
	                    out.normalize && out.normalize();
	                    return out;
	                };
	            while (node.firstChild) {
	                node.removeChild(node.firstChild);
	            }
	            var tuned = tuner(value);
	            while (tuned.firstChild) {
	                node.appendChild(tuned.firstChild);
	            }
	        }
	        eve.stop();
	    })(-1);
	    function setFontSize(value) {
	        eve.stop();
	        if (value == +value) {
	            value += "px";
	        }
	        this.node.style.fontSize = value;
	    }
	    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
	    eve.on("snap.util.attr.font-size", setFontSize)(-1);
	
	
	    eve.on("snap.util.getattr.transform", function () {
	        eve.stop();
	        return this.transform();
	    })(-1);
	    eve.on("snap.util.getattr.textpath", function () {
	        eve.stop();
	        return this.textPath;
	    })(-1);
	    // Markers
	    (function () {
	        function getter(end) {
	            return function () {
	                eve.stop();
	                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
	                if (style == "none") {
	                    return style;
	                } else {
	                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
	                }
	            };
	        }
	        function setter(end) {
	            return function (value) {
	                eve.stop();
	                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
	                if (value == "" || !value) {
	                    this.node.style[name] = "none";
	                    return;
	                }
	                if (value.type == "marker") {
	                    var id = value.node.id;
	                    if (!id) {
	                        $(value.node, {id: value.id});
	                    }
	                    this.node.style[name] = URL(id);
	                    return;
	                }
	            };
	        }
	        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
	        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
	        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
	        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
	        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
	        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
	        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
	        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
	        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
	        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
	        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
	        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
	    }());
	    eve.on("snap.util.getattr.r", function () {
	        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
	            eve.stop();
	            return $(this.node, "rx");
	        }
	    })(-1);
	    function textExtract(node) {
	        var out = [];
	        var children = node.childNodes;
	        for (var i = 0, ii = children.length; i < ii; i++) {
	            var chi = children[i];
	            if (chi.nodeType == 3) {
	                out.push(chi.nodeValue);
	            }
	            if (chi.tagName == "tspan") {
	                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
	                    out.push(chi.firstChild.nodeValue);
	                } else {
	                    out.push(textExtract(chi));
	                }
	            }
	        }
	        return out;
	    }
	    eve.on("snap.util.getattr.text", function () {
	        if (this.type == "text" || this.type == "tspan") {
	            eve.stop();
	            var out = textExtract(this.node);
	            return out.length == 1 ? out[0] : out;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.#text", function () {
	        return this.node.textContent;
	    })(-1);
	    eve.on("snap.util.getattr.fill", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.stroke", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.viewBox", function () {
	        eve.stop();
	        var vb = $(this.node, "viewBox");
	        if (vb) {
	            vb = vb.split(separator);
	            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.points", function () {
	        var p = $(this.node, "points");
	        eve.stop();
	        if (p) {
	            return p.split(separator);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.path", function () {
	        var p = $(this.node, "d");
	        eve.stop();
	        return p;
	    })(-1);
	    eve.on("snap.util.getattr.class", function () {
	        return this.node.className.baseVal;
	    })(-1);
	    function getFontSize() {
	        eve.stop();
	        return this.node.style.fontSize;
	    }
	    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
	    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var rgNotSpace = /\S+/g,
	        rgBadSpace = /[\t\r\n\f]/g,
	        rgTrim = /(^\s+|\s+$)/g,
	        Str = String,
	        elproto = Element.prototype;
	    /*\
	     * Element.addClass
	     [ method ]
	     **
	     * Adds given class name or list of class names to the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.addClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	
	        if (classes.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (!~pos) {
	                    curClasses.push(clazz);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.removeClass
	     [ method ]
	     **
	     * Removes given class name or list of class names from the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.removeClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        if (curClasses.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (~pos) {
	                    curClasses.splice(pos, 1);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.hasClass
	     [ method ]
	     **
	     * Checks if the element has a given class name in the list of class names applied to it.
	     - value (string) class name
	     **
	     = (boolean) `true` if the element has given class
	    \*/
	    elproto.hasClass = function (value) {
	        var elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [];
	        return !!~curClasses.indexOf(value);
	    };
	    /*\
	     * Element.toggleClass
	     [ method ]
	     **
	     * Add or remove one or more classes from the element, depending on either
	     * the class’s presence or the value of the `flag` argument.
	     - value (string) class name or space separated list of class names
	     - flag (boolean) value to determine whether the class should be added or removed
	     **
	     = (Element) original element.
	    \*/
	    elproto.toggleClass = function (value, flag) {
	        if (flag != null) {
	            if (flag) {
	                return this.addClass(value);
	            } else {
	                return this.removeClass(value);
	            }
	        }
	        var classes = (value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        j = 0;
	        while (clazz = classes[j++]) {
	            pos = curClasses.indexOf(clazz);
	            if (~pos) {
	                curClasses.splice(pos, 1);
	            } else {
	                curClasses.push(clazz);
	            }
	        }
	
	        finalValue = curClasses.join(" ");
	        if (className != finalValue) {
	            elem.className.baseVal = finalValue;
	        }
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var operators = {
	            "+": function (x, y) {
	                    return x + y;
	                },
	            "-": function (x, y) {
	                    return x - y;
	                },
	            "/": function (x, y) {
	                    return x / y;
	                },
	            "*": function (x, y) {
	                    return x * y;
	                }
	        },
	        Str = String,
	        reUnit = /[a-z]+$/i,
	        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    eve.on("snap.util.attr", function (val) {
	        var plus = Str(val).match(reAddon);
	        if (plus) {
	            var evnt = eve.nt(),
	                name = evnt.substring(evnt.lastIndexOf(".") + 1),
	                a = this.attr(name),
	                atr = {};
	            eve.stop();
	            var unit = plus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[plus[1]];
	            if (aUnit && aUnit == unit) {
	                val = op(parseFloat(a), +plus[2]);
	            } else {
	                a = this.asPX(name);
	                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
	            }
	            if (isNaN(a) || isNaN(val)) {
	                return;
	            }
	            atr[name] = val;
	            this.attr(atr);
	        }
	    })(-10);
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this,
	            bplus = Str(b).match(reAddon);
	        if (bplus) {
	            eve.stop();
	            var unit = bplus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[bplus[1]];
	            if (aUnit && aUnit == unit) {
	                return {
	                    from: parseFloat(a),
	                    to: op(parseFloat(a), +bplus[2]),
	                    f: getUnit(aUnit)
	                };
	            } else {
	                a = this.asPX(name);
	                return {
	                    from: a,
	                    to: op(a, this.asPX(name, bplus[2] + unit)),
	                    f: getNumber
	                };
	            }
	        }
	    })(-10);
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var proto = Paper.prototype,
	        is = Snap.is;
	    /*\
	     * Paper.rect
	     [ method ]
	     *
	     * Draws a rectangle
	     **
	     - x (number) x coordinate of the top left corner
	     - y (number) y coordinate of the top left corner
	     - width (number) width
	     - height (number) height
	     - rx (number) #optional horizontal radius for rounded corners, default is 0
	     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
	     = (object) the `rect` element
	     **
	     > Usage
	     | // regular rectangle
	     | var c = paper.rect(10, 10, 50, 50);
	     | // rectangle with rounded corners
	     | var c = paper.rect(40, 40, 50, 50, 10);
	    \*/
	    proto.rect = function (x, y, w, h, rx, ry) {
	        var attr;
	        if (ry == null) {
	            ry = rx;
	        }
	        if (is(x, "object") && x == "[object Object]") {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                width: w,
	                height: h
	            };
	            if (rx != null) {
	                attr.rx = rx;
	                attr.ry = ry;
	            }
	        }
	        return this.el("rect", attr);
	    };
	    /*\
	     * Paper.circle
	     [ method ]
	     **
	     * Draws a circle
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - r (number) radius
	     = (object) the `circle` element
	     **
	     > Usage
	     | var c = paper.circle(50, 50, 40);
	    \*/
	    proto.circle = function (cx, cy, r) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr = {
	                cx: cx,
	                cy: cy,
	                r: r
	            };
	        }
	        return this.el("circle", attr);
	    };
	
	    var preload = (function () {
	        function onerror() {
	            this.parentNode.removeChild(this);
	        }
	        return function (src, f) {
	            var img = glob.doc.createElement("img"),
	                body = glob.doc.body;
	            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
	            img.onload = function () {
	                f.call(img);
	                img.onload = img.onerror = null;
	                body.removeChild(img);
	            };
	            img.onerror = onerror;
	            body.appendChild(img);
	            img.src = src;
	        };
	    }());
	
	    /*\
	     * Paper.image
	     [ method ]
	     **
	     * Places an image on the surface
	     **
	     - src (string) URI of the source image
	     - x (number) x offset position
	     - y (number) y offset position
	     - width (number) width of the image
	     - height (number) height of the image
	     = (object) the `image` element
	     * or
	     = (object) Snap element object with type `image`
	     **
	     > Usage
	     | var c = paper.image("apple.png", 10, 10, 80, 80);
	    \*/
	    proto.image = function (src, x, y, width, height) {
	        var el = this.el("image");
	        if (is(src, "object") && "src" in src) {
	            el.attr(src);
	        } else if (src != null) {
	            var set = {
	                "xlink:href": src,
	                preserveAspectRatio: "none"
	            };
	            if (x != null && y != null) {
	                set.x = x;
	                set.y = y;
	            }
	            if (width != null && height != null) {
	                set.width = width;
	                set.height = height;
	            } else {
	                preload(src, function () {
	                    Snap._.$(el.node, {
	                        width: this.offsetWidth,
	                        height: this.offsetHeight
	                    });
	                });
	            }
	            Snap._.$(el.node, set);
	        }
	        return el;
	    };
	    /*\
	     * Paper.ellipse
	     [ method ]
	     **
	     * Draws an ellipse
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - rx (number) horizontal radius
	     - ry (number) vertical radius
	     = (object) the `ellipse` element
	     **
	     > Usage
	     | var c = paper.ellipse(50, 50, 40, 20);
	    \*/
	    proto.ellipse = function (cx, cy, rx, ry) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr ={
	                cx: cx,
	                cy: cy,
	                rx: rx,
	                ry: ry
	            };
	        }
	        return this.el("ellipse", attr);
	    };
	    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
	    /*\
	     * Paper.path
	     [ method ]
	     **
	     * Creates a `<path>` element using the given string as the path's definition
	     - pathString (string) #optional path string in SVG format
	     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
	     | "M10,20L30,40"
	     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
	     *
	     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
	     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
	     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
	     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
	     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
	     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
	     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
	     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
	     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
	     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
	     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
	     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
	     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
	     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
	     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
	     > Usage
	     | var c = paper.path("M10 10L90 90");
	     | // draw a diagonal line:
	     | // move to 10,10, line to 90,90
	    \*/
	    proto.path = function (d) {
	        var attr;
	        if (is(d, "object") && !is(d, "array")) {
	            attr = d;
	        } else if (d) {
	            attr = {d: d};
	        }
	        return this.el("path", attr);
	    };
	    /*\
	     * Paper.g
	     [ method ]
	     **
	     * Creates a group element
	     **
	     - varargs (…) #optional elements to nest within the group
	     = (object) the `g` element
	     **
	     > Usage
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g(c2, c1); // note that the order of elements is different
	     * or
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g();
	     | g.add(c2, c1);
	    \*/
	    /*\
	     * Paper.group
	     [ method ]
	     **
	     * See @Paper.g
	    \*/
	    proto.group = proto.g = function (first) {
	        var attr,
	            el = this.el("g");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.svg
	     [ method ]
	     **
	     * Creates a nested SVG element.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `svg` element
	     **
	    \*/
	    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
	        var attrs = {};
	        if (is(x, "object") && y == null) {
	            attrs = x;
	        } else {
	            if (x != null) {
	                attrs.x = x;
	            }
	            if (y != null) {
	                attrs.y = y;
	            }
	            if (width != null) {
	                attrs.width = width;
	            }
	            if (height != null) {
	                attrs.height = height;
	            }
	            if (vbx != null && vby != null && vbw != null && vbh != null) {
	                attrs.viewBox = [vbx, vby, vbw, vbh];
	            }
	        }
	        return this.el("svg", attrs);
	    };
	    /*\
	     * Paper.mask
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a mask.
	     **
	     = (object) the `mask` element
	     **
	    \*/
	    proto.mask = function (first) {
	        var attr,
	            el = this.el("mask");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.ptrn
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `pattern` element
	     **
	    \*/
	    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
	        if (is(x, "object")) {
	            var attr = x;
	        } else {
	            attr = {patternUnits: "userSpaceOnUse"};
	            if (x) {
	                attr.x = x;
	            }
	            if (y) {
	                attr.y = y;
	            }
	            if (width != null) {
	                attr.width = width;
	            }
	            if (height != null) {
	                attr.height = height;
	            }
	            if (vx != null && vy != null && vw != null && vh != null) {
	                attr.viewBox = [vx, vy, vw, vh];
	            } else {
	                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
	            }
	        }
	        return this.el("pattern", attr);
	    };
	    /*\
	     * Paper.use
	     [ method ]
	     **
	     * Creates a <use> element.
	     - id (string) @optional id of element to link
	     * or
	     - id (Element) @optional element to link
	     **
	     = (object) the `use` element
	     **
	    \*/
	    proto.use = function (id) {
	        if (id != null) {
	            if (id instanceof Element) {
	                if (!id.attr("id")) {
	                    id.attr({id: Snap._.id(id)});
	                }
	                id = id.attr("id");
	            }
	            if (String(id).charAt() == "#") {
	                id = id.substring(1);
	            }
	            return this.el("use", {"xlink:href": "#" + id});
	        } else {
	            return Element.prototype.use.call(this);
	        }
	    };
	    /*\
	     * Paper.symbol
	     [ method ]
	     **
	     * Creates a <symbol> element.
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     = (object) the `symbol` element
	     **
	    \*/
	    proto.symbol = function (vx, vy, vw, vh) {
	        var attr = {};
	        if (vx != null && vy != null && vw != null && vh != null) {
	            attr.viewBox = [vx, vy, vw, vh];
	        }
	
	        return this.el("symbol", attr);
	    };
	    /*\
	     * Paper.text
	     [ method ]
	     **
	     * Draws a text string
	     **
	     - x (number) x coordinate position
	     - y (number) y coordinate position
	     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
	     = (object) the `text` element
	     **
	     > Usage
	     | var t1 = paper.text(50, 50, "Snap");
	     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
	     | // Text path usage
	     | t1.attr({textpath: "M10,10L100,100"});
	     | // or
	     | var pth = paper.path("M10,10L100,100");
	     | t1.attr({textpath: pth});
	    \*/
	    proto.text = function (x, y, text) {
	        var attr = {};
	        if (is(x, "object")) {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                text: text || ""
	            };
	        }
	        return this.el("text", attr);
	    };
	    /*\
	     * Paper.line
	     [ method ]
	     **
	     * Draws a line
	     **
	     - x1 (number) x coordinate position of the start
	     - y1 (number) y coordinate position of the start
	     - x2 (number) x coordinate position of the end
	     - y2 (number) y coordinate position of the end
	     = (object) the `line` element
	     **
	     > Usage
	     | var t1 = paper.line(50, 50, 100, 100);
	    \*/
	    proto.line = function (x1, y1, x2, y2) {
	        var attr = {};
	        if (is(x1, "object")) {
	            attr = x1;
	        } else if (x1 != null) {
	            attr = {
	                x1: x1,
	                x2: x2,
	                y1: y1,
	                y2: y2
	            };
	        }
	        return this.el("line", attr);
	    };
	    /*\
	     * Paper.polyline
	     [ method ]
	     **
	     * Draws a polyline
	     **
	     - points (array) array of points
	     * or
	     - varargs (…) points
	     = (object) the `polyline` element
	     **
	     > Usage
	     | var p1 = paper.polyline([10, 10, 100, 100]);
	     | var p2 = paper.polyline(10, 10, 100, 100);
	    \*/
	    proto.polyline = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polyline", attr);
	    };
	    /*\
	     * Paper.polygon
	     [ method ]
	     **
	     * Draws a polygon. See @Paper.polyline
	    \*/
	    proto.polygon = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polygon", attr);
	    };
	    // gradients
	    (function () {
	        var $ = Snap._.$;
	        // gradients' helpers
	        /*\
	         * Element.stops
	         [ method ]
	         **
	         * Only for gradients!
	         * Returns array of gradient stops elements.
	         = (array) the stops array.
	        \*/
	        function Gstops() {
	            return this.selectAll("stop");
	        }
	        /*\
	         * Element.addStop
	         [ method ]
	         **
	         * Only for gradients!
	         * Adds another stop to the gradient.
	         - color (string) stops color
	         - offset (number) stops offset 0..100
	         = (object) gradient element
	        \*/
	        function GaddStop(color, offset) {
	            var stop = $("stop"),
	                attr = {
	                    offset: +offset + "%"
	                };
	            color = Snap.color(color);
	            attr["stop-color"] = color.hex;
	            if (color.opacity < 1) {
	                attr["stop-opacity"] = color.opacity;
	            }
	            $(stop, attr);
	            var stops = this.stops(),
	                inserted;
	            for (var i = 0; i < stops.length; i++) {
	                var stopOffset = parseFloat(stops[i].attr("offset"));
	                if (stopOffset > offset) {
	                    this.node.insertBefore(stop, stops[i].node);
	                    inserted = true;
	                    break;
	                }
	            }
	            if (!inserted) {
	                this.node.appendChild(stop);
	            }
	            return this;
	        }
	        function GgetBBox() {
	            if (this.type == "linearGradient") {
	                var x1 = $(this.node, "x1") || 0,
	                    x2 = $(this.node, "x2") || 1,
	                    y1 = $(this.node, "y1") || 0,
	                    y2 = $(this.node, "y2") || 0;
	                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
	            } else {
	                var cx = this.node.cx || .5,
	                    cy = this.node.cy || .5,
	                    r = this.node.r || 0;
	                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
	            }
	        }
	        /*\
	         * Element.setStops
	         [ method ]
	         **
	         * Only for gradients!
	         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
	         - str (string) gradient descriptor part after `()`.
	         = (object) gradient element
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         | g.setStops("#fff-#000-#f00-#fc0");
	        \*/
	        function GsetStops(str) {
	            var grad = str,
	                stops = this.stops();
	            if (typeof str == "string") {
	                grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
	            }
	            if (!Snap.is(grad, "array")) {
	                return;
	            }
	            for (var i = 0; i < stops.length; i++) {
	                if (grad[i]) {
	                    var color = Snap.color(grad[i].color),
	                        attr = {"offset": grad[i].offset + "%"};
	                    attr["stop-color"] = color.hex;
	                    if (color.opacity < 1) {
	                        attr["stop-opacity"] = color.opacity;
	                    }
	                    stops[i].attr(attr);
	                } else {
	                    stops[i].remove();
	                }
	            }
	            for (i = stops.length; i < grad.length; i++) {
	                this.addStop(grad[i].color, grad[i].offset);
	            }
	            return this;
	        }
	        function gradient(defs, str) {
	            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
	                el;
	            if (!grad) {
	                return null;
	            }
	            grad.params.unshift(defs);
	            if (grad.type.toLowerCase() == "l") {
	                el = gradientLinear.apply(0, grad.params);
	            } else {
	                el = gradientRadial.apply(0, grad.params);
	            }
	            if (grad.type != grad.type.toLowerCase()) {
	                $(el.node, {
	                    gradientUnits: "userSpaceOnUse"
	                });
	            }
	            var stops = grad.stops,
	                len = stops.length;
	            for (var i = 0; i < len; i++) {
	                var stop = stops[i];
	                el.addStop(stop.color, stop.offset);
	            }
	            return el;
	        }
	        function gradientLinear(defs, x1, y1, x2, y2) {
	            var el = Snap._.make("linearGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            el.setStops = GsetStops;
	            if (x1 != null) {
	                $(el.node, {
	                    x1: x1,
	                    y1: y1,
	                    x2: x2,
	                    y2: y2
	                });
	            }
	            return el;
	        }
	        function gradientRadial(defs, cx, cy, r, fx, fy) {
	            var el = Snap._.make("radialGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            if (cx != null) {
	                $(el.node, {
	                    cx: cx,
	                    cy: cy,
	                    r: r
	                });
	            }
	            if (fx != null && fy != null) {
	                $(el.node, {
	                    fx: fx,
	                    fy: fy
	                });
	            }
	            return el;
	        }
	        /*\
	         * Paper.gradient
	         [ method ]
	         **
	         * Creates a gradient element
	         **
	         - gradient (string) gradient descriptor
	         > Gradient Descriptor
	         * The gradient descriptor is an expression formatted as
	         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
	         * either linear or radial.  The uppercase `L` or `R` letters
	         * indicate absolute coordinates offset from the SVG surface.
	         * Lowercase `l` or `r` letters indicate coordinates
	         * calculated relative to the element to which the gradient is
	         * applied.  Coordinates specify a linear gradient vector as
	         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
	         * `r` and optional `fx`, `fy` specifying a focal point away
	         * from the center of the circle. Specify `<colors>` as a list
	         * of dash-separated CSS color values.  Each color may be
	         * followed by a custom offset value, separated with a colon
	         * character.
	         > Examples
	         * Linear gradient, relative from top-left corner to bottom-right
	         * corner, from black through red to white:
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         * Linear gradient, absolute from (0, 0) to (100, 100), from black
	         * through red at 25% to white:
	         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
	         * Radial gradient, relative from the center of the element with radius
	         * half the width, from black to white:
	         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
	         * To apply the gradient:
	         | paper.circle(50, 50, 40).attr({
	         |     fill: g
	         | });
	         = (object) the `gradient` element
	        \*/
	        proto.gradient = function (str) {
	            return gradient(this.defs, str);
	        };
	        proto.gradientLinear = function (x1, y1, x2, y2) {
	            return gradientLinear(this.defs, x1, y1, x2, y2);
	        };
	        proto.gradientRadial = function (cx, cy, r, fx, fy) {
	            return gradientRadial(this.defs, cx, cy, r, fx, fy);
	        };
	        /*\
	         * Paper.toString
	         [ method ]
	         **
	         * Returns SVG code for the @Paper
	         = (string) SVG code for the @Paper
	        \*/
	        proto.toString = function () {
	            var doc = this.node.ownerDocument,
	                f = doc.createDocumentFragment(),
	                d = doc.createElement("div"),
	                svg = this.node.cloneNode(true),
	                res;
	            f.appendChild(d);
	            d.appendChild(svg);
	            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
	            res = d.innerHTML;
	            f.removeChild(f.firstChild);
	            return res;
	        };
	        /*\
	         * Paper.toDataURL
	         [ method ]
	         **
	         * Returns SVG code for the @Paper as Data URI string.
	         = (string) Data URI string
	        \*/
	        proto.toDataURL = function () {
	            if (window && window.btoa) {
	                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
	            }
	        };
	        /*\
	         * Paper.clear
	         [ method ]
	         **
	         * Removes all child nodes of the paper, except <defs>.
	        \*/
	        proto.clear = function () {
	            var node = this.node.firstChild,
	                next;
	            while (node) {
	                next = node.nextSibling;
	                if (node.tagName != "defs") {
	                    node.parentNode.removeChild(node);
	                } else {
	                    proto.clear.call({node: node});
	                }
	                node = next;
	            }
	        };
	    }());
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        clone = Snap._.clone,
	        has = "hasOwnProperty",
	        p2s = /,?([a-z]),?/gi,
	        toFloat = parseFloat,
	        math = Math,
	        PI = math.PI,
	        mmin = math.min,
	        mmax = math.max,
	        pow = math.pow,
	        abs = math.abs;
	    function paths(ps) {
	        var p = paths.ps = paths.ps || {};
	        if (p[ps]) {
	            p[ps].sleep = 100;
	        } else {
	            p[ps] = {
	                sleep: 100
	            };
	        }
	        setTimeout(function () {
	            for (var key in p) if (p[has](key) && key != ps) {
	                p[key].sleep--;
	                !p[key].sleep && delete p[key];
	            }
	        });
	        return p[ps];
	    }
	    function box(x, y, width, height) {
	        if (x == null) {
	            x = y = width = height = 0;
	        }
	        if (y == null) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        return {
	            x: x,
	            y: y,
	            width: width,
	            w: width,
	            height: height,
	            h: height,
	            x2: x + width,
	            y2: y + height,
	            cx: x + width / 2,
	            cy: y + height / 2,
	            r1: math.min(width, height) / 2,
	            r2: math.max(width, height) / 2,
	            r0: math.sqrt(width * width + height * height) / 2,
	            path: rectPath(x, y, width, height),
	            vb: [x, y, width, height].join(" ")
	        };
	    }
	    function toString() {
	        return this.join(",").replace(p2s, "$1");
	    }
	    function pathClone(pathArray) {
	        var res = clone(pathArray);
	        res.toString = toString;
	        return res;
	    }
	    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
	        if (length == null) {
	            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
	        } else {
	            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
	                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
	        }
	    }
	    function getLengthFactory(istotal, subpath) {
	        function O(val) {
	            return +(+val).toFixed(3);
	        }
	        return Snap._.cacher(function (path, length, onlystart) {
	            if (path instanceof Element) {
	                path = path.attr("d");
	            }
	            path = path2curve(path);
	            var x, y, p, l, sp = "", subpaths = {}, point,
	                len = 0;
	            for (var i = 0, ii = path.length; i < ii; i++) {
	                p = path[i];
	                if (p[0] == "M") {
	                    x = +p[1];
	                    y = +p[2];
	                } else {
	                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                    if (len + l > length) {
	                        if (subpath && !subpaths.start) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            sp += [
	                                "C" + O(point.start.x),
	                                O(point.start.y),
	                                O(point.m.x),
	                                O(point.m.y),
	                                O(point.x),
	                                O(point.y)
	                            ];
	                            if (onlystart) {return sp;}
	                            subpaths.start = sp;
	                            sp = [
	                                "M" + O(point.x),
	                                O(point.y) + "C" + O(point.n.x),
	                                O(point.n.y),
	                                O(point.end.x),
	                                O(point.end.y),
	                                O(p[5]),
	                                O(p[6])
	                            ].join();
	                            len += l;
	                            x = +p[5];
	                            y = +p[6];
	                            continue;
	                        }
	                        if (!istotal && !subpath) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            return point;
	                        }
	                    }
	                    len += l;
	                    x = +p[5];
	                    y = +p[6];
	                }
	                sp += p.shift() + p;
	            }
	            subpaths.end = sp;
	            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
	            return point;
	        }, null, Snap._.clone);
	    }
	    var getTotalLength = getLengthFactory(1),
	        getPointAtLength = getLengthFactory(),
	        getSubpathsAtLength = getLengthFactory(0, 1);
	    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t,
	            t13 = pow(t1, 3),
	            t12 = pow(t1, 2),
	            t2 = t * t,
	            t3 = t2 * t,
	            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
	            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
	            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
	            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
	            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
	            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
	            ax = t1 * p1x + t * c1x,
	            ay = t1 * p1y + t * c1y,
	            cx = t1 * c2x + t * p2x,
	            cy = t1 * c2y + t * p2y,
	            alpha = 90 - math.atan2(mx - nx, my - ny) * 180 / PI;
	        // (mx > nx || my < ny) && (alpha += 180);
	        return {
	            x: x,
	            y: y,
	            m: {x: mx, y: my},
	            n: {x: nx, y: ny},
	            start: {x: ax, y: ay},
	            end: {x: cx, y: cy},
	            alpha: alpha
	        };
	    }
	    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
	        if (!Snap.is(p1x, "array")) {
	            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
	        }
	        var bbox = curveDim.apply(null, p1x);
	        return box(
	            bbox.min.x,
	            bbox.min.y,
	            bbox.max.x - bbox.min.x,
	            bbox.max.y - bbox.min.y
	        );
	    }
	    function isPointInsideBBox(bbox, x, y) {
	        return  x >= bbox.x &&
	                x <= bbox.x + bbox.width &&
	                y >= bbox.y &&
	                y <= bbox.y + bbox.height;
	    }
	    function isBBoxIntersect(bbox1, bbox2) {
	        bbox1 = box(bbox1);
	        bbox2 = box(bbox2);
	        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
	            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
	                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
	            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
	                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
	    }
	    function base3(t, p1, p2, p3, p4) {
	        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
	            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
	        return t * t2 - 3 * p1 + 3 * p2;
	    }
	    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
	        if (z == null) {
	            z = 1;
	        }
	        z = z > 1 ? 1 : z < 0 ? 0 : z;
	        var z2 = z / 2,
	            n = 12,
	            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
	            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
	            sum = 0;
	        for (var i = 0; i < n; i++) {
	            var ct = z2 * Tvalues[i] + z2,
	                xbase = base3(ct, x1, x2, x3, x4),
	                ybase = base3(ct, y1, y2, y3, y4),
	                comb = xbase * xbase + ybase * ybase;
	            sum += Cvalues[i] * math.sqrt(comb);
	        }
	        return z2 * sum;
	    }
	    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
	        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
	            return;
	        }
	        var t = 1,
	            step = t / 2,
	            t2 = t - step,
	            l,
	            e = .01;
	        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        while (abs(l - ll) > e) {
	            step /= 2;
	            t2 += (l < ll ? 1 : -1) * step;
	            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        }
	        return t2;
	    }
	    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	        if (
	            mmax(x1, x2) < mmin(x3, x4) ||
	            mmin(x1, x2) > mmax(x3, x4) ||
	            mmax(y1, y2) < mmin(y3, y4) ||
	            mmin(y1, y2) > mmax(y3, y4)
	        ) {
	            return;
	        }
	        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
	            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
	            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	
	        if (!denominator) {
	            return;
	        }
	        var px = nx / denominator,
	            py = ny / denominator,
	            px2 = +px.toFixed(2),
	            py2 = +py.toFixed(2);
	        if (
	            px2 < +mmin(x1, x2).toFixed(2) ||
	            px2 > +mmax(x1, x2).toFixed(2) ||
	            px2 < +mmin(x3, x4).toFixed(2) ||
	            px2 > +mmax(x3, x4).toFixed(2) ||
	            py2 < +mmin(y1, y2).toFixed(2) ||
	            py2 > +mmax(y1, y2).toFixed(2) ||
	            py2 < +mmin(y3, y4).toFixed(2) ||
	            py2 > +mmax(y3, y4).toFixed(2)
	        ) {
	            return;
	        }
	        return {x: px, y: py};
	    }
	    function inter(bez1, bez2) {
	        return interHelper(bez1, bez2);
	    }
	    function interCount(bez1, bez2) {
	        return interHelper(bez1, bez2, 1);
	    }
	    function interHelper(bez1, bez2, justCount) {
	        var bbox1 = bezierBBox(bez1),
	            bbox2 = bezierBBox(bez2);
	        if (!isBBoxIntersect(bbox1, bbox2)) {
	            return justCount ? 0 : [];
	        }
	        var l1 = bezlen.apply(0, bez1),
	            l2 = bezlen.apply(0, bez2),
	            n1 = ~~(l1 / 8),
	            n2 = ~~(l2 / 8),
	            dots1 = [],
	            dots2 = [],
	            xy = {},
	            res = justCount ? 0 : [];
	        for (var i = 0; i < n1 + 1; i++) {
	            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
	            dots1.push({x: p.x, y: p.y, t: i / n1});
	        }
	        for (i = 0; i < n2 + 1; i++) {
	            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
	            dots2.push({x: p.x, y: p.y, t: i / n2});
	        }
	        for (i = 0; i < n1; i++) {
	            for (var j = 0; j < n2; j++) {
	                var di = dots1[i],
	                    di1 = dots1[i + 1],
	                    dj = dots2[j],
	                    dj1 = dots2[j + 1],
	                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
	                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
	                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
	                if (is) {
	                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
	                        continue;
	                    }
	                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
	                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
	                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
	                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
	                        if (justCount) {
	                            res++;
	                        } else {
	                            res.push({
	                                x: is.x,
	                                y: is.y,
	                                t1: t1,
	                                t2: t2
	                            });
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function pathIntersection(path1, path2) {
	        return interPathHelper(path1, path2);
	    }
	    function pathIntersectionNumber(path1, path2) {
	        return interPathHelper(path1, path2, 1);
	    }
	    function interPathHelper(path1, path2, justCount) {
	        path1 = path2curve(path1);
	        path2 = path2curve(path2);
	        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
	            res = justCount ? 0 : [];
	        for (var i = 0, ii = path1.length; i < ii; i++) {
	            var pi = path1[i];
	            if (pi[0] == "M") {
	                x1 = x1m = pi[1];
	                y1 = y1m = pi[2];
	            } else {
	                if (pi[0] == "C") {
	                    bez1 = [x1, y1].concat(pi.slice(1));
	                    x1 = bez1[6];
	                    y1 = bez1[7];
	                } else {
	                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
	                    x1 = x1m;
	                    y1 = y1m;
	                }
	                for (var j = 0, jj = path2.length; j < jj; j++) {
	                    var pj = path2[j];
	                    if (pj[0] == "M") {
	                        x2 = x2m = pj[1];
	                        y2 = y2m = pj[2];
	                    } else {
	                        if (pj[0] == "C") {
	                            bez2 = [x2, y2].concat(pj.slice(1));
	                            x2 = bez2[6];
	                            y2 = bez2[7];
	                        } else {
	                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
	                            x2 = x2m;
	                            y2 = y2m;
	                        }
	                        var intr = interHelper(bez1, bez2, justCount);
	                        if (justCount) {
	                            res += intr;
	                        } else {
	                            for (var k = 0, kk = intr.length; k < kk; k++) {
	                                intr[k].segment1 = i;
	                                intr[k].segment2 = j;
	                                intr[k].bez1 = bez1;
	                                intr[k].bez2 = bez2;
	                            }
	                            res = res.concat(intr);
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function isPointInsidePath(path, x, y) {
	        var bbox = pathBBox(path);
	        return isPointInsideBBox(bbox, x, y) &&
	               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
	    }
	    function pathBBox(path) {
	        var pth = paths(path);
	        if (pth.bbox) {
	            return clone(pth.bbox);
	        }
	        if (!path) {
	            return box();
	        }
	        path = path2curve(path);
	        var x = 0,
	            y = 0,
	            X = [],
	            Y = [],
	            p;
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            p = path[i];
	            if (p[0] == "M") {
	                x = p[1];
	                y = p[2];
	                X.push(x);
	                Y.push(y);
	            } else {
	                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                X = X.concat(dim.min.x, dim.max.x);
	                Y = Y.concat(dim.min.y, dim.max.y);
	                x = p[5];
	                y = p[6];
	            }
	        }
	        var xmin = mmin.apply(0, X),
	            ymin = mmin.apply(0, Y),
	            xmax = mmax.apply(0, X),
	            ymax = mmax.apply(0, Y),
	            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
	        pth.bbox = clone(bb);
	        return bb;
	    }
	    function rectPath(x, y, w, h, r) {
	        if (r) {
	            return [
	                ["M", +x + +r, y],
	                ["l", w - r * 2, 0],
	                ["a", r, r, 0, 0, 1, r, r],
	                ["l", 0, h - r * 2],
	                ["a", r, r, 0, 0, 1, -r, r],
	                ["l", r * 2 - w, 0],
	                ["a", r, r, 0, 0, 1, -r, -r],
	                ["l", 0, r * 2 - h],
	                ["a", r, r, 0, 0, 1, r, -r],
	                ["z"]
	            ];
	        }
	        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
	        res.toString = toString;
	        return res;
	    }
	    function ellipsePath(x, y, rx, ry, a) {
	        if (a == null && ry == null) {
	            ry = rx;
	        }
	        x = +x;
	        y = +y;
	        rx = +rx;
	        ry = +ry;
	        if (a != null) {
	            var rad = Math.PI / 180,
	                x1 = x + rx * Math.cos(-ry * rad),
	                x2 = x + rx * Math.cos(-a * rad),
	                y1 = y + rx * Math.sin(-ry * rad),
	                y2 = y + rx * Math.sin(-a * rad),
	                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
	        } else {
	            res = [
	                ["M", x, y],
	                ["m", 0, -ry],
	                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
	                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
	                ["z"]
	            ];
	        }
	        res.toString = toString;
	        return res;
	    }
	    var unit2px = Snap._unit2px,
	        getPath = {
	        path: function (el) {
	            return el.attr("path");
	        },
	        circle: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx, attr.cy, attr.r);
	        },
	        ellipse: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
	        },
	        rect: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
	        },
	        image: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
	        },
	        line: function (el) {
	            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
	        },
	        polyline: function (el) {
	            return "M" + el.attr("points");
	        },
	        polygon: function (el) {
	            return "M" + el.attr("points") + "z";
	        },
	        deflt: function (el) {
	            var bbox = el.node.getBBox();
	            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
	        }
	    };
	    function pathToRelative(pathArray) {
	        var pth = paths(pathArray),
	            lowerCase = String.prototype.toLowerCase;
	        if (pth.rel) {
	            return pathClone(pth.rel);
	        }
	        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0;
	        if (pathArray[0][0] == "M") {
	            x = pathArray[0][1];
	            y = pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res.push(["M", x, y]);
	        }
	        for (var i = start, ii = pathArray.length; i < ii; i++) {
	            var r = res[i] = [],
	                pa = pathArray[i];
	            if (pa[0] != lowerCase.call(pa[0])) {
	                r[0] = lowerCase.call(pa[0]);
	                switch (r[0]) {
	                    case "a":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +(pa[6] - x).toFixed(3);
	                        r[7] = +(pa[7] - y).toFixed(3);
	                        break;
	                    case "v":
	                        r[1] = +(pa[1] - y).toFixed(3);
	                        break;
	                    case "m":
	                        mx = pa[1];
	                        my = pa[2];
	                    default:
	                        for (var j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
	                        }
	                }
	            } else {
	                r = res[i] = [];
	                if (pa[0] == "m") {
	                    mx = pa[1] + x;
	                    my = pa[2] + y;
	                }
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    res[i][k] = pa[k];
	                }
	            }
	            var len = res[i].length;
	            switch (res[i][0]) {
	                case "z":
	                    x = mx;
	                    y = my;
	                    break;
	                case "h":
	                    x += +res[i][len - 1];
	                    break;
	                case "v":
	                    y += +res[i][len - 1];
	                    break;
	                default:
	                    x += +res[i][len - 2];
	                    y += +res[i][len - 1];
	            }
	        }
	        res.toString = toString;
	        pth.rel = pathClone(res);
	        return res;
	    }
	    function pathToAbsolute(pathArray) {
	        var pth = paths(pathArray);
	        if (pth.abs) {
	            return pathClone(pth.abs);
	        }
	        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        if (!pathArray || !pathArray.length) {
	            return [["M", 0, 0]];
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0,
	            pa0;
	        if (pathArray[0][0] == "M") {
	            x = +pathArray[0][1];
	            y = +pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res[0] = ["M", x, y];
	        }
	        var crz = pathArray.length == 3 &&
	            pathArray[0][0] == "M" &&
	            pathArray[1][0].toUpperCase() == "R" &&
	            pathArray[2][0].toUpperCase() == "Z";
	        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
	            res.push(r = []);
	            pa = pathArray[i];
	            pa0 = pa[0];
	            if (pa0 != pa0.toUpperCase()) {
	                r[0] = pa0.toUpperCase();
	                switch (r[0]) {
	                    case "A":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +pa[6] + x;
	                        r[7] = +pa[7] + y;
	                        break;
	                    case "V":
	                        r[1] = +pa[1] + y;
	                        break;
	                    case "H":
	                        r[1] = +pa[1] + x;
	                        break;
	                    case "R":
	                        var dots = [x, y].concat(pa.slice(1));
	                        for (var j = 2, jj = dots.length; j < jj; j++) {
	                            dots[j] = +dots[j] + x;
	                            dots[++j] = +dots[j] + y;
	                        }
	                        res.pop();
	                        res = res.concat(catmullRom2bezier(dots, crz));
	                        break;
	                    case "O":
	                        res.pop();
	                        dots = ellipsePath(x, y, pa[1], pa[2]);
	                        dots.push(dots[0]);
	                        res = res.concat(dots);
	                        break;
	                    case "U":
	                        res.pop();
	                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                        r = ["U"].concat(res[res.length - 1].slice(-2));
	                        break;
	                    case "M":
	                        mx = +pa[1] + x;
	                        my = +pa[2] + y;
	                    default:
	                        for (j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +pa[j] + (j % 2 ? x : y);
	                        }
	                }
	            } else if (pa0 == "R") {
	                dots = [x, y].concat(pa.slice(1));
	                res.pop();
	                res = res.concat(catmullRom2bezier(dots, crz));
	                r = ["R"].concat(pa.slice(-2));
	            } else if (pa0 == "O") {
	                res.pop();
	                dots = ellipsePath(x, y, pa[1], pa[2]);
	                dots.push(dots[0]);
	                res = res.concat(dots);
	            } else if (pa0 == "U") {
	                res.pop();
	                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                r = ["U"].concat(res[res.length - 1].slice(-2));
	            } else {
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    r[k] = pa[k];
	                }
	            }
	            pa0 = pa0.toUpperCase();
	            if (pa0 != "O") {
	                switch (r[0]) {
	                    case "Z":
	                        x = +mx;
	                        y = +my;
	                        break;
	                    case "H":
	                        x = r[1];
	                        break;
	                    case "V":
	                        y = r[1];
	                        break;
	                    case "M":
	                        mx = r[r.length - 2];
	                        my = r[r.length - 1];
	                    default:
	                        x = r[r.length - 2];
	                        y = r[r.length - 1];
	                }
	            }
	        }
	        res.toString = toString;
	        pth.abs = pathClone(res);
	        return res;
	    }
	    function l2c(x1, y1, x2, y2) {
	        return [x1, y1, x2, y2, x2, y2];
	    }
	    function q2c(x1, y1, ax, ay, x2, y2) {
	        var _13 = 1 / 3,
	            _23 = 2 / 3;
	        return [
	                _13 * x1 + _23 * ax,
	                _13 * y1 + _23 * ay,
	                _13 * x2 + _23 * ax,
	                _13 * y2 + _23 * ay,
	                x2,
	                y2
	            ];
	    }
	    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
	        // for more information of where this math came from visit:
	        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	        var _120 = PI * 120 / 180,
	            rad = PI / 180 * (+angle || 0),
	            res = [],
	            xy,
	            rotate = Snap._.cacher(function (x, y, rad) {
	                var X = x * math.cos(rad) - y * math.sin(rad),
	                    Y = x * math.sin(rad) + y * math.cos(rad);
	                return {x: X, y: Y};
	            });
	        if (!rx || !ry) {
	            return [x1, y1, x2, y2, x2, y2];
	        }
	        if (!recursive) {
	            xy = rotate(x1, y1, -rad);
	            x1 = xy.x;
	            y1 = xy.y;
	            xy = rotate(x2, y2, -rad);
	            x2 = xy.x;
	            y2 = xy.y;
	            var cos = math.cos(PI / 180 * angle),
	                sin = math.sin(PI / 180 * angle),
	                x = (x1 - x2) / 2,
	                y = (y1 - y2) / 2;
	            var h = x * x / (rx * rx) + y * y / (ry * ry);
	            if (h > 1) {
	                h = math.sqrt(h);
	                rx = h * rx;
	                ry = h * ry;
	            }
	            var rx2 = rx * rx,
	                ry2 = ry * ry,
	                k = (large_arc_flag == sweep_flag ? -1 : 1) *
	                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
	                cx = k * rx * y / ry + (x1 + x2) / 2,
	                cy = k * -ry * x / rx + (y1 + y2) / 2,
	                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
	                f2 = math.asin(((y2 - cy) / ry).toFixed(9));
	
	            f1 = x1 < cx ? PI - f1 : f1;
	            f2 = x2 < cx ? PI - f2 : f2;
	            f1 < 0 && (f1 = PI * 2 + f1);
	            f2 < 0 && (f2 = PI * 2 + f2);
	            if (sweep_flag && f1 > f2) {
	                f1 = f1 - PI * 2;
	            }
	            if (!sweep_flag && f2 > f1) {
	                f2 = f2 - PI * 2;
	            }
	        } else {
	            f1 = recursive[0];
	            f2 = recursive[1];
	            cx = recursive[2];
	            cy = recursive[3];
	        }
	        var df = f2 - f1;
	        if (abs(df) > _120) {
	            var f2old = f2,
	                x2old = x2,
	                y2old = y2;
	            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
	            x2 = cx + rx * math.cos(f2);
	            y2 = cy + ry * math.sin(f2);
	            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
	        }
	        df = f2 - f1;
	        var c1 = math.cos(f1),
	            s1 = math.sin(f1),
	            c2 = math.cos(f2),
	            s2 = math.sin(f2),
	            t = math.tan(df / 4),
	            hx = 4 / 3 * rx * t,
	            hy = 4 / 3 * ry * t,
	            m1 = [x1, y1],
	            m2 = [x1 + hx * s1, y1 - hy * c1],
	            m3 = [x2 + hx * s2, y2 - hy * c2],
	            m4 = [x2, y2];
	        m2[0] = 2 * m1[0] - m2[0];
	        m2[1] = 2 * m1[1] - m2[1];
	        if (recursive) {
	            return [m2, m3, m4].concat(res);
	        } else {
	            res = [m2, m3, m4].concat(res).join().split(",");
	            var newres = [];
	            for (var i = 0, ii = res.length; i < ii; i++) {
	                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
	            }
	            return newres;
	        }
	    }
	    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t;
	        return {
	            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
	            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
	        };
	    }
	
	    // Returns bounding box of cubic bezier curve.
	    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	    // Original version: NISHIO Hirokazu
	    // Modifications: https://github.com/timo22345
	    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
	        var tvalues = [],
	            bounds = [[], []],
	            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
	        for (var i = 0; i < 2; ++i) {
	            if (i == 0) {
	                b = 6 * x0 - 12 * x1 + 6 * x2;
	                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
	                c = 3 * x1 - 3 * x0;
	            } else {
	                b = 6 * y0 - 12 * y1 + 6 * y2;
	                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
	                c = 3 * y1 - 3 * y0;
	            }
	            if (abs(a) < 1e-12) {
	                if (abs(b) < 1e-12) {
	                    continue;
	                }
	                t = -c / b;
	                if (0 < t && t < 1) {
	                    tvalues.push(t);
	                }
	                continue;
	            }
	            b2ac = b * b - 4 * c * a;
	            sqrtb2ac = math.sqrt(b2ac);
	            if (b2ac < 0) {
	                continue;
	            }
	            t1 = (-b + sqrtb2ac) / (2 * a);
	            if (0 < t1 && t1 < 1) {
	                tvalues.push(t1);
	            }
	            t2 = (-b - sqrtb2ac) / (2 * a);
	            if (0 < t2 && t2 < 1) {
	                tvalues.push(t2);
	            }
	        }
	
	        var x, y, j = tvalues.length,
	            jlen = j,
	            mt;
	        while (j--) {
	            t = tvalues[j];
	            mt = 1 - t;
	            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
	            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
	        }
	
	        bounds[0][jlen] = x0;
	        bounds[1][jlen] = y0;
	        bounds[0][jlen + 1] = x3;
	        bounds[1][jlen + 1] = y3;
	        bounds[0].length = bounds[1].length = jlen + 2;
	
	
	        return {
	          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
	          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
	        };
	    }
	
	    function path2curve(path, path2) {
	        var pth = !path2 && paths(path);
	        if (!path2 && pth.curve) {
	            return pathClone(pth.curve);
	        }
	        var p = pathToAbsolute(path),
	            p2 = path2 && pathToAbsolute(path2),
	            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            processPath = function (path, d, pcom) {
	                var nx, ny;
	                if (!path) {
	                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
	                }
	                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
	                switch (path[0]) {
	                    case "M":
	                        d.X = path[1];
	                        d.Y = path[2];
	                        break;
	                    case "A":
	                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
	                        break;
	                    case "S":
	                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
	                            nx = d.x * 2 - d.bx;          // And reflect the previous
	                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
	                        }
	                        else {                            // or some else or nothing
	                            nx = d.x;
	                            ny = d.y;
	                        }
	                        path = ["C", nx, ny].concat(path.slice(1));
	                        break;
	                    case "T":
	                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
	                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
	                            d.qy = d.y * 2 - d.qy;        // to case "S".
	                        }
	                        else {                            // or something else or nothing
	                            d.qx = d.x;
	                            d.qy = d.y;
	                        }
	                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
	                        break;
	                    case "Q":
	                        d.qx = path[1];
	                        d.qy = path[2];
	                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
	                        break;
	                    case "L":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
	                        break;
	                    case "H":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
	                        break;
	                    case "V":
	                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
	                        break;
	                    case "Z":
	                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
	                        break;
	                }
	                return path;
	            },
	            fixArc = function (pp, i) {
	                if (pp[i].length > 7) {
	                    pp[i].shift();
	                    var pi = pp[i];
	                    while (pi.length) {
	                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
	                        p2 && (pcoms2[i] = "A"); // the same as above
	                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
	                    }
	                    pp.splice(i, 1);
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            fixM = function (path1, path2, a1, a2, i) {
	                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
	                    path2.splice(i, 0, ["M", a2.x, a2.y]);
	                    a1.bx = 0;
	                    a1.by = 0;
	                    a1.x = path1[i][1];
	                    a1.y = path1[i][2];
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            pcoms1 = [], // path commands of original path p
	            pcoms2 = [], // path commands of original path p2
	            pfirst = "", // temporary holder for original path command
	            pcom = ""; // holder for previous path command of original path
	        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
	            p[i] && (pfirst = p[i][0]); // save current path command
	
	            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
	            {
	                pcoms1[i] = pfirst; // Save current path command
	                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
	            }
	            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath
	
	            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
	            // which may produce multiple C:s
	            // so we have to make sure that C is also C in original path
	
	            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
	
	            if (p2) { // the same procedures is done to p2
	                p2[i] && (pfirst = p2[i][0]);
	                if (pfirst != "C") {
	                    pcoms2[i] = pfirst;
	                    i && (pcom = pcoms2[i - 1]);
	                }
	                p2[i] = processPath(p2[i], attrs2, pcom);
	
	                if (pcoms2[i] != "A" && pfirst == "C") {
	                    pcoms2[i] = "C";
	                }
	
	                fixArc(p2, i);
	            }
	            fixM(p, p2, attrs, attrs2, i);
	            fixM(p2, p, attrs2, attrs, i);
	            var seg = p[i],
	                seg2 = p2 && p2[i],
	                seglen = seg.length,
	                seg2len = p2 && seg2.length;
	            attrs.x = seg[seglen - 2];
	            attrs.y = seg[seglen - 1];
	            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
	            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
	            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
	            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
	            attrs2.x = p2 && seg2[seg2len - 2];
	            attrs2.y = p2 && seg2[seg2len - 1];
	        }
	        if (!p2) {
	            pth.curve = pathClone(p);
	        }
	        return p2 ? [p, p2] : p;
	    }
	    function mapPath(path, matrix) {
	        if (!matrix) {
	            return path;
	        }
	        var x, y, i, j, ii, jj, pathi;
	        path = path2curve(path);
	        for (i = 0, ii = path.length; i < ii; i++) {
	            pathi = path[i];
	            for (j = 1, jj = pathi.length; j < jj; j += 2) {
	                x = matrix.x(pathi[j], pathi[j + 1]);
	                y = matrix.y(pathi[j], pathi[j + 1]);
	                pathi[j] = x;
	                pathi[j + 1] = y;
	            }
	        }
	        return path;
	    }
	
	    // http://schepers.cc/getting-to-the-point
	    function catmullRom2bezier(crp, z) {
	        var d = [];
	        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
	            var p = [
	                        {x: +crp[i - 2], y: +crp[i - 1]},
	                        {x: +crp[i],     y: +crp[i + 1]},
	                        {x: +crp[i + 2], y: +crp[i + 3]},
	                        {x: +crp[i + 4], y: +crp[i + 5]}
	                    ];
	            if (z) {
	                if (!i) {
	                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
	                } else if (iLen - 4 == i) {
	                    p[3] = {x: +crp[0], y: +crp[1]};
	                } else if (iLen - 2 == i) {
	                    p[2] = {x: +crp[0], y: +crp[1]};
	                    p[3] = {x: +crp[2], y: +crp[3]};
	                }
	            } else {
	                if (iLen - 4 == i) {
	                    p[3] = p[2];
	                } else if (!i) {
	                    p[0] = {x: +crp[i], y: +crp[i + 1]};
	                }
	            }
	            d.push(["C",
	                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
	                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
	                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
	                  (p[1].y + 6*p[2].y - p[3].y) / 6,
	                  p[2].x,
	                  p[2].y
	            ]);
	        }
	
	        return d;
	    }
	
	    // export
	    Snap.path = paths;
	
	    /*\
	     * Snap.path.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the given path in pixels
	     **
	     - path (string) SVG path string
	     **
	     = (number) length
	    \*/
	    Snap.path.getTotalLength = getTotalLength;
	    /*\
	     * Snap.path.getPointAtLength
	     [ method ]
	     **
	     * Returns the coordinates of the point located at the given length along the given path
	     **
	     - path (string) SVG path string
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    Snap.path.getPointAtLength = getPointAtLength;
	    /*\
	     * Snap.path.getSubpath
	     [ method ]
	     **
	     * Returns the subpath of a given path between given start and end lengths
	     **
	     - path (string) SVG path string
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    Snap.path.getSubpath = function (path, from, to) {
	        if (this.getTotalLength(path) - to < 1e-6) {
	            return getSubpathsAtLength(path, from).end;
	        }
	        var a = getSubpathsAtLength(path, to, 1);
	        return from ? getSubpathsAtLength(a, from).end : a;
	    };
	    /*\
	     * Element.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the path in pixels (only works for `path` elements)
	     = (number) length
	    \*/
	    elproto.getTotalLength = function () {
	        if (this.node.getTotalLength) {
	            return this.node.getTotalLength();
	        }
	    };
	    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
	    /*\
	     * Element.getPointAtLength
	     [ method ]
	     **
	     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
	     **
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    elproto.getPointAtLength = function (length) {
	        return getPointAtLength(this.attr("d"), length);
	    };
	    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
	    /*\
	     * Element.getSubpath
	     [ method ]
	     **
	     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
	     **
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    elproto.getSubpath = function (from, to) {
	        return Snap.path.getSubpath(this.attr("d"), from, to);
	    };
	    Snap._.box = box;
	    /*\
	     * Snap.path.findDotsAtSegment
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds dot coordinates on the given cubic beziér curve at the given t
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     - t (number) position on the curve (0..1)
	     = (object) point information in format:
	     o {
	     o     x: (number) x coordinate of the point,
	     o     y: (number) y coordinate of the point,
	     o     m: {
	     o         x: (number) x coordinate of the left anchor,
	     o         y: (number) y coordinate of the left anchor
	     o     },
	     o     n: {
	     o         x: (number) x coordinate of the right anchor,
	     o         y: (number) y coordinate of the right anchor
	     o     },
	     o     start: {
	     o         x: (number) x coordinate of the start of the curve,
	     o         y: (number) y coordinate of the start of the curve
	     o     },
	     o     end: {
	     o         x: (number) x coordinate of the end of the curve,
	     o         y: (number) y coordinate of the end of the curve
	     o     },
	     o     alpha: (number) angle of the curve derivative at the point
	     o }
	    \*/
	    Snap.path.findDotsAtSegment = findDotsAtSegment;
	    /*\
	     * Snap.path.bezierBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given cubic beziér curve
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     * or
	     - bez (array) array of six points for beziér curve
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.bezierBBox = bezierBBox;
	    /*\
	     * Snap.path.isPointInsideBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside bounding box
	     - bbox (string) bounding box
	     - x (string) x coordinate of the point
	     - y (string) y coordinate of the point
	     = (boolean) `true` if point is inside
	    \*/
	    Snap.path.isPointInsideBBox = isPointInsideBBox;
	    Snap.closest = function (x, y, X, Y) {
	        var r = 100,
	            b = box(x - r / 2, y - r / 2, r, r),
	            inside = [],
	            getter = X[0].hasOwnProperty("x") ? function (i) {
	                return {
	                    x: X[i].x,
	                    y: X[i].y
	                };
	            } : function (i) {
	                return {
	                    x: X[i],
	                    y: Y[i]
	                };
	            },
	            found = 0;
	        while (r <= 1e6 && !found) {
	            for (var i = 0, ii = X.length; i < ii; i++) {
	                var xy = getter(i);
	                if (isPointInsideBBox(b, xy.x, xy.y)) {
	                    found++;
	                    inside.push(xy);
	                    break;
	                }
	            }
	            if (!found) {
	                r *= 2;
	                b = box(x - r / 2, y - r / 2, r, r)
	            }
	        }
	        if (r == 1e6) {
	            return;
	        }
	        var len = Infinity,
	            res;
	        for (i = 0, ii = inside.length; i < ii; i++) {
	            var l = Snap.len(x, y, inside[i].x, inside[i].y);
	            if (len > l) {
	                len = l;
	                inside[i].len = l;
	                res = inside[i];
	            }
	        }
	        return res;
	    };
	    /*\
	     * Snap.path.isBBoxIntersect
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if two bounding boxes intersect
	     - bbox1 (string) first bounding box
	     - bbox2 (string) second bounding box
	     = (boolean) `true` if bounding boxes intersect
	    \*/
	    Snap.path.isBBoxIntersect = isBBoxIntersect;
	    /*\
	     * Snap.path.intersection
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds intersections of two paths
	     - path1 (string) path string
	     - path2 (string) path string
	     = (array) dots of intersection
	     o [
	     o     {
	     o         x: (number) x coordinate of the point,
	     o         y: (number) y coordinate of the point,
	     o         t1: (number) t value for segment of path1,
	     o         t2: (number) t value for segment of path2,
	     o         segment1: (number) order number for segment of path1,
	     o         segment2: (number) order number for segment of path2,
	     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
	     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
	     o     }
	     o ]
	    \*/
	    Snap.path.intersection = pathIntersection;
	    Snap.path.intersectionNumber = pathIntersectionNumber;
	    /*\
	     * Snap.path.isPointInside
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside a given closed path.
	     *
	     * Note: fill mode doesn’t affect the result of this method.
	     - path (string) path string
	     - x (number) x of the point
	     - y (number) y of the point
	     = (boolean) `true` if point is inside the path
	    \*/
	    Snap.path.isPointInside = isPointInsidePath;
	    /*\
	     * Snap.path.getBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given path
	     - path (string) path string
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.getBBox = pathBBox;
	    Snap.path.get = getPath;
	    /*\
	     * Snap.path.toRelative
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into relative values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toRelative = pathToRelative;
	    /*\
	     * Snap.path.toAbsolute
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into absolute values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toAbsolute = pathToAbsolute;
	    /*\
	     * Snap.path.toCubic
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path to a new path where all segments are cubic beziér curves
	     - pathString (string|array) path string or array of segments
	     = (array) array of segments
	    \*/
	    Snap.path.toCubic = path2curve;
	    /*\
	     * Snap.path.map
	     [ method ]
	     **
	     * Transform the path string with the given matrix
	     - path (string) path string
	     - matrix (object) see @Matrix
	     = (string) transformed path string
	    \*/
	    Snap.path.map = mapPath;
	    Snap.path.toString = toString;
	    Snap.path.clone = pathClone;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var mmax = Math.max,
	        mmin = Math.min;
	
	    // Set
	    var Set = function (items) {
	        this.items = [];
		this.bindings = {};
	        this.length = 0;
	        this.type = "set";
	        if (items) {
	            for (var i = 0, ii = items.length; i < ii; i++) {
	                if (items[i]) {
	                    this[this.items.length] = this.items[this.items.length] = items[i];
	                    this.length++;
	                }
	            }
	        }
	    },
	    setproto = Set.prototype;
	    /*\
	     * Set.push
	     [ method ]
	     **
	     * Adds each argument to the current set
	     = (object) original element
	    \*/
	    setproto.push = function () {
	        var item,
	            len;
	        for (var i = 0, ii = arguments.length; i < ii; i++) {
	            item = arguments[i];
	            if (item) {
	                len = this.items.length;
	                this[len] = this.items[len] = item;
	                this.length++;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.pop
	     [ method ]
	     **
	     * Removes last element and returns it
	     = (object) element
	    \*/
	    setproto.pop = function () {
	        this.length && delete this[this.length--];
	        return this.items.pop();
	    };
	    /*\
	     * Set.forEach
	     [ method ]
	     **
	     * Executes given function for each element in the set
	     *
	     * If the function returns `false`, the loop stops running.
	     **
	     - callback (function) function to run
	     - thisArg (object) context object for the callback
	     = (object) Set object
	    \*/
	    setproto.forEach = function (callback, thisArg) {
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            if (callback.call(thisArg, this.items[i], i) === false) {
	                return this;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.animate
	     [ method ]
	     **
	     * Animates each element in set in sync.
	     *
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     * or
	     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
	     > Usage
	     | // animate all elements in set to radius 10
	     | set.animate({r: 10}, 500, mina.easein);
	     | // or
	     | // animate first element to radius 10, but second to radius 20 and in different time
	     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
	     = (Element) the current element
	    \*/
	    setproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Snap._.Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = easing.dur;
	            attrs = attrs.attr;
	        }
	        var args = arguments;
	        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
	            var each = true;
	        }
	        var begin,
	            handler = function () {
	                if (begin) {
	                    this.b = begin;
	                } else {
	                    begin = this.b;
	                }
	            },
	            cb = 0,
	            set = this,
	            callbacker = callback && function () {
	                if (++cb == set.length) {
	                    callback.call(this);
	                }
	            };
	        return this.forEach(function (el, i) {
	            eve.once("snap.animcreated." + el.id, handler);
	            if (each) {
	                args[i] && el.animate.apply(el, args[i]);
	            } else {
	                el.animate(attrs, ms, easing, callbacker);
	            }
	        });
	    };
	    /*\
	     * Set.remove
	     [ method ]
	     **
	     * Removes all children of the set.
	     *
	     = (object) Set object
	    \*/
	    setproto.remove = function () {
	        while (this.length) {
	            this.pop().remove();
	        }
	        return this;
	    };
	    /*\
	     * Set.bind
	     [ method ]
	     **
	     * Specifies how to handle a specific attribute when applied
	     * to a set.
	     *
	     **
	     - attr (string) attribute name
	     - callback (function) function to run
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     - eattr (string) attribute on the element to bind the attribute to
	     = (object) Set object
	    \*/
	    setproto.bind = function (attr, a, b) {
	        var data = {};
	        if (typeof a == "function") {
	            this.bindings[attr] = a;
	        } else {
	            var aname = b || attr;
	            this.bindings[attr] = function (v) {
	                data[aname] = v;
	                a.attr(data);
	            };
	        }
	        return this;
	    };
	    /*\
	     * Set.attr
	     [ method ]
	     **
	     * Equivalent of @Element.attr.
	     = (object) Set object
	    \*/
	    setproto.attr = function (value) {
	        var unbound = {};
	        for (var k in value) {
	            if (this.bindings[k]) {
	                this.bindings[k](value[k]);
	            } else {
	                unbound[k] = value[k];
	            }
	        }
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            this.items[i].attr(unbound);
	        }
	        return this;
	    };
	    /*\
	     * Set.clear
	     [ method ]
	     **
	     * Removes all elements from the set
	    \*/
	    setproto.clear = function () {
	        while (this.length) {
	            this.pop();
	        }
	    };
	    /*\
	     * Set.splice
	     [ method ]
	     **
	     * Removes range of elements from the set
	     **
	     - index (number) position of the deletion
	     - count (number) number of element to remove
	     - insertion… (object) #optional elements to insert
	     = (object) set elements that were deleted
	    \*/
	    setproto.splice = function (index, count, insertion) {
	        index = index < 0 ? mmax(this.length + index, 0) : index;
	        count = mmax(0, mmin(this.length - index, count));
	        var tail = [],
	            todel = [],
	            args = [],
	            i;
	        for (i = 2; i < arguments.length; i++) {
	            args.push(arguments[i]);
	        }
	        for (i = 0; i < count; i++) {
	            todel.push(this[index + i]);
	        }
	        for (; i < this.length - index; i++) {
	            tail.push(this[index + i]);
	        }
	        var arglen = args.length;
	        for (i = 0; i < arglen + tail.length; i++) {
	            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
	        }
	        i = this.items.length = this.length -= count - arglen;
	        while (this[i]) {
	            delete this[i++];
	        }
	        return new Set(todel);
	    };
	    /*\
	     * Set.exclude
	     [ method ]
	     **
	     * Removes given element from the set
	     **
	     - element (object) element to remove
	     = (boolean) `true` if object was found and removed from the set
	    \*/
	    setproto.exclude = function (el) {
	        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
	            this.splice(i, 1);
	            return true;
	        }
	        return false;
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Inserts set elements after given element.
	     **
	     - element (object) set will be inserted after this element
	     = (object) Set object
	    \*/
	    setproto.insertAfter = function (el) {
	        var i = this.items.length;
	        while (i--) {
	            this.items[i].insertAfter(el);
	        }
	        return this;
	    };
	    /*\
	     * Set.getBBox
	     [ method ]
	     **
	     * Union of all bboxes of the set. See @Element.getBBox.
	     = (object) bounding box descriptor. See @Element.getBBox.
	    \*/
	    setproto.getBBox = function () {
	        var x = [],
	            y = [],
	            x2 = [],
	            y2 = [];
	        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
	            var box = this.items[i].getBBox();
	            x.push(box.x);
	            y.push(box.y);
	            x2.push(box.x + box.width);
	            y2.push(box.y + box.height);
	        }
	        x = mmin.apply(0, x);
	        y = mmin.apply(0, y);
	        x2 = mmax.apply(0, x2);
	        y2 = mmax.apply(0, y2);
	        return {
	            x: x,
	            y: y,
	            x2: x2,
	            y2: y2,
	            width: x2 - x,
	            height: y2 - y,
	            cx: x + (x2 - x) / 2,
	            cy: y + (y2 - y) / 2
	        };
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Creates a clone of the set.
	     **
	     = (object) New Set object
	    \*/
	    setproto.clone = function (s) {
	        s = new Set;
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            s.push(this.items[i].clone());
	        }
	        return s;
	    };
	    setproto.toString = function () {
	        return "Snap\u2018s set";
	    };
	    setproto.type = "set";
	    // export
	    /*\
	     * Snap.Set
	     [ property ]
	     **
	     * Set constructor.
	    \*/
	    Snap.Set = Set;
	    /*\
	     * Snap.set
	     [ method ]
	     **
	     * Creates a set and fills it with list of arguments.
	     **
	     = (object) New Set object
	     | var r = paper.rect(0, 0, 10, 10),
	     |     s1 = Snap.set(), // empty set
	     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
	    \*/
	    Snap.set = function () {
	        var set = new Set;
	        if (arguments.length) {
	            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
	        }
	        return set;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var names = {},
	        reUnit = /[%a-z]+$/i,
	        Str = String;
	    names.stroke = names.fill = "colour";
	    function getEmpty(item) {
	        var l = item[0];
	        switch (l.toLowerCase()) {
	            case "t": return [l, 0, 0];
	            case "m": return [l, 1, 0, 0, 1, 0, 0];
	            case "r": if (item.length == 4) {
	                return [l, 0, item[2], item[3]];
	            } else {
	                return [l, 0];
	            }
	            case "s": if (item.length == 5) {
	                return [l, 1, 1, item[3], item[4]];
	            } else if (item.length == 3) {
	                return [l, 1, 1];
	            } else {
	                return [l, 1];
	            }
	        }
	    }
	    function equaliseTransform(t1, t2, getBBox) {
	        t1 = t1 || new Snap.Matrix;
	        t2 = t2 || new Snap.Matrix;
	        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
	        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
	        var maxlength = Math.max(t1.length, t2.length),
	            from = [],
	            to = [],
	            i = 0, j, jj,
	            tt1, tt2;
	        for (; i < maxlength; i++) {
	            tt1 = t1[i] || getEmpty(t2[i]);
	            tt2 = t2[i] || getEmpty(tt1);
	            if (tt1[0] != tt2[0] ||
	                tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) ||
	                tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])
	                ) {
	                    t1 = Snap._.transform2matrix(t1, getBBox());
	                    t2 = Snap._.transform2matrix(t2, getBBox());
	                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
	                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
	                    break;
	            }
	            from[i] = [];
	            to[i] = [];
	            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
	                j in tt1 && (from[i][j] = tt1[j]);
	                j in tt2 && (to[i][j] = tt2[j]);
	            }
	        }
	        return {
	            from: path2array(from),
	            to: path2array(to),
	            f: getPath(from)
	        };
	    }
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    function getViewBox(val) {
	        return val.join(" ");
	    }
	    function getColour(clr) {
	        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
	    }
	    function getPath(path) {
	        var k = 0, i, ii, j, jj, out, a, b = [];
	        for (i = 0, ii = path.length; i < ii; i++) {
	            out = "[";
	            a = ['"' + path[i][0] + '"'];
	            for (j = 1, jj = path[i].length; j < jj; j++) {
	                a[j] = "val[" + k++ + "]";
	            }
	            out += a + "]";
	            b[i] = out;
	        }
	        return Function("val", "return Snap.path.toString.call([" + b + "])");
	    }
	    function path2array(path) {
	        var out = [];
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            for (var j = 1, jj = path[i].length; j < jj; j++) {
	                out.push(path[i][j]);
	            }
	        }
	        return out;
	    }
	    function isNumeric(obj) {
	        return isFinite(obj);
	    }
	    function arrayEqual(arr1, arr2) {
	        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
	            return false;
	        }
	        return arr1.toString() == arr2.toString();
	    }
	    Element.prototype.equal = function (name, b) {
	        return eve("snap.util.equal", this, name, b).firstDefined();
	    };
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this;
	        if (names[name] == "colour") {
	            A = Snap.color(a);
	            B = Snap.color(b);
	            return {
	                from: [A.r, A.g, A.b, A.opacity],
	                to: [B.r, B.g, B.b, B.opacity],
	                f: getColour
	            };
	        }
	        if (name == "viewBox") {
	            A = this.attr(name).vb.split(" ").map(Number);
	            B = b.split(" ").map(Number);
	            return {
	                from: A,
	                to: B,
	                f: getViewBox
	            };
	        }
	        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
	            if (typeof b == "string") {
	                b = Str(b).replace(/\.{3}|\u2026/g, a);
	            }
	            a = this.matrix;
	            if (!Snap._.rgTransform.test(b)) {
	                b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
	            } else {
	                b = Snap._.transform2matrix(b, this.getBBox());
	            }
	            return equaliseTransform(a, b, function () {
	                return el.getBBox(1);
	            });
	        }
	        if (name == "d" || name == "path") {
	            A = Snap.path.toCubic(a, b);
	            return {
	                from: path2array(A[0]),
	                to: path2array(A[1]),
	                f: getPath(A[0])
	            };
	        }
	        if (name == "points") {
	            A = Str(a).split(Snap._.separator);
	            B = Str(b).split(Snap._.separator);
	            return {
	                from: A,
	                to: B,
	                f: function (val) { return val; }
	            };
	        }
	        if (isNumeric(a) && isNumeric(b)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getNumber
	            };
	        }
	        var aUnit = a.match(reUnit),
	            bUnit = Str(b).match(reUnit);
	        if (aUnit && arrayEqual(aUnit, bUnit)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getUnit(aUnit)
	            };
	        } else {
	            return {
	                from: this.asPX(name),
	                to: this.asPX(name, b),
	                f: getNumber
	            };
	        }
	    });
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	// 
	// http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	    has = "hasOwnProperty",
	    supportsTouch = "createTouch" in glob.doc,
	    events = [
	        "click", "dblclick", "mousedown", "mousemove", "mouseout",
	        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
	        "touchcancel"
	    ],
	    touchMap = {
	        mousedown: "touchstart",
	        mousemove: "touchmove",
	        mouseup: "touchend"
	    },
	    getScroll = function (xy, el) {
	        var name = xy == "y" ? "scrollTop" : "scrollLeft",
	            doc = el && el.node ? el.node.ownerDocument : glob.doc;
	        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
	    },
	    preventDefault = function () {
	        this.returnValue = false;
	    },
	    preventTouch = function () {
	        return this.originalEvent.preventDefault();
	    },
	    stopPropagation = function () {
	        this.cancelBubble = true;
	    },
	    stopTouch = function () {
	        return this.originalEvent.stopPropagation();
	    },
	    addEvent = function (obj, type, fn, element) {
	        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
	            f = function (e) {
	                var scrollY = getScroll("y", element),
	                    scrollX = getScroll("x", element);
	                if (supportsTouch && touchMap[has](type)) {
	                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
	                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
	                            var olde = e;
	                            e = e.targetTouches[i];
	                            e.originalEvent = olde;
	                            e.preventDefault = preventTouch;
	                            e.stopPropagation = stopTouch;
	                            break;
	                        }
	                    }
	                }
	                var x = e.clientX + scrollX,
	                    y = e.clientY + scrollY;
	                return fn.call(element, e, x, y);
	            };
	
	        if (type !== realName) {
	            obj.addEventListener(type, f, false);
	        }
	
	        obj.addEventListener(realName, f, false);
	
	        return function () {
	            if (type !== realName) {
	                obj.removeEventListener(type, f, false);
	            }
	
	            obj.removeEventListener(realName, f, false);
	            return true;
	        };
	    },
	    drag = [],
	    dragMove = function (e) {
	        var x = e.clientX,
	            y = e.clientY,
	            scrollY = getScroll("y"),
	            scrollX = getScroll("x"),
	            dragi,
	            j = drag.length;
	        while (j--) {
	            dragi = drag[j];
	            if (supportsTouch) {
	                var i = e.touches && e.touches.length,
	                    touch;
	                while (i--) {
	                    touch = e.touches[i];
	                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
	                        x = touch.clientX;
	                        y = touch.clientY;
	                        (e.originalEvent ? e.originalEvent : e).preventDefault();
	                        break;
	                    }
	                }
	            } else {
	                e.preventDefault();
	            }
	            var node = dragi.el.node,
	                o,
	                next = node.nextSibling,
	                parent = node.parentNode,
	                display = node.style.display;
	            // glob.win.opera && parent.removeChild(node);
	            // node.style.display = "none";
	            // o = dragi.el.paper.getElementByPoint(x, y);
	            // node.style.display = display;
	            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
	            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
	            x += scrollX;
	            y += scrollY;
	            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
	        }
	    },
	    dragUp = function (e) {
	        Snap.unmousemove(dragMove).unmouseup(dragUp);
	        var i = drag.length,
	            dragi;
	        while (i--) {
	            dragi = drag[i];
	            dragi.el._drag = {};
	            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
	            eve.off("snap.drag.*." + dragi.el.id);
	        }
	        drag = [];
	    };
	    /*\
	     * Element.click
	     [ method ]
	     **
	     * Adds a click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unclick
	     [ method ]
	     **
	     * Removes a click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.dblclick
	     [ method ]
	     **
	     * Adds a double click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.undblclick
	     [ method ]
	     **
	     * Removes a double click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousedown
	     [ method ]
	     **
	     * Adds a mousedown event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousedown
	     [ method ]
	     **
	     * Removes a mousedown event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousemove
	     [ method ]
	     **
	     * Adds a mousemove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousemove
	     [ method ]
	     **
	     * Removes a mousemove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseout
	     [ method ]
	     **
	     * Adds a mouseout event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseout
	     [ method ]
	     **
	     * Removes a mouseout event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseover
	     [ method ]
	     **
	     * Adds a mouseover event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseover
	     [ method ]
	     **
	     * Removes a mouseover event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseup
	     [ method ]
	     **
	     * Adds a mouseup event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseup
	     [ method ]
	     **
	     * Removes a mouseup event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchstart
	     [ method ]
	     **
	     * Adds a touchstart event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchstart
	     [ method ]
	     **
	     * Removes a touchstart event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchmove
	     [ method ]
	     **
	     * Adds a touchmove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchmove
	     [ method ]
	     **
	     * Removes a touchmove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchend
	     [ method ]
	     **
	     * Adds a touchend event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchend
	     [ method ]
	     **
	     * Removes a touchend event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchcancel
	     [ method ]
	     **
	     * Adds a touchcancel event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchcancel
	     [ method ]
	     **
	     * Removes a touchcancel event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    for (var i = events.length; i--;) {
	        (function (eventName) {
	            Snap[eventName] = elproto[eventName] = function (fn, scope) {
	                if (Snap.is(fn, "function")) {
	                    this.events = this.events || [];
	                    this.events.push({
	                        name: eventName,
	                        f: fn,
	                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
	                    });
	                } else {
	                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
	                        try {
	                            this.events[i].f.call(this);
	                        } catch (e) {}
	                    }
	                }
	                return this;
	            };
	            Snap["un" + eventName] =
	            elproto["un" + eventName] = function (fn) {
	                var events = this.events || [],
	                    l = events.length;
	                while (l--) if (events[l].name == eventName &&
	                               (events[l].f == fn || !fn)) {
	                    events[l].unbind();
	                    events.splice(l, 1);
	                    !events.length && delete this.events;
	                    return this;
	                }
	                return this;
	            };
	        })(events[i]);
	    }
	    /*\
	     * Element.hover
	     [ method ]
	     **
	     * Adds hover event handlers to the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     - icontext (object) #optional context for hover in handler
	     - ocontext (object) #optional context for hover out handler
	     = (object) @Element
	    \*/
	    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
	        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
	    };
	    /*\
	     * Element.unhover
	     [ method ]
	     **
	     * Removes hover event handlers from the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     = (object) @Element
	    \*/
	    elproto.unhover = function (f_in, f_out) {
	        return this.unmouseover(f_in).unmouseout(f_out);
	    };
	    var draggable = [];
	    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
	    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
	    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
	    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
	    /*\
	     * Element.drag
	     [ method ]
	     **
	     * Adds event handlers for an element's drag gesture
	     **
	     - onmove (function) handler for moving
	     - onstart (function) handler for drag start
	     - onend (function) handler for drag end
	     - mcontext (object) #optional context for moving handler
	     - scontext (object) #optional context for drag start handler
	     - econtext (object) #optional context for drag end handler
	     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
	     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
	     * `drag.over.<id>` fires as well.
	     *
	     * Start event and start handler are called in specified context or in context of the element with following parameters:
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * Move event and move handler are called in specified context or in context of the element with following parameters:
	     o dx (number) shift by x from the start point
	     o dy (number) shift by y from the start point
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * End event and end handler are called in specified context or in context of the element with following parameters:
	     o event (object) DOM event object
	     = (object) @Element
	    \*/
	    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
	        var el = this;
	        if (!arguments.length) {
	            var origTransform;
	            return el.drag(function (dx, dy) {
	                this.attr({
	                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
	                });
	            }, function () {
	                origTransform = this.transform().local;
	            });
	        }
	        function start(e, x, y) {
	            (e.originalEvent || e).preventDefault();
	            el._drag.x = x;
	            el._drag.y = y;
	            el._drag.id = e.identifier;
	            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
	            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
	            onstart && eve.on("snap.drag.start." + el.id, onstart);
	            onmove && eve.on("snap.drag.move." + el.id, onmove);
	            onend && eve.on("snap.drag.end." + el.id, onend);
	            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
	        }
	        function init(e, x, y) {
	            eve("snap.draginit." + el.id, el, e, x, y);
	        }
	        eve.on("snap.draginit." + el.id, start);
	        el._drag = {};
	        draggable.push({el: el, start: start, init: init});
	        el.mousedown(init);
	        return el;
	    };
	    /*
	     * Element.onDragOver
	     [ method ]
	     **
	     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
	     - f (function) handler for event, first argument would be the element you are dragging over
	    \*/
	    // elproto.onDragOver = function (f) {
	    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
	    // };
	    /*\
	     * Element.undrag
	     [ method ]
	     **
	     * Removes all drag event handlers from the given element
	    \*/
	    elproto.undrag = function () {
	        var i = draggable.length;
	        while (i--) if (draggable[i].el == this) {
	            this.unmousedown(draggable[i].init);
	            draggable.splice(i, 1);
	            eve.unbind("snap.drag.*." + this.id);
	            eve.unbind("snap.draginit." + this.id);
	        }
	        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        pproto = Paper.prototype,
	        rgurl = /^\s*url\((.+)\)/,
	        Str = String,
	        $ = Snap._.$;
	    Snap.filter = {};
	    /*\
	     * Paper.filter
	     [ method ]
	     **
	     * Creates a `<filter>` element
	     **
	     - filstr (string) SVG fragment of filter provided as a string
	     = (object) @Element
	     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
	     > Usage
	     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    pproto.filter = function (filstr) {
	        var paper = this;
	        if (paper.type != "svg") {
	            paper = paper.paper;
	        }
	        var f = Snap.parse(Str(filstr)),
	            id = Snap._.id(),
	            width = paper.node.offsetWidth,
	            height = paper.node.offsetHeight,
	            filter = $("filter");
	        $(filter, {
	            id: id,
	            filterUnits: "userSpaceOnUse"
	        });
	        filter.appendChild(f.node);
	        paper.defs.appendChild(filter);
	        return new Element(filter);
	    };
	
	    eve.on("snap.util.getattr.filter", function () {
	        eve.stop();
	        var p = $(this.node, "filter");
	        if (p) {
	            var match = Str(p).match(rgurl);
	            return match && Snap.select(match[1]);
	        }
	    });
	    eve.on("snap.util.attr.filter", function (value) {
	        if (value instanceof Element && value.type == "filter") {
	            eve.stop();
	            var id = value.node.id;
	            if (!id) {
	                $(value.node, {id: value.id});
	                id = value.id;
	            }
	            $(this.node, {
	                filter: Snap.url(id)
	            });
	        }
	        if (!value || value == "none") {
	            eve.stop();
	            this.node.removeAttribute("filter");
	        }
	    });
	    /*\
	     * Snap.filter.blur
	     [ method ]
	     **
	     * Returns an SVG markup string for the blur filter
	     **
	     - x (number) amount of horizontal blur, in pixels
	     - y (number) #optional amount of vertical blur, in pixels
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.blur(5, 10)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.blur = function (x, y) {
	        if (x == null) {
	            x = 2;
	        }
	        var def = y == null ? x : [x, y];
	        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
	            def: def
	        });
	    };
	    Snap.filter.blur.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.shadow
	     [ method ]
	     **
	     * Returns an SVG markup string for the shadow filter
	     **
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - blur (number) #optional amount of blur
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * which makes blur default to `4`. Or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - opacity (number) #optional `0..1` opacity of the shadow
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
	        if (opacity == null) {
	            if (color == null) {
	                opacity = blur;
	                blur = 4;
	                color = "#000";
	            } else {
	                opacity = color;
	                color = blur;
	                blur = 4;
	            }
	        }
	        if (blur == null) {
	            blur = 4;
	        }
	        if (opacity == null) {
	            opacity = 1;
	        }
	        if (dx == null) {
	            dx = 0;
	            dy = 2;
	        }
	        if (dy == null) {
	            dy = dx;
	        }
	        color = Snap.color(color);
	        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
	            color: color,
	            dx: dx,
	            dy: dy,
	            blur: blur,
	            opacity: opacity
	        });
	    };
	    Snap.filter.shadow.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.grayscale
	     [ method ]
	     **
	     * Returns an SVG markup string for the grayscale filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.grayscale = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
	            a: 0.2126 + 0.7874 * (1 - amount),
	            b: 0.7152 - 0.7152 * (1 - amount),
	            c: 0.0722 - 0.0722 * (1 - amount),
	            d: 0.2126 - 0.2126 * (1 - amount),
	            e: 0.7152 + 0.2848 * (1 - amount),
	            f: 0.0722 - 0.0722 * (1 - amount),
	            g: 0.2126 - 0.2126 * (1 - amount),
	            h: 0.0722 + 0.9278 * (1 - amount)
	        });
	    };
	    Snap.filter.grayscale.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.sepia
	     [ method ]
	     **
	     * Returns an SVG markup string for the sepia filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.sepia = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
	            a: 0.393 + 0.607 * (1 - amount),
	            b: 0.769 - 0.769 * (1 - amount),
	            c: 0.189 - 0.189 * (1 - amount),
	            d: 0.349 - 0.349 * (1 - amount),
	            e: 0.686 + 0.314 * (1 - amount),
	            f: 0.168 - 0.168 * (1 - amount),
	            g: 0.272 - 0.272 * (1 - amount),
	            h: 0.534 - 0.534 * (1 - amount),
	            i: 0.131 + 0.869 * (1 - amount)
	        });
	    };
	    Snap.filter.sepia.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.saturate
	     [ method ]
	     **
	     * Returns an SVG markup string for the saturate filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.saturate = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
	            amount: 1 - amount
	        });
	    };
	    Snap.filter.saturate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.hueRotate
	     [ method ]
	     **
	     * Returns an SVG markup string for the hue-rotate filter
	     **
	     - angle (number) angle of rotation
	     = (string) filter representation
	    \*/
	    Snap.filter.hueRotate = function (angle) {
	        angle = angle || 0;
	        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
	            angle: angle
	        });
	    };
	    Snap.filter.hueRotate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.invert
	     [ method ]
	     **
	     * Returns an SVG markup string for the invert filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.invert = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
	        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: 1 - amount
	        });
	    };
	    Snap.filter.invert.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.brightness
	     [ method ]
	     **
	     * Returns an SVG markup string for the brightness filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.brightness = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
	            amount: amount
	        });
	    };
	    Snap.filter.brightness.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.contrast
	     [ method ]
	     **
	     * Returns an SVG markup string for the contrast filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.contrast = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: .5 - amount / 2
	        });
	    };
	    Snap.filter.contrast.toString = function () {
	        return this();
	    };
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var box = Snap._.box,
	        is = Snap.is,
	        firstLetter = /^[^a-z]*([tbmlrc])/i,
	        toString = function () {
	            return "T" + this.dx + "," + this.dy;
	        };
	    /*\
	     * Element.getAlign
	     [ method ]
	     **
	     * Returns shift needed to align the element relatively to given element.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
	     > Usage
	     | el.transform(el.getAlign(el2, "top"));
	     * or
	     | var dy = el.getAlign(el2, "top").dy;
	    \*/
	    Element.prototype.getAlign = function (el, way) {
	        if (way == null && is(el, "string")) {
	            way = el;
	            el = null;
	        }
	        el = el || this.paper;
	        var bx = el.getBBox ? el.getBBox() : box(el),
	            bb = this.getBBox(),
	            out = {};
	        way = way && way.match(firstLetter);
	        way = way ? way[1].toLowerCase() : "c";
	        switch (way) {
	            case "t":
	                out.dx = 0;
	                out.dy = bx.y - bb.y;
	            break;
	            case "b":
	                out.dx = 0;
	                out.dy = bx.y2 - bb.y2;
	            break;
	            case "m":
	                out.dx = 0;
	                out.dy = bx.cy - bb.cy;
	            break;
	            case "l":
	                out.dx = bx.x - bb.x;
	                out.dy = 0;
	            break;
	            case "r":
	                out.dx = bx.x2 - bb.x2;
	                out.dy = 0;
	            break;
	            default:
	                out.dx = bx.cx - bb.cx;
	                out.dy = 0;
	            break;
	        }
	        out.toString = toString;
	        return out;
	    };
	    /*\
	     * Element.align
	     [ method ]
	     **
	     * Aligns the element relatively to given one via transformation.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object) this element
	     > Usage
	     | el.align(el2, "top");
	     * or
	     | el.align("middle");
	    \*/
	    Element.prototype.align = function (el, way) {
	        return this.transform("..." + this.getAlign(el, way));
	    };
	});
	
	// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        has = "hasOwnProperty";
	    function slice(from, to, f) {
	        return function (arr) {
	            var res = arr.slice(from, to);
	            if (res.length == 1) {
	                res = res[0];
	            }
	            return f ? f(res) : res;
	        };
	    }
	    var Animation = function (attr, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        this.attr = attr;
	        this.dur = ms;
	        easing && (this.easing = easing);
	        callback && (this.callback = callback);
	    };
	    Snap._.Animation = Animation;
	    /*\
	     * Snap.animation
	     [ method ]
	     **
	     * Creates an animation object
	     **
	     - attr (object) attributes of final destination
	     - duration (number) duration of the animation, in milliseconds
	     - easing (function) #optional one of easing functions of @mina or custom one
	     - callback (function) #optional callback function that fires when animation ends
	     = (object) animation object
	    \*/
	    Snap.animation = function (attr, ms, easing, callback) {
	        return new Animation(attr, ms, easing, callback);
	    };
	    /*\
	     * Element.inAnim
	     [ method ]
	     **
	     * Returns a set of animations that may be able to manipulate the current element
	     **
	     = (object) in format:
	     o {
	     o     anim (object) animation object,
	     o     mina (object) @mina object,
	     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	    \*/
	    elproto.inAnim = function () {
	        var el = this,
	            res = [];
	        for (var id in el.anims) if (el.anims[has](id)) {
	            (function (a) {
	                res.push({
	                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
	                    mina: a,
	                    curStatus: a.status(),
	                    status: function (val) {
	                        return a.status(val);
	                    },
	                    stop: function () {
	                        a.stop();
	                    }
	                });
	            }(el.anims[id]));
	        }
	        return res;
	    };
	    /*\
	     * Snap.animate
	     [ method ]
	     **
	     * Runs generic animation of one number into another with a caring function
	     **
	     - from (number|array) number or array of numbers
	     - to (number|array) number or array of numbers
	     - setter (function) caring function that accepts one number argument
	     - duration (number) duration, in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function to execute when animation ends
	     = (object) animation object in @mina format
	     o {
	     o     id (string) animation id, consider it read-only,
	     o     duration (function) gets or sets the duration of the animation,
	     o     easing (function) easing,
	     o     speed (function) gets or sets the speed of the animation,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	     | var rect = Snap().rect(0, 0, 10, 10);
	     | Snap.animate(0, 10, function (val) {
	     |     rect.attr({
	     |         x: val
	     |     });
	     | }, 1000);
	     | // in given context is equivalent to
	     | rect.animate({x: 10}, 1000);
	    \*/
	    Snap.animate = function (from, to, setter, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        var now = mina.time(),
	            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
	        callback && eve.once("mina.finish." + anim.id, callback);
	        return anim;
	    };
	    /*\
	     * Element.stop
	     [ method ]
	     **
	     * Stops all the animations for the current element
	     **
	     = (Element) the current element
	    \*/
	    elproto.stop = function () {
	        var anims = this.inAnim();
	        for (var i = 0, ii = anims.length; i < ii; i++) {
	            anims[i].stop();
	        }
	        return this;
	    };
	    /*\
	     * Element.animate
	     [ method ]
	     **
	     * Animates the given attributes of the element
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     = (Element) the current element
	    \*/
	    elproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = attrs.dur;
	            attrs = attrs.attr;
	        }
	        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
	            el = this;
	        for (var key in attrs) if (attrs[has](key)) {
	            if (el.equal) {
	                eq = el.equal(key, Str(attrs[key]));
	                from = eq.from;
	                to = eq.to;
	                f = eq.f;
	            } else {
	                from = +el.attr(key);
	                to = +attrs[key];
	            }
	            var len = is(from, "array") ? from.length : 1;
	            keys[key] = slice(fkeys.length, fkeys.length + len, f);
	            fkeys = fkeys.concat(from);
	            tkeys = tkeys.concat(to);
	        }
	        var now = mina.time(),
	            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
	                var attr = {};
	                for (var key in keys) if (keys[has](key)) {
	                    attr[key] = keys[key](val);
	                }
	                el.attr(attr);
	            }, easing);
	        el.anims[anim.id] = anim;
	        anim._attrs = attrs;
	        anim._callback = callback;
	        eve("snap.animcreated." + el.id, anim);
	        eve.once("mina.finish." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	            callback && callback.call(el);
	        });
	        eve.once("mina.stop." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	        });
	        return el;
	    };
	});
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    // Colours are from https://www.materialui.co
	    var red         = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
	        pink        = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
	        purple      = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
	        deeppurple  = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
	        indigo      = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
	        blue        = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
	        lightblue   = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
	        cyan        = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
	        teal        = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
	        green       = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
	        lightgreen  = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
	        lime        = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
	        yellow      = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
	        amber       = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
	        orange      = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
	        deeporange  = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
	        brown       = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
	        grey        = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
	        bluegrey    = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
	    /*\
	     * Snap.mui
	     [ property ]
	     **
	     * Contain Material UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.mui = {};
	    /*\
	     * Snap.flat
	     [ property ]
	     **
	     * Contain Flat UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.flat = {};
	    function saveColor(colors) {
	        colors = colors.split(/(?=#)/);
	        var color = new String(colors[5]);
	        color[50] = colors[0];
	        color[100] = colors[1];
	        color[200] = colors[2];
	        color[300] = colors[3];
	        color[400] = colors[4];
	        color[500] = colors[5];
	        color[600] = colors[6];
	        color[700] = colors[7];
	        color[800] = colors[8];
	        color[900] = colors[9];
	        if (colors[10]) {
	            color.A100 = colors[10];
	            color.A200 = colors[11];
	            color.A400 = colors[12];
	            color.A700 = colors[13];
	        }
	        return color;
	    }
	    Snap.mui.red = saveColor(red);
	    Snap.mui.pink = saveColor(pink);
	    Snap.mui.purple = saveColor(purple);
	    Snap.mui.deeppurple = saveColor(deeppurple);
	    Snap.mui.indigo = saveColor(indigo);
	    Snap.mui.blue = saveColor(blue);
	    Snap.mui.lightblue = saveColor(lightblue);
	    Snap.mui.cyan = saveColor(cyan);
	    Snap.mui.teal = saveColor(teal);
	    Snap.mui.green = saveColor(green);
	    Snap.mui.lightgreen = saveColor(lightgreen);
	    Snap.mui.lime = saveColor(lime);
	    Snap.mui.yellow = saveColor(yellow);
	    Snap.mui.amber = saveColor(amber);
	    Snap.mui.orange = saveColor(orange);
	    Snap.mui.deeporange = saveColor(deeporange);
	    Snap.mui.brown = saveColor(brown);
	    Snap.mui.grey = saveColor(grey);
	    Snap.mui.bluegrey = saveColor(bluegrey);
	    Snap.flat.turquoise = "#1abc9c";
	    Snap.flat.greensea = "#16a085";
	    Snap.flat.sunflower = "#f1c40f";
	    Snap.flat.orange = "#f39c12";
	    Snap.flat.emerland = "#2ecc71";
	    Snap.flat.nephritis = "#27ae60";
	    Snap.flat.carrot = "#e67e22";
	    Snap.flat.pumpkin = "#d35400";
	    Snap.flat.peterriver = "#3498db";
	    Snap.flat.belizehole = "#2980b9";
	    Snap.flat.alizarin = "#e74c3c";
	    Snap.flat.pomegranate = "#c0392b";
	    Snap.flat.amethyst = "#9b59b6";
	    Snap.flat.wisteria = "#8e44ad";
	    Snap.flat.clouds = "#ecf0f1";
	    Snap.flat.silver = "#bdc3c7";
	    Snap.flat.wetasphalt = "#34495e";
	    Snap.flat.midnightblue = "#2c3e50";
	    Snap.flat.concrete = "#95a5a6";
	    Snap.flat.asbestos = "#7f8c8d";
	    /*\
	     * Snap.importMUIColors
	     [ method ]
	     **
	     * Imports Material UI colours into global object.
	     | Snap.importMUIColors();
	     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.importMUIColors = function () {
	        for (var color in Snap.mui) {
	            if (Snap.mui.hasOwnProperty(color)) {
	                window[color] = Snap.mui[color];
	            }
	        }
	    };
	});
	
	module.exports = Snap


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var framesync = __webpack_require__(26);
	var styleValueTypes = __webpack_require__(22);
	var tslib_1 = __webpack_require__(13);
	var heyListen = __webpack_require__(5);
	
	var createStyler = function (_a) {
	    var onRead = _a.onRead, onRender = _a.onRender, _b = _a.aliasMap, aliasMap = _b === void 0 ? {} : _b, _c = _a.useCache, useCache = _c === void 0 ? true : _c;
	    return function (props) {
	        var state = {};
	        var changedValues = [];
	        var hasChanged = false;
	        var setValue = function (unmappedKey, value) {
	            var key = aliasMap[unmappedKey] || unmappedKey;
	            var currentValue = state[key];
	            state[key] = value;
	            if (state[key] !== currentValue) {
	                if (changedValues.indexOf(key) === -1) {
	                    changedValues.push(key);
	                }
	                if (!hasChanged) {
	                    hasChanged = true;
	                    framesync.onFrameRender(render);
	                }
	            }
	        };
	        function render(forceRender) {
	            if (forceRender === void 0) { forceRender = false; }
	            if (forceRender || hasChanged) {
	                onRender(state, props, changedValues);
	                hasChanged = false;
	                changedValues.length = 0;
	            }
	            return this;
	        }
	        return {
	            get: function (unmappedKey) {
	                var key = aliasMap[unmappedKey] || unmappedKey;
	                return (key)
	                    ? (useCache && state[key] !== undefined)
	                        ? state[key]
	                        : onRead(key, props)
	                    : state;
	            },
	            set: function (values, value) {
	                if (typeof values === 'string') {
	                    if (value !== undefined) {
	                        setValue(values, value);
	                    }
	                    else {
	                        return function (v) { return setValue(values, v); };
	                    }
	                }
	                else {
	                    for (var key in values) {
	                        if (values.hasOwnProperty(key)) {
	                            setValue(key, values[key]);
	                        }
	                    }
	                }
	                return this;
	            },
	            render: render,
	        };
	    };
	};
	
	var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
	var REPLACE_TEMPLATE = '$1-$2';
	var camelToDash = function (str) { return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase(); };
	var setDomAttrs = function (element, attrs) {
	    for (var key in attrs) {
	        if (attrs.hasOwnProperty(key)) {
	            element.setAttribute(key, attrs[key]);
	        }
	    }
	};
	
	var camelCache = new Map();
	var dashCache = new Map();
	var prefixes = ['Webkit', 'Moz', 'O', 'ms', ''];
	var numPrefixes = prefixes.length;
	var testElement;
	var testPrefix = function (key) {
	    if (typeof document === 'undefined')
	        return;
	    testElement = testElement || document.createElement('div');
	    for (var i = 0; i < numPrefixes; i++) {
	        var prefix = prefixes[i];
	        var noPrefix = (prefix === '');
	        var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);
	        if (prefixedPropertyName in testElement.style) {
	            camelCache.set(key, prefixedPropertyName);
	            dashCache.set(key, "" + (noPrefix ? '' : '-') + camelToDash(prefixedPropertyName));
	        }
	    }
	};
	var prefixer = (function (key, asDashCase) {
	    if (asDashCase === void 0) { asDashCase = false; }
	    var cache = asDashCase ? dashCache : camelCache;
	    if (!cache.has(key))
	        testPrefix(key);
	    return cache.get(key) || key;
	});
	
	var axes = ['', 'X', 'Y', 'Z'];
	var order = ['translate', 'scale', 'rotate', 'skew', 'transformPerspective'];
	var TRANSFORM_ORIGIN_X = 'transformOriginX';
	var TRANSFORM_ORIGIN_Y = 'transformOriginY';
	var transformProps = order.reduce(function (acc, key) {
	    return axes.reduce(function (axesAcc, axesKey) {
	        axesAcc.push(key + axesKey);
	        return axesAcc;
	    }, acc);
	}, ['x', 'y', 'z']);
	var transformPropDictionary = transformProps.reduce(function (dict, key) {
	    dict[key] = true;
	    return dict;
	}, {});
	var isTransformProp = function (key) { return transformPropDictionary[key] === true; };
	var sortTransformProps = function (a, b) { return transformProps.indexOf(a) - transformProps.indexOf(b); };
	var isTransformOriginProp = function (key) { return key === TRANSFORM_ORIGIN_X || key === TRANSFORM_ORIGIN_Y; };
	
	var valueTypes = {
	    color: styleValueTypes.color,
	    backgroundColor: styleValueTypes.color,
	    outlineColor: styleValueTypes.color,
	    fill: styleValueTypes.color,
	    stroke: styleValueTypes.color,
	    borderColor: styleValueTypes.color,
	    borderTopColor: styleValueTypes.color,
	    borderRightColor: styleValueTypes.color,
	    borderBottomColor: styleValueTypes.color,
	    borderLeftColor: styleValueTypes.color,
	    borderRadius: styleValueTypes.px,
	    width: styleValueTypes.px,
	    maxWidth: styleValueTypes.px,
	    height: styleValueTypes.px,
	    maxHeight: styleValueTypes.px,
	    top: styleValueTypes.px,
	    left: styleValueTypes.px,
	    bottom: styleValueTypes.px,
	    right: styleValueTypes.px,
	    rotate: styleValueTypes.degrees,
	    rotateX: styleValueTypes.degrees,
	    rotateY: styleValueTypes.degrees,
	    rotateZ: styleValueTypes.degrees,
	    scale: styleValueTypes.scale,
	    scaleX: styleValueTypes.scale,
	    scaleY: styleValueTypes.scale,
	    scaleZ: styleValueTypes.scale,
	    skewX: styleValueTypes.degrees,
	    skewY: styleValueTypes.degrees,
	    distance: styleValueTypes.px,
	    translateX: styleValueTypes.px,
	    translateY: styleValueTypes.px,
	    translateZ: styleValueTypes.px,
	    perspective: styleValueTypes.px,
	    opacity: styleValueTypes.alpha,
	    transformOriginX: styleValueTypes.percent,
	    transformOriginY: styleValueTypes.percent,
	    transformOriginZ: styleValueTypes.px
	};
	var getValueType = (function (key) { return valueTypes[key]; });
	
	var aliasMap = {
	    x: 'translateX',
	    y: 'translateY',
	    z: 'translateZ',
	    originX: 'transformOriginX',
	    originY: 'transformOriginY',
	    originZ: 'transformOriginZ'
	};
	var NUMBER = 'number';
	var OBJECT = 'object';
	var COLON = ':';
	var SEMI_COLON = ';';
	var TRANSFORM_ORIGIN = 'transform-origin';
	var TRANSFORM = 'transform';
	var TRANSLATE_Z = 'translateZ';
	var TRANSFORM_NONE = ';transform: none';
	var styleRule = function (key, value) {
	    return "" + SEMI_COLON + key + COLON + value;
	};
	function buildStylePropertyString(state, changedValues, enableHardwareAcceleration, blacklist) {
	    if (changedValues === void 0) { changedValues = true; }
	    if (enableHardwareAcceleration === void 0) { enableHardwareAcceleration = true; }
	    var valuesToChange = changedValues === true ? Object.keys(state) : changedValues;
	    var propertyString = '';
	    var transformString = '';
	    var hasTransformOrigin = false;
	    var transformIsDefault = true;
	    var hasTransform = false;
	    var transformHasZ = false;
	    var numChangedValues = valuesToChange.length;
	    for (var i = 0; i < numChangedValues; i++) {
	        var key = valuesToChange[i];
	        if (isTransformProp(key)) {
	            hasTransform = true;
	            for (var stateKey in state) {
	                if (isTransformProp(stateKey) &&
	                    valuesToChange.indexOf(stateKey) === -1) {
	                    valuesToChange.push(stateKey);
	                }
	            }
	            break;
	        }
	    }
	    valuesToChange.sort(sortTransformProps);
	    var totalNumChangedValues = valuesToChange.length;
	    for (var i = 0; i < totalNumChangedValues; i++) {
	        var key = valuesToChange[i];
	        if (blacklist.has(key))
	            continue;
	        var isTransformKey = isTransformProp(key);
	        var value = state[key];
	        var valueType = getValueType(key);
	        if (isTransformKey) {
	            if ((valueType.default && value !== valueType.default) ||
	                (!valueType.default && value !== 0)) {
	                transformIsDefault = false;
	            }
	        }
	        if (valueType &&
	            (typeof value === NUMBER || typeof value === OBJECT) &&
	            valueType.transform) {
	            value = valueType.transform(value);
	        }
	        if (isTransformKey) {
	            transformString += key + '(' + value + ') ';
	            transformHasZ = key === TRANSLATE_Z ? true : transformHasZ;
	        }
	        else if (isTransformOriginProp(key)) {
	            state[key] = value;
	            hasTransformOrigin = true;
	        }
	        else {
	            propertyString += styleRule(prefixer(key, true), value);
	        }
	    }
	    if (hasTransformOrigin) {
	        propertyString += styleRule(TRANSFORM_ORIGIN, (state.transformOriginX || 0) + " " + (state.transformOriginY ||
	            0) + " " + (state.transformOriginZ || 0));
	    }
	    if (hasTransform) {
	        if (!transformHasZ && enableHardwareAcceleration) {
	            transformString += TRANSLATE_Z + "(0)";
	        }
	        propertyString += styleRule(TRANSFORM, transformIsDefault ? TRANSFORM_NONE : transformString);
	    }
	    return propertyString;
	}
	
	var SCROLL_LEFT = 'scrollLeft';
	var SCROLL_TOP = 'scrollTop';
	var scrollValues = new Set([SCROLL_LEFT, SCROLL_TOP]);
	var cssStyler = createStyler({
	    onRead: function (key, _a) {
	        var element = _a.element, preparseOutput = _a.preparseOutput;
	        var valueType = getValueType(key);
	        if (isTransformProp(key)) {
	            return valueType ? valueType.default || 0 : 0;
	        }
	        else if (scrollValues.has(key)) {
	            return element[key];
	        }
	        else {
	            var domValue = window
	                .getComputedStyle(element, null)
	                .getPropertyValue(prefixer(key, true)) || 0;
	            return preparseOutput && valueType && valueType.parse
	                ? valueType.parse(domValue)
	                : domValue;
	        }
	    },
	    onRender: function (state, _a, changedValues) {
	        var element = _a.element, enableHardwareAcceleration = _a.enableHardwareAcceleration;
	        element.style.cssText += buildStylePropertyString(state, changedValues, enableHardwareAcceleration, scrollValues);
	        if (changedValues.indexOf(SCROLL_LEFT) !== -1)
	            element.scrollLeft = state.scrollLeft;
	        if (changedValues.indexOf(SCROLL_TOP) !== -1)
	            element.scrollTop = state.scrollTop;
	    },
	    aliasMap: aliasMap,
	    uncachedValues: scrollValues
	});
	var css = (function (element, props) {
	    return cssStyler(tslib_1.__assign({ element: element, enableHardwareAcceleration: true, preparseOutput: true }, props));
	});
	
	var ZERO_NOT_ZERO = 0.0000001;
	var percentToPixels = function (percent, length) {
	    return (percent / 100) * length + 'px';
	};
	var build = function (state, dimensions, isPath, pathLength) {
	    var hasTransform = false;
	    var hasDashArray = false;
	    var props = {};
	    var dashArrayStyles = isPath ? {
	        pathLength: '0',
	        pathSpacing: "" + pathLength
	    } : undefined;
	    var scale = state.scale !== undefined ? state.scale || ZERO_NOT_ZERO : state.scaleX || 1;
	    var scaleY = state.scaleY !== undefined ? state.scaleY || ZERO_NOT_ZERO : scale || 1;
	    var transformOriginX = dimensions.width * ((state.originX || 50) / 100) + dimensions.x;
	    var transformOriginY = dimensions.height * ((state.originY || 50) / 100) + dimensions.y;
	    var scaleTransformX = -transformOriginX * (scale * 1);
	    var scaleTransformY = -transformOriginY * (scaleY * 1);
	    var scaleReplaceX = transformOriginX / scale;
	    var scaleReplaceY = transformOriginY / scaleY;
	    var transform = {
	        translate: "translate(" + state.translateX + ", " + state.translateY + ") ",
	        scale: "translate(" + scaleTransformX + ", " + scaleTransformY + ") scale(" + scale + ", " + scaleY + ") translate(" + scaleReplaceX + ", " + scaleReplaceY + ") ",
	        rotate: "rotate(" + state.rotate + ", " + transformOriginX + ", " + transformOriginY + ") ",
	        skewX: "skewX(" + state.skewX + ") ",
	        skewY: "skewY(" + state.skewY + ") "
	    };
	    for (var key in state) {
	        if (state.hasOwnProperty(key)) {
	            var value = state[key];
	            if (isTransformProp(key)) {
	                hasTransform = true;
	            }
	            else if (isPath && (key === 'pathLength' || key === 'pathSpacing') && typeof value === 'number') {
	                hasDashArray = true;
	                dashArrayStyles[key] = percentToPixels(value, pathLength);
	            }
	            else if (isPath && key === 'pathOffset') {
	                props['stroke-dashoffset'] = percentToPixels(-value, pathLength);
	            }
	            else {
	                props[camelToDash(key)] = value;
	            }
	        }
	    }
	    if (hasDashArray) {
	        props['stroke-dasharray'] = dashArrayStyles.pathLength + ' ' + dashArrayStyles.pathSpacing;
	    }
	    if (hasTransform) {
	        props.transform = '';
	        for (var key in transform) {
	            if (transform.hasOwnProperty(key)) {
	                var defaultValue = (key === 'scale') ? '1' : '0';
	                props.transform += transform[key].replace(/undefined/g, defaultValue);
	            }
	        }
	    }
	    return props;
	};
	
	var valueTypes$1 = {
	    fill: styleValueTypes.color,
	    stroke: styleValueTypes.color,
	    scale: styleValueTypes.scale,
	    scaleX: styleValueTypes.scale,
	    scaleY: styleValueTypes.scale,
	    opacity: styleValueTypes.alpha,
	    fillOpacity: styleValueTypes.alpha,
	    strokeOpacity: styleValueTypes.alpha
	};
	var getValueType$1 = (function (key) { return valueTypes$1[key]; });
	
	var svgStyler = createStyler({
	    onRead: function (key, _a) {
	        var element = _a.element;
	        if (!isTransformProp(key)) {
	            return element.getAttribute(key);
	        }
	        else {
	            var valueType = getValueType$1(key);
	            return valueType ? valueType.default : 0;
	        }
	    },
	    onRender: function (state, _a, changedValues) {
	        var dimensions = _a.dimensions, element = _a.element, isPath = _a.isPath, pathLength = _a.pathLength;
	        setDomAttrs(element, build(state, dimensions, isPath, pathLength));
	    },
	    aliasMap: {
	        x: 'translateX',
	        y: 'translateY',
	        background: 'fill'
	    }
	});
	var svg = (function (element) {
	    var _a = element.getBBox(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	    var props = {
	        element: element,
	        dimensions: { x: x, y: y, width: width, height: height },
	        isPath: false
	    };
	    if (element.tagName === 'path') {
	        props.isPath = true;
	        props.pathLength = element.getTotalLength();
	    }
	    return svgStyler(props);
	});
	
	var viewport = createStyler({
	    useCache: false,
	    onRead: function (key) {
	        return key === 'scrollTop' ? window.pageYOffset : window.pageXOffset;
	    },
	    onRender: function (_a) {
	        var _b = _a.scrollTop, scrollTop = _b === void 0 ? 0 : _b, _c = _a.scrollLeft, scrollLeft = _c === void 0 ? 0 : _c;
	        return window.scrollTo(scrollLeft, scrollTop);
	    }
	});
	
	var cache = new WeakMap();
	var createDOMStyler = function (node, props) {
	    var styler;
	    if (node instanceof HTMLElement) {
	        styler = css(node, props);
	    }
	    else if (node instanceof SVGElement) {
	        styler = svg(node);
	    }
	    else if (typeof window !== 'undefined' && node === window) {
	        styler = viewport(node);
	    }
	    heyListen.invariant(styler !== undefined, 'No valid node provided. Node must be HTMLElement, SVGElement or window.');
	    cache.set(node, styler);
	    return styler;
	};
	var getStyler = function (node, props) {
	    return cache.has(node) ? cache.get(node) : createDOMStyler(node, props);
	};
	function index (nodeOrSelector, props) {
	    var node = typeof nodeOrSelector === 'string'
	        ? document.querySelector(nodeOrSelector)
	        : nodeOrSelector;
	    return getStyler(node, props);
	}
	
	exports.default = index;
	exports.createStylerFactory = createStyler;
	exports.buildStyles = buildStylePropertyString;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(179);
	
	var _HOMEPAGEWANCLOUDSCONCTACTUSTELEPHONE = __webpack_require__(208);
	
	var _HOMEPAGEWANCLOUDSCONCTACTUSTELEPHONE2 = _interopRequireDefault(_HOMEPAGEWANCLOUDSCONCTACTUSTELEPHONE);
	
	var _HOMEPAGEWANCLOUDSCONTACTUSEMAILICON = __webpack_require__(209);
	
	var _HOMEPAGEWANCLOUDSCONTACTUSEMAILICON2 = _interopRequireDefault(_HOMEPAGEWANCLOUDSCONTACTUSEMAILICON);
	
	var _BLOGPRINCIPAL_CONTACTCEL = __webpack_require__(192);
	
	var _BLOGPRINCIPAL_CONTACTCEL2 = _interopRequireDefault(_BLOGPRINCIPAL_CONTACTCEL);
	
	var _BLOGPRINCIPAL_CONTACTEMAIL = __webpack_require__(193);
	
	var _BLOGPRINCIPAL_CONTACTEMAIL2 = _interopRequireDefault(_BLOGPRINCIPAL_CONTACTEMAIL);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var encode = function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	  }).join("&");
	};
	
	var ContactUs = function (_React$Component) {
	  _inherits(ContactUs, _React$Component);
	
	  function ContactUs(props) {
	    _classCallCheck(this, ContactUs);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.emailSuccess = function () {
	      _this.setState(_extends({}, _this.state, { emailSuccess: true }));
	      console.log(_this.state);
	    };
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      return _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.sendEmail = function (e) {
	      e.preventDefault();
	      _this.setState(_extends({}, _this.state, { formSent: true }));
	
	      fetch("/", {
	        method: "POST",
	        headers: { "Content-Type": "application/x-www-form-urlencoded" },
	        body: encode(_extends({ "form-name": "contact" }, _this.state))
	      }).then(function () {
	        return _this.emailSuccess();
	      }).catch(function (error) {
	        return alert("ERROOOOOOOR");
	      });
	
	      // setTimeout(this.emailSuccess, 2000)
	      // clearInterval(wait);
	    };
	
	    _this.state = {
	      formSent: false,
	      emailSuccess: false,
	      error: false,
	      name: "",
	      email: "",
	      comment: ""
	    };
	    return _this;
	  }
	
	  ContactUs.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'section-contact', id: 'contact' },
	      _react2.default.createElement(
	        'div',
	        { className: this.props.state === "blog" ? "left-blog" : "left" },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Contact Us'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We engineer and execute cloud-based solutions for our clients. Contact our team to learn how we can start your business transformation today.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'info-line' },
	            _react2.default.createElement('img', { src: this.props.state === "blog" ? _BLOGPRINCIPAL_CONTACTCEL2.default : _HOMEPAGEWANCLOUDSCONCTACTUSTELEPHONE2.default, alt: 'phone' }),
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:305-351-3070' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                '(305)351-3070'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'info-line' },
	            _react2.default.createElement('img', { src: this.props.state === "blog" ? _BLOGPRINCIPAL_CONTACTEMAIL2.default : _HOMEPAGEWANCLOUDSCONTACTUSEMAILICON2.default, alt: 'email' }),
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:admin@wan-clouds.com' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'admin@wan-clouds.com'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'click', style: this.props.state === "blog" ? { backgroundColor: "#d9dcdd" } : { backgroundColor: "#f1efef" } },
	        this.state.error ? _react2.default.createElement(
	          'div',
	          { className: 'thank-you' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'There was an error sending the Email, please try again.'
	          )
	        ) : null,
	        this.state.formSent && this.state.emailSuccess ? _react2.default.createElement(
	          'div',
	          { className: 'thank-you' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Thank you for your message!'
	          ),
	          ' ',
	          _react2.default.createElement('br', null),
	          ' ',
	          _react2.default.createElement(
	            'h4',
	            null,
	            'We will reply to your email shortly.'
	          )
	        ) : this.state.formSent && !this.state.emailSuccess ? _react2.default.createElement(
	          'div',
	          { className: 'thank-you' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Sending message...'
	          )
	        ) : _react2.default.createElement(
	          'form',
	          { onSubmit: this.sendEmail },
	          _react2.default.createElement(
	            'label',
	            null,
	            'Full Name:',
	            _react2.default.createElement('input', { type: 'text', name: 'name', value: this.state.name, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'label',
	            null,
	            'Email:',
	            _react2.default.createElement('input', { type: 'text', name: 'email', value: this.state.email, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'label',
	            null,
	            'Message',
	            _react2.default.createElement('textarea', { name: 'comment', cols: '10', rows: '3', value: this.state.comment, onChange: this.handleChange })
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit' },
	            'SEND'
	          )
	        )
	      )
	    );
	  };
	
	  return ContactUs;
	}(_react2.default.Component);
	
	exports.default = ContactUs;
	module.exports = exports['default'];

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAsCAYAAACQXhN9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozMWZlNjMwZi04ZWQ3LWNjNDAtYjQ5Yi0zZjJhNDI0ZTExNWIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTZBOUU5OUU2NTNFMTFFODhBRkJDQ0NDOEY1QjI5N0QiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTZBOUU5OUQ2NTNFMTFFODhBRkJDQ0NDOEY1QjI5N0QiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzFmZTYzMGYtOGVkNy1jYzQwLWI0OWItM2YyYTQyNGUxMTViIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjMxZmU2MzBmLThlZDctY2M0MC1iNDliLTNmMmE0MjRlMTE1YiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpxM+aEAAAJOSURBVHja7JdNSFRRFMffmx7TpGY4JgkS5BclRNLGwK1CItjGVkGuRN20cCe1C1q4aSGiNO1ai7sMAo0UI5A+sAiJIcyPjWBl44AzMvP6H/g/eDze17y502oO/Lxvrve9//0695yrax0jGmwGjIJzmlrLyLcN/HlOAbG/Ho1NoNuenaZ7vFcPHhkUyIN2sKd4JDfBksEfvwMEJsFPsAgegvO2EUm5DFZc3vsE9i2RMz4CMhVP2YmP4IlLm1seIo0gboQYsvS0BuRAESRsI9FZHvp0UHMTkbVpcNTtsFeXwC44dfy/E1ywdeqA7YpuIi0grWDBZSMlwR83kYss18FrECvx49LzYXAD1IGsm0ie5QuQijiKOEUKVoVXT5vLmKpGZ0VM+w9WFamKhLbL4Ad4UykROaO+glbwvRIiIvCZ0W4WjPNEHuOZV7ZIJwOQHPnT4AHr34NnoK9ckevgC6ilwBQTjm+gm1Fx0e8DYYLWEDgL5imgMa50gQ+gP+gDYUTmwFvwzla3zSlMq1r4I4eAZemqx1dFIonkykyHfEV0W8YR1eLOTD/m4ZyPmUOZJSLvTAR5/DaTujYmZ6bPdMQ9cl9x3i3eFBJuInIJuq1wzZNRdtcAY8oG6A3RvhD2gLSsB7yy/ZZ8+WqYCFnKSO6ylCvCNT4PqnbGlywlxq/xeaUUkUKIthJTRrhjZIfdAZsB7/wSx9Zxj5dtegKawLHiE0VcYVUWfoHznaGfBN0fs/SHGp/7u2VXrN11n8O/Z1UqNFmGlG6aZsVP4X8CDADWJoAvq6GRMgAAAABJRU5ErkJggg=="

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAoCAYAAACB4MgqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozMWZlNjMwZi04ZWQ3LWNjNDAtYjQ5Yi0zZjJhNDI0ZTExNWIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTZBOUU5QTI2NTNFMTFFODhBRkJDQ0NDOEY1QjI5N0QiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTZBOUU5QTE2NTNFMTFFODhBRkJDQ0NDOEY1QjI5N0QiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzFmZTYzMGYtOGVkNy1jYzQwLWI0OWItM2YyYTQyNGUxMTViIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjMxZmU2MzBmLThlZDctY2M0MC1iNDliLTNmMmE0MjRlMTE1YiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PulYGG4AAAT4SURBVHjazFlpbFVFFL6v0gZQfhCfDQGNWEWwAVEjUZ6GoERNXJFUK4tiqmwmAmqJWsAFWYxxAVQk0AhYqZrQliVgoqgxihWUtECUpYpGQ4gRqzb0VRD6/E74JjkM917u1uJJvtw7y33zzZkz55yZl8rlco6XpPqNdyLKQ8ASoIDlx4CFYX8k17TKsy3PSVYKgVqgkqSPsP414CPgwqQGSpL4SGAfcDfLjwNdgQc5gZvYPjaJwboE7NcLSPtM/mHgUZb/AV4E3uYK1AHnAc8C5wDvAsOBN4FjHr/5N/CrH6FUABu/AtgG5IdQyL9W/2MhlGTkRtj4Z3FMZZAiIbNs51OjDcgSbSSp28/iSmQV3H6nXY17VVxTOcznfuBKsxhO8mLIfwIMAVqSsHGz/C1Ox8uRpLzKbxEmmYTDOBSX+M18Hu8k4sZbDI3kVeBReuLxFlDKqt1AsdXtLg6QUgMGEdN/B/C+9e0WIMP3D4DJ8C5/BSIO0iV4LAXOVdV7gMtUWTzN0QQ0LGM0exA3JjMJ5Gt9NydIr2C0c6iRjUAFXZpj+eYy4DpriYNqXNDAYGO3OVzta+nJasBrOchPPEXjaBC/WaXMoQYQzV8M/AD8CFzSCTZeT8IZEK0Hr1qVRuwExqO+UW/OzxXp59BYwvdrImg0CRnCDHEUHvNYdzn9/Elepbt6L8VMjbk0OWdGmmgJZVx5I91sG28FelCzsgnF1ouAb31c6SvADTHIbQce8Qg6vUH6eTyfYfkoU+WsTdxsvlvo4uSj2ao960J8ekytDgbKLeKtfFaqOsksP2SyV2ATNzb8O+xqDma7C+/LVDrbk5M7rrxKsbHFiCJj/Gl5lN6WK5wAPmvBp0h7Hbcwfj7QiM516Cwb4R0Gmgt4EBgDbFVBaXeCm3E10I/l9cD94NGieLmG/JxLaG/hyWYqyzLrr4EFCW/EOTQDQ3qaKEuRPiXlyPMIDra8DlxKlynyFIPH1adJlkb7nJyMe9um9pJEzQHAYp8cJuWlcT/3JEeuGSzLyegbYKZLX5nkd0A1U4WMS58nGJnNHnkSuB7Y21GH5Zd5OmlgeS7TgrQ6NO8ieZOLbOG51MSLGv6OwwlKpHwpRLoQ2FRsaSD5+SzfSrJVPBwXkJCE6s3ss5zZnvQbxTqJAwPVZo90PRElpIuZ9GWQkpuAcaxfTR+9ltcSxmbv5Qbfy41YHiFPT+xepdXKHGdzAtoLiJeYZKXEUcf23JxhDsKTJWAx9ZT09DbavJssoy3/orQ+60zcZK1gzizyBfObTaf5Ziv71bH8ArCBOVJQU0lFtfEB3GAme3wDGAYcDPh9lpvTJE+3M/oOjatxP1O5j95iIMtT1NVbWBFt38MEqw/wVZjfCqNxuXF9j9/sZ9RcGnNjr6HpbGd5Me8W88KYipekqQ2TwlZZg8WVn6iERSzLbe73KoAF1ri+rMzQNIz9PQ08kNDp3hZRzAS+95d9hOz0TsuF+mr8Zx6ZpjNUFzIvHuGcuD7uSKlkDtTE6LsOPOapFNpX44XoPJ82LfIxNfBpJ501d9BzVbNcAT4rWZdzI24i3SaahOTCE3kF19zJB+V22noJV1su6r/Ul6JdvGwI8odz4h+EBeZkrdpSPi40zrsuy+3wASotrdrybeJnWz9wEfCq8/+TrjZxOVfe4eLTcz6+PhfyXZejfivphfOfAAMAjVZdDLCCPBUAAAAASUVORK5CYII="

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3YzIwMzMxZS1mZmE1LWE5NDYtOTQyZS1lZWNkOTU3YTYyMzYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTYyODQzNjU0MUYwMTFFOEExREU4Njg3RDQzNzBFMUEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTYyODQzNjQ0MUYwMTFFOEExREU4Njg3RDQzNzBFMUEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZDU2NjMxOWMtOGI5Yi00MjRmLWJmMmEtYTdjZjQ4M2NhMjQzIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NGUwYjA0MWQtM2M1Yi0xMWU4LWIwMTAtZmQ1NTIzZDQ0Y2UyIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+2VsQhwAAAa1JREFUeNqc1E0rRFEYB/BzXyYsWHhL3iNWFhZYWFpMKSULio2ylE9gZ2EnCxY+gJ2dJCVRdjaiJEqSDGZG0YzBTGau/5P/zek07lxO/eree+5zz3Puec6xPM9bVErNQU59Nw9ewYYU78uhmv0OXFoIlI4pOGWHC82Qh1aw4AXOtMAVeekeNuFN/bQGeIIJjnwE51r/ocsvV0ETDEAZRDjasZb+DNzCnnzM5XxkDhtQwXnlONKHlr680w/DcCUPClAPWRiBmPq97UAPJG1O/pNfr1TBTVJ+l2xso8MtEWgxWNnqn61U4Dx0hwnUU90GqaokCyJwTmk+k6Ao1MAWPMA4V6BoYIK/u4+F0AWNMGlmaAZKtVxwJGnX0BFmjo5WLYprFuqvFv66HDYXNlHi/Sw3gPJr1d97o7JJAwJ74UA2gcu/F4d9ngR+ujfco518R8rtGXZhSOEAiEGLHAQgJ4LD6yjM8trRnotlP9WIVv2SdhusQi3UwYKRct5fx7jRkeKPkv7HInNN+4fVGJxoHRkYhHZY59Gir/WaBC7hYtpYeMWTIMPKcY3Auy8BBgAx2pHRKtkESAAAAABJRU5ErkJggg=="

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPose = __webpack_require__(32);
	
	var _reactPose2 = _interopRequireDefault(_reactPose);
	
	__webpack_require__(375);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Box = _reactPose2.default.div({
	  idle: {
	    scale: 1
	  },
	  hovered: {
	    scale: 1.3
	  }
	});
	
	var Expertise = function (_React$Component) {
	  _inherits(Expertise, _React$Component);
	
	  function Expertise() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Expertise);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.hoverIn = function () {
	      _this.setState({ hovered: true });
	    }, _this.hoverOut = function () {
	      _this.setState({ hovered: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Expertise.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        Box,
	        { pose: this.state.hovered ? "hovered" : "idle",
	          id: 'box-desktop',
	          className: this.props.style, onMouseEnter: function onMouseEnter() {
	            return _this2.hoverIn();
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this2.hoverOut();
	          } },
	        this.props.children
	      ),
	      _react2.default.createElement(
	        Box,
	        { pose: this.state.hovered ? "hovered" : "idle",
	          id: 'box-mobile',
	          className: this.props.style, onMouseEnter: function onMouseEnter() {
	            return _this2.hoverIn();
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this2.hoverOut();
	          } },
	        this.props.children
	      )
	    );
	  };
	
	  return Expertise;
	}(_react2.default.Component);
	
	exports.default = Expertise;
	module.exports = exports['default'];

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(370);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutUs = function AboutUs(_ref) {
	  var siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'div',
	    { className: 'section-about', id: 'about-us' },
	    _react2.default.createElement(
	      'div',
	      { className: 'left' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'About Us'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our team has over 100 years of combined experience in product and business development, working with Fortune 500 and other high technology companies including Alcatel-Lucent, Motorola, MCI, AT&T, Comcast, VCE, Federal Express, and SOPRIS Technologies. We optimize business capabilities and add long term value to corporations through technology driven solutions; increasing efficiency, reducing costs and growing revenue.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The WanClouds Miami family excels in human relations and capital development. By building our team with the right candidates, creating leaders and fostering growth within the company we ensure only the highest standards are met. Determination, curiosity, motivation, excellence, and attention to detail are a must within our team members. Passion is in our every movement.'
	      )
	    )
	  );
	};
	
	exports.default = AboutUs;
	module.exports = exports['default'];

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(374);
	
	var _expertise = __webpack_require__(212);
	
	var _expertise2 = _interopRequireDefault(_expertise);
	
	var _HOME_ESQUEMACUSTOMSOLUTIONSWANCLOUDS = __webpack_require__(499);
	
	var _HOME_ESQUEMACUSTOMSOLUTIONSWANCLOUDS2 = _interopRequireDefault(_HOME_ESQUEMACUSTOMSOLUTIONSWANCLOUDS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomSolutions = function (_React$Component) {
	  _inherits(CustomSolutions, _React$Component);
	
	  function CustomSolutions() {
	    _classCallCheck(this, CustomSolutions);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CustomSolutions.prototype.render = function render() {
	    return _react2.default.createElement(
	      'a',
	      { id: 'custom' },
	      _react2.default.createElement(
	        'div',
	        { className: 'custom-container', id: 'custom' },
	        _react2.default.createElement(
	          'div',
	          { className: 'custom-name' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Custom'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Solutions'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'custom-solutions' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Made to Order'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'description-short' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The WanClouds Miami product development team has the capability to design and execute bespoke solutions for busines process optimizations. We cover every estep of the product design cycle from concept, to desing, manufacturing, logistics and application.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'drawing' },
	            _react2.default.createElement(
	              'h6',
	              { className: 'label concept' },
	              'Concept'
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'label design' },
	              'Design'
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'label manufacture' },
	              'Manufacture'
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'label logistics' },
	              'Logistics'
	            ),
	            _react2.default.createElement(
	              'h6',
	              { className: 'label application' },
	              'Application'
	            ),
	            _react2.default.createElement('img', { src: _HOME_ESQUEMACUSTOMSOLUTIONSWANCLOUDS2.default, alt: 'drawing' })
	          ),
	          _react2.default.createElement(
	            'h5',
	            null,
	            'Our areas of expertise include but are not limited to:'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'expertise-squres' },
	            _react2.default.createElement(
	              _expertise2.default,
	              { style: 'expertise' },
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Service Assurance'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Solutions i.e. Data Centers'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Enterprise Application'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Software'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _expertise2.default,
	              { style: 'expertise' },
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Solutions for End-User'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Experiences i.e. Video'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Consumers, Enterprise'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Software Users'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _expertise2.default,
	              { style: 'expertise' },
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'SDN, NFV & Cloud'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Solutions - Wired and'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Wireless Network Migration'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'to Virtualized Solutions'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _expertise2.default,
	              { style: 'expertise' },
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Massive Data'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Analytics'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _expertise2.default,
	              { style: 'expertise' },
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Professional'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Network Security'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return CustomSolutions;
	}(_react2.default.Component);
	
	exports.default = CustomSolutions;
	module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactAnchorLinkSmoothScroll = __webpack_require__(112);
	
	var _reactAnchorLinkSmoothScroll2 = _interopRequireDefault(_reactAnchorLinkSmoothScroll);
	
	var _reactBurgerMenu = __webpack_require__(114);
	
	__webpack_require__(376);
	
	var _navIcon = __webpack_require__(270);
	
	var _navIcon2 = _interopRequireDefault(_navIcon);
	
	var _LOGOLANDINGPAGEWANCLOUDS = __webpack_require__(516);
	
	var _LOGOLANDINGPAGEWANCLOUDS2 = _interopRequireDefault(_LOGOLANDINGPAGEWANCLOUDS);
	
	var _HOME_MENUICON01WANCLOUDS = __webpack_require__(501);
	
	var _HOME_MENUICON01WANCLOUDS2 = _interopRequireDefault(_HOME_MENUICON01WANCLOUDS);
	
	var _HOME_MENUICONAboutWANCLOUDS = __webpack_require__(511);
	
	var _HOME_MENUICONAboutWANCLOUDS2 = _interopRequireDefault(_HOME_MENUICONAboutWANCLOUDS);
	
	var _HOME_MENUICON04WANCLOUDS = __webpack_require__(507);
	
	var _HOME_MENUICON04WANCLOUDS2 = _interopRequireDefault(_HOME_MENUICON04WANCLOUDS);
	
	var _HOME_MENUICON02WANCLOUDS = __webpack_require__(503);
	
	var _HOME_MENUICON02WANCLOUDS2 = _interopRequireDefault(_HOME_MENUICON02WANCLOUDS);
	
	var _HOME_MENUICON05WANCLOUDS = __webpack_require__(509);
	
	var _HOME_MENUICON05WANCLOUDS2 = _interopRequireDefault(_HOME_MENUICON05WANCLOUDS);
	
	var _HOME_MENUICON03WANCLOUDS = __webpack_require__(505);
	
	var _HOME_MENUICON03WANCLOUDS2 = _interopRequireDefault(_HOME_MENUICON03WANCLOUDS);
	
	var _HOME_MENUICON01WANCLOUDSHOVER = __webpack_require__(500);
	
	var _HOME_MENUICON01WANCLOUDSHOVER2 = _interopRequireDefault(_HOME_MENUICON01WANCLOUDSHOVER);
	
	var _HOME_MENUICONAboutWANCLOUDSHover = __webpack_require__(510);
	
	var _HOME_MENUICONAboutWANCLOUDSHover2 = _interopRequireDefault(_HOME_MENUICONAboutWANCLOUDSHover);
	
	var _HOME_MENUICON04WANCLOUDSHOVER = __webpack_require__(506);
	
	var _HOME_MENUICON04WANCLOUDSHOVER2 = _interopRequireDefault(_HOME_MENUICON04WANCLOUDSHOVER);
	
	var _HOME_MENUICON02WANCLOUDSHOVER = __webpack_require__(502);
	
	var _HOME_MENUICON02WANCLOUDSHOVER2 = _interopRequireDefault(_HOME_MENUICON02WANCLOUDSHOVER);
	
	var _HOME_MENUICON05WANCLOUDSHOVER = __webpack_require__(508);
	
	var _HOME_MENUICON05WANCLOUDSHOVER2 = _interopRequireDefault(_HOME_MENUICON05WANCLOUDSHOVER);
	
	var _HOME_MENUICON03WANCLOUDSHOVER = __webpack_require__(504);
	
	var _HOME_MENUICON03WANCLOUDSHOVER2 = _interopRequireDefault(_HOME_MENUICON03WANCLOUDSHOVER);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.addNavigationReference = function (e, data) {
	      e.preventDefault();
	      console.log("In here!");
	      // console.log("Event: " + e.target + " Data: " + data)
	    };
	
	    _this.state = {
	      menuOpen: false
	
	    };
	    return _this;
	  }
	
	  Header.prototype.showSettings = function showSettings(event) {
	    event.preventDefault();
	  };
	
	  Header.prototype.handleStateChange = function handleStateChange(state) {
	    this.setState({ menuOpen: state.isOpen });
	  };
	
	  Header.prototype.closeMenu = function closeMenu() {
	    this.setState({ menuOpen: false });
	  };
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'header', id: 'home' },
	      _react2.default.createElement(
	        'div',
	        { className: 'logo' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          _react2.default.createElement('img', { src: _LOGOLANDINGPAGEWANCLOUDS2.default, alt: 'logo', className: 'logo-image' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'nav' },
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#home' },
	          _react2.default.createElement(_navIcon2.default, { name: 'Home', image: _HOME_MENUICON01WANCLOUDS2.default, hoverImage: _HOME_MENUICON01WANCLOUDSHOVER2.default })
	        ),
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#about-us' },
	          _react2.default.createElement(_navIcon2.default, { name: 'About', image: _HOME_MENUICONAboutWANCLOUDS2.default, hoverImage: _HOME_MENUICONAboutWANCLOUDSHover2.default })
	        ),
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#business' },
	          _react2.default.createElement(_navIcon2.default, { name: 'Professional Services', image: _HOME_MENUICON02WANCLOUDS2.default, hoverImage: _HOME_MENUICON02WANCLOUDSHOVER2.default })
	        ),
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#custom' },
	          _react2.default.createElement(_navIcon2.default, { name: 'Custom Solutions', image: _HOME_MENUICON03WANCLOUDS2.default, hoverImage: _HOME_MENUICON03WANCLOUDSHOVER2.default })
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/' },
	          _react2.default.createElement(_navIcon2.default, { name: 'News', image: _HOME_MENUICON04WANCLOUDS2.default, hoverImage: _HOME_MENUICON04WANCLOUDSHOVER2.default })
	        ),
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#contact' },
	          _react2.default.createElement(_navIcon2.default, { name: 'Contact', image: _HOME_MENUICON05WANCLOUDS2.default, hoverImage: _HOME_MENUICON05WANCLOUDSHOVER2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'nav-tablet' },
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#home' },
	          _react2.default.createElement(_navIcon2.default, { name: 'Home', image: _HOME_MENUICON01WANCLOUDS2.default, hoverImage: _HOME_MENUICON01WANCLOUDSHOVER2.default })
	        ),
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#about-us' },
	          _react2.default.createElement(_navIcon2.default, { name: 'About', image: _HOME_MENUICONAboutWANCLOUDS2.default, hoverImage: _HOME_MENUICONAboutWANCLOUDSHover2.default })
	        ),
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#business' },
	          _react2.default.createElement(_navIcon2.default, { name: 'Professional Services', image: _HOME_MENUICON02WANCLOUDS2.default, hoverImage: _HOME_MENUICON02WANCLOUDSHOVER2.default })
	        ),
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#custom' },
	          _react2.default.createElement(_navIcon2.default, { name: 'Custom Solutions', image: _HOME_MENUICON03WANCLOUDS2.default, hoverImage: _HOME_MENUICON03WANCLOUDSHOVER2.default })
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/' },
	          _react2.default.createElement(_navIcon2.default, { name: 'News', image: _HOME_MENUICON04WANCLOUDS2.default, hoverImage: _HOME_MENUICON04WANCLOUDSHOVER2.default })
	        ),
	        _react2.default.createElement(
	          _reactAnchorLinkSmoothScroll2.default,
	          { href: '#contact' },
	          _react2.default.createElement(_navIcon2.default, { name: 'Contact', image: _HOME_MENUICON05WANCLOUDS2.default, hoverImage: _HOME_MENUICON05WANCLOUDSHOVER2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'nav-mobile' },
	        _react2.default.createElement(
	          _reactBurgerMenu.slide,
	          { right: true, width: '100%', isOpen: this.state.menuOpen, onStateChange: function onStateChange(state) {
	              return _this2.handleStateChange(state);
	            } },
	          _react2.default.createElement(
	            _reactAnchorLinkSmoothScroll2.default,
	            { href: '#home', onClick: function onClick() {
	                return _this2.closeMenu();
	              } },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'HOME'
	            )
	          ),
	          _react2.default.createElement(
	            _reactAnchorLinkSmoothScroll2.default,
	            { href: '#about-us', onClick: function onClick() {
	                return _this2.closeMenu();
	              } },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'ABOUT'
	            )
	          ),
	          _react2.default.createElement(
	            _reactAnchorLinkSmoothScroll2.default,
	            { href: '#business', onClick: function onClick() {
	                return _this2.closeMenu();
	              } },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'PROFESSIONAL SERVICES'
	            )
	          ),
	          _react2.default.createElement(
	            _reactAnchorLinkSmoothScroll2.default,
	            { href: '#custom', onClick: function onClick() {
	                return _this2.closeMenu();
	              } },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'CUSTOM SOLUTIONS'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/blog/' },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'NEWS'
	            )
	          ),
	          _react2.default.createElement(
	            _reactAnchorLinkSmoothScroll2.default,
	            { href: '#contact', onClick: function onClick() {
	                return _this2.closeMenu();
	              } },
	            _react2.default.createElement(
	              'h4',
	              null,
	              'CONTACT'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(377);
	
	var _HOME_NUBESLOGANWANCLOUDS = __webpack_require__(512);
	
	var _HOME_NUBESLOGANWANCLOUDS2 = _interopRequireDefault(_HOME_NUBESLOGANWANCLOUDS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main(props) {
	    _classCallCheck(this, Main);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.move = function () {
	      var divs = document.getElementsByClassName("animated");
	      for (var i = 0; i < divs.length; i++) {
	        var moveByY = _this.props.position.y - divs[i].offsetTop + divs[i].clientHeight / 2;
	        var moveByX = _this.props.position.x - divs[i].offsetLeft;
	        divs[i].style.transform = 'translate(' + moveByX / 100 + '%, ' + moveByY / 100 + '%)';
	      }
	
	      var cloud = document.getElementById("cloud");
	      var moveCloudByY = _this.props.position.y - cloud.offsetTop + cloud.clientHeight / 2;
	      var moveCloudByX = _this.props.position.x - cloud.offsetLeft;
	      cloud.style.transform = 'translate(' + moveCloudByX / 100 + '%, ' + moveCloudByY / 100 + '%)';
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  Main.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'main', onMouseMove: function onMouseMove() {
	          return _this2.move();
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: 'text' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Business evolution'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'h5',
	            null,
	            'through the'
	          ),
	          _react2.default.createElement(
	            'h1',
	            null,
	            'CLOUD.'
	          )
	        )
	      ),
	      _react2.default.createElement('img', { id: 'cloud', src: _HOME_NUBESLOGANWANCLOUDS2.default, alt: 'cloud' }),
	      _react2.default.createElement('div', { id: 'white-circle1', className: 'animated' }),
	      _react2.default.createElement('div', { id: 'white-circle2', className: 'animated' }),
	      _react2.default.createElement('div', { id: 'white-circle3', className: 'animated' }),
	      _react2.default.createElement('div', { id: 'white-circle4', className: 'animated' }),
	      _react2.default.createElement('div', { id: 'white-circle5', className: 'animated' }),
	      _react2.default.createElement('div', { id: 'white-circle6', className: 'animated' }),
	      _react2.default.createElement('div', { id: 'white-circle7', className: 'animated' })
	    );
	  };
	
	  return Main;
	}(_react2.default.Component);
	
	exports.default = Main;
	module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPose = __webpack_require__(32);
	
	var _reactPose2 = _interopRequireDefault(_reactPose);
	
	__webpack_require__(378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavTitle = _reactPose2.default.p({
	  idle: {
	    opacity: 0,
	    top: "30px",
	    flip: true
	  },
	  hovered: {
	    opacity: 1,
	    top: "3vw",
	    flip: true
	  }
	});
	
	var NavTitleTablet = _reactPose2.default.p({
	  idle: {
	    opacity: 0,
	    top: "30px",
	    flip: true
	  },
	  hovered: {
	    opacity: 1,
	    top: "4vw",
	    flip: true
	  }
	});
	
	var HoverImage = _reactPose2.default.img({
	  idle: {
	    opacity: 0
	  },
	  hovered: {
	    opacity: 1
	  }
	});
	
	var NavIcon = function (_React$Component) {
	  _inherits(NavIcon, _React$Component);
	
	  function NavIcon() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NavIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.hoverIn = function () {
	      _this.setState({ hovered: true });
	    }, _this.hoverOut = function () {
	      _this.setState({ hovered: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  NavIcon.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'nav-element', onMouseEnter: function onMouseEnter() {
	          return _this2.hoverIn();
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this2.hoverOut();
	        } },
	      _react2.default.createElement(HoverImage, { pose: this.state.hovered ? "hovered" : "idle", className: 'nav-logo hover', src: this.props.hoverImage, alt: this.props.name }),
	      _react2.default.createElement('img', { className: 'nav-logo', src: this.props.image, alt: this.props.name }),
	      _react2.default.createElement(
	        NavTitle,
	        { id: 'header-desktop', pose: this.state.hovered ? "hovered" : "idle" },
	        this.props.name
	      ),
	      _react2.default.createElement(
	        NavTitleTablet,
	        { id: 'header-ipad', pose: this.state.hovered ? "hovered" : "idle" },
	        this.props.name
	      )
	    );
	  };
	
	  return NavIcon;
	}(_react2.default.Component);
	
	exports.default = NavIcon;
	module.exports = exports['default'];

/***/ }),
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(379);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var News = function News(_ref) {
	  var siteTitle = _ref.siteTitle,
	      post = _ref.post;
	  return _react2.default.createElement(
	    'div',
	    { className: 'news-container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'news-name' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'News'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'news-solutions' },
	      _react2.default.createElement(
	        'h4',
	        { id: 'author-name' },
	        'Author: ',
	        post.author.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'description-news-short' },
	        _react2.default.createElement(
	          'p',
	          null,
	          post.author.shortBiography.childMarkdownRemark.rawMarkdownBody
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'article' },
	        _react2.default.createElement(
	          'div',
	          { className: 'preview' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/blog/' + post.slug },
	              post.title
	            )
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            post.subtitle
	          ),
	          _react2.default.createElement(
	            'small',
	            null,
	            ' By: ',
	            post.author.name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'body-preview' },
	            _react2.default.createElement(
	              'p',
	              null,
	              post.body.childMarkdownRemark.rawMarkdownBody
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'read-more' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/blog/' + post.slug },
	                'Read more'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'preview-image' },
	          _react2.default.createElement(
	            'div',
	            { className: 'image-cropper', id: 'news-main-image' },
	            _react2.default.createElement('img', { src: post.mainPhoto.file.url, alt: 'post-image' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = News;
	module.exports = exports['default'];

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPose = __webpack_require__(32);
	
	var _reactPose2 = _interopRequireDefault(_reactPose);
	
	__webpack_require__(380);
	
	var _HOME_PARTNERSAMAZONWANCLOUDS = __webpack_require__(513);
	
	var _HOME_PARTNERSAMAZONWANCLOUDS2 = _interopRequireDefault(_HOME_PARTNERSAMAZONWANCLOUDS);
	
	var _HOME_PARTNERSMICROSOFTWANCLOUDS = __webpack_require__(514);
	
	var _HOME_PARTNERSMICROSOFTWANCLOUDS2 = _interopRequireDefault(_HOME_PARTNERSMICROSOFTWANCLOUDS);
	
	var _HOME_PARTNERSSOPRISWANCLOUDS = __webpack_require__(515);
	
	var _HOME_PARTNERSSOPRISWANCLOUDS2 = _interopRequireDefault(_HOME_PARTNERSSOPRISWANCLOUDS);
	
	var _HOME_STRATEGICPARTNERSICONNEXT = __webpack_require__(148);
	
	var _HOME_STRATEGICPARTNERSICONNEXT2 = _interopRequireDefault(_HOME_STRATEGICPARTNERSICONNEXT);
	
	var _HOME_STRATEGICPARTNERSICONPREVIOUS = __webpack_require__(251);
	
	var _HOME_STRATEGICPARTNERSICONPREVIOUS2 = _interopRequireDefault(_HOME_STRATEGICPARTNERSICONPREVIOUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerMobile = _reactPose2.default.div({
	  idle: {
	    width: "72vw",
	    height: "72vw",
	    flip: true
	  },
	  hovered: {
	    width: "74vw",
	    height: "74vw",
	    flip: true
	  }
	});
	
	var Partner = _reactPose2.default.div({
	  idle: {
	    width: "30vw",
	    height: "29vw",
	    flip: true
	  },
	  hovered: {
	    width: "33vw",
	    height: "32vw",
	    flip: true
	  }
	});
	
	var Indicator = _reactPose2.default.div({
	  idle: {
	    scale: 1
	  },
	  active: {
	    scale: 1.3
	  }
	});
	
	var Partners = function (_React$Component) {
	  _inherits(Partners, _React$Component);
	
	  function Partners(props) {
	    _classCallCheck(this, Partners);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.nextPartners = function () {
	      if (_this.state.selectedPartnerTwo === _this.state.parterns.length - 1) {
	        _this.setState(_extends({}, _this.state, {
	          selectedPartnerOne: 0,
	          selectedPartnerTwo: 1
	        }));
	      } else {
	        _this.setState(_extends({}, _this.state, {
	          selectedPartnerOne: _this.state.selectedPartnerOne + 1,
	          selectedPartnerTwo: _this.state.selectedPartnerTwo + 1
	        }));
	      }
	    };
	
	    _this.previousPartners = function () {
	      if (_this.state.selectedPartnerOne === 0) {
	        _this.setState(_extends({}, _this.state, {
	          selectedPartnerOne: _this.state.parterns.length - 2,
	          selectedPartnerTwo: _this.state.parterns.length - 1
	        }));
	      } else {
	        _this.setState(_extends({}, _this.state, {
	          selectedPartnerOne: _this.state.selectedPartnerOne - 1,
	          selectedPartnerTwo: _this.state.selectedPartnerTwo - 1
	        }));
	      }
	    };
	
	    _this.mobileNext = function () {
	      if (_this.state.selectedPartnerTwo === _this.state.parterns.length) {
	        _this.setState(_extends({}, _this.state, {
	          selectedPartnerOne: 0,
	          selectedPartnerTwo: 1
	        }));
	      } else {
	        _this.setState(_extends({}, _this.state, {
	          selectedPartnerOne: _this.state.selectedPartnerOne + 1,
	          selectedPartnerTwo: _this.state.selectedPartnerTwo + 1
	        }));
	      }
	    };
	
	    _this.mobilePrevious = function () {
	      if (_this.state.selectedPartnerOne === 0) {
	        _this.setState(_extends({}, _this.state, {
	          selectedPartnerOne: _this.state.parterns.length - 1,
	          selectedPartnerTwo: _this.state.parterns.length
	        }));
	      } else {
	        _this.setState(_extends({}, _this.state, {
	          selectedPartnerOne: _this.state.selectedPartnerOne - 1,
	          selectedPartnerTwo: _this.state.selectedPartnerTwo - 1
	        }));
	      }
	    };
	
	    _this.state = {
	      parterns: [_HOME_PARTNERSAMAZONWANCLOUDS2.default, _HOME_PARTNERSMICROSOFTWANCLOUDS2.default, _HOME_PARTNERSSOPRISWANCLOUDS2.default],
	      selectedPartnerOne: 0,
	      selectedPartnerTwo: 1
	    };
	    return _this;
	  }
	
	  Partners.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section-heading' },
	        _react2.default.createElement(
	          'div',
	          { className: 'name' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Strategic'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Partners'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'description' },
	          _react2.default.createElement(
	            'h6',
	            null,
	            '['
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Our cutting edge tech and business solutions are created in partnership with:'
	          ),
	          _react2.default.createElement(
	            'h6',
	            null,
	            ']'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'slider' },
	        _react2.default.createElement(
	          'div',
	          { className: 'arrow-left', onClick: function onClick() {
	              return _this2.previousPartners();
	            } },
	          _react2.default.createElement('img', { src: _HOME_STRATEGICPARTNERSICONPREVIOUS2.default, className: 'arrow-image', alt: 'arrow' })
	        ),
	        _react2.default.createElement(
	          Partner,
	          { pose: this.state.selectedPartnerOne % 2 ? "hovered" : "idle", className: 'partner-one' },
	          _react2.default.createElement('img', { className: 'partner-image', src: this.state.parterns[this.state.selectedPartnerOne], alt: 'partner' })
	        ),
	        _react2.default.createElement(
	          Partner,
	          { pose: this.state.selectedPartnerTwo % 2 == 0 ? "idle" : "hovered", className: 'partner-one' },
	          _react2.default.createElement('img', { className: 'partner-image', src: this.state.parterns[this.state.selectedPartnerTwo], alt: 'partner' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'arrow-right', onClick: function onClick() {
	              return _this2.nextPartners();
	            } },
	          _react2.default.createElement('img', { src: _HOME_STRATEGICPARTNERSICONNEXT2.default, className: 'arrow-image', alt: 'arrow' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'slider-mobile' },
	        _react2.default.createElement(
	          'div',
	          { className: 'arrow-left', onClick: function onClick() {
	              return _this2.mobilePrevious();
	            } },
	          _react2.default.createElement('img', { src: _HOME_STRATEGICPARTNERSICONPREVIOUS2.default, className: 'arrow-image', alt: 'arrow' })
	        ),
	        _react2.default.createElement(
	          PartnerMobile,
	          { pose: this.state.selectedPartnerOne % 2 ? "hovered" : "idle", className: 'partner-one' },
	          _react2.default.createElement('img', { className: 'partner-image', src: this.state.parterns[this.state.selectedPartnerOne], alt: 'partner' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'arrow-right', onClick: function onClick() {
	              return _this2.mobileNext();
	            } },
	          _react2.default.createElement('img', { src: _HOME_STRATEGICPARTNERSICONNEXT2.default, className: 'arrow-image', alt: 'arrow' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'slider-indicator' },
	        _react2.default.createElement(Indicator, { className: 'blue-circle',
	          pose: this.state.selectedPartnerOne === 0 || this.state.selectedPartnerTwo === 0 ? "active" : "idle" }),
	        _react2.default.createElement(Indicator, { className: 'blue-circle',
	          pose: this.state.selectedPartnerOne === 1 || this.state.selectedPartnerTwo === 1 ? "active" : "idle" }),
	        _react2.default.createElement(Indicator, { className: 'blue-circle',
	          pose: this.state.selectedPartnerOne === 2 || this.state.selectedPartnerTwo === 2 ? "active" : "idle" })
	      )
	    );
	  };
	
	  return Partners;
	}(_react2.default.Component);
	
	exports.default = Partners;
	module.exports = exports['default'];

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPose = __webpack_require__(32);
	
	var _reactPose2 = _interopRequireDefault(_reactPose);
	
	var _popmotion = __webpack_require__(51);
	
	__webpack_require__(381);
	
	var _expertise = __webpack_require__(212);
	
	var _expertise2 = _interopRequireDefault(_expertise);
	
	var _HOME_GRAFICAPROFESSIONALSERVICES = __webpack_require__(491);
	
	var _HOME_GRAFICAPROFESSIONALSERVICES2 = _interopRequireDefault(_HOME_GRAFICAPROFESSIONALSERVICES);
	
	var _HOME_STRATEGICPARTNERSICONNEXT = __webpack_require__(148);
	
	var _HOME_STRATEGICPARTNERSICONNEXT2 = _interopRequireDefault(_HOME_STRATEGICPARTNERSICONNEXT);
	
	var _HOME_STRATEGICPARTNERSICONPREVIOUS = __webpack_require__(251);
	
	var _HOME_STRATEGICPARTNERSICONPREVIOUS2 = _interopRequireDefault(_HOME_STRATEGICPARTNERSICONPREVIOUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CloudMigration = _reactPose2.default.div({
	  enter: {
	    x: '0%',
	    opacity: 1,
	    transition: function transition(props) {
	      return (0, _popmotion.tween)(_extends({}, props, { duration: 400 }));
	    }
	  },
	  exit: {
	    x: '-100%',
	    opacity: 0,
	    transition: function transition(props) {
	      return (0, _popmotion.tween)(_extends({}, props, { duration: 400 }));
	    }
	  }
	});
	
	var RDBoost = _reactPose2.default.div({
	  enter: {
	    x: '0%',
	    opacity: 1,
	    transition: function transition(props) {
	      return (0, _popmotion.tween)(_extends({}, props, { duration: 400 }));
	    }
	  },
	  exit: {
	    x: '100%',
	    opacity: 0,
	    transition: function transition(props) {
	      return (0, _popmotion.tween)(_extends({}, props, { duration: 400 }));
	    }
	  }
	});
	
	var ProfessionalServices = function (_React$Component) {
	  _inherits(ProfessionalServices, _React$Component);
	
	  function ProfessionalServices(props) {
	    _classCallCheck(this, ProfessionalServices);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.nextService = function () {
	      if (_this.state.selectedService === _this.state.services.length - 1) {
	        _this.setState(_extends({}, _this.state, {
	          selectedService: 0
	        }));
	      } else {
	        _this.setState(_extends({}, _this.state, {
	          selectedService: _this.state.selectedService + 1
	        }));
	      }
	    };
	
	    _this.previousService = function () {
	      if (_this.state.selectedService === 0) {
	        _this.setState(_extends({}, _this.state, {
	          selectedService: _this.state.services.length - 1
	        }));
	      } else {
	        _this.setState(_extends({}, _this.state, {
	          selectedService: _this.state.selectedService - 1
	        }));
	      }
	    };
	
	    _this.state = {
	      services: ["Cloud Migration", "RD Research"],
	      selectedService: 0
	    };
	    return _this;
	  }
	
	  ProfessionalServices.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'services-container', id: 'business' },
	      _react2.default.createElement(
	        'div',
	        { className: 'service-name' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Professional'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Services'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'arrows-services-mobile' },
	        _react2.default.createElement('img', { src: _HOME_STRATEGICPARTNERSICONPREVIOUS2.default, alt: 'left', onClick: function onClick() {
	            return _this2.previousService();
	          } }),
	        _react2.default.createElement('img', { src: _HOME_STRATEGICPARTNERSICONNEXT2.default, alt: 'right', onClick: function onClick() {
	            return _this2.nextService();
	          } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'changing-content' },
	        _react2.default.createElement(
	          _reactPose.PoseGroup,
	          { animateOnMount: true },
	          this.state.services[this.state.selectedService] === "Cloud Migration" ? _react2.default.createElement(
	            CloudMigration,
	            { id: 'services', key: 'services' },
	            _react2.default.createElement(
	              'div',
	              { className: 'chart' },
	              _react2.default.createElement('img', { src: _HOME_GRAFICAPROFESSIONALSERVICES2.default, alt: 'chart' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'information' },
	              _react2.default.createElement(
	                'div',
	                { className: 'service' },
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Cloud Migration'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'At WanClouds Miami we understand both the technical and human resource requirements for a software defined business transformation, and can help your organization shift from physical to virtual and software-centric systems running in the cloud. The WanClouds Miami team will define processes and controls, determine financial applications, and complete all training for your staff among other tasks. Our capabilities span your entire IT lifecycle, and follow an easy three step process: 1. Planning, 2. Building, 3. Optimizing.'
	                )
	              )
	            )
	          ) : _react2.default.createElement(
	            RDBoost,
	            { className: 'services-two', key: 'services-two' },
	            _react2.default.createElement(
	              'div',
	              { className: 'service-two-desc' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'R&D Boost'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'description-short-two' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'For clients focused on research and development of new products, WanClouds Miami can provide consulting services and staff expertise, engaging with your R&D team at any point in your design cycle. This allows your team to focus on their specific areas of expertise, resulting in a more efficient use of R&D dollars and more rapid design completion and turnover. This is key when looking to enter new markets, expand current ones, or win new accounts.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              'Our areas of expertise include but are not limited to:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'expertise-squares' },
	              _react2.default.createElement(
	                _expertise2.default,
	                { style: 'expertise-yellow' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Development of software ',
	                    _react2.default.createElement('br', null),
	                    ' ZenPacks to unify, ',
	                    _react2.default.createElement('br', null),
	                    ' enhance and extend ',
	                    _react2.default.createElement('br', null),
	                    ' monitoring for edge ',
	                    _react2.default.createElement('br', null),
	                    ' routing, demarcation ',
	                    _react2.default.createElement('br', null),
	                    ' devices, wireless base ',
	                    _react2.default.createElement('br', null),
	                    ' stations among others. '
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _expertise2.default,
	                { style: 'expertise-yellow' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Building customized ',
	                    _react2.default.createElement('br', null),
	                    'solutions and developing ',
	                    _react2.default.createElement('br', null),
	                    ' superior products to ',
	                    _react2.default.createElement('br', null),
	                    ' replace critical out of date ',
	                    _react2.default.createElement('br', null),
	                    ' software as part of a ',
	                    _react2.default.createElement('br', null),
	                    ' primary business function.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _expertise2.default,
	                { style: 'expertise-yellow' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Design and integration of ',
	                    _react2.default.createElement('br', null),
	                    ' SDK software players such ',
	                    _react2.default.createElement('br', null),
	                    ' as Android and IOS for use ',
	                    _react2.default.createElement('br', null),
	                    ' in superior video ',
	                    _react2.default.createElement('br', null),
	                    ' monitoring solutions.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _expertise2.default,
	                { style: 'expertise-yellow' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    'Functionality ',
	                    _react2.default.createElement('br', null),
	                    ' enhancement software ',
	                    _react2.default.createElement('br', null),
	                    ' development for leading ',
	                    _react2.default.createElement('br', null),
	                    ' open architecture Unified ',
	                    _react2.default.createElement('br', null),
	                    ' Monitoring Systems. '
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'arrows-services' },
	        _react2.default.createElement('img', { src: _HOME_STRATEGICPARTNERSICONPREVIOUS2.default, alt: 'left', onClick: function onClick() {
	            return _this2.previousService();
	          } }),
	        _react2.default.createElement('img', { src: _HOME_STRATEGICPARTNERSICONNEXT2.default, alt: 'right', onClick: function onClick() {
	            return _this2.nextService();
	          } })
	      )
	    );
	  };
	
	  return ProfessionalServices;
	}(_react2.default.Component);
	
	exports.default = ProfessionalServices;
	module.exports = exports['default'];

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(105);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(127);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactCursorPosition = __webpack_require__(425);
	
	var _reactCursorPosition2 = _interopRequireDefault(_reactCursorPosition);
	
	var _reactSpring = __webpack_require__(486);
	
	__webpack_require__(382);
	
	var _header = __webpack_require__(268);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _aboutUs = __webpack_require__(262);
	
	var _aboutUs2 = _interopRequireDefault(_aboutUs);
	
	var _partners = __webpack_require__(273);
	
	var _partners2 = _interopRequireDefault(_partners);
	
	var _main = __webpack_require__(269);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _contactUs = __webpack_require__(150);
	
	var _contactUs2 = _interopRequireDefault(_contactUs);
	
	var _footer = __webpack_require__(53);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _profesionalServices = __webpack_require__(274);
	
	var _profesionalServices2 = _interopRequireDefault(_profesionalServices);
	
	var _customSolutions = __webpack_require__(267);
	
	var _customSolutions2 = _interopRequireDefault(_customSolutions);
	
	var _news = __webpack_require__(272);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _HOMEBG = __webpack_require__(498);
	
	var _HOMEBG2 = _interopRequireDefault(_HOMEBG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RootIndex = function (_React$Component) {
	  _inherits(RootIndex, _React$Component);
	
	  function RootIndex(props) {
	    _classCallCheck(this, RootIndex);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleScroll = function () {
	      var windowScroll = window.scrollY;
	      var itemTranslate = -1 * windowScroll / 10;
	
	      _this.setState({
	        transform: itemTranslate
	      });
	    };
	
	    _this.state = {
	      transform: 0
	    };
	    _this.myRef = _react2.default.createRef();
	    return _this;
	  }
	
	  RootIndex.prototype.componentDidMount = function componentDidMount() {
	    document.body.style.background = "url(" + _HOMEBG2.default + ")";
	    window.addEventListener('scroll', this.handleScroll, true);
	  };
	
	  RootIndex.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleScroll, true);
	  };
	
	  RootIndex.prototype.render = function render() {
	    var siteTitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.title');
	    var posts = (0, _get2.default)(this, 'props.data.allContentfulPost.edges');
	    // const [author] = get(this, 'props.data.allContentfulPerson.edges')
	
	    return (
	      // <Parallax pages={7} ref={ref => this.parallax = ref}>
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: siteTitle + ' | Business evolution through the cloud',
	          meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }]
	        }),
	        _react2.default.createElement(_header2.default, { siteTitle: siteTitle + ' | Business evolution through the cloud' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'parallax-container', style: { transform: 'translateY(' + this.state.transform + 'px)' }, ref: this.myRef },
	            _react2.default.createElement('div', { className: 'sphere', id: 'about' }),
	            _react2.default.createElement('div', { className: 'sphere', id: 'strategic' }),
	            _react2.default.createElement('div', { className: 'sphere', id: 'partners' }),
	            _react2.default.createElement('div', { className: 'sphere', id: 'profesional' }),
	            _react2.default.createElement('div', { className: 'sphere', id: 'custom-sol' }),
	            _react2.default.createElement('div', { className: 'sphere', id: 'right' }),
	            _react2.default.createElement('div', { className: 'sphere', id: 'news' }),
	            _react2.default.createElement('div', { className: 'sphere', id: 'last' })
	          ),
	          _react2.default.createElement(
	            _reactCursorPosition2.default,
	            null,
	            _react2.default.createElement(_main2.default, null)
	          ),
	          _react2.default.createElement(_aboutUs2.default, null),
	          _react2.default.createElement(_partners2.default, null),
	          _react2.default.createElement(_profesionalServices2.default, null),
	          _react2.default.createElement(_customSolutions2.default, null),
	          _react2.default.createElement(_news2.default, { post: posts[0].node }),
	          _react2.default.createElement(_contactUs2.default, null),
	          _react2.default.createElement(_footer2.default, { color: 'light' })
	        )
	      )
	      // </Parallax>
	
	    );
	  };
	
	  return RootIndex;
	}(_react2.default.Component);
	
	exports.default = RootIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	//     allContentfulPerson(filter: { id: { eq: "c15jwOBqpxqSAOy2eOO4S0m" } }) {
	//       edges {
	//         node {
	//           name
	//           shortBio {
	//             shortBio
	//           }
	//           title
	//           image {
	//             file {
	//               url
	//               fileName
	//               contentType
	//             }
	//           }
	//         }
	//       }
	//     }
	//   }
	// `

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, exports) {

	/*!
	 * for-in <https://github.com/jonschlinkert/for-in>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function forIn(obj, fn, thisArg) {
	  for (var key in obj) {
	    if (fn.call(thisArg, obj[key], key, obj) === false) {
	      break;
	    }
	  }
	};


/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, exports) {

	/*!
	 * is-extendable <https://github.com/jonschlinkert/is-extendable>
	 *
	 * Copyright (c) 2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isExtendable(val) {
	  return typeof val !== 'undefined' && val !== null
	    && (typeof val === 'object' || typeof val === 'function');
	};


/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * object.omit <https://github.com/jonschlinkert/object.omit>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(410);
	var forOwn = __webpack_require__(422);
	
	module.exports = function omit(obj, keys) {
	  if (!isObject(obj)) return {};
	
	  keys = [].concat.apply([], [].slice.call(arguments, 1));
	  var last = keys[keys.length - 1];
	  var res = {}, fn;
	
	  if (typeof last === 'function') {
	    fn = keys.pop();
	  }
	
	  var isFunction = typeof fn === 'function';
	  if (!keys.length && !isFunction) {
	    return obj;
	  }
	
	  forOwn(obj, function(value, key) {
	    if (keys.indexOf(key) === -1) {
	
	      if (!isFunction) {
	        res[key] = value;
	      } else if (fn(value, key, obj)) {
	        res[key] = value;
	      }
	    }
	  });
	  return res;
	};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * for-own <https://github.com/jonschlinkert/for-own>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var forIn = __webpack_require__(391);
	var hasOwn = Object.prototype.hasOwnProperty;
	
	module.exports = function forOwn(obj, fn, thisArg) {
	  forIn(obj, function(val, key) {
	    if (hasOwn.call(obj, key)) {
	      return fn.call(thisArg, obj[key], key, obj);
	    }
	  });
	};


/***/ }),
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objectAssign = __webpack_require__(50);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _object = __webpack_require__(421);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _ElementRelativeCursorPosition = __webpack_require__(427);
	
	var _ElementRelativeCursorPosition2 = _interopRequireDefault(_ElementRelativeCursorPosition);
	
	var _addEventListener = __webpack_require__(428);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _constants = __webpack_require__(426);
	
	var constants = _interopRequireWildcard(_constants);
	
	var _noop = __webpack_require__(429);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	        _classCallCheck(this, _class);
	
	        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        _this.state = {
	            detectedEnvironment: {
	                isMouseDetected: false,
	                isTouchDetected: false
	            },
	            elementDimensions: {
	                width: 0,
	                height: 0
	            },
	            isActive: false,
	            isPositionOutside: true,
	            position: {
	                x: 0,
	                y: 0
	            }
	        };
	
	        _this.shouldGuardAgainstMouseEmulationByDevices = false;
	        _this.eventListeners = [];
	        _this.timers = [];
	        _this.elementOffset = {
	            x: 0,
	            y: 0
	        };
	
	        _this.onTouchStart = _this.onTouchStart.bind(_this);
	        _this.onTouchMove = _this.onTouchMove.bind(_this);
	        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
	        _this.onTouchCancel = _this.onTouchCancel.bind(_this);
	        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	        _this.onMouseMove = _this.onMouseMove.bind(_this);
	        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	        return _this;
	    }
	
	    _createClass(_class, [{
	        key: 'onTouchStart',
	        value: function onTouchStart(e) {
	            this.init();
	            this.onTouchDetected();
	            this.setShouldGuardAgainstMouseEmulationByDevices();
	
	            var position = this.core.getCursorPosition(this.getTouchEvent(e));
	            this.setPositionState(position);
	
	            if (this.props.isActivatedOnTouch) {
	                e.preventDefault();
	                this.activate();
	                return;
	            }
	
	            this.initPressEventCriteria(position);
	            this.setPressEventTimer();
	        }
	    }, {
	        key: 'onTouchMove',
	        value: function onTouchMove(e) {
	            var position = this.core.getCursorPosition(this.getTouchEvent(e));
	
	            if (!this.state.isActive) {
	                this.setPressEventCriteria(position);
	                return;
	            }
	
	            this.setPositionState(position);
	            e.preventDefault();
	
	            if (this.props.shouldStopTouchMovePropagation) {
	                e.stopPropagation();
	            }
	        }
	    }, {
	        key: 'onTouchEnd',
	        value: function onTouchEnd() {
	            this.deactivate();
	            this.unsetShouldGuardAgainstMouseEmulationByDevices();
	        }
	    }, {
	        key: 'onTouchCancel',
	        value: function onTouchCancel() {
	            this.deactivate();
	            this.unsetShouldGuardAgainstMouseEmulationByDevices();
	        }
	    }, {
	        key: 'onMouseEnter',
	        value: function onMouseEnter(e) {
	            if (this.shouldGuardAgainstMouseEmulationByDevices) {
	                return;
	            }
	
	            this.init();
	            this.onMouseDetected();
	            this.setPositionState(this.core.getCursorPosition(e));
	            this.clearActivationTimers();
	            this.schedulActivation(this.props.hoverDelayInMs);
	        }
	    }, {
	        key: 'onMouseMove',
	        value: function onMouseMove(e) {
	            this.setPositionState(this.core.getCursorPosition(e));
	        }
	    }, {
	        key: 'onMouseLeave',
	        value: function onMouseLeave() {
	            this.clearActivationTimers();
	            this.scheduleDeactivation(this.props.hoverOffDelayInMs);
	            this.setState({ isPositionOutside: true });
	        }
	    }, {
	        key: 'onTouchDetected',
	        value: function onTouchDetected() {
	            var environment = {
	                isTouchDetected: true,
	                isMouseDetected: false
	            };
	
	            this.setState({ detectedEnvironment: environment });
	            this.props.onDetectedEnvironmentChanged(environment);
	        }
	    }, {
	        key: 'onMouseDetected',
	        value: function onMouseDetected() {
	            var environment = {
	                isTouchDetected: false,
	                isMouseDetected: true
	            };
	
	            this.setState({ detectedEnvironment: environment });
	            this.props.onDetectedEnvironmentChanged(environment);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.isEnabled) {
	                this.enable();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(_ref) {
	            var willBeEnabled = _ref.isEnabled;
	            var isEnabled = this.props.isEnabled;
	
	            var isEnabledWillChange = isEnabled !== willBeEnabled;
	
	            if (!isEnabledWillChange) {
	                return;
	            }
	
	            if (willBeEnabled) {
	                this.enable();
	            } else {
	                this.disable();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearTimers();
	            this.disable();
	        }
	    }, {
	        key: 'enable',
	        value: function enable() {
	            this.addEventListeners();
	        }
	    }, {
	        key: 'disable',
	        value: function disable() {
	            this.removeEventListeners();
	        }
	    }, {
	        key: 'init',
	        value: function init() {
	            this.core = new _ElementRelativeCursorPosition2.default(this.el);
	
	            this.setElementDimensionsState(this.getElementDimensions(this.el));
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            var _core = this.core;
	            _core = _core === undefined ? {} : _core;
	            var lastMouseEvent = _core.lastEvent;
	
	
	            this.init();
	
	            if (!lastMouseEvent) {
	                return;
	            }
	
	            this.setPositionState(this.core.getCursorPosition(lastMouseEvent));
	        }
	    }, {
	        key: 'activate',
	        value: function activate() {
	            this.setState({ isActive: true });
	            this.props.onActivationChanged({ isActive: true });
	        }
	    }, {
	        key: 'deactivate',
	        value: function deactivate() {
	            var _this2 = this;
	
	            this.clearTimer(constants.PRESS_EVENT_TIMER_NAME);
	
	            this.setState({ isActive: false }, function () {
	                var _state = _this2.state,
	                    isPositionOutside = _state.isPositionOutside,
	                    position = _state.position;
	
	
	                _this2.props.onPositionChanged({
	                    isPositionOutside: isPositionOutside,
	                    position: position
	                });
	
	                _this2.props.onActivationChanged({ isActive: false });
	            });
	        }
	    }, {
	        key: 'setPositionState',
	        value: function setPositionState(position) {
	            var isPositionOutside = this.getIsPositionOutside(position);
	
	            this.setState({
	                isPositionOutside: isPositionOutside,
	                position: position
	            }, this.onPositionChanged);
	        }
	    }, {
	        key: 'setElementDimensionsState',
	        value: function setElementDimensionsState(dimensions) {
	            this.setState({
	                elementDimensions: dimensions
	            });
	        }
	    }, {
	        key: 'schedulActivation',
	        value: function schedulActivation(schedule) {
	            var _this3 = this;
	
	            var scheduleId = setTimeout(function () {
	                _this3.activate();
	            }, schedule);
	
	            this.timers.push({
	                id: scheduleId,
	                name: constants.SET_ACTIVATION_TIMER_NAME
	            });
	        }
	    }, {
	        key: 'scheduleDeactivation',
	        value: function scheduleDeactivation(schedule) {
	            var _this4 = this;
	
	            var scheduleId = setTimeout(function () {
	                _this4.deactivate();
	            }, schedule);
	
	            this.timers.push({
	                id: scheduleId,
	                name: constants.UNSET_ACTIVATION_TIMER_NAME
	            });
	        }
	    }, {
	        key: 'clearActivationTimers',
	        value: function clearActivationTimers() {
	            this.clearTimer(constants.SET_ACTIVATION_TIMER_NAME);
	            this.clearTimer(constants.UNSET_ACTIVATION_TIMER_NAME);
	        }
	    }, {
	        key: 'setPressEventTimer',
	        value: function setPressEventTimer() {
	            var _this5 = this;
	
	            var _props = this.props,
	                pressDuration = _props.pressDuration,
	                pressMoveThreshold = _props.pressMoveThreshold;
	
	
	            this.timers.push({
	                name: constants.PRESS_EVENT_TIMER_NAME,
	                id: setTimeout(function () {
	                    if (Math.abs(_this5.currentElTop - _this5.initialElTop) < pressMoveThreshold) {
	                        _this5.activate();
	                    }
	                }, pressDuration)
	            });
	        }
	    }, {
	        key: 'setPressEventCriteria',
	        value: function setPressEventCriteria(position) {
	            this.currentElTop = position.y;
	        }
	    }, {
	        key: 'initPressEventCriteria',
	        value: function initPressEventCriteria(position) {
	            var top = position.y;
	            this.initialElTop = top;
	            this.currentElTop = top;
	        }
	    }, {
	        key: 'setShouldGuardAgainstMouseEmulationByDevices',
	        value: function setShouldGuardAgainstMouseEmulationByDevices() {
	            this.shouldGuardAgainstMouseEmulationByDevices = true;
	        }
	    }, {
	        key: 'unsetShouldGuardAgainstMouseEmulationByDevices',
	        value: function unsetShouldGuardAgainstMouseEmulationByDevices() {
	            var _this6 = this;
	
	            this.timers.push({
	                name: constants.MOUSE_EMULATION_GUARD_TIMER_NAME,
	                id: setTimeout(function () {
	                    _this6.shouldGuardAgainstMouseEmulationByDevices = false;
	                }, 0)
	            });
	        }
	    }, {
	        key: 'clearTimers',
	        value: function clearTimers() {
	            var timers = this.timers;
	            while (timers.length) {
	                var timer = timers.pop();
	                clearTimeout(timer.id);
	            }
	        }
	    }, {
	        key: 'clearTimer',
	        value: function clearTimer(timerName) {
	            this.timers.forEach(function (timer) {
	                if (timer.name === timerName) {
	                    clearTimeout(timer.id);
	                }
	            });
	        }
	    }, {
	        key: 'getElementDimensions',
	        value: function getElementDimensions(el) {
	            var _el$getBoundingClient = el.getBoundingClientRect(),
	                width = _el$getBoundingClient.width,
	                height = _el$getBoundingClient.height;
	
	            return {
	                width: width,
	                height: height
	            };
	        }
	    }, {
	        key: 'getIsPositionOutside',
	        value: function getIsPositionOutside(position) {
	            var x = position.x,
	                y = position.y;
	            var _state$elementDimensi = this.state.elementDimensions,
	                width = _state$elementDimensi.width,
	                height = _state$elementDimensi.height;
	
	
	            var isPositionOutside = x < 0 || y < 0 || x > width || y > height;
	
	            return isPositionOutside;
	        }
	    }, {
	        key: 'getTouchEvent',
	        value: function getTouchEvent(e) {
	            return e.touches[0];
	        }
	    }, {
	        key: 'isReactComponent',
	        value: function isReactComponent(reactElement) {
	            return typeof reactElement.type === 'function';
	        }
	    }, {
	        key: 'shouldDecorateChild',
	        value: function shouldDecorateChild(child) {
	            return !!child && this.isReactComponent(child) && this.props.shouldDecorateChildren;
	        }
	    }, {
	        key: 'decorateChild',
	        value: function decorateChild(child, props) {
	            return (0, _react.cloneElement)(child, props);
	        }
	    }, {
	        key: 'decorateChildren',
	        value: function decorateChildren(children, props) {
	            var _this7 = this;
	
	            return _react.Children.map(children, function (child) {
	                return _this7.shouldDecorateChild(child) ? _this7.decorateChild(child, props) : child;
	            });
	        }
	    }, {
	        key: 'addEventListeners',
	        value: function addEventListeners() {
	            this.eventListeners.push((0, _addEventListener2.default)(this.el, 'touchstart', this.onTouchStart, { passive: false }), (0, _addEventListener2.default)(this.el, 'touchmove', this.onTouchMove, { passive: false }), (0, _addEventListener2.default)(this.el, 'touchend', this.onTouchEnd), (0, _addEventListener2.default)(this.el, 'touchcancel', this.onTouchCancel), (0, _addEventListener2.default)(this.el, 'mouseenter', this.onMouseEnter), (0, _addEventListener2.default)(this.el, 'mousemove', this.onMouseMove), (0, _addEventListener2.default)(this.el, 'mouseleave', this.onMouseLeave));
	        }
	    }, {
	        key: 'removeEventListeners',
	        value: function removeEventListeners() {
	            while (this.eventListeners.length) {
	                this.eventListeners.pop().removeEventListener();
	            }
	        }
	    }, {
	        key: 'getPassThroughProps',
	        value: function getPassThroughProps() {
	            var ownPropNames = Object.keys(this.constructor.propTypes);
	            return (0, _object2.default)(this.props, ownPropNames);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this8 = this;
	
	            var _props2 = this.props,
	                children = _props2.children,
	                className = _props2.className,
	                mapChildProps = _props2.mapChildProps,
	                style = _props2.style;
	
	            var props = (0, _objectAssign2.default)({}, mapChildProps(this.state), this.getPassThroughProps());
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: className,
	                    ref: function ref(el) {
	                        return _this8.el = el;
	                    },
	                    style: (0, _objectAssign2.default)({}, style, {
	                        WebkitUserSelect: 'none'
	                    })
	                },
	                this.decorateChildren(children, props)
	            );
	        }
	    }]);
	
	    return _class;
	}(_react2.default.Component);
	
	_class.displayName = 'ReactCursorPosition';
	_class.propTypes = {
	    children: _propTypes2.default.any,
	    className: _propTypes2.default.string,
	    hoverDelayInMs: _propTypes2.default.number,
	    hoverOffDelayInMs: _propTypes2.default.number,
	    isActivatedOnTouch: _propTypes2.default.bool,
	    isEnabled: _propTypes2.default.bool,
	    mapChildProps: _propTypes2.default.func,
	    onActivationChanged: _propTypes2.default.func,
	    onPositionChanged: _propTypes2.default.func,
	    onDetectedEnvironmentChanged: _propTypes2.default.func,
	    pressDuration: _propTypes2.default.number,
	    pressMoveThreshold: _propTypes2.default.number,
	    shouldDecorateChildren: _propTypes2.default.bool,
	    shouldStopTouchMovePropagation: _propTypes2.default.bool,
	    style: _propTypes2.default.object
	};
	_class.defaultProps = {
	    isActivatedOnTouch: false,
	    isEnabled: true,
	    hoverDelayInMs: 0,
	    hoverOffDelayInMs: 0,
	    mapChildProps: function mapChildProps(props) {
	        return props;
	    },
	    onActivationChanged: _noop2.default,
	    onPositionChanged: _noop2.default,
	    onDetectedEnvironmentChanged: _noop2.default,
	    pressDuration: 500,
	    pressMoveThreshold: 5,
	    shouldDecorateChildren: true,
	    shouldStopTouchMovePropagation: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	    var _this9 = this;
	
	    this.onPositionChanged = function () {
	        var onPositionChanged = _this9.props.onPositionChanged;
	
	        onPositionChanged(_this9.state);
	    };
	};
	
	exports.default = _class;

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PRESS_EVENT_TIMER_NAME = exports.PRESS_EVENT_TIMER_NAME = 'pressEvent';
	var MOUSE_EMULATION_GUARD_TIMER_NAME = exports.MOUSE_EMULATION_GUARD_TIMER_NAME = 'mouseEmulation';
	var SET_ACTIVATION_TIMER_NAME = exports.SET_ACTIVATION_TIMER_NAME = 'setHovering';
	var UNSET_ACTIVATION_TIMER_NAME = exports.UNSET_ACTIVATION_TIMER_NAME = 'unsetHovering';

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ElementRelativeCursorPosition = function () {
	    function ElementRelativeCursorPosition(el) {
	        _classCallCheck(this, ElementRelativeCursorPosition);
	
	        this.el = el;
	    }
	
	    _createClass(ElementRelativeCursorPosition, [{
	        key: "getDocumentRelativeElementOffset",
	        value: function getDocumentRelativeElementOffset(el) {
	            var rootEl = this.getRootOfEl(el);
	
	            var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
	                docLeft = _rootEl$getBoundingCl.left,
	                docTop = _rootEl$getBoundingCl.top;
	
	            var _el$getBoundingClient = el.getBoundingClientRect(),
	                elLeft = _el$getBoundingClient.left,
	                elTop = _el$getBoundingClient.top;
	
	            return {
	                x: Math.abs(docLeft) + elLeft,
	                y: Math.abs(docTop) + elTop
	            };
	        }
	    }, {
	        key: "getRootOfEl",
	        value: function getRootOfEl(el) {
	            if (el.parentElement) {
	                return this.getRootOfEl(el.parentElement);
	            }
	            return el;
	        }
	    }, {
	        key: "getComputedElementRelativeCursorPosition",
	        value: function getComputedElementRelativeCursorPosition(event, documentRelativeElementOffset) {
	            this.lastEvent = event;
	            var position = this.getDocumentRelativeCursorPosition(event);
	            var cursorX = position.x,
	                cursorY = position.y;
	            var offsetX = documentRelativeElementOffset.x,
	                offsetY = documentRelativeElementOffset.y;
	
	
	            return {
	                x: Math.round(cursorX - offsetX),
	                y: Math.round(cursorY - offsetY)
	            };
	        }
	    }, {
	        key: "getDocumentRelativeCursorPosition",
	        value: function getDocumentRelativeCursorPosition(event) {
	            return {
	                x: event.pageX,
	                y: event.pageY
	            };
	        }
	    }, {
	        key: "getCursorPosition",
	        value: function getCursorPosition(event) {
	            return this.getComputedElementRelativeCursorPosition(event, this.documentRelativeElementOffset);
	        }
	    }, {
	        key: "documentRelativeElementOffset",
	        get: function get() {
	            if (!this.elementOffset) {
	                this.elementOffset = this.getDocumentRelativeElementOffset(this.el);
	            }
	
	            return this.elementOffset;
	        }
	    }]);
	
	    return ElementRelativeCursorPosition;
	}();
	
	exports.default = ElementRelativeCursorPosition;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = addEventListener;
	function addEventListener(node, eventName, handler, options) {
	    node.addEventListener(eventName, handler, options);
	    return {
	        removeEventListener: function removeEventListener() {
	            node.removeEventListener(eventName, handler, options);
	        }
	    };
	}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {};

/***/ }),
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(252));
	var _inheritsLoose = _interopDefault(__webpack_require__(253));
	var React = _interopDefault(__webpack_require__(1));
	var ReactDOM = _interopDefault(__webpack_require__(48));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(254));
	
	var bugfixes = undefined;
	var applyAnimatedValues = undefined;
	var colorNames = [];
	var requestFrame = function requestFrame(cb) {
	  return global.requestAnimationFrame(cb);
	};
	var cancelFrame = function cancelFrame(cb) {
	  return global.cancelAnimationFrame(cb);
	};
	var interpolation = undefined;
	var injectApplyAnimatedValues = function injectApplyAnimatedValues(fn, transform) {
	  return applyAnimatedValues = {
	    fn: fn,
	    transform: transform
	  };
	};
	var injectColorNames = function injectColorNames(names) {
	  return colorNames = names;
	};
	var injectBugfixes = function injectBugfixes(fn) {
	  return bugfixes = fn;
	};
	var injectInterpolation = function injectInterpolation(cls) {
	  return interpolation = cls;
	};
	var injectFrame = function injectFrame(raf, caf) {
	  var _ref;
	
	  return _ref = [raf, caf], requestFrame = _ref[0], cancelFrame = _ref[1], _ref;
	};
	
	var Globals = /*#__PURE__*/Object.freeze({
	  get bugfixes () { return bugfixes; },
	  get applyAnimatedValues () { return applyAnimatedValues; },
	  get colorNames () { return colorNames; },
	  get requestFrame () { return requestFrame; },
	  get cancelFrame () { return cancelFrame; },
	  get interpolation () { return interpolation; },
	  injectApplyAnimatedValues: injectApplyAnimatedValues,
	  injectColorNames: injectColorNames,
	  injectBugfixes: injectBugfixes,
	  injectInterpolation: injectInterpolation,
	  injectFrame: injectFrame
	});
	
	var colors = {
	  transparent: 0x00000000,
	  // http://www.w3.org/TR/css3-color/#svg-color
	  aliceblue: 0xf0f8ffff,
	  antiquewhite: 0xfaebd7ff,
	  aqua: 0x00ffffff,
	  aquamarine: 0x7fffd4ff,
	  azure: 0xf0ffffff,
	  beige: 0xf5f5dcff,
	  bisque: 0xffe4c4ff,
	  black: 0x000000ff,
	  blanchedalmond: 0xffebcdff,
	  blue: 0x0000ffff,
	  blueviolet: 0x8a2be2ff,
	  brown: 0xa52a2aff,
	  burlywood: 0xdeb887ff,
	  burntsienna: 0xea7e5dff,
	  cadetblue: 0x5f9ea0ff,
	  chartreuse: 0x7fff00ff,
	  chocolate: 0xd2691eff,
	  coral: 0xff7f50ff,
	  cornflowerblue: 0x6495edff,
	  cornsilk: 0xfff8dcff,
	  crimson: 0xdc143cff,
	  cyan: 0x00ffffff,
	  darkblue: 0x00008bff,
	  darkcyan: 0x008b8bff,
	  darkgoldenrod: 0xb8860bff,
	  darkgray: 0xa9a9a9ff,
	  darkgreen: 0x006400ff,
	  darkgrey: 0xa9a9a9ff,
	  darkkhaki: 0xbdb76bff,
	  darkmagenta: 0x8b008bff,
	  darkolivegreen: 0x556b2fff,
	  darkorange: 0xff8c00ff,
	  darkorchid: 0x9932ccff,
	  darkred: 0x8b0000ff,
	  darksalmon: 0xe9967aff,
	  darkseagreen: 0x8fbc8fff,
	  darkslateblue: 0x483d8bff,
	  darkslategray: 0x2f4f4fff,
	  darkslategrey: 0x2f4f4fff,
	  darkturquoise: 0x00ced1ff,
	  darkviolet: 0x9400d3ff,
	  deeppink: 0xff1493ff,
	  deepskyblue: 0x00bfffff,
	  dimgray: 0x696969ff,
	  dimgrey: 0x696969ff,
	  dodgerblue: 0x1e90ffff,
	  firebrick: 0xb22222ff,
	  floralwhite: 0xfffaf0ff,
	  forestgreen: 0x228b22ff,
	  fuchsia: 0xff00ffff,
	  gainsboro: 0xdcdcdcff,
	  ghostwhite: 0xf8f8ffff,
	  gold: 0xffd700ff,
	  goldenrod: 0xdaa520ff,
	  gray: 0x808080ff,
	  green: 0x008000ff,
	  greenyellow: 0xadff2fff,
	  grey: 0x808080ff,
	  honeydew: 0xf0fff0ff,
	  hotpink: 0xff69b4ff,
	  indianred: 0xcd5c5cff,
	  indigo: 0x4b0082ff,
	  ivory: 0xfffff0ff,
	  khaki: 0xf0e68cff,
	  lavender: 0xe6e6faff,
	  lavenderblush: 0xfff0f5ff,
	  lawngreen: 0x7cfc00ff,
	  lemonchiffon: 0xfffacdff,
	  lightblue: 0xadd8e6ff,
	  lightcoral: 0xf08080ff,
	  lightcyan: 0xe0ffffff,
	  lightgoldenrodyellow: 0xfafad2ff,
	  lightgray: 0xd3d3d3ff,
	  lightgreen: 0x90ee90ff,
	  lightgrey: 0xd3d3d3ff,
	  lightpink: 0xffb6c1ff,
	  lightsalmon: 0xffa07aff,
	  lightseagreen: 0x20b2aaff,
	  lightskyblue: 0x87cefaff,
	  lightslategray: 0x778899ff,
	  lightslategrey: 0x778899ff,
	  lightsteelblue: 0xb0c4deff,
	  lightyellow: 0xffffe0ff,
	  lime: 0x00ff00ff,
	  limegreen: 0x32cd32ff,
	  linen: 0xfaf0e6ff,
	  magenta: 0xff00ffff,
	  maroon: 0x800000ff,
	  mediumaquamarine: 0x66cdaaff,
	  mediumblue: 0x0000cdff,
	  mediumorchid: 0xba55d3ff,
	  mediumpurple: 0x9370dbff,
	  mediumseagreen: 0x3cb371ff,
	  mediumslateblue: 0x7b68eeff,
	  mediumspringgreen: 0x00fa9aff,
	  mediumturquoise: 0x48d1ccff,
	  mediumvioletred: 0xc71585ff,
	  midnightblue: 0x191970ff,
	  mintcream: 0xf5fffaff,
	  mistyrose: 0xffe4e1ff,
	  moccasin: 0xffe4b5ff,
	  navajowhite: 0xffdeadff,
	  navy: 0x000080ff,
	  oldlace: 0xfdf5e6ff,
	  olive: 0x808000ff,
	  olivedrab: 0x6b8e23ff,
	  orange: 0xffa500ff,
	  orangered: 0xff4500ff,
	  orchid: 0xda70d6ff,
	  palegoldenrod: 0xeee8aaff,
	  palegreen: 0x98fb98ff,
	  paleturquoise: 0xafeeeeff,
	  palevioletred: 0xdb7093ff,
	  papayawhip: 0xffefd5ff,
	  peachpuff: 0xffdab9ff,
	  peru: 0xcd853fff,
	  pink: 0xffc0cbff,
	  plum: 0xdda0ddff,
	  powderblue: 0xb0e0e6ff,
	  purple: 0x800080ff,
	  rebeccapurple: 0x663399ff,
	  red: 0xff0000ff,
	  rosybrown: 0xbc8f8fff,
	  royalblue: 0x4169e1ff,
	  saddlebrown: 0x8b4513ff,
	  salmon: 0xfa8072ff,
	  sandybrown: 0xf4a460ff,
	  seagreen: 0x2e8b57ff,
	  seashell: 0xfff5eeff,
	  sienna: 0xa0522dff,
	  silver: 0xc0c0c0ff,
	  skyblue: 0x87ceebff,
	  slateblue: 0x6a5acdff,
	  slategray: 0x708090ff,
	  slategrey: 0x708090ff,
	  snow: 0xfffafaff,
	  springgreen: 0x00ff7fff,
	  steelblue: 0x4682b4ff,
	  tan: 0xd2b48cff,
	  teal: 0x008080ff,
	  thistle: 0xd8bfd8ff,
	  tomato: 0xff6347ff,
	  turquoise: 0x40e0d0ff,
	  violet: 0xee82eeff,
	  wheat: 0xf5deb3ff,
	  white: 0xffffffff,
	  whitesmoke: 0xf5f5f5ff,
	  yellow: 0xffff00ff,
	  yellowgreen: 0x9acd32ff
	};
	
	var linear = function linear(t) {
	  return t;
	};
	
	var Interpolation =
	/*#__PURE__*/
	function () {
	  function Interpolation() {}
	
	  Interpolation.create = function create(config) {
	    if (typeof config === 'function') return function () {
	      return config.apply(void 0, arguments);
	    };
	    if (interpolation && config.output && typeof config.output[0] === 'string') return interpolation(config);
	    var outputRange = config.output;
	    var inputRange = config.range;
	    var easing = config.easing || linear;
	    var extrapolateLeft = 'extend';
	    var map = config.map;
	
	    if (config.extrapolateLeft !== undefined) {
	      extrapolateLeft = config.extrapolateLeft;
	    } else if (config.extrapolate !== undefined) {
	      extrapolateLeft = config.extrapolate;
	    }
	
	    var extrapolateRight = 'extend';
	
	    if (config.extrapolateRight !== undefined) {
	      extrapolateRight = config.extrapolateRight;
	    } else if (config.extrapolate !== undefined) {
	      extrapolateRight = config.extrapolate;
	    }
	
	    return function (input) {
	      var range = findRange(input, inputRange);
	      return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, map);
	    };
	  };
	
	  return Interpolation;
	}();
	
	function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
	  var result = map ? map(input) : input; // Extrapolate
	
	  if (result < inputMin) {
	    if (extrapolateLeft === 'identity') {
	      return result;
	    } else if (extrapolateLeft === 'clamp') {
	      result = inputMin;
	    }
	  }
	
	  if (result > inputMax) {
	    if (extrapolateRight === 'identity') {
	      return result;
	    } else if (extrapolateRight === 'clamp') {
	      result = inputMax;
	    }
	  }
	
	  if (outputMin === outputMax) return outputMin;
	
	  if (inputMin === inputMax) {
	    if (input <= inputMin) return outputMin;
	    return outputMax;
	  } // Input Range
	
	
	  if (inputMin === -Infinity) {
	    result = -result;
	  } else if (inputMax === Infinity) {
	    result = result - inputMin;
	  } else {
	    result = (result - inputMin) / (inputMax - inputMin);
	  } // Easing
	
	
	  result = easing(result); // Output Range
	
	  if (outputMin === -Infinity) {
	    result = -result;
	  } else if (outputMax === Infinity) {
	    result = result + outputMin;
	  } else {
	    result = result * (outputMax - outputMin) + outputMin;
	  }
	
	  return result;
	}
	
	function findRange(input, inputRange) {
	  for (var i = 1; i < inputRange.length - 1; ++i) {
	    if (inputRange[i] >= input) break;
	  }
	
	  return i - 1;
	}
	
	/*
	https://github.com/react-community/normalize-css-color
	
	BSD 3-Clause License
	
	Copyright (c) 2016, React Community
	All rights reserved.
	
	Redistribution and use in source and binary forms, with or without
	modification, are permitted provided that the following conditions are met:
	
	* Redistributions of source code must retain the above copyright notice, this
	  list of conditions and the following disclaimer.
	
	* Redistributions in binary form must reproduce the above copyright notice,
	  this list of conditions and the following disclaimer in the documentation
	  and/or other materials provided with the distribution.
	
	* Neither the name of the copyright holder nor the names of its
	  contributors may be used to endorse or promote products derived from
	  this software without specific prior written permission.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
	FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
	DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
	SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
	CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
	OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	function normalizeColor(color) {
	  var match;
	
	  if (typeof color === 'number') {
	    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
	  } // Ordered based on occurrences on Facebook codebase
	
	
	  if (match = matchers.hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
	  if (colors.hasOwnProperty(color)) return colors[color];
	
	  if (match = matchers.rgb.exec(color)) {
	    return (parse255(match[1]) << 24 | // r
	    parse255(match[2]) << 16 | // g
	    parse255(match[3]) << 8 | // b
	    0x000000ff) >>> // a
	    0;
	  }
	
	  if (match = matchers.rgba.exec(color)) {
	    return (parse255(match[1]) << 24 | // r
	    parse255(match[2]) << 16 | // g
	    parse255(match[3]) << 8 | // b
	    parse1(match[4])) >>> // a
	    0;
	  }
	
	  if (match = matchers.hex3.exec(color)) {
	    return parseInt(match[1] + match[1] + // r
	    match[2] + match[2] + // g
	    match[3] + match[3] + // b
	    'ff', // a
	    16) >>> 0;
	  } // https://drafts.csswg.org/css-color-4/#hex-notation
	
	
	  if (match = matchers.hex8.exec(color)) return parseInt(match[1], 16) >>> 0;
	
	  if (match = matchers.hex4.exec(color)) {
	    return parseInt(match[1] + match[1] + // r
	    match[2] + match[2] + // g
	    match[3] + match[3] + // b
	    match[4] + match[4], // a
	    16) >>> 0;
	  }
	
	  if (match = matchers.hsl.exec(color)) {
	    return (hslToRgb(parse360(match[1]), // h
	    parsePercentage(match[2]), // s
	    parsePercentage(match[3]) // l
	    ) | 0x000000ff) >>> // a
	    0;
	  }
	
	  if (match = matchers.hsla.exec(color)) {
	    return (hslToRgb(parse360(match[1]), // h
	    parsePercentage(match[2]), // s
	    parsePercentage(match[3]) // l
	    ) | parse1(match[4])) >>> // a
	    0;
	  }
	
	  return null;
	}
	
	function hue2rgb(p, q, t) {
	  if (t < 0) t += 1;
	  if (t > 1) t -= 1;
	  if (t < 1 / 6) return p + (q - p) * 6 * t;
	  if (t < 1 / 2) return q;
	  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	  return p;
	}
	
	function hslToRgb(h, s, l) {
	  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	  var p = 2 * l - q;
	  var r = hue2rgb(p, q, h + 1 / 3);
	  var g = hue2rgb(p, q, h);
	  var b = hue2rgb(p, q, h - 1 / 3);
	  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
	} // var INTEGER = '[-+]?\\d+';
	
	
	var NUMBER = '[-+]?\\d*\\.?\\d+';
	var PERCENTAGE = NUMBER + '%';
	
	function toArray(arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	}
	
	function call() {
	  return '\\(\\s*(' + toArray(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
	}
	
	var matchers = {
	  rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
	  rgba: new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER)),
	  hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
	  hsla: new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
	  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	  hex6: /^#([0-9a-fA-F]{6})$/,
	  hex8: /^#([0-9a-fA-F]{8})$/
	};
	
	function parse255(str) {
	  var int = parseInt(str, 10);
	  if (int < 0) return 0;
	  if (int > 255) return 255;
	  return int;
	}
	
	function parse360(str) {
	  var int = parseFloat(str);
	  return (int % 360 + 360) % 360 / 360;
	}
	
	function parse1(str) {
	  var num = parseFloat(str);
	  if (num < 0) return 0;
	  if (num > 1) return 255;
	  return Math.round(num * 255);
	}
	
	function parsePercentage(str) {
	  // parseFloat conveniently ignores the final %
	  var int = parseFloat(str, 10);
	  if (int < 0) return 0;
	  if (int > 100) return 1;
	  return int / 100;
	}
	
	function colorToRgba(input) {
	  var int32Color = normalizeColor(input);
	  if (int32Color === null) return input;
	  int32Color = int32Color || 0;
	  var r = (int32Color & 0xff000000) >>> 24;
	  var g = (int32Color & 0x00ff0000) >>> 16;
	  var b = (int32Color & 0x0000ff00) >>> 8;
	  var a = (int32Color & 0x000000ff) / 255;
	  return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
	} // Problem: https://github.com/animatedjs/animated/pull/102
	// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662
	
	
	var stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	/**
	 * Supports string shapes by extracting numbers so new values can be computed,
	 * and recombines those values into new strings of the same shape.  Supports
	 * things like:
	 *
	 *   rgba(123, 42, 99, 0.36)           // colors
	 *   -45deg                            // values with units
	 */
	
	function createInterpolation(config) {
	  var outputRange = config.output.map(colorToRgba); // ->
	  // [
	  //   [0, 50],
	  //   [100, 150],
	  //   [200, 250],
	  //   [0, 0.5],
	  // ]
	
	  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
	    return [];
	  });
	  outputRange.forEach(function (value) {
	    value.match(stringShapeRegex).forEach(function (number, i) {
	      return outputRanges[i].push(+number);
	    });
	  });
	  var interpolations = outputRange[0].match(stringShapeRegex).map(function (value, i) {
	    return Interpolation.create(_extends({}, config, {
	      output: outputRanges[i]
	    }));
	  });
	  var shouldRound = /^rgb/.test(outputRange[0]);
	  return function (input) {
	    var i = 0;
	    return outputRange[0].replace(stringShapeRegex, function () {
	      var val = interpolations[i++](input);
	      return String(shouldRound && i < 4 ? Math.round(val) : val);
	    });
	  };
	}
	
	var Animated =
	/*#__PURE__*/
	function () {
	  function Animated() {}
	
	  var _proto = Animated.prototype;
	
	  _proto.__attach = function __attach() {};
	
	  _proto.__detach = function __detach() {};
	
	  _proto.__getValue = function __getValue() {};
	
	  _proto.__getAnimatedValue = function __getAnimatedValue() {
	    return this.__getValue();
	  };
	
	  _proto.__addChild = function __addChild(child) {};
	
	  _proto.__removeChild = function __removeChild(child) {};
	
	  _proto.__getChildren = function __getChildren() {
	    return [];
	  };
	
	  return Animated;
	}();
	
	var AnimatedTracking =
	/*#__PURE__*/
	function (_Animated) {
	  _inheritsLoose(AnimatedTracking, _Animated);
	
	  function AnimatedTracking(value, parent, animationClass, animationConfig, callback) {
	    var _this;
	
	    _this = _Animated.call(this) || this;
	    _this.update = throttle(function () {
	      _this._value.animate(new _this._animationClass(_extends({}, _this._animationConfig, {
	        to: _this._animationConfig.to.__getValue()
	      })), _this._callback);
	    }, 1000 / 30);
	    _this._value = value;
	    _this._parent = parent;
	    _this._animationClass = animationClass;
	    _this._animationConfig = animationConfig;
	    _this._callback = callback;
	
	    _this.__attach();
	
	    return _this;
	  }
	
	  var _proto = AnimatedTracking.prototype;
	
	  _proto.__getValue = function __getValue() {
	    return this._parent.__getValue();
	  };
	
	  _proto.__attach = function __attach() {
	    this._parent.__addChild(this);
	  };
	
	  _proto.__detach = function __detach() {
	    this._parent.__removeChild(this);
	  };
	
	  return AnimatedTracking;
	}(Animated);
	
	function throttle(callback, limit) {
	  var wait = false;
	  return function () {
	    if (!wait) {
	      callback.call();
	      wait = true;
	      setTimeout(function () {
	        return wait = false;
	      }, limit);
	    }
	  };
	}
	
	var AnimatedWithChildren =
	/*#__PURE__*/
	function (_Animated) {
	  _inheritsLoose(AnimatedWithChildren, _Animated);
	
	  function AnimatedWithChildren() {
	    var _this;
	
	    _this = _Animated.call(this) || this;
	    _this._children = [];
	    return _this;
	  }
	
	  var _proto = AnimatedWithChildren.prototype;
	
	  _proto.__addChild = function __addChild(child) {
	    if (this._children.length === 0) this.__attach();
	
	    this._children.push(child);
	  };
	
	  _proto.__removeChild = function __removeChild(child) {
	    var index = this._children.indexOf(child);
	
	    if (index === -1) {
	      console.warn("Trying to remove a child that doesn't exist");
	      return;
	    }
	
	    this._children.splice(index, 1);
	
	    if (this._children.length === 0) this.__detach();
	  };
	
	  _proto.__getChildren = function __getChildren() {
	    return this._children;
	  };
	
	  return AnimatedWithChildren;
	}(Animated);
	
	var AnimatedInterpolation =
	/*#__PURE__*/
	function (_AnimatedWithChildren) {
	  _inheritsLoose(AnimatedInterpolation, _AnimatedWithChildren);
	
	  function AnimatedInterpolation(parents, config) {
	    var _this;
	
	    _this = _AnimatedWithChildren.call(this) || this;
	    _this._parents = Array.isArray(parents) ? parents : [parents];
	    _this._interpolation = Interpolation.create(config);
	    return _this;
	  }
	
	  var _proto = AnimatedInterpolation.prototype;
	
	  _proto.__getValue = function __getValue() {
	    return this._interpolation.apply(this, this._parents.map(function (value) {
	      return value.__getValue();
	    }));
	  };
	
	  _proto.__attach = function __attach() {
	    for (var i = 0; i < this._parents.length; ++i) {
	      if (this._parents[i] instanceof Animated) this._parents[i].__addChild(this);
	    }
	  };
	
	  _proto.__detach = function __detach() {
	    for (var i = 0; i < this._parents.length; ++i) {
	      if (this._parents[i] instanceof Animated) this._parents[i].__removeChild(this);
	    }
	  };
	
	  _proto.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  return AnimatedInterpolation;
	}(AnimatedWithChildren);
	var interpolate$1 = function interpolate(parents, config) {
	  return new AnimatedInterpolation(parents, config);
	};
	
	var _uniqueId = 0;
	/**
	 * Animated works by building a directed acyclic graph of dependencies
	 * transparently when you render your Animated components.
	 *
	 *               new Animated.Value(0)
	 *     .interpolate()        .interpolate()    new Animated.Value(1)
	 *         opacity               translateY      scale
	 *          style                         transform
	 *         View#234                         style
	 *                                         View#123
	 *
	 * A) Top Down phase
	 * When an Animated.Value is updated, we recursively go down through this
	 * graph in order to find leaf nodes: the views that we flag as needing
	 * an update.
	 *
	 * B) Bottom Up phase
	 * When a view is flagged as needing an update, we recursively go back up
	 * in order to build the new value that it needs. The reason why we need
	 * this two-phases process is to deal with composite props such as
	 * transform which can receive values from multiple parents.
	 */
	
	function findAnimatedStyles(node, styles) {
	  if (typeof node.update === 'function') styles.add(node);else node.__getChildren().forEach(function (child) {
	    return findAnimatedStyles(child, styles);
	  });
	}
	/**
	 * Standard value for driving animations.  One `Animated.Value` can drive
	 * multiple properties in a synchronized fashion, but can only be driven by one
	 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
	 * or calling `setValue`) will stop any previous ones.
	 */
	
	
	var AnimatedValue =
	/*#__PURE__*/
	function (_AnimatedWithChildren) {
	  _inheritsLoose(AnimatedValue, _AnimatedWithChildren);
	
	  function AnimatedValue(value) {
	    var _this;
	
	    _this = _AnimatedWithChildren.call(this) || this;
	    _this._value = value;
	    _this._animation = null;
	    _this._animatedStyles = new Set();
	    _this._listeners = {};
	    return _this;
	  }
	
	  var _proto = AnimatedValue.prototype;
	
	  _proto.__detach = function __detach() {
	    this.stopAnimation();
	  };
	
	  _proto.__getValue = function __getValue() {
	    return this._value;
	  };
	
	  _proto._update = function _update() {
	    findAnimatedStyles(this, this._animatedStyles);
	  };
	
	  _proto._flush = function _flush() {
	    if (this._animatedStyles.size === 0) this._update();
	
	    this._animatedStyles.forEach(function (animatedStyle) {
	      return animatedStyle.update();
	    });
	  };
	
	  _proto._updateValue = function _updateValue(value) {
	    this._value = value;
	
	    this._flush();
	
	    for (var key in this._listeners) {
	      this._listeners[key]({
	        value: this.__getValue()
	      });
	    }
	  };
	  /**
	   * Directly set the value.  This will stop any animations running on the value
	   * and update all the bound properties.
	   */
	
	
	  _proto.setValue = function setValue(value) {
	    if (this._animation) {
	      this._animation.stop();
	
	      this._animation = null;
	    }
	
	    this._animatedStyles.clear();
	
	    this._updateValue(value);
	  };
	  /**
	   * Stops any running animation or tracking.  `callback` is invoked with the
	   * final value after stopping the animation, which is useful for updating
	   * state to match the animation position with layout.
	   */
	
	
	  _proto.stopAnimation = function stopAnimation(callback) {
	    this.stopTracking();
	    this._animation && this._animation.stop();
	    this._animation = null;
	    callback && callback(this.__getValue());
	  };
	  /**
	   * Interpolates the value before updating the property, e.g. mapping 0-1 to
	   * 0-10.
	   */
	
	
	  _proto.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	  /**
	   * Typically only used internally, but could be used by a custom Animation
	   * class.
	   */
	
	
	  _proto.animate = function animate(animation, callback) {
	    var _this2 = this;
	
	    var previousAnimation = this._animation;
	    this._animation && this._animation.stop();
	    this._animation = animation;
	
	    this._animatedStyles.clear();
	
	    animation.start(this._value, function (value) {
	      return _this2._updateValue(value);
	    }, function (result) {
	      _this2._animation = null;
	      callback && callback(result);
	    }, previousAnimation);
	  };
	  /**
	   * Adds an asynchronous listener to the value so you can observe updates from
	   * animations.  This is useful because there is no way to
	   * synchronously read the value because it might be driven natively.
	   */
	
	
	  _proto.addListener = function addListener(callback) {
	    var id = String(_uniqueId++);
	    this._listeners[id] = callback;
	    return id;
	  };
	
	  _proto.removeListener = function removeListener(id) {
	    delete this._listeners[id];
	  };
	
	  _proto.removeAllListeners = function removeAllListeners() {
	    this._listeners = {};
	  };
	  /**
	   * Typically only used internally.
	   */
	
	
	  _proto.stopTracking = function stopTracking() {
	    this._tracking && this._tracking.__detach();
	    this._tracking = null;
	  };
	  /**
	   * Typically only used internally.
	   */
	
	
	  _proto.track = function track(tracking) {
	    this.stopTracking();
	    this._tracking = tracking;
	  };
	
	  return AnimatedValue;
	}(AnimatedWithChildren);
	
	var getValues = function getValues(object) {
	  return Object.keys(object).map(function (k) {
	    return object[k];
	  });
	};
	
	var check = function check(value) {
	  return value === 'auto';
	};
	
	var overwrite = function overwrite(width, height) {
	  return function (acc, _ref2) {
	    var _extends3;
	
	    var name = _ref2[0],
	        value = _ref2[1];
	    return _extends({}, acc, (_extends3 = {}, _extends3[name] = value === 'auto' ? ~name.indexOf('height') ? height : width : value, _extends3));
	  };
	};
	
	function fixAuto(spring, props) {
	  var native = props.native,
	      children = props.children,
	      render = props.render,
	      from = props.from,
	      to = props.to; // Dry-route props back if nothing's using 'auto' in there
	
	  if (!getValues(from).concat(getValues(to)).some(check)) return; // Fetch render v-dom
	
	  var element = spring.renderChildren(props, spring.convertValues(props));
	  var elementStyles = element.props.style; // Return v.dom with injected ref
	
	  return React.createElement(element.type, _extends({}, element.props, {
	    style: _extends({}, elementStyles, {
	      position: 'absolute',
	      visibility: 'hidden'
	    }),
	    ref: function ref(_ref3) {
	      if (_ref3) {
	        // Once it's rendered out, fetch bounds (minus padding/margin/borders)
	        var node = ReactDOM.findDOMNode(_ref3);
	        var width, height;
	        var cs = getComputedStyle(node);
	
	        if (cs.boxSizing === 'border-box') {
	          width = node.clientWidth;
	          height = node.clientHeight;
	        } else {
	          var paddingX = parseFloat(cs.paddingLeft || 0) + parseFloat(cs.paddingRight || 0);
	          var paddingY = parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0);
	          var borderX = parseFloat(cs.borderLeftWidth || 0) + parseFloat(cs.borderRightWidth || 0);
	          var borderY = parseFloat(cs.borderTopWidth || 0) + parseFloat(cs.borderBottomWidth || 0);
	          width = node.offsetWidth - paddingX - borderX;
	          height = node.offsetHeight - paddingY - borderY;
	        } // Defer to next frame, or else the springs updateToken is canceled
	
	
	        var _convert = overwrite(width, height);
	
	        requestAnimationFrame(function () {
	          return spring.updateProps(_extends({}, props, {
	            from: Object.entries(from).reduce(_convert, from),
	            to: Object.entries(to).reduce(_convert, to)
	          }), true, true);
	        });
	      }
	    }
	  }));
	}
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	var prefixKey = function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	};
	
	var prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  return prefixes.forEach(function (pre) {
	    return isUnitlessNumber[prefixKey(pre, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	function dangerousStyleValue(name, value, isCustomProperty) {
	  if (value == null || typeof value === 'boolean' || value === '') return '';
	  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	
	  return ('' + value).trim();
	}
	
	injectInterpolation(createInterpolation);
	injectColorNames(colors);
	injectBugfixes(fixAuto);
	injectApplyAnimatedValues(function (instance, props) {
	  if (instance.nodeType && instance.setAttribute !== undefined) {
	    var style = props.style,
	        attributes = _objectWithoutProperties(props, ["style"]); // Set styles ...
	
	
	    for (var styleName in style) {
	      if (!style.hasOwnProperty(styleName)) continue;
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
	      if (styleName === 'float') styleName = 'cssFloat';
	      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
	    } // Set attributes ...
	
	
	    for (var name in attributes) {
	      if (instance.getAttribute(name)) instance.setAttribute(name, attributes[name]);
	    }
	  } else return false;
	}, function (style) {
	  return style;
	});
	
	// Important note: start() and stop() will only be called at most once.
	// Once an animation has been stopped or finished its course, it will
	// not be reused.
	var Animation =
	/*#__PURE__*/
	function () {
	  function Animation() {}
	
	  var _proto = Animation.prototype;
	
	  _proto.start = function start(fromValue, onUpdate, onEnd, previousAnimation) {};
	
	  _proto.stop = function stop() {}; // Helper function for subclasses to make sure onEnd is only called once.
	
	
	  _proto.__debouncedOnEnd = function __debouncedOnEnd(result) {
	    var onEnd = this.__onEnd;
	    this.__onEnd = null;
	    onEnd && onEnd(result);
	  };
	
	  return Animation;
	}();
	
	var withDefault = function withDefault(value, defaultValue) {
	  return value === undefined || value === null ? defaultValue : value;
	};
	
	var tensionFromOrigamiValue = function tensionFromOrigamiValue(oValue) {
	  return (oValue - 30) * 3.62 + 194;
	};
	
	var frictionFromOrigamiValue = function frictionFromOrigamiValue(oValue) {
	  return (oValue - 8) * 3 + 25;
	};
	
	var fromOrigamiTensionAndFriction = function fromOrigamiTensionAndFriction(tension, friction) {
	  return {
	    tension: tensionFromOrigamiValue(tension),
	    friction: frictionFromOrigamiValue(friction)
	  };
	};
	
	var SpringAnimation =
	/*#__PURE__*/
	function (_Animation) {
	  _inheritsLoose(SpringAnimation, _Animation);
	
	  function SpringAnimation(config) {
	    var _this;
	
	    _this = _Animation.call(this) || this;
	
	    _this.onUpdate = function () {
	      var position = _this._lastPosition;
	      var velocity = _this._lastVelocity;
	      var tempPosition = _this._lastPosition;
	      var tempVelocity = _this._lastVelocity; // If for some reason we lost a lot of frames (e.g. process large payload or
	      // stopped in the debugger), we only advance by 4 frames worth of
	      // computation and will continue on the next frame. It's better to have it
	      // running at faster speed than jumping to the end.
	
	      var MAX_STEPS = 64;
	      var now = Date.now();
	      if (now > _this._lastTime + MAX_STEPS) now = _this._lastTime + MAX_STEPS; // We are using a fixed time step and a maximum number of iterations.
	      // The following post provides a lot of thoughts into how to build this
	      // loop: http://gafferongames.com/game-physics/fix-your-timestep/
	
	      var TIMESTEP_MSEC = 1;
	      var numSteps = Math.floor((now - _this._lastTime) / TIMESTEP_MSEC);
	
	      for (var i = 0; i < numSteps; ++i) {
	        // Velocity is based on seconds instead of milliseconds
	        var step = TIMESTEP_MSEC / 1000; // This is using RK4. A good blog post to understand how it works:
	        // http://gafferongames.com/game-physics/integration-basics/
	
	        var aVelocity = velocity;
	        var aAcceleration = _this._tension * (_this._to - tempPosition) - _this._friction * tempVelocity;
	        var tempPosition = position + aVelocity * step / 2;
	        var tempVelocity = velocity + aAcceleration * step / 2;
	        var bVelocity = tempVelocity;
	        var bAcceleration = _this._tension * (_this._to - tempPosition) - _this._friction * tempVelocity;
	        tempPosition = position + bVelocity * step / 2;
	        tempVelocity = velocity + bAcceleration * step / 2;
	        var cVelocity = tempVelocity;
	        var cAcceleration = _this._tension * (_this._to - tempPosition) - _this._friction * tempVelocity;
	        tempPosition = position + cVelocity * step / 2;
	        tempVelocity = velocity + cAcceleration * step / 2;
	        var dVelocity = tempVelocity;
	        var dAcceleration = _this._tension * (_this._to - tempPosition) - _this._friction * tempVelocity;
	        tempPosition = position + cVelocity * step / 2;
	        tempVelocity = velocity + cAcceleration * step / 2;
	        var dxdt = (aVelocity + 2 * (bVelocity + cVelocity) + dVelocity) / 6;
	        var dvdt = (aAcceleration + 2 * (bAcceleration + cAcceleration) + dAcceleration) / 6;
	        position += dxdt * step;
	        velocity += dvdt * step;
	      }
	
	      _this._lastTime = now;
	      _this._lastPosition = position;
	      _this._lastVelocity = velocity;
	
	      _this._onUpdate(position); // a listener might have stopped us in _onUpdate
	
	
	      if (!_this.__active) return; // Conditions for stopping the spring animation
	
	      var isOvershooting = false;
	
	      if (_this._overshootClamping && _this._tension !== 0) {
	        if (_this._startPosition < _this._to) {
	          isOvershooting = position > _this._to;
	        } else {
	          isOvershooting = position < _this._to;
	        }
	      }
	
	      var isVelocity = Math.abs(velocity) <= _this._restSpeedThreshold;
	
	      var isDisplacement = true;
	      if (_this._tension !== 0) isDisplacement = Math.abs(_this._to - position) <= _this._restDisplacementThreshold;
	
	      if (isOvershooting || isVelocity && isDisplacement) {
	        // Ensure that we end up with a round value
	        if (_this._tension !== 0) _this._onUpdate(_this._to);
	        return _this.__debouncedOnEnd({
	          finished: true
	        });
	      }
	
	      _this._animationFrame = requestFrame(_this.onUpdate);
	    };
	
	    _this._overshootClamping = withDefault(config.overshootClamping, false);
	    _this._restDisplacementThreshold = withDefault(config.restDisplacementThreshold, 0.0001);
	    _this._restSpeedThreshold = withDefault(config.restSpeedThreshold, 0.0001);
	    _this._initialVelocity = config.velocity;
	    _this._lastVelocity = withDefault(config.velocity, 0);
	    _this._to = config.to;
	    var springConfig = fromOrigamiTensionAndFriction(withDefault(config.tension, 40), withDefault(config.friction, 7));
	    _this._tension = springConfig.tension;
	    _this._friction = springConfig.friction;
	    return _this;
	  }
	
	  var _proto = SpringAnimation.prototype;
	
	  _proto.start = function start(fromValue, onUpdate, onEnd, previousAnimation) {
	    this.__active = true;
	    this._startPosition = fromValue;
	    this._lastPosition = this._startPosition;
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	    this._lastTime = Date.now();
	
	    if (previousAnimation instanceof SpringAnimation) {
	      var internalState = previousAnimation.getInternalState();
	      this._lastPosition = internalState.lastPosition;
	      this._lastVelocity = internalState.lastVelocity;
	      this._lastTime = internalState.lastTime;
	    }
	
	    if (typeof fromValue === 'string') {
	      this._onUpdate(fromValue);
	
	      return this.__debouncedOnEnd({
	        finished: true
	      });
	    }
	
	    if (this._initialVelocity !== undefined && this._initialVelocity !== null) this._lastVelocity = this._initialVelocity;
	    this.onUpdate();
	  };
	
	  _proto.getInternalState = function getInternalState() {
	    return {
	      lastPosition: this._lastPosition,
	      lastVelocity: this._lastVelocity,
	      lastTime: this._lastTime
	    };
	  };
	
	  _proto.stop = function stop() {
	    this.__active = false;
	    clearTimeout(this._timeout);
	    cancelFrame(this._animationFrame);
	
	    this.__debouncedOnEnd({
	      finished: false
	    });
	  };
	
	  return SpringAnimation;
	}(Animation);
	
	var AnimatedArray =
	/*#__PURE__*/
	function (_AnimatedWithChildren) {
	  _inheritsLoose(AnimatedArray, _AnimatedWithChildren);
	
	  function AnimatedArray(array) {
	    var _this;
	
	    _this = _AnimatedWithChildren.call(this) || this;
	    _this._values = array.map(function (n) {
	      return new AnimatedValue(n);
	    });
	    return _this;
	  }
	
	  var _proto = AnimatedArray.prototype;
	
	  _proto.setValue = function setValue(values) {
	    var _this2 = this;
	
	    values.forEach(function (n, i) {
	      return _this2._values[i].setValue(n);
	    });
	  };
	
	  _proto.__getValue = function __getValue() {
	    return this._values.map(function (v) {
	      return v.__getValue();
	    });
	  };
	
	  _proto.stopAnimation = function stopAnimation(callback) {
	    this._values.forEach(function (v) {
	      return v.stopAnimation();
	    });
	
	    callback && callback(this.__getValue());
	  };
	
	  _proto.__attach = function __attach() {
	    for (var i = 0; i < this._values.length; ++i) {
	      if (this._values[i] instanceof Animated) this._values[i].__addChild(this);
	    }
	  };
	
	  _proto.__detach = function __detach() {
	    for (var i = 0; i < this._values.length; ++i) {
	      if (this._values[i] instanceof Animated) this._values[i].__removeChild(this);
	    }
	  };
	
	  return AnimatedArray;
	}(AnimatedWithChildren);
	
	function maybeVectorAnim(array, _ref, anim, impl) {
	  var tension = _ref.tension,
	      friction = _ref.friction,
	      to = _ref.to;
	  // { tension, friction, to: [...]}
	  if (array instanceof AnimatedArray) return parallel(array._values.map(function (v, i) {
	    return anim(v, {
	      tension: tension,
	      friction: friction,
	      to: to[i]
	    }, impl);
	  }), {
	    stopTogether: false
	  });
	  return null;
	}
	
	function parallel(animations, config) {
	  var doneCount = 0;
	  var hasEnded = {};
	  var stopTogether = !(config && config.stopTogether === false);
	  var result = {
	    start: function start(callback) {
	      if (doneCount === animations.length) return callback && callback({
	        finished: true
	      });
	      animations.forEach(function (animation, idx) {
	        var cb = function cb(endResult) {
	          hasEnded[idx] = true;
	          doneCount++;
	
	          if (doneCount === animations.length) {
	            doneCount = 0;
	            return callback && callback(endResult);
	          }
	
	          if (!endResult.finished && stopTogether) result.stop();
	        };
	
	        if (!animation) cb({
	          finished: true
	        });else animation.start(cb);
	      });
	    },
	    stop: function stop() {
	      animations.forEach(function (animation, idx) {
	        !hasEnded[idx] && animation.stop();
	        hasEnded[idx] = true;
	      });
	    }
	  };
	  return result;
	}
	
	function controller(value, config, impl) {
	  if (impl === void 0) {
	    impl = SpringAnimation;
	  }
	
	  return maybeVectorAnim(value, config, controller, impl) || {
	    start: function start(callback) {
	      var singleValue = value;
	      var singleConfig = config;
	      singleValue.stopTracking();
	      if (config.to instanceof Animated) singleValue.track(new AnimatedTracking(singleValue, config.to, impl, singleConfig, callback));else singleValue.animate(new impl(singleConfig), callback);
	    },
	    stop: function stop() {
	      value.stopAnimation();
	    }
	  };
	}
	
	var AnimatedStyle =
	/*#__PURE__*/
	function (_AnimatedWithChildren) {
	  _inheritsLoose(AnimatedStyle, _AnimatedWithChildren);
	
	  function AnimatedStyle(style) {
	    var _this;
	
	    _this = _AnimatedWithChildren.call(this) || this;
	    style = style || {};
	    if (style.transform && !(style.transform instanceof Animated)) style = applyAnimatedValues.transform(style);
	    _this._style = style;
	    return _this;
	  }
	
	  var _proto = AnimatedStyle.prototype;
	
	  _proto.__getValue = function __getValue() {
	    var style = {};
	
	    for (var key in this._style) {
	      var value = this._style[key];
	      style[key] = value instanceof Animated ? value.__getValue() : value;
	    }
	
	    return style;
	  };
	
	  _proto.__getAnimatedValue = function __getAnimatedValue() {
	    var style = {};
	
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof Animated) style[key] = value.__getAnimatedValue();
	    }
	
	    return style;
	  };
	
	  _proto.__attach = function __attach() {
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof Animated) value.__addChild(this);
	    }
	  };
	
	  _proto.__detach = function __detach() {
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof Animated) value.__removeChild(this);
	    }
	  };
	
	  return AnimatedStyle;
	}(AnimatedWithChildren);
	
	var AnimatedProps =
	/*#__PURE__*/
	function (_Animated) {
	  _inheritsLoose(AnimatedProps, _Animated);
	
	  function AnimatedProps(props, callback) {
	    var _this;
	
	    _this = _Animated.call(this) || this;
	
	    if (props.style) {
	      props = _extends({}, props, {
	        style: new AnimatedStyle(props.style)
	      });
	    }
	
	    _this._props = props;
	    _this._callback = callback;
	
	    _this.__attach();
	
	    return _this;
	  }
	
	  var _proto = AnimatedProps.prototype;
	
	  _proto.__getValue = function __getValue() {
	    var props = {};
	
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof Animated) props[key] = value.__getValue();else props[key] = value;
	    }
	
	    return props;
	  };
	
	  _proto.__getAnimatedValue = function __getAnimatedValue() {
	    var props = {};
	
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof Animated) props[key] = value.__getAnimatedValue();
	    }
	
	    return props;
	  };
	
	  _proto.__attach = function __attach() {
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof Animated) value.__addChild(this);
	    }
	  };
	
	  _proto.__detach = function __detach() {
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof Animated) value.__removeChild(this);
	    }
	  };
	
	  _proto.update = function update() {
	    this._callback();
	  };
	
	  return AnimatedProps;
	}(Animated);
	
	function createAnimatedComponent(Component) {
	  return (
	    /*#__PURE__*/
	    function (_React$Component) {
	      _inheritsLoose(AnimatedComponent, _React$Component);
	
	      function AnimatedComponent() {
	        return _React$Component.apply(this, arguments) || this;
	      }
	
	      var _proto = AnimatedComponent.prototype;
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        this._propsAnimated && this._propsAnimated.__detach();
	      };
	
	      _proto.setNativeProps = function setNativeProps(props) {
	        var didUpdate = applyAnimatedValues.fn(this.node, props, this);
	        if (didUpdate === false) this.forceUpdate();
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        this.attachProps(this.props);
	      };
	
	      _proto.attachProps = function attachProps(nextProps) {
	        var _this = this;
	
	        var oldPropsAnimated = this._propsAnimated; // The system is best designed when setNativeProps is implemented. It is
	        // able to avoid re-rendering and directly set the attributes that
	        // changed. However, setNativeProps can only be implemented on leaf
	        // native components. If you want to animate a composite component, you
	        // need to re-render it. In this case, we have a fallback that uses
	        // forceUpdate.
	
	        var callback = function callback() {
	          if (_this.node) {
	            var didUpdate = applyAnimatedValues.fn(_this.node, _this._propsAnimated.__getAnimatedValue(), _this);
	            if (didUpdate === false) _this.forceUpdate();
	          }
	        };
	
	        this._propsAnimated = new AnimatedProps(nextProps, callback); // When you call detach, it removes the element from the parent list
	        // of children. If it goes to 0, then the parent also detaches itself
	        // and so on.
	        // An optimization is to attach the new elements and THEN detach the old
	        // ones instead of detaching and THEN attaching.
	        // This way the intermediate state isn't to go to 0 and trigger
	        // this expensive recursive detaching to then re-attach everything on
	        // the very next operation.
	
	        oldPropsAnimated && oldPropsAnimated.__detach();
	      };
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.attachProps(nextProps);
	      };
	
	      _proto.render = function render() {
	        var _this2 = this;
	
	        var props = this._propsAnimated.__getValue();
	
	        return React.createElement(Component, _extends({}, props, {
	          ref: function ref(node) {
	            return _this2.node = node;
	          }
	        }));
	      };
	
	      return AnimatedComponent;
	    }(React.Component)
	  );
	}
	
	function shallowDiff(a, b) {
	  for (var i in a) {
	    if (!(i in b)) return true;
	  }
	
	  for (var _i in b) {
	    if (a[_i] !== b[_i]) return true;
	  }
	
	  return false;
	}
	
	var config = {
	  default: {
	    tension: 170,
	    friction: 26
	  },
	  gentle: {
	    tension: 120,
	    friction: 14
	  },
	  wobbly: {
	    tension: 180,
	    friction: 12
	  },
	  stiff: {
	    tension: 210,
	    friction: 20
	  },
	  slow: {
	    tension: 280,
	    friction: 60
	  }
	};
	
	var callProp = function callProp(p, n) {
	  return typeof p === 'function' ? p(n) : p;
	};
	
	var convert$1 = function convert(acc, _ref) {
	  var _extends2;
	
	  var name = _ref[0],
	      value = _ref[1];
	  return _extends({}, acc, (_extends2 = {}, _extends2[name] = new AnimatedValue(value), _extends2));
	};
	
	var Spring =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Spring, _React$Component);
	
	  function Spring() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      props: undefined
	    };
	    _this.animations = {};
	
	    _this.callback = function () {
	      if (_this.props.onFrame) _this.props.onFrame(_this.animatedProps.__getValue());
	      !_this.props.native && _this.forceUpdate();
	    };
	
	    return _this;
	  }
	
	  var _proto = Spring.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.stop();
	  };
	
	  _proto.componentWillMount = function componentWillMount() {
	    this.updatePropsAsync(this.props);
	  };
	
	  _proto.componentWillUpdate = function componentWillUpdate(props) {
	    if (props.reset || shallowDiff(props.to, this.props.to)) this.updatePropsAsync(props);
	  };
	
	  _proto.updatePropsAsync = function updatePropsAsync(props) {
	    if (props.inject) {
	      this.inject = props.inject(this, props);
	      if (this.inject) return;
	    }
	
	    this.updateProps(props);
	  };
	
	  _proto.updateProps = function updateProps(props, force, didInject) {
	    var _this2 = this;
	
	    if (force === void 0) {
	      force = false;
	    }
	
	    if (didInject === void 0) {
	      didInject = false;
	    }
	
	    // Springs can be destroyed, the "destroyed" flag prevents them from ever
	    // updating further, they'll just animate out and function no more ...
	    if (this.destroyed && props.destroyed) return;
	    this.destroyed = props.destroyed;
	    var impl = props.impl,
	        from = props.from,
	        to = props.to,
	        config = props.config,
	        attach = props.attach,
	        immediate = props.immediate,
	        reset = props.reset,
	        onFrame = props.onFrame,
	        onRest = props.onRest,
	        inject = props.inject,
	        native = props.native;
	    var allProps = Object.entries(_extends({}, from, to));
	    this.interpolators = {};
	    this.animations = allProps.reduce(function (acc, _ref2, i) {
	      var _extends3;
	
	      var name = _ref2[0],
	          value = _ref2[1];
	      var entry = reset === false && _this2.animations[name] || (_this2.animations[name] = {});
	      var isNumber = typeof value === 'number';
	      var isString = typeof value === 'string' && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
	      var isArray = !isNumber && !isString && Array.isArray(value);
	      var fromValue = from[name] !== undefined ? from[name] : value;
	      var fromAnimated = fromValue instanceof AnimatedValue;
	      var toValue = isNumber || isArray ? value : 1;
	
	      if (attach) {
	        // Attach value to target animation
	        var target = attach(_this2);
	        var attachedAnimation = target && target.animations[name];
	        if (attachedAnimation) toValue = attachedAnimation.animation;
	      }
	
	      if (fromAnimated) {
	        // Use provided animated value
	        entry.animation = entry.interpolation = fromValue;
	      } else if (isNumber || isString) {
	        // Create animated value
	        entry.animation = entry.interpolation = entry.animation || new AnimatedValue(fromValue);
	      } else if (isArray) {
	        // Create animated array
	        entry.animation = entry.interpolation = entry.animation || new AnimatedArray(fromValue);
	      } else {
	        // Deal with interpolations
	        var previous = entry.interpolation && entry.interpolation._interpolation(entry.animation._value);
	
	        entry.animation = new AnimatedValue(0);
	        entry.interpolation = entry.animation.interpolate({
	          range: [0, 1],
	          output: [previous !== undefined ? previous : fromValue, value]
	        });
	      }
	
	      if (callProp(immediate, name)) entry.animation.setValue(toValue);
	      entry.stopped = false;
	
	      entry.onFinish = function (cb) {
	        _this2.animations[name].stopped = true;
	
	        if (_this2.getAnimations().every(function (a) {
	          return a.stopped;
	        })) {
	          var current = _extends({}, _this2.props.from, _this2.props.to);
	
	          if (onRest) onRest(current);
	          cb && typeof cb === 'function' && cb(current);
	
	          if (didInject) {
	            // Restore the original values for injected props
	            var componentProps = _this2.convertValues(_this2.props);
	
	            _this2.inject = _this2.renderChildren(_this2.props, componentProps);
	
	            _this2.forceUpdate();
	          }
	        }
	      };
	
	      entry.start = function (cb) {
	        if (entry.animation.__getValue() === toValue) return entry.onFinish(cb);
	        controller(entry.animation, _extends({
	          to: toValue
	        }, callProp(config, name)), impl).start(function (props) {
	          return props.finished && entry.onFinish(cb);
	        });
	      };
	
	      entry.stop = function () {
	        entry.stopped = true;
	        entry.animation.stopAnimation();
	      };
	
	      _this2.interpolators[name] = entry.interpolation;
	      return _extends({}, acc, (_extends3 = {}, _extends3[name] = entry, _extends3));
	    }, {});
	    var oldAnimatedProps = this.animatedProps;
	    this.animatedProps = new AnimatedProps(this.interpolators, this.callback);
	    oldAnimatedProps && oldAnimatedProps.__detach();
	    this.updateToken = true;
	    if (force) this.forceUpdate();
	  };
	
	  _proto.start = function start() {
	    var _this3 = this;
	
	    var onStart = this.props.onStart;
	
	    var fn = function fn() {
	      return _this3.getAnimations().forEach(function (animation) {
	        return animation.start(resolve);
	      });
	    };
	
	    var resolve,
	        promise = new Promise(function (r) {
	      return resolve = r;
	    });
	
	    if (this.props.delay) {
	      if (this.timeout) clearTimeout(this.timeout);
	      return this.timeout = setTimeout(function () {
	        return fn();
	      }, this.props.delay);
	    }
	
	    if (onStart) onStart();
	    fn();
	    return promise;
	  };
	
	  _proto.stop = function stop() {
	    this.getAnimations().forEach(function (animation) {
	      return animation.stop();
	    });
	  };
	
	  _proto.flush = function flush() {
	    this.getAnimations().forEach(function (_ref3) {
	      var animation = _ref3.animation;
	      return animation._update && animation._update();
	    });
	  };
	
	  _proto.getAnimations = function getAnimations() {
	    var _this4 = this;
	
	    return Object.keys(this.animations).map(function (key) {
	      return _this4.animations[key];
	    });
	  };
	
	  _proto.getValues = function getValues() {
	    return this.animatedProps ? this.animatedProps.__getValue() : {};
	  };
	
	  _proto.getAnimatedValues = function getAnimatedValues() {
	    return this.props.native ? this.interpolators : this.getValues();
	  };
	
	  _proto.convertValues = function convertValues(props) {
	    var from = props.from,
	        to = props.to,
	        native = props.native,
	        children = props.children,
	        render = props.render;
	    var forward = this.getForwardProps(props);
	    var allProps = Object.entries(_extends({}, from, to));
	    return native ? allProps.reduce(convert$1, forward) : _extends({}, from, to, forward);
	  };
	
	  _proto.getForwardProps = function getForwardProps(props) {
	    if (props === void 0) {
	      props = this.props;
	    }
	
	    var _props = props,
	        to = _props.to,
	        from = _props.from,
	        config = _props.config,
	        native = _props.native,
	        onRest = _props.onRest,
	        onFrame = _props.onFrame,
	        children = _props.children,
	        render = _props.render,
	        reset = _props.reset,
	        immediate = _props.immediate,
	        impl = _props.impl,
	        inject = _props.inject,
	        forward = _objectWithoutProperties(_props, ["to", "from", "config", "native", "onRest", "onFrame", "children", "render", "reset", "immediate", "impl", "inject"]);
	
	    return forward;
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    // Animation has to start *after* render, since at that point the scene
	    // graph should be established, so we do it here. Unfortunatelly, non-native
	    // animations call forceUpdate, so it's causing a loop. updateToken prevents
	    // that as it gets set only on prop changes.
	    if (this.updateToken) {
	      this.updateToken = false;
	      this.start();
	    }
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateToken = false;
	    this.start();
	  };
	
	  _proto.renderChildren = function renderChildren(props, componentProps) {
	    return props.render ? props.render(_extends({}, componentProps, {
	      children: props.children
	    })) : props.children(componentProps);
	  };
	
	  _proto.render = function render() {
	    if (this.inject) {
	      var content = this.inject;
	      this.inject = undefined;
	      return content;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        render = _this$props.render;
	    var values = this.getAnimatedValues();
	    return values && Object.keys(values).length ? this.renderChildren(this.props, _extends({}, values, this.getForwardProps())) : null;
	  };
	
	  return Spring;
	}(React.Component);
	
	Spring.defaultProps = {
	  from: {},
	  to: {},
	  config: config.default,
	  native: false,
	  immediate: false,
	  reset: false,
	  impl: SpringAnimation,
	  inject: bugfixes
	};
	
	var empty = function empty() {
	  return null;
	};
	
	var ref = function ref(object, key) {
	  if (object === void 0) {
	    object = {};
	  }
	
	  return typeof object === 'function' ? object(key) : object;
	};
	
	var get = function get(props) {
	  var keys = props.keys,
	      children = props.children,
	      render = props.render,
	      items = props.items,
	      rest = _objectWithoutProperties(props, ["keys", "children", "render", "items"]);
	
	  children = render || children || empty;
	  keys = typeof keys === 'function' ? items.map(keys) : keys;
	
	  if (!Array.isArray(children)) {
	    children = [children];
	    keys = keys ? [keys] : children.map(function (c) {
	      return c.toString();
	    });
	  }
	
	  return _extends({
	    keys: keys,
	    children: children,
	    items: items
	  }, rest);
	};
	
	var Transition =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inheritsLoose(Transition, _React$PureComponent);
	
	  function Transition(prevProps) {
	    var _this;
	
	    _this = _React$PureComponent.call(this) || this;
	    _this.springs = [];
	    _this.state = {
	      transitions: [],
	      prevProps: prevProps
	    };
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref) {
	    var transitions = _ref.transitions,
	        prevProps = _ref.prevProps;
	
	    var _get = get(props),
	        keys = _get.keys,
	        children = _get.children,
	        items = _get.items,
	        from = _get.from,
	        enter = _get.enter,
	        leave = _get.leave,
	        update = _get.update;
	
	    var _get2 = get(prevProps),
	        _keys = _get2.keys,
	        _children = _get2.children,
	        _items = _get2.items; // Compare next keys with current keys
	
	
	    var allKeys = transitions.map(function (t) {
	      return t.key;
	    });
	    var nextSet = new Set(keys);
	    var currentSet = new Set(allKeys);
	    var added = keys.filter(function (item) {
	      return !currentSet.has(item);
	    });
	    var deleted = allKeys.filter(function (item) {
	      return !nextSet.has(item);
	    });
	    var rest = keys.filter(function (item) {
	      return currentSet.has(item);
	    }); // Insert new keys into the transition collection
	
	    added.forEach(function (key) {
	      var i = keys.indexOf(key);
	      transitions = transitions.slice(0, i).concat([key], transitions.slice(i));
	    });
	    transitions = transitions.map(function (transition) {
	      var isTransition = typeof transition === 'object';
	      var key = isTransition ? transition.key : transition;
	      var keyIndex = keys.indexOf(key);
	      var item = items ? items[keyIndex] : key;
	
	      if (isTransition) {
	        // A transition already exists
	        if (deleted.find(function (k) {
	          return k === key;
	        })) {
	          // The transition was removed, re-key it and animate it out
	          return _extends({}, transition, {
	            destroyed: true,
	            prevKey: key,
	            key: transition.key + '_',
	            to: !transition.destroyed ? ref(leave, _items ? _items[_keys.indexOf(key)] : key) : transition.to
	          });
	        } // Transition remains untouched, update children and call hook
	
	
	        return _extends({}, transition, {
	          children: children[keyIndex] || transition.children,
	          to: update && rest.indexOf(transition.key) !== -1 ? ref(update, item) || transition.to : transition.to
	        });
	      } // Map added key into transition
	
	
	      return {
	        children: children[keyIndex],
	        key: key,
	        item: item,
	        to: ref(enter, item),
	        from: ref(from, item)
	      };
	    }); // Re-order list
	
	    var ordered = keys.map(function (key) {
	      return transitions.find(function (child) {
	        return child.key === key;
	      });
	    });
	    transitions.forEach(function (t, i) {
	      if (t.destroyed) ordered = ordered.slice(0, i).concat([t], ordered.slice(i));
	    });
	    return {
	      transitions: ordered,
	      prevProps: props
	    };
	  };
	
	  var _proto = Transition.prototype;
	
	  _proto.getValues = function getValues() {
	    return undefined;
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    var _this$props = this.props,
	        render = _this$props.render,
	        _this$props$from = _this$props.from,
	        _this$props$enter = _this$props.enter,
	        _this$props$leave = _this$props.leave,
	        _this$props$native = _this$props.native,
	        native = _this$props$native === void 0 ? false : _this$props$native,
	        _this$props$config = _this$props.config,
	        config$$1 = _this$props$config === void 0 ? config.default : _this$props$config,
	        keys = _this$props.keys,
	        items = _this$props.items,
	        onFrame = _this$props.onFrame,
	        onRest = _this$props.onRest,
	        extra = _objectWithoutProperties(_this$props, ["render", "from", "enter", "leave", "native", "config", "keys", "items", "onFrame", "onRest"]);
	
	    var props = _extends({
	      native: native,
	      config: config$$1
	    }, extra);
	
	    return this.state.transitions.map(function (transition, i) {
	      var prevKey = transition.prevKey,
	          key = transition.key,
	          item = transition.item,
	          children = transition.children,
	          from = transition.from,
	          rest = _objectWithoutProperties(transition, ["prevKey", "key", "item", "children", "from"]);
	
	      return React.createElement(Spring, _extends({
	        ref: function ref(r) {
	          return r && (_this2.springs[key] = r);
	        },
	        key: key,
	        onRest: rest.destroyed ? function () {
	          return _this2.setState(function (_ref2) {
	            var transitions = _ref2.transitions;
	            return {
	              transitions: transitions.filter(function (t) {
	                return t !== transition;
	              })
	            };
	          }, function () {
	            return delete _this2.springs[key];
	          });
	        } : onRest && function (values) {
	          return onRest(item, values);
	        },
	        onFrame: onFrame && function (values) {
	          return onFrame(item, values);
	        }
	      }, rest, props, {
	        from: rest.destroyed ? _this2.springs[prevKey].getValues() : from,
	        render: render && children,
	        children: render ? _this2.props.children : children
	      }));
	    });
	  };
	
	  return Transition;
	}(React.PureComponent);
	
	var Trail =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inheritsLoose(Trail, _React$PureComponent);
	
	  function Trail() {
	    return _React$PureComponent.apply(this, arguments) || this;
	  }
	
	  var _proto = Trail.prototype;
	
	  _proto.getValues = function getValues() {
	    return this.instance && this.instance.getValues();
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.instance && this.instance.flush();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this.instance && this.instance.flush();
	  };
	
	  _proto.render = function render() {
	    var _this = this;
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        render = _this$props.render,
	        _this$props$from = _this$props.from,
	        from = _this$props$from === void 0 ? {} : _this$props$from,
	        _this$props$to = _this$props.to,
	        to = _this$props$to === void 0 ? {} : _this$props$to,
	        _this$props$native = _this$props.native,
	        native = _this$props$native === void 0 ? false : _this$props$native,
	        _this$props$config = _this$props.config,
	        config$$1 = _this$props$config === void 0 ? config.default : _this$props$config,
	        keys = _this$props.keys,
	        delay = _this$props.delay,
	        onRest = _this$props.onRest,
	        extra = _objectWithoutProperties(_this$props, ["children", "render", "from", "to", "native", "config", "keys", "delay", "onRest"]);
	
	    var animations = new Set();
	
	    var hook = function hook(index, animation) {
	      animations.add(animation);
	      if (index === 0) return undefined;else return Array.from(animations)[index - 1];
	    };
	
	    var props = _extends({}, extra, {
	      native: native,
	      from: from,
	      config: config$$1,
	      to: to
	    });
	
	    var target = render || children;
	    return target.map(function (child, i) {
	      var attachedHook = function attachedHook(animation) {
	        return hook(i, animation);
	      };
	
	      var firstDelay = i === 0 && delay;
	      return React.createElement(Spring, _extends({
	        ref: function ref(_ref) {
	          return i === 0 && (_this.instance = _ref);
	        },
	        onRest: i === 0 ? onRest : null,
	        key: keys[i]
	      }, props, {
	        delay: firstDelay,
	        attach: attachedHook,
	        render: render && child,
	        children: render ? children : child
	      }));
	    });
	  };
	
	  return Trail;
	}(React.PureComponent);
	
	var DEFAULT = '__default';
	
	var Keyframes =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inheritsLoose(Keyframes, _React$PureComponent);
	
	  function Keyframes() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
	    _this.guid = 0;
	    _this.state = {
	      primitive: undefined,
	      props: {},
	      oldProps: {},
	      resolve: function resolve() {
	        return null;
	      }
	    };
	
	    _this.next = function (primitive, props) {
	      return new Promise(function (resolve) {
	        _this.setState(function (state) {
	          return {
	            primitive: primitive,
	            props: props,
	            oldProps: _extends({}, _this.state.props),
	            resolve: resolve
	          };
	        });
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = Keyframes.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({});
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    if (prevProps.state !== this.props.state) {
	      (function () {
	        var _this2$props = _this2.props,
	            states = _this2$props.states,
	            state = _this2$props.state,
	            primitive = _this2$props.primitive;
	
	        if (states && state && primitive) {
	          (function () {
	            var localId = ++_this2.guid;
	            var slots = states[state];
	
	            if (slots) {
	              if (Array.isArray(slots)) {
	                var q = Promise.resolve();
	
	                var _loop = function _loop() {
	                  if (_isArray) {
	                    if (_i >= _iterator.length) return "break";
	                    _ref = _iterator[_i++];
	                  } else {
	                    _i = _iterator.next();
	                    if (_i.done) return "break";
	                    _ref = _i.value;
	                  }
	
	                  var s = _ref;
	                  q = q.then(function () {
	                    return localId === _this2.guid && _this2.next(primitive, s);
	                  });
	                };
	
	                for (var _iterator = slots, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                  var _ref;
	
	                  var _ret = _loop();
	
	                  if (_ret === "break") break;
	                }
	              } else if (typeof slots === 'function') {
	                slots(function (props) {
	                  return localId === _this2.guid && _this2.next(primitive, props);
	                }, _this2.props);
	              } else {
	                _this2.next(primitive, states[state]);
	              }
	            }
	          })();
	        }
	      })();
	    }
	  };
	
	  _proto.render = function render() {
	    var _this3 = this;
	
	    var _this$state = this.state,
	        Component = _this$state.primitive,
	        props = _this$state.props,
	        oldProps = _this$state.oldProps,
	        resolve = _this$state.resolve;
	
	    var _this$props = this.props,
	        ownFrom = _this$props.from,
	        _onRest = _this$props.onRest,
	        rest = _objectWithoutProperties(_this$props, ["from", "onRest"]);
	
	    if (Component) {
	      var current = this.instance && this.instance.getValues();
	      var from = typeof props.from === 'function' ? props.from : _extends({}, oldProps.from, current, props.from);
	      return React.createElement(Component, _extends({
	        ref: function ref(_ref2) {
	          return _this3.instance = _ref2;
	        }
	      }, rest, props, {
	        from: _extends({}, from, ownFrom),
	        onRest: function onRest(args) {
	          resolve(args);
	          if (_onRest) _onRest(args);
	        }
	      }));
	    } else return null;
	  };
	
	  return Keyframes;
	}(React.PureComponent);
	
	Keyframes.defaultProps = {
	  state: DEFAULT
	};
	
	Keyframes.create = function (primitive) {
	  return function (states) {
	    var _states;
	
	    if (typeof states === 'function') states = (_states = {}, _states[DEFAULT] = states, _states);
	    return function (props) {
	      return React.createElement(Keyframes, _extends({
	        primitive: primitive,
	        states: states
	      }, props));
	    };
	  };
	};
	
	Keyframes.Spring = Keyframes.create(Spring);
	Keyframes.Trail = Keyframes.create(Trail);
	Keyframes.Transition = Keyframes.create(Transition);
	
	var AnimatedDiv = createAnimatedComponent('div');
	
	var _React$createContext = React.createContext(null),
	    Provider = _React$createContext.Provider,
	    Consumer = _React$createContext.Consumer;
	
	function getScrollType(horizontal) {
	  return horizontal ? 'scrollLeft' : 'scrollTop';
	}
	
	var START_TRANSLATE_3D = 'translate3d(0px,0px,0px)';
	var START_TRANSLATE = 'translate(0px,0px)';
	var ParallaxLayer =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inheritsLoose(ParallaxLayer, _React$PureComponent);
	
	  function ParallaxLayer() {
	    return _React$PureComponent.apply(this, arguments) || this;
	  }
	
	  var _proto = ParallaxLayer.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    var parent = this.parent;
	
	    if (parent) {
	      parent.layers = parent.layers.concat(this);
	      parent.update();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    var _this = this;
	
	    var parent = this.parent;
	
	    if (parent) {
	      parent.layers = parent.layers.filter(function (layer) {
	        return layer !== _this;
	      });
	      parent.update();
	    }
	  };
	
	  _proto.setPosition = function setPosition(height, scrollTop, immediate) {
	    if (immediate === void 0) {
	      immediate = false;
	    }
	
	    var _this$parent$props = this.parent.props,
	        config$$1 = _this$parent$props.config,
	        impl = _this$parent$props.impl;
	    var targetScroll = Math.floor(this.props.offset) * height;
	    var offset = height * this.props.offset + targetScroll * this.props.speed;
	    var to = parseFloat(-(scrollTop * this.props.speed) + offset);
	    if (!immediate) controller(this.animatedTranslate, _extends({
	      to: to
	    }, config$$1), impl).start();else this.animatedTranslate.setValue(to);
	  };
	
	  _proto.setHeight = function setHeight(height, immediate) {
	    if (immediate === void 0) {
	      immediate = false;
	    }
	
	    var _this$parent$props2 = this.parent.props,
	        config$$1 = _this$parent$props2.config,
	        impl = _this$parent$props2.impl;
	    var to = parseFloat(height * this.props.factor);
	    if (!immediate) controller(this.animatedSpace, _extends({
	      to: to
	    }, config$$1), impl).start();else this.animatedSpace.setValue(to);
	  };
	
	  _proto.initialize = function initialize() {
	    var props = this.props;
	    var parent = this.parent;
	    var targetScroll = Math.floor(props.offset) * parent.space;
	    var offset = parent.space * props.offset + targetScroll * props.speed;
	    var to = parseFloat(-(parent.current * props.speed) + offset);
	    this.animatedTranslate = new AnimatedValue(to);
	    this.animatedSpace = new AnimatedValue(parent.space * props.factor);
	  };
	
	  _proto.renderLayer = function renderLayer() {
	    var _extends2;
	
	    var _this$props = this.props,
	        style = _this$props.style,
	        children = _this$props.children,
	        offset = _this$props.offset,
	        speed = _this$props.speed,
	        factor = _this$props.factor,
	        className = _this$props.className,
	        props = _objectWithoutProperties(_this$props, ["style", "children", "offset", "speed", "factor", "className"]);
	
	    var horizontal = this.parent.props.horizontal;
	    var translate3d = this.animatedTranslate.interpolate({
	      range: [0, 1],
	      output: horizontal ? [START_TRANSLATE_3D, 'translate3d(1px,0,0)'] : [START_TRANSLATE_3D, 'translate3d(0,1px,0)']
	    });
	    return React.createElement(AnimatedDiv, _extends({}, props, {
	      className: className,
	      style: _extends((_extends2 = {
	        position: 'absolute',
	        backgroundSize: 'auto',
	        backgroundRepeat: 'no-repeat',
	        willChange: 'transform'
	      }, _extends2[horizontal ? 'height' : 'width'] = '100%', _extends2[horizontal ? 'width' : 'height'] = this.animatedSpace, _extends2.WebkitTransform = translate3d, _extends2.MsTransform = translate3d, _extends2.transform = translate3d, _extends2), style)
	    }), children);
	  };
	
	  _proto.render = function render() {
	    var _this2 = this;
	
	    return React.createElement(Consumer, null, function (parent) {
	      if (parent && !_this2.parent) {
	        _this2.parent = parent;
	
	        _this2.initialize();
	      }
	
	      return _this2.renderLayer();
	    });
	  };
	
	  return ParallaxLayer;
	}(React.PureComponent);
	ParallaxLayer.defaultProps = {
	  factor: 1,
	  offset: 0,
	  speed: 0
	};
	
	var Parallax =
	/*#__PURE__*/
	function (_React$PureComponent2) {
	  _inheritsLoose(Parallax, _React$PureComponent2);
	
	  function Parallax() {
	    var _this3;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this3 = _React$PureComponent2.call.apply(_React$PureComponent2, [this].concat(args)) || this;
	    _this3.state = {
	      ready: false
	    };
	    _this3.layers = [];
	    _this3.space = 0;
	    _this3.current = 0;
	    _this3.offset = 0;
	    _this3.busy = false;
	
	    _this3.moveItems = function () {
	      _this3.layers.forEach(function (layer) {
	        return layer.setPosition(_this3.space, _this3.current);
	      });
	
	      _this3.busy = false;
	    };
	
	    _this3.scrollerRaf = function () {
	      return requestAnimationFrame(_this3.moveItems);
	    };
	
	    _this3.onScroll = function (event) {
	      var horizontal = _this3.props.horizontal;
	
	      if (!_this3.busy) {
	        _this3.busy = true;
	
	        _this3.scrollerRaf();
	
	        _this3.current = event.target[getScrollType(horizontal)];
	      }
	    };
	
	    _this3.update = function () {
	      var _this3$props = _this3.props,
	          scrolling = _this3$props.scrolling,
	          horizontal = _this3$props.horizontal;
	      var scrollType = getScrollType(horizontal);
	      if (!_this3.container) return;
	      _this3.space = _this3.container[horizontal ? 'clientWidth' : 'clientHeight'];
	      if (scrolling) _this3.current = _this3.container[scrollType];else _this3.container[scrollType] = _this3.current = _this3.offset * _this3.space;
	      if (_this3.content) _this3.content.style[horizontal ? 'width' : 'height'] = _this3.space * _this3.props.pages + "px";
	
	      _this3.layers.forEach(function (layer) {
	        layer.setHeight(_this3.space, true);
	        layer.setPosition(_this3.space, _this3.current, true);
	      });
	    };
	
	    _this3.updateRaf = function () {
	      requestAnimationFrame(_this3.update); // Some browsers don't fire on maximize
	
	      setTimeout(_this3.update, 150);
	    };
	
	    _this3.scrollStop = function (event) {
	      return _this3.animatedScroll && _this3.animatedScroll.stopAnimation();
	    };
	
	    return _this3;
	  }
	
	  var _proto2 = Parallax.prototype;
	
	  _proto2.scrollTo = function scrollTo(offset) {
	    var _this$props2 = this.props,
	        horizontal = _this$props2.horizontal,
	        config$$1 = _this$props2.config,
	        impl = _this$props2.impl;
	    var scrollType = getScrollType(horizontal);
	    this.scrollStop();
	    this.offset = offset;
	    var target = this.container;
	    this.animatedScroll = new AnimatedValue(target[scrollType]);
	    this.animatedScroll.addListener(function (_ref) {
	      var value = _ref.value;
	      return target[scrollType] = value;
	    });
	    controller(this.animatedScroll, _extends({
	      to: offset * this.space
	    }, config$$1), impl).start();
	  };
	
	  _proto2.componentDidMount = function componentDidMount() {
	    window.addEventListener('resize', this.updateRaf, false);
	    this.update();
	    this.setState({
	      ready: true
	    });
	  };
	
	  _proto2.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.updateRaf, false);
	  };
	
	  _proto2.componentDidUpdate = function componentDidUpdate() {
	    this.update();
	  };
	
	  _proto2.render = function render() {
	    var _this4 = this,
	        _extends3;
	
	    var _this$props3 = this.props,
	        style = _this$props3.style,
	        innerStyle = _this$props3.innerStyle,
	        pages = _this$props3.pages,
	        className = _this$props3.className,
	        scrolling = _this$props3.scrolling,
	        children = _this$props3.children,
	        horizontal = _this$props3.horizontal;
	    var overflow = scrolling ? 'scroll' : 'hidden';
	    return React.createElement("div", {
	      ref: function ref(node) {
	        return _this4.container = node;
	      },
	      onScroll: this.onScroll,
	      onWheel: scrolling ? this.scrollStop : null,
	      onTouchStart: scrolling ? this.scrollStop : null,
	      style: _extends({
	        position: 'absolute',
	        width: '100%',
	        height: '100%',
	        overflow: overflow,
	        overflowY: horizontal ? 'hidden' : overflow,
	        overflowX: horizontal ? overflow : 'hidden',
	        WebkitOverflowScrolling: 'touch',
	        WebkitTransform: START_TRANSLATE,
	        MsTransform: START_TRANSLATE,
	        transform: START_TRANSLATE_3D
	      }, style),
	      className: className
	    }, this.state.ready && React.createElement("div", {
	      ref: function ref(node) {
	        return _this4.content = node;
	      },
	      style: _extends((_extends3 = {
	        position: 'absolute'
	      }, _extends3[horizontal ? 'height' : 'width'] = '100%', _extends3.WebkitTransform = START_TRANSLATE, _extends3.MsTransform = START_TRANSLATE, _extends3.transform = START_TRANSLATE_3D, _extends3.overflow = 'hidden', _extends3[horizontal ? 'width' : 'height'] = this.space * pages, _extends3), innerStyle)
	    }, React.createElement(Provider, {
	      value: this
	    }, children)));
	  };
	
	  return Parallax;
	}(React.PureComponent);
	
	Parallax.Layer = ParallaxLayer;
	Parallax.defaultProps = {
	  config: config.slow,
	  scrolling: true,
	  horizontal: false,
	  impl: SpringAnimation
	};
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	var elements = domElements.reduce(function (acc, element) {
	  var _extends2;
	
	  return _extends({}, acc, (_extends2 = {}, _extends2[element] = createAnimatedComponent(element), _extends2));
	}, {});
	Object.assign(createAnimatedComponent, elements);
	
	var createAnimatedComponent$1 = function createAnimatedComponent$$1(comp) {
	  return console.warn('createAnimatedComponent is deprecated, use animated(comp) instead') || createAnimatedComponent(comp);
	};
	
	exports.Spring = Spring;
	exports.Keyframes = Keyframes;
	exports.Transition = Transition;
	exports.Trail = Trail;
	exports.Parallax = Parallax;
	exports.ParallaxLayer = ParallaxLayer;
	exports.Animation = Animation;
	exports.SpringAnimation = SpringAnimation;
	exports.AnimatedValue = AnimatedValue;
	exports.config = config;
	exports.animated = createAnimatedComponent;
	exports.controller = controller;
	exports.interpolate = interpolate$1;
	exports.createAnimatedComponent = createAnimatedComponent$1;
	exports.Globals = Globals;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2-HOME_GRAFICA-PROFESSIONAL-SERVICES.2f8eada5.png";

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HOME-BG.6b67f399.jpg";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HOME_ESQUEMA-CUSTOMSOLUTIONS-WANCLOUDS.8b3a62f1.png";

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA9CAYAAAATfBGuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpkYjU3ODljOC03ODI1LTMzNGQtYjc5Zi05ZDk2MjY5ODlmN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDMwMkIyNEI2NTNCMTFFOEJBRkJFNUQ2NTc4MDdEQjgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDMwMkIyNEE2NTNCMTFFOEJBRkJFNUQ2NTc4MDdEQjgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZGI1Nzg5YzgtNzgyNS0zMzRkLWI3OWYtOWQ5NjI2OTg5ZjdkIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmRiNTc4OWM4LTc4MjUtMzM0ZC1iNzlmLTlkOTYyNjk4OWY3ZCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PiDSNYQAAAWtSURBVHja3FtrbBRVFL4dkWBiK5FHQtLaREuoQRMaoKFhlepgojWGKJWqCQaVly/iI00MiZBI+KGSKPGF0h8U8IdWQhuCBrKLq7QUeegPIKKASQMGHzQprlGstfod9xuYNtvdmbv3bnf3S75M73TuuefrTO8959yZkmg0qiyhCrwTnA7eDN4ITgBLwavAf8AE2Av+AH4LngD3gaeDDOC6biiHxhgWOBtcAt4LVma4VgSPJ28C7/L9rgfcDbaCh0w55xiwMRZcCR6nY08FEJoJlbTzFe2u5DijJlb6LuUj9x4fVxuYTvunOZ6Ta7G3gp3gZrBC5QYVHK+T41sXWwI2g1+DdWp0UMfxm2OxWIktsWXgDvA1CxNbWIyhHzsguMy02HKwC7xf5RfEny4ILjclVgzFwVtUfkL8igcRnEmsBAFRroP5DPEvCsETdMWOAzvAaaowIH52QPA4HbFvgXNVYWEu/Q4ldhEX8ELEUtzdB4OKnQK+rwobH0DwlCBiX2VwXsgYTx1pxUp0slgVBxbj7talE7tOFRfWjSR2luTDRSbWxd2dlSp5b9Y0+A34Ww4clxi4RqOf6Gr6P4thWeY68BfNBPkoeA/4q0Whk8DPwJkaffvBya7rXvQe40YNoV65RBz4kjG0DZTTvif0sEYlpdH/P9uk4YSUSt7mz9XgAZUssplEFe1Ws/0OuELDTpMnVpRHNAz8Cz7rm/GkktANzjAkdAbtVfhm1mc4blhEMFGNFbG14DVZOLUGfJ4/TwS/0PzjDXGOdiay/QLH0YXoqxWxcwzchTfBx8BBzpp7wQZNWw3sX0Z7YvcNAz7OcXz/D9liC7iQs5/8JdvBh0PaeIj9pP/ftLfFkH/VInaqwQmlncvQ7+DV4HZOZEEnvA/ZT/rfTXumMFXEViqzkO2L+eAFToBS812doc9qXifX97L/PsN+VTqWMhyp5N8B/sj2enCDSpZi/Sjh+fVsy/X17G88ExKxpZaCAdm2uA08w/aLYItK7vEoHjfzvOJ1t7OfDZQ6ysx+z0j4GfzO134c/Ai8lscnfL/7HvzJoi+Ow+ndBiTe/tS3BP3Bo8ywPTz6z8vEtpv9bGBQxCYsBe4xcB7bu8AbuH4KrudxL8/vYrue/SZZ8CkhYvssBO77fYG7LD8PcJa9D2zj+Ta2e/n77b7EYr+FxKLP4SNlbC1jPOvVmqWs+Sg44Eu3JNBYwmM/zw/wOq8MOo0JgMkYoEfEnjJkrIYOenfkFXBVisBdXi9o5XF4YrGK/bzE4oBmwp4Kp0TsSQOGZImJ+wL358C1mrbWsr+XWMRpP1ucFLEHszQi70/s8QXu8ohuzNLmRtrxEos9HCcbHHRYcfhT08Aj4E4G7n9xomk19Ni10p6XWOzkeDoQfYccGuvUMCAveGxj4J7getpheAbt4Pqb4DjbOG5YdLqu2+9FTx9rGFjG6OuCpcB9pMRimYYNidYul1LbWN/RqS7GeVcblF3EvcJZSMiT+4lf7EXmjos0jDVqOpErtEsZVQ1LAl5XxYnLuvxijzAuLSbEcFePpBIreLnIxA7RM1ysxLVbi0ToVtzV7nRiBS9ZyIRyjT7qUJnEngeXF7jY5bir54OI9dbdlgIV2gKhbSnrMmk6yT5OV4EJ7aLfKqzYS+ACNbRgls8QPxfgrl7SEavUlYL1mTwXKv7Nh9DedBcFKaOeU8lC2LE8FSp+1UPouUwXBq0Zi6EIc8p8gvgTCSI0jFiBvCQitV55IWNglEUO0I+FEBr45ZWwuwFSFJO9mRpGW6OBbo6/AUJD7cLrbn0c52MtifTZHIk8y/EiSnM/KJt9nkEGHvKSx5Mq+bWVDZyg/SqOp71dY2JTSyoBm1Ty9XV5P+NdlX3hvYd2aml3k7pSUNeG6a84DpNPq+Sr7P5v8aQ90rd4sk563+J9rgJ+ixcW/wkwAEWARgBP+YS7AAAAAElFTkSuQmCC"

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAA9CAYAAAATfBGuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpkYjU3ODljOC03ODI1LTMzNGQtYjc5Zi05ZDk2MjY5ODlmN2QiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTFENUQ5Qzc3MzJGMTFFODk2RjRCMTg2NDJGQUNBQUMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTFENUQ5QzY3MzJGMTFFODk2RjRCMTg2NDJGQUNBQUMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjZjMGFkNGQtMzc5YS01YjRkLWEwYWUtYTZlMjhhOWZkZTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmRiNTc4OWM4LTc4MjUtMzM0ZC1iNzlmLTlkOTYyNjk4OWY3ZCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PopEg3kAAAU8SURBVHja7JtdbBVFFMenq14pRagSsEbF0qJSP16MX4VaCVHjV6wNfkYFEgnRRxOID75oSIw++aDxiURtfKAqqdWAUUExkdYPEk2oWMWqLTUaFWwRREpvr//D/V+yudmdj+5uu9vrSX5pujs7c86d2ZlzzsxWFQoFlZAsASvB5aAJNID54CxwGsiDv8FB8CP4FvSBj8EPSShUFbOx14C14A5wUYR6BsE28Cr4MjbtxNiI5MBjoK+QjPSx/lxUXaM87IF1YKgwNTLE9rypNvYK0FOYHulh+856e67vONgAvgLNanqkme1voD6JTFBzOWG0q/RIFyfEw3EaewHYDq5U6ZO94HYwHIexYugu0KjSKwNghclgk7HiBOwGl6r0y3dgGTgUVkA3Qc0C3RkxVFHPd6i3s7EvguUqW7KcejsN43vBGyq7ch9408bY88A+UJthY0cYfPxmGsbPZdxQRf2fN/WseCc9auaIzM69YT27Sc0s2RTWs1fHGjumRyTG3lPesxunoOGjoBM8A16z9Wkjysby4H0eOJ5waLYFLCgLu+aAFxJu9zjtO9Wz94Bcgr/uFvAg+KPs+hHwRMJzRY72nXpnPwA3J9SYJNUWM7EWJqcz4bYkIR0+BLd4tLzF4UHpnaeYObyLMe6Epvy7BkNFxtn7YSL1d4A2tivt/+6gc8tJO9GzLQ7jvx/UBaQ82kE+5JknLdMmD4Q8L/W2BZSvoz62skx69nqHX+iRchfMlzF4SePN2MhsTUDSHXBd9Fjjks4RY5daFt5nWIc7Qq63WtZ/nWO9Ip8zjrWRpWLsxZaFhyd5v9kinbMQPBRyb9Dw7C+W+l8ixtpm7k3l6sPCSE4+54TcrwFb+TdIGgztLrLUf5Hn8E5JJuAGzf1HNfcuA1/znZ/t88tvBV8YVoN1mns3OixXZyvNLBokP4P6gJlxtUMdY2AQHHZ4ZnVAm/XUx1by4lS47myJP/syE3Fz6Z20a4LoZ1Vxk6qWGYSVTBAcZNbybTDkWz/rQuqSGf8tel0Suj3O9q1FjM0bclH+qV6WgHM5/EqJrQPgfbAA3KmK25GKi74Mz/0O+izkD9DE/0/4nBLJDZ/P6/+C93i9jW2bZEKGw4jFENhGp700hKpBE2gAVb7r14I/+cyaSe4jtfJ5qecq3/UqDl1pt8Z3vRZst7BhRFmM+1FWaKvsWs4D1RF2CA+Ahx3Ki35HDXb85FmsY7v57tlKN53/YxEc9/0cvi4Jtk8MZYY8i3dqzFHRv2hsFJFJcNTxGVNg8L0Y228o9M8klM1HNHYigTCvX4z9LOaejUNOJFBnr0cP5phKl5wZc31i3x6PPfeppmCNY8WzYkqlVDs+o9NT7BsrOROdmoKtJ/1Ke2mn4xGldxqZBbGV+YZQstOfg5rH2SynCbNkO/CQzhtjuCju4xngaaZMXUVCvdc54rZytdC5tBJN3Q0u1Mw54pmN+pPknfRdY50UGPDb+t/yY92mHA+GGER2I+/396xIRe0IyIWdM8zQnSVDy3u2lEKpmF28XkOCK0vS4Tc0qGeVqrCd91/B+oz36noVkN8Oy1DI4YvNGTV0swo4PBI2jP1u3w6VreNBEnvfxLSNk7ElN6wiTrgpJrTklxpIuaED1FPnzlplFWVbY4Uqnv5Mo+xVFoc0bY0tGSxp0a6UGdpFvYZtCrucJJe80CpVPJAxPs1GjlOPVcrlEEolfSPw/9cfM/W7nrR/sfWKP0SLKnEbW55H8n+L10gnZY4qHgWSSeYI13JZJ+Vo0Dfgo6TW9f8EGAD0sQmhHZT7RAAAAABJRU5ErkJggg=="

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HOME_NUBE-SLOGAN-WANCLOUDS.b1bdbf3a.png";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HOME_PARTNERS-AMAZON-WANCLOUDS.79b4ffe8.png";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HOME_PARTNERS-MICROSOFT-WANCLOUDS.316793f6.png";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HOME_PARTNERS-SOPRIS-WANCLOUDS.d2c6cf27.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/LOGO-LANDINGPAGE-WANCLOUDS.5b47536b.png";

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-a589555506dccfe56f8b.js